[
    {
      "ID": 3,
      "greek_letter": "",
      "constellation": "Psc",
      "RA_hour": "00",
      "RA_min": "05",
      "RA_sec": 20.1,
      "dec_deg": "-05",
      "dec_min": 42,
      "dec_sec": 27,
      "magnitude": 4.61
    },
    {
      "ID": 15,
      "greek_letter": "alf",
      "constellation": "And",
      "RA_hour": "00",
      "RA_min": "08",
      "RA_sec": 23.2,
      "dec_deg": "+29",
      "dec_min": "05",
      "dec_sec": 26,
      "magnitude": 2.06
    },
    {
      "ID": 21,
      "greek_letter": "bet",
      "constellation": "Cas",
      "RA_hour": "00",
      "RA_min": "09",
      "RA_sec": 10.6,
      "dec_deg": "+59",
      "dec_min": "08",
      "dec_sec": 59,
      "magnitude": 2.27
    },
    {
      "ID": 25,
      "greek_letter": "eps",
      "constellation": "Phe",
      "RA_hour": "00",
      "RA_min": "09",
      "RA_sec": 24.6,
      "dec_deg": -45,
      "dec_min": 44,
      "dec_sec": 51,
      "magnitude": 3.87
    },
    {
      "ID": 33,
      "greek_letter": "",
      "constellation": "Cet",
      "RA_hour": "00",
      "RA_min": 11,
      "RA_sec": 15.8,
      "dec_deg": -15,
      "dec_min": 28,
      "dec_sec": "05",
      "magnitude": 4.89
    },
    {
      "ID": 39,
      "greek_letter": "gam",
      "constellation": "Peg",
      "RA_hour": "00",
      "RA_min": 13,
      "RA_sec": 14.1,
      "dec_deg": "+15",
      "dec_min": 11,
      "dec_sec": "01",
      "magnitude": 2.84
    },
    {
      "ID": 45,
      "greek_letter": "chi",
      "constellation": "Peg",
      "RA_hour": "00",
      "RA_min": 14,
      "RA_sec": 36.1,
      "dec_deg": "+20",
      "dec_min": 12,
      "dec_sec": 24,
      "magnitude": 4.8
    },
    {
      "ID": 48,
      "greek_letter": "",
      "constellation": "Cet",
      "RA_hour": "00",
      "RA_min": 14,
      "RA_sec": 38.3,
      "dec_deg": -18,
      "dec_min": 55,
      "dec_sec": 58,
      "magnitude": 4.46
    },
    {
      "ID": 63,
      "greek_letter": "tet",
      "constellation": "And",
      "RA_hour": "00",
      "RA_min": 17,
      "RA_sec": "05.4",
      "dec_deg": "+38",
      "dec_min": 40,
      "dec_sec": 54,
      "magnitude": 4.61
    },
    {
      "ID": 68,
      "greek_letter": "sig",
      "constellation": "And",
      "RA_hour": "00",
      "RA_min": 18,
      "RA_sec": 19.6,
      "dec_deg": "+36",
      "dec_min": 47,
      "dec_sec": "07",
      "magnitude": 4.52
    },
    {
      "ID": 74,
      "greek_letter": "iot",
      "constellation": "Cet",
      "RA_hour": "00",
      "RA_min": 19,
      "RA_sec": 25.6,
      "dec_deg": "-08",
      "dec_min": 49,
      "dec_sec": 26,
      "magnitude": 3.55
    },
    {
      "ID": 77,
      "greek_letter": "zet",
      "constellation": "Tuc",
      "RA_hour": "00",
      "RA_min": 20,
      "RA_sec": "04.2",
      "dec_deg": -64,
      "dec_min": 52,
      "dec_sec": 30,
      "magnitude": 4.23
    },
    {
      "ID": 98,
      "greek_letter": "bet",
      "constellation": "Hyi",
      "RA_hour": "00",
      "RA_min": 25,
      "RA_sec": 45.3,
      "dec_deg": -77,
      "dec_min": 15,
      "dec_sec": 16,
      "magnitude": 2.79
    },
    {
      "ID": 99,
      "greek_letter": "alf",
      "constellation": "Phe",
      "RA_hour": "00",
      "RA_min": 26,
      "RA_sec": 17,
      "dec_deg": -42,
      "dec_min": 18,
      "dec_sec": 22,
      "magnitude": 2.38
    },
    {
      "ID": 100,
      "greek_letter": "kap",
      "constellation": "Phe",
      "RA_hour": "00",
      "RA_min": 26,
      "RA_sec": 12.1,
      "dec_deg": -43,
      "dec_min": 40,
      "dec_sec": 48,
      "magnitude": 3.93
    },
    {
      "ID": 105,
      "greek_letter": "eta",
      "constellation": "Scl",
      "RA_hour": "00",
      "RA_min": 27,
      "RA_sec": 55.7,
      "dec_deg": -33,
      "dec_min": "00",
      "dec_sec": 26,
      "magnitude": 4.81
    },
    {
      "ID": 123,
      "greek_letter": "lam",
      "constellation": "Cas",
      "RA_hour": "00",
      "RA_min": 31,
      "RA_sec": 46.3,
      "dec_deg": "+54",
      "dec_min": 31,
      "dec_sec": 20,
      "magnitude": 4.73
    },
    {
      "ID": 125,
      "greek_letter": "lam1",
      "constellation": "Phe",
      "RA_hour": "00",
      "RA_min": 31,
      "RA_sec": 24.9,
      "dec_deg": -48,
      "dec_min": 48,
      "dec_sec": 13,
      "magnitude": 4.77
    },
    {
      "ID": 126,
      "greek_letter": "bet1",
      "constellation": "Tuc",
      "RA_hour": "00",
      "RA_min": 31,
      "RA_sec": 32.7,
      "dec_deg": -62,
      "dec_min": 57,
      "dec_sec": 30,
      "magnitude": 4.37
    },
    {
      "ID": 127,
      "greek_letter": "bet2",
      "constellation": "Tuc",
      "RA_hour": "00",
      "RA_min": 31,
      "RA_sec": 33.6,
      "dec_deg": -62,
      "dec_min": 57,
      "dec_sec": 57,
      "magnitude": 4.54
    },
    {
      "ID": 130,
      "greek_letter": "kap",
      "constellation": "Cas",
      "RA_hour": "00",
      "RA_min": 32,
      "RA_sec": 59.9,
      "dec_deg": "+62",
      "dec_min": 55,
      "dec_sec": 55,
      "magnitude": 4.16
    },
    {
      "ID": 153,
      "greek_letter": "zet",
      "constellation": "Cas",
      "RA_hour": "00",
      "RA_min": 36,
      "RA_sec": 58.2,
      "dec_deg": "+53",
      "dec_min": 53,
      "dec_sec": 49,
      "magnitude": 3.66
    },
    {
      "ID": 154,
      "greek_letter": "pi",
      "constellation": "And",
      "RA_hour": "00",
      "RA_min": 36,
      "RA_sec": 52.8,
      "dec_deg": "+33",
      "dec_min": 43,
      "dec_sec": 10,
      "magnitude": 4.36
    },
    {
      "ID": 163,
      "greek_letter": "eps",
      "constellation": "And",
      "RA_hour": "00",
      "RA_min": 38,
      "RA_sec": 33.3,
      "dec_deg": "+29",
      "dec_min": 18,
      "dec_sec": 43,
      "magnitude": 4.38
    },
    {
      "ID": 165,
      "greek_letter": "del",
      "constellation": "And",
      "RA_hour": "00",
      "RA_min": 39,
      "RA_sec": 19.6,
      "dec_deg": "+30",
      "dec_min": 51,
      "dec_sec": 40,
      "magnitude": 3.28
    },
    {
      "ID": 168,
      "greek_letter": "alf",
      "constellation": "Cas",
      "RA_hour": "00",
      "RA_min": 40,
      "RA_sec": 30.4,
      "dec_deg": "+56",
      "dec_min": 32,
      "dec_sec": 15,
      "magnitude": 2.23
    },
    {
      "ID": 179,
      "greek_letter": "xi",
      "constellation": "Cas",
      "RA_hour": "00",
      "RA_min": 42,
      "RA_sec": "03.8",
      "dec_deg": "+50",
      "dec_min": 30,
      "dec_sec": 45,
      "magnitude": 4.81
    },
    {
      "ID": 180,
      "greek_letter": "mu",
      "constellation": "Phe",
      "RA_hour": "00",
      "RA_min": 41,
      "RA_sec": 19.5,
      "dec_deg": -46,
      "dec_min": "05",
      "dec_sec": "06",
      "magnitude": 4.59
    },
    {
      "ID": 184,
      "greek_letter": "pi",
      "constellation": "Cas",
      "RA_hour": "00",
      "RA_min": 43,
      "RA_sec": 28,
      "dec_deg": "+47",
      "dec_min": "01",
      "dec_sec": 29,
      "magnitude": 4.94
    },
    {
      "ID": 188,
      "greek_letter": "bet",
      "constellation": "Cet",
      "RA_hour": "00",
      "RA_min": 43,
      "RA_sec": 35.3,
      "dec_deg": -17,
      "dec_min": 59,
      "dec_sec": 12,
      "magnitude": 2.01
    },
    {
      "ID": 191,
      "greek_letter": "eta",
      "constellation": "Phe",
      "RA_hour": "00",
      "RA_min": 43,
      "RA_sec": 21.2,
      "dec_deg": -57,
      "dec_min": 27,
      "dec_sec": 47,
      "magnitude": 4.36
    },
    {
      "ID": 193,
      "greek_letter": "omi",
      "constellation": "Cas",
      "RA_hour": "00",
      "RA_min": 44,
      "RA_sec": 43.5,
      "dec_deg": "+48",
      "dec_min": 17,
      "dec_sec": "04",
      "magnitude": 4.5
    },
    {
      "ID": 194,
      "greek_letter": "phi1",
      "constellation": "Cet",
      "RA_hour": "00",
      "RA_min": 44,
      "RA_sec": 11.3,
      "dec_deg": -10,
      "dec_min": 36,
      "dec_sec": 34,
      "magnitude": 4.75
    },
    {
      "ID": 215,
      "greek_letter": "zet",
      "constellation": "And",
      "RA_hour": "00",
      "RA_min": 47,
      "RA_sec": 20.3,
      "dec_deg": "+24",
      "dec_min": 16,
      "dec_sec": "02",
      "magnitude": 4.06
    },
    {
      "ID": 219,
      "greek_letter": "eta",
      "constellation": "Cas",
      "RA_hour": "00",
      "RA_min": 49,
      "RA_sec": "06.0",
      "dec_deg": "+57",
      "dec_min": 48,
      "dec_sec": 58,
      "magnitude": 3.44
    },
    {
      "ID": 223,
      "greek_letter": "nu",
      "constellation": "Cas",
      "RA_hour": "00",
      "RA_min": 48,
      "RA_sec": 50,
      "dec_deg": "+50",
      "dec_min": 58,
      "dec_sec": "06",
      "magnitude": 4.89
    },
    {
      "ID": 224,
      "greek_letter": "del",
      "constellation": "Psc",
      "RA_hour": "00",
      "RA_min": 48,
      "RA_sec": 40.9,
      "dec_deg": "+07",
      "dec_min": 35,
      "dec_sec": "06",
      "magnitude": 4.44
    },
    {
      "ID": 226,
      "greek_letter": "nu",
      "constellation": "And",
      "RA_hour": "00",
      "RA_min": 49,
      "RA_sec": 48.8,
      "dec_deg": "+41",
      "dec_min": "04",
      "dec_sec": 44,
      "magnitude": 4.53
    },
    {
      "ID": 244,
      "greek_letter": "",
      "constellation": "",
      "RA_hour": "00",
      "RA_min": 53,
      "RA_sec": "04.1",
      "dec_deg": "+61",
      "dec_min": "07",
      "dec_sec": 27,
      "magnitude": 4.8
    },
    {
      "ID": 248,
      "greek_letter": "",
      "constellation": "Cet",
      "RA_hour": "00",
      "RA_min": 53,
      "RA_sec": "00.4",
      "dec_deg": "-01",
      "dec_min": "08",
      "dec_sec": 40,
      "magnitude": 4.76
    },
    {
      "ID": 253,
      "greek_letter": "ups1",
      "constellation": "Cas",
      "RA_hour": "00",
      "RA_min": 55,
      "RA_sec": "00.0",
      "dec_deg": "+58",
      "dec_min": 58,
      "dec_sec": 22,
      "magnitude": 4.84
    },
    {
      "ID": 264,
      "greek_letter": "gam",
      "constellation": "Cas",
      "RA_hour": "00",
      "RA_min": 56,
      "RA_sec": 42.4,
      "dec_deg": "+60",
      "dec_min": 43,
      "dec_sec": "00",
      "magnitude": 2.47
    },
    {
      "ID": 265,
      "greek_letter": "ups2",
      "constellation": "Cas",
      "RA_hour": "00",
      "RA_min": 56,
      "RA_sec": 39.7,
      "dec_deg": "+59",
      "dec_min": 10,
      "dec_sec": 52,
      "magnitude": 4.64
    },
    {
      "ID": 269,
      "greek_letter": "mu",
      "constellation": "And",
      "RA_hour": "00",
      "RA_min": 56,
      "RA_sec": 45.1,
      "dec_deg": "+38",
      "dec_min": 29,
      "dec_sec": 58,
      "magnitude": 3.87
    },
    {
      "ID": 271,
      "greek_letter": "eta",
      "constellation": "And",
      "RA_hour": "00",
      "RA_min": 57,
      "RA_sec": 12.4,
      "dec_deg": "+23",
      "dec_min": 25,
      "dec_sec": "04",
      "magnitude": 4.42
    },
    {
      "ID": 280,
      "greek_letter": "alf",
      "constellation": "Scl",
      "RA_hour": "00",
      "RA_min": 58,
      "RA_sec": 36.3,
      "dec_deg": -29,
      "dec_min": 21,
      "dec_sec": 28,
      "magnitude": 4.27
    },
    {
      "ID": 285,
      "greek_letter": "",
      "constellation": "",
      "RA_hour": "01",
      "RA_min": "08",
      "RA_sec": 44.9,
      "dec_deg": "+86",
      "dec_min": 15,
      "dec_sec": 26,
      "magnitude": 4.26
    },
    {
      "ID": 294,
      "greek_letter": "eps",
      "constellation": "Psc",
      "RA_hour": "01",
      "RA_min": "02",
      "RA_sec": 56.5,
      "dec_deg": "+07",
      "dec_min": 53,
      "dec_sec": 24,
      "magnitude": 4.28
    },
    {
      "ID": 322,
      "greek_letter": "bet",
      "constellation": "Phe",
      "RA_hour": "01",
      "RA_min": "06",
      "RA_sec": "05.0",
      "dec_deg": -46,
      "dec_min": 43,
      "dec_sec": "08",
      "magnitude": 3.3
    },
    {
      "ID": 334,
      "greek_letter": "eta",
      "constellation": "Cet",
      "RA_hour": "01",
      "RA_min": "08",
      "RA_sec": 35.3,
      "dec_deg": -10,
      "dec_min": 10,
      "dec_sec": 56,
      "magnitude": 3.44
    },
    {
      "ID": 335,
      "greek_letter": "phi",
      "constellation": "And",
      "RA_hour": "01",
      "RA_min": "09",
      "RA_sec": 30.1,
      "dec_deg": "+47",
      "dec_min": 14,
      "dec_sec": 31,
      "magnitude": 4.25
    },
    {
      "ID": 337,
      "greek_letter": "bet",
      "constellation": "And",
      "RA_hour": "01",
      "RA_min": "09",
      "RA_sec": 43.9,
      "dec_deg": "+35",
      "dec_min": 37,
      "dec_sec": 14,
      "magnitude": 2.05
    },
    {
      "ID": 338,
      "greek_letter": "zet",
      "constellation": "Phe",
      "RA_hour": "01",
      "RA_min": "08",
      "RA_sec": 23,
      "dec_deg": -55,
      "dec_min": 14,
      "dec_sec": 45,
      "magnitude": 3.92
    },
    {
      "ID": 343,
      "greek_letter": "tet",
      "constellation": "Cas",
      "RA_hour": "01",
      "RA_min": 11,
      "RA_sec": "06.1",
      "dec_deg": "+55",
      "dec_min": "09",
      "dec_sec": "00",
      "magnitude": 4.34
    },
    {
      "ID": 351,
      "greek_letter": "chi",
      "constellation": "Psc",
      "RA_hour": "01",
      "RA_min": 11,
      "RA_sec": 27.1,
      "dec_deg": "+21",
      "dec_min": "02",
      "dec_sec": "05",
      "magnitude": 4.66
    },
    {
      "ID": 352,
      "greek_letter": "tau",
      "constellation": "Psc",
      "RA_hour": "01",
      "RA_min": 11,
      "RA_sec": 39.6,
      "dec_deg": "+30",
      "dec_min": "05",
      "dec_sec": 23,
      "magnitude": 4.51
    },
    {
      "ID": 360,
      "greek_letter": "phi",
      "constellation": "Psc",
      "RA_hour": "01",
      "RA_min": 13,
      "RA_sec": 44.8,
      "dec_deg": "+24",
      "dec_min": 35,
      "dec_sec": "01",
      "magnitude": 4.66
    },
    {
      "ID": 370,
      "greek_letter": "nu",
      "constellation": "Phe",
      "RA_hour": "01",
      "RA_min": 15,
      "RA_sec": 11.1,
      "dec_deg": -45,
      "dec_min": 31,
      "dec_sec": 54,
      "magnitude": 4.96
    },
    {
      "ID": 377,
      "greek_letter": "kap",
      "constellation": "Tuc",
      "RA_hour": "01",
      "RA_min": 15,
      "RA_sec": 46.2,
      "dec_deg": -68,
      "dec_min": 52,
      "dec_sec": 34,
      "magnitude": 4.86
    },
    {
      "ID": 382,
      "greek_letter": "phi",
      "constellation": "Cas",
      "RA_hour": "01",
      "RA_min": 20,
      "RA_sec": "04.8",
      "dec_deg": "+58",
      "dec_min": 13,
      "dec_sec": 54,
      "magnitude": 4.99
    },
    {
      "ID": 383,
      "greek_letter": "ups",
      "constellation": "Psc",
      "RA_hour": "01",
      "RA_min": 19,
      "RA_sec": 27.9,
      "dec_deg": "+27",
      "dec_min": 15,
      "dec_sec": 51,
      "magnitude": 4.76
    },
    {
      "ID": 390,
      "greek_letter": "xi",
      "constellation": "And",
      "RA_hour": "01",
      "RA_min": 22,
      "RA_sec": 20.3,
      "dec_deg": "+45",
      "dec_min": 31,
      "dec_sec": 44,
      "magnitude": 4.9
    },
    {
      "ID": 399,
      "greek_letter": "psi",
      "constellation": "Cas",
      "RA_hour": "01",
      "RA_min": 25,
      "RA_sec": 56,
      "dec_deg": "+68",
      "dec_min": "07",
      "dec_sec": 48,
      "magnitude": 4.74
    },
    {
      "ID": 402,
      "greek_letter": "tet",
      "constellation": "Cet",
      "RA_hour": "01",
      "RA_min": 24,
      "RA_sec": "01.3",
      "dec_deg": "-08",
      "dec_min": 11,
      "dec_sec": "01",
      "magnitude": 3.59
    },
    {
      "ID": 403,
      "greek_letter": "del",
      "constellation": "Cas",
      "RA_hour": "01",
      "RA_min": 25,
      "RA_sec": 48.9,
      "dec_deg": "+60",
      "dec_min": 14,
      "dec_sec": "07",
      "magnitude": 2.68
    },
    {
      "ID": 412,
      "greek_letter": "",
      "constellation": "Cet",
      "RA_hour": "01",
      "RA_min": 25,
      "RA_sec": 37.1,
      "dec_deg": -14,
      "dec_min": 35,
      "dec_sec": 56,
      "magnitude": 4.9
    },
    {
      "ID": 417,
      "greek_letter": "omg",
      "constellation": "And",
      "RA_hour": "01",
      "RA_min": 27,
      "RA_sec": 39.2,
      "dec_deg": "+45",
      "dec_min": 24,
      "dec_sec": 25,
      "magnitude": 4.82
    },
    {
      "ID": 424,
      "greek_letter": "alf",
      "constellation": "UMi",
      "RA_hour": "02",
      "RA_min": 31,
      "RA_sec": 50.5,
      "dec_deg": "+89",
      "dec_min": 15,
      "dec_sec": 51,
      "magnitude": 2.02
    },
    {
      "ID": 429,
      "greek_letter": "gam",
      "constellation": "Phe",
      "RA_hour": "01",
      "RA_min": 28,
      "RA_sec": 21.9,
      "dec_deg": -43,
      "dec_min": 19,
      "dec_sec": "06",
      "magnitude": 3.41
    },
    {
      "ID": 434,
      "greek_letter": "mu",
      "constellation": "Psc",
      "RA_hour": "01",
      "RA_min": 30,
      "RA_sec": 11.1,
      "dec_deg": "+06",
      "dec_min": "08",
      "dec_sec": 38,
      "magnitude": 4.84
    },
    {
      "ID": 437,
      "greek_letter": "eta",
      "constellation": "Psc",
      "RA_hour": "01",
      "RA_min": 31,
      "RA_sec": 28.9,
      "dec_deg": "+15",
      "dec_min": 20,
      "dec_sec": 45,
      "magnitude": 3.62
    },
    {
      "ID": 440,
      "greek_letter": "del",
      "constellation": "Phe",
      "RA_hour": "01",
      "RA_min": 31,
      "RA_sec": 15,
      "dec_deg": -49,
      "dec_min": "04",
      "dec_sec": 22,
      "magnitude": 3.95
    },
    {
      "ID": 442,
      "greek_letter": "chi",
      "constellation": "Cas",
      "RA_hour": "01",
      "RA_min": 33,
      "RA_sec": 55.9,
      "dec_deg": "+59",
      "dec_min": 13,
      "dec_sec": 56,
      "magnitude": 4.72
    },
    {
      "ID": 458,
      "greek_letter": "ups",
      "constellation": "And",
      "RA_hour": "01",
      "RA_min": 36,
      "RA_sec": 47.8,
      "dec_deg": "+41",
      "dec_min": 24,
      "dec_sec": 20,
      "magnitude": 4.1
    },
    {
      "ID": 464,
      "greek_letter": "",
      "constellation": "And",
      "RA_hour": "01",
      "RA_min": 37,
      "RA_sec": 59.5,
      "dec_deg": "+48",
      "dec_min": 37,
      "dec_sec": 42,
      "magnitude": 3.57
    },
    {
      "ID": 469,
      "greek_letter": "chi",
      "constellation": "And",
      "RA_hour": "01",
      "RA_min": 39,
      "RA_sec": 20.9,
      "dec_deg": "+44",
      "dec_min": 23,
      "dec_sec": 10,
      "magnitude": 4.98
    },
    {
      "ID": 472,
      "greek_letter": "alf",
      "constellation": "Eri",
      "RA_hour": "01",
      "RA_min": 37,
      "RA_sec": 42.9,
      "dec_deg": -57,
      "dec_min": 14,
      "dec_sec": 12,
      "magnitude": 0.46
    },
    {
      "ID": 477,
      "greek_letter": "tau",
      "constellation": "And",
      "RA_hour": "01",
      "RA_min": 40,
      "RA_sec": 34.7,
      "dec_deg": "+40",
      "dec_min": 34,
      "dec_sec": 37,
      "magnitude": 4.94
    },
    {
      "ID": 483,
      "greek_letter": "",
      "constellation": "",
      "RA_hour": "01",
      "RA_min": 41,
      "RA_sec": 47.1,
      "dec_deg": "+42",
      "dec_min": 36,
      "dec_sec": 49,
      "magnitude": 4.96
    },
    {
      "ID": 489,
      "greek_letter": "nu",
      "constellation": "Psc",
      "RA_hour": "01",
      "RA_min": 41,
      "RA_sec": 25.8,
      "dec_deg": "+05",
      "dec_min": 29,
      "dec_sec": 15,
      "magnitude": 4.44
    },
    {
      "ID": 496,
      "greek_letter": "phi",
      "constellation": "Per",
      "RA_hour": "01",
      "RA_min": 43,
      "RA_sec": 39.6,
      "dec_deg": "+50",
      "dec_min": 41,
      "dec_sec": 20,
      "magnitude": 4.06
    },
    {
      "ID": 500,
      "greek_letter": "",
      "constellation": "",
      "RA_hour": "01",
      "RA_min": 42,
      "RA_sec": 43.4,
      "dec_deg": "-03",
      "dec_min": 41,
      "dec_sec": 25,
      "magnitude": 5
    },
    {
      "ID": 509,
      "greek_letter": "tau",
      "constellation": "Cet",
      "RA_hour": "01",
      "RA_min": 44,
      "RA_sec": "04.0",
      "dec_deg": -15,
      "dec_min": 56,
      "dec_sec": 15,
      "magnitude": 3.5
    },
    {
      "ID": 510,
      "greek_letter": "omi",
      "constellation": "Psc",
      "RA_hour": "01",
      "RA_min": 45,
      "RA_sec": 23.6,
      "dec_deg": "+09",
      "dec_min": "09",
      "dec_sec": 28,
      "magnitude": 4.26
    },
    {
      "ID": 531,
      "greek_letter": "chi",
      "constellation": "Cet",
      "RA_hour": "01",
      "RA_min": 49,
      "RA_sec": 35,
      "dec_deg": -10,
      "dec_min": 41,
      "dec_sec": 11,
      "magnitude": 4.68
    },
    {
      "ID": 539,
      "greek_letter": "zet",
      "constellation": "Cet",
      "RA_hour": "01",
      "RA_min": 51,
      "RA_sec": 27.5,
      "dec_deg": -10,
      "dec_min": 20,
      "dec_sec": "06",
      "magnitude": 3.72
    },
    {
      "ID": 542,
      "greek_letter": "eps",
      "constellation": "Cas",
      "RA_hour": "01",
      "RA_min": 54,
      "RA_sec": 23.6,
      "dec_deg": "+63",
      "dec_min": 40,
      "dec_sec": 13,
      "magnitude": 3.37
    },
    {
      "ID": 544,
      "greek_letter": "alf",
      "constellation": "Tri",
      "RA_hour": "01",
      "RA_min": 53,
      "RA_sec": "04.8",
      "dec_deg": "+29",
      "dec_min": 34,
      "dec_sec": 44,
      "magnitude": 3.42
    },
    {
      "ID": 545,
      "greek_letter": "gam1",
      "constellation": "Ari",
      "RA_hour": "01",
      "RA_min": 53,
      "RA_sec": 31.7,
      "dec_deg": "+19",
      "dec_min": 17,
      "dec_sec": 45,
      "magnitude": 4.83
    },
    {
      "ID": 546,
      "greek_letter": "gam2",
      "constellation": "Ari",
      "RA_hour": "01",
      "RA_min": 53,
      "RA_sec": 31.8,
      "dec_deg": "+19",
      "dec_min": 17,
      "dec_sec": 37,
      "magnitude": 4.75
    },
    {
      "ID": 548,
      "greek_letter": "omg",
      "constellation": "Cas",
      "RA_hour": "01",
      "RA_min": 55,
      "RA_sec": 59.9,
      "dec_deg": "+68",
      "dec_min": 41,
      "dec_sec": "07",
      "magnitude": 4.99
    },
    {
      "ID": 549,
      "greek_letter": "xi",
      "constellation": "Psc",
      "RA_hour": "01",
      "RA_min": 53,
      "RA_sec": 33.3,
      "dec_deg": "+03",
      "dec_min": 11,
      "dec_sec": 15,
      "magnitude": 4.63
    },
    {
      "ID": 553,
      "greek_letter": "bet",
      "constellation": "Ari",
      "RA_hour": "01",
      "RA_min": 54,
      "RA_sec": 38.3,
      "dec_deg": "+20",
      "dec_min": 48,
      "dec_sec": 29,
      "magnitude": 2.65
    },
    {
      "ID": 555,
      "greek_letter": "psi",
      "constellation": "Phe",
      "RA_hour": "01",
      "RA_min": 53,
      "RA_sec": 38.7,
      "dec_deg": -46,
      "dec_min": 18,
      "dec_sec": 10,
      "magnitude": 4.41
    },
    {
      "ID": 565,
      "greek_letter": "",
      "constellation": "Cet",
      "RA_hour": "01",
      "RA_min": 56,
      "RA_sec": 40.1,
      "dec_deg": -22,
      "dec_min": 31,
      "dec_sec": 36,
      "magnitude": 4.85
    },
    {
      "ID": 566,
      "greek_letter": "chi",
      "constellation": "Eri",
      "RA_hour": "01",
      "RA_min": 55,
      "RA_sec": 57.4,
      "dec_deg": -51,
      "dec_min": 36,
      "dec_sec": 32,
      "magnitude": 3.7
    },
    {
      "ID": 569,
      "greek_letter": "lam",
      "constellation": "Ari",
      "RA_hour": "01",
      "RA_min": 57,
      "RA_sec": 55.7,
      "dec_deg": "+23",
      "dec_min": 35,
      "dec_sec": 46,
      "magnitude": 4.79
    },
    {
      "ID": 570,
      "greek_letter": "eta2",
      "constellation": "Hyi",
      "RA_hour": "01",
      "RA_min": 54,
      "RA_sec": 56.1,
      "dec_deg": -67,
      "dec_min": 38,
      "dec_sec": 51,
      "magnitude": 4.69
    },
    {
      "ID": 574,
      "greek_letter": "",
      "constellation": "",
      "RA_hour": "01",
      "RA_min": 57,
      "RA_sec": 10,
      "dec_deg": -47,
      "dec_min": 23,
      "dec_sec": "06",
      "magnitude": 4.82
    },
    {
      "ID": 575,
      "greek_letter": "",
      "constellation": "Cas",
      "RA_hour": "02",
      "RA_min": "01",
      "RA_sec": 57.3,
      "dec_deg": "+70",
      "dec_min": 54,
      "dec_sec": 26,
      "magnitude": 4.54
    },
    {
      "ID": 580,
      "greek_letter": "",
      "constellation": "Cas",
      "RA_hour": "02",
      "RA_min": "03",
      "RA_sec": 26,
      "dec_deg": "+72",
      "dec_min": 25,
      "dec_sec": 17,
      "magnitude": 3.98
    },
    {
      "ID": 585,
      "greek_letter": "ups",
      "constellation": "Cet",
      "RA_hour": "02",
      "RA_min": "00",
      "RA_sec": "00.2",
      "dec_deg": -21,
      "dec_min": "04",
      "dec_sec": 40,
      "magnitude": 4.02
    },
    {
      "ID": 591,
      "greek_letter": "alf",
      "constellation": "Hyi",
      "RA_hour": "01",
      "RA_min": 58,
      "RA_sec": 46.2,
      "dec_deg": -61,
      "dec_min": 34,
      "dec_sec": 12,
      "magnitude": 2.86
    },
    {
      "ID": 596,
      "greek_letter": "alf",
      "constellation": "Psc",
      "RA_hour": "02",
      "RA_min": "02",
      "RA_sec": "02.7",
      "dec_deg": "+02",
      "dec_min": 45,
      "dec_sec": 49,
      "magnitude": 4.33
    },
    {
      "ID": 603,
      "greek_letter": "gam1",
      "constellation": "And",
      "RA_hour": "02",
      "RA_min": "03",
      "RA_sec": 53.9,
      "dec_deg": "+42",
      "dec_min": 19,
      "dec_sec": 47,
      "magnitude": 2.26
    },
    {
      "ID": 604,
      "greek_letter": "gam2",
      "constellation": "And",
      "RA_hour": "02",
      "RA_min": "03",
      "RA_sec": 54.7,
      "dec_deg": "+42",
      "dec_min": 19,
      "dec_sec": 51,
      "magnitude": 4.84
    },
    {
      "ID": 612,
      "greek_letter": "nu",
      "constellation": "For",
      "RA_hour": "02",
      "RA_min": "04",
      "RA_sec": 29.4,
      "dec_deg": -29,
      "dec_min": 17,
      "dec_sec": 49,
      "magnitude": 4.69
    },
    {
      "ID": 617,
      "greek_letter": "alf",
      "constellation": "Ari",
      "RA_hour": "02",
      "RA_min": "07",
      "RA_sec": 10.3,
      "dec_deg": "+23",
      "dec_min": 27,
      "dec_sec": 45,
      "magnitude": 2.01
    },
    {
      "ID": 620,
      "greek_letter": "",
      "constellation": "And",
      "RA_hour": "02",
      "RA_min": "08",
      "RA_sec": 29.2,
      "dec_deg": "+37",
      "dec_min": 51,
      "dec_sec": 33,
      "magnitude": 4.83
    },
    {
      "ID": 622,
      "greek_letter": "bet",
      "constellation": "Tri",
      "RA_hour": "02",
      "RA_min": "09",
      "RA_sec": 32.5,
      "dec_deg": "+34",
      "dec_min": 59,
      "dec_sec": 14,
      "magnitude": 3
    },
    {
      "ID": 623,
      "greek_letter": "",
      "constellation": "Ari",
      "RA_hour": "02",
      "RA_min": "09",
      "RA_sec": 25.3,
      "dec_deg": "+25",
      "dec_min": 56,
      "dec_sec": 24,
      "magnitude": 4.98
    },
    {
      "ID": 642,
      "greek_letter": "",
      "constellation": "Tri",
      "RA_hour": "02",
      "RA_min": 12,
      "RA_sec": 22.2,
      "dec_deg": "+30",
      "dec_min": 18,
      "dec_sec": 11,
      "magnitude": 4.94
    },
    {
      "ID": 643,
      "greek_letter": "",
      "constellation": "And",
      "RA_hour": "02",
      "RA_min": 13,
      "RA_sec": 13.2,
      "dec_deg": "+44",
      "dec_min": 13,
      "dec_sec": 55,
      "magnitude": 4.83
    },
    {
      "ID": 649,
      "greek_letter": "xi1",
      "constellation": "Cet",
      "RA_hour": "02",
      "RA_min": 12,
      "RA_sec": 59.9,
      "dec_deg": "+08",
      "dec_min": 50,
      "dec_sec": 48,
      "magnitude": 4.35
    },
    {
      "ID": 660,
      "greek_letter": "del",
      "constellation": "Tri",
      "RA_hour": "02",
      "RA_min": 17,
      "RA_sec": "03.2",
      "dec_deg": "+34",
      "dec_min": 13,
      "dec_sec": 28,
      "magnitude": 4.87
    },
    {
      "ID": 664,
      "greek_letter": "gam",
      "constellation": "Tri",
      "RA_hour": "02",
      "RA_min": 17,
      "RA_sec": 18.8,
      "dec_deg": "+33",
      "dec_min": 50,
      "dec_sec": 50,
      "magnitude": 4.01
    },
    {
      "ID": 674,
      "greek_letter": "phi",
      "constellation": "Eri",
      "RA_hour": "02",
      "RA_min": 16,
      "RA_sec": 30.6,
      "dec_deg": -51,
      "dec_min": 30,
      "dec_sec": 44,
      "magnitude": 3.56
    },
    {
      "ID": 681,
      "greek_letter": "omi",
      "constellation": "Cet",
      "RA_hour": "02",
      "RA_min": 19,
      "RA_sec": 20.7,
      "dec_deg": "-02",
      "dec_min": 58,
      "dec_sec": 39,
      "magnitude": 3.05
    },
    {
      "ID": 699,
      "greek_letter": "",
      "constellation": "And",
      "RA_hour": "02",
      "RA_min": 25,
      "RA_sec": 37.3,
      "dec_deg": "+50",
      "dec_min": 16,
      "dec_sec": 43,
      "magnitude": 4.7
    },
    {
      "ID": 705,
      "greek_letter": "del",
      "constellation": "Hyi",
      "RA_hour": "02",
      "RA_min": 21,
      "RA_sec": 45.1,
      "dec_deg": -68,
      "dec_min": 39,
      "dec_sec": 34,
      "magnitude": 4.09
    },
    {
      "ID": 707,
      "greek_letter": "iot",
      "constellation": "Cas",
      "RA_hour": "02",
      "RA_min": 29,
      "RA_sec": "03.9",
      "dec_deg": "+67",
      "dec_min": 24,
      "dec_sec": "09",
      "magnitude": 4.53
    },
    {
      "ID": 708,
      "greek_letter": "ro",
      "constellation": "Cet",
      "RA_hour": "02",
      "RA_min": 25,
      "RA_sec": 56.9,
      "dec_deg": -12,
      "dec_min": 17,
      "dec_sec": 26,
      "magnitude": 4.89
    },
    {
      "ID": 718,
      "greek_letter": "xi2",
      "constellation": "Cet",
      "RA_hour": "02",
      "RA_min": 28,
      "RA_sec": "09.5",
      "dec_deg": "+08",
      "dec_min": 27,
      "dec_sec": 36,
      "magnitude": 4.3
    },
    {
      "ID": 721,
      "greek_letter": "kap",
      "constellation": "Eri",
      "RA_hour": "02",
      "RA_min": 26,
      "RA_sec": 59.1,
      "dec_deg": -47,
      "dec_min": 42,
      "dec_sec": 14,
      "magnitude": 4.25
    },
    {
      "ID": 740,
      "greek_letter": "sig",
      "constellation": "Cet",
      "RA_hour": "02",
      "RA_min": 32,
      "RA_sec": "05.1",
      "dec_deg": -15,
      "dec_min": 14,
      "dec_sec": 41,
      "magnitude": 4.75
    },
    {
      "ID": 749,
      "greek_letter": "omg",
      "constellation": "For",
      "RA_hour": "02",
      "RA_min": 33,
      "RA_sec": 50.6,
      "dec_deg": -28,
      "dec_min": 13,
      "dec_sec": 57,
      "magnitude": 4.89
    },
    {
      "ID": 754,
      "greek_letter": "nu",
      "constellation": "Cet",
      "RA_hour": "02",
      "RA_min": 35,
      "RA_sec": 52.4,
      "dec_deg": "+05",
      "dec_min": 35,
      "dec_sec": 36,
      "magnitude": 4.86
    },
    {
      "ID": 779,
      "greek_letter": "del",
      "constellation": "Cet",
      "RA_hour": "02",
      "RA_min": 39,
      "RA_sec": 28.9,
      "dec_deg": "+00",
      "dec_min": 19,
      "dec_sec": 43,
      "magnitude": 4.06
    },
    {
      "ID": 781,
      "greek_letter": "eps",
      "constellation": "Cet",
      "RA_hour": "02",
      "RA_min": 39,
      "RA_sec": 33.7,
      "dec_deg": -11,
      "dec_min": 52,
      "dec_sec": 20,
      "magnitude": 4.84
    },
    {
      "ID": 788,
      "greek_letter": "",
      "constellation": "Per",
      "RA_hour": "02",
      "RA_min": 42,
      "RA_sec": 14.9,
      "dec_deg": "+40",
      "dec_min": 11,
      "dec_sec": 38,
      "magnitude": 4.92
    },
    {
      "ID": 789,
      "greek_letter": "",
      "constellation": "",
      "RA_hour": "02",
      "RA_min": 39,
      "RA_sec": 47.9,
      "dec_deg": -42,
      "dec_min": 53,
      "dec_sec": 30,
      "magnitude": 4.75
    },
    {
      "ID": 794,
      "greek_letter": "iot",
      "constellation": "Eri",
      "RA_hour": "02",
      "RA_min": 40,
      "RA_sec": 40,
      "dec_deg": -39,
      "dec_min": 51,
      "dec_sec": 19,
      "magnitude": 4.11
    },
    {
      "ID": 799,
      "greek_letter": "tet",
      "constellation": "Per",
      "RA_hour": "02",
      "RA_min": 44,
      "RA_sec": 11.9,
      "dec_deg": "+49",
      "dec_min": 13,
      "dec_sec": 43,
      "magnitude": 4.13
    },
    {
      "ID": 801,
      "greek_letter": "",
      "constellation": "Ari",
      "RA_hour": "02",
      "RA_min": 43,
      "RA_sec": 27,
      "dec_deg": "+27",
      "dec_min": 42,
      "dec_sec": 26,
      "magnitude": 4.67
    },
    {
      "ID": 804,
      "greek_letter": "gam",
      "constellation": "Cet",
      "RA_hour": "02",
      "RA_min": 43,
      "RA_sec": 18,
      "dec_deg": "+03",
      "dec_min": 14,
      "dec_sec": "09",
      "magnitude": 3.47
    },
    {
      "ID": 806,
      "greek_letter": "eps",
      "constellation": "Hyi",
      "RA_hour": "02",
      "RA_min": 39,
      "RA_sec": 35.5,
      "dec_deg": -68,
      "dec_min": 16,
      "dec_sec": "01",
      "magnitude": 4.11
    },
    {
      "ID": 811,
      "greek_letter": "pi",
      "constellation": "Cet",
      "RA_hour": "02",
      "RA_min": 44,
      "RA_sec": "07.3",
      "dec_deg": -13,
      "dec_min": 51,
      "dec_sec": 32,
      "magnitude": 4.24
    },
    {
      "ID": 813,
      "greek_letter": "mu",
      "constellation": "Cet",
      "RA_hour": "02",
      "RA_min": 44,
      "RA_sec": 56.5,
      "dec_deg": "+10",
      "dec_min": "06",
      "dec_sec": 51,
      "magnitude": 4.27
    },
    {
      "ID": 818,
      "greek_letter": "tau1",
      "constellation": "Eri",
      "RA_hour": "02",
      "RA_min": 45,
      "RA_sec": "06.1",
      "dec_deg": -18,
      "dec_min": 34,
      "dec_sec": 21,
      "magnitude": 4.46
    },
    {
      "ID": 824,
      "greek_letter": "",
      "constellation": "Ari",
      "RA_hour": "02",
      "RA_min": 47,
      "RA_sec": 54.5,
      "dec_deg": "+29",
      "dec_min": 14,
      "dec_sec": 50,
      "magnitude": 4.52
    },
    {
      "ID": 834,
      "greek_letter": "eta",
      "constellation": "Per",
      "RA_hour": "02",
      "RA_min": 50,
      "RA_sec": 41.8,
      "dec_deg": "+55",
      "dec_min": 53,
      "dec_sec": 44,
      "magnitude": 3.79
    },
    {
      "ID": 837,
      "greek_letter": "zet",
      "constellation": "Hyi",
      "RA_hour": "02",
      "RA_min": 45,
      "RA_sec": 32.6,
      "dec_deg": -67,
      "dec_min": 37,
      "dec_sec": "00",
      "magnitude": 4.84
    },
    {
      "ID": 838,
      "greek_letter": "",
      "constellation": "Ari",
      "RA_hour": "02",
      "RA_min": 49,
      "RA_sec": 59,
      "dec_deg": "+27",
      "dec_min": 15,
      "dec_sec": 38,
      "magnitude": 3.62
    },
    {
      "ID": 840,
      "greek_letter": "",
      "constellation": "Per",
      "RA_hour": "02",
      "RA_min": 50,
      "RA_sec": 34.9,
      "dec_deg": "+38",
      "dec_min": 19,
      "dec_sec": "07",
      "magnitude": 4.23
    },
    {
      "ID": 841,
      "greek_letter": "bet",
      "constellation": "For",
      "RA_hour": "02",
      "RA_min": 49,
      "RA_sec": "05.4",
      "dec_deg": -32,
      "dec_min": 24,
      "dec_sec": 22,
      "magnitude": 4.46
    },
    {
      "ID": 843,
      "greek_letter": "",
      "constellation": "Per",
      "RA_hour": "02",
      "RA_min": 51,
      "RA_sec": 30.8,
      "dec_deg": "+35",
      "dec_min": "03",
      "dec_sec": 35,
      "magnitude": 4.53
    },
    {
      "ID": 850,
      "greek_letter": "tau2",
      "constellation": "Eri",
      "RA_hour": "02",
      "RA_min": 51,
      "RA_sec": "02.2",
      "dec_deg": -21,
      "dec_min": "00",
      "dec_sec": 15,
      "magnitude": 4.77
    },
    {
      "ID": 854,
      "greek_letter": "tau",
      "constellation": "Per",
      "RA_hour": "02",
      "RA_min": 54,
      "RA_sec": 15.4,
      "dec_deg": "+52",
      "dec_min": 45,
      "dec_sec": 45,
      "magnitude": 3.96
    },
    {
      "ID": 868,
      "greek_letter": "",
      "constellation": "",
      "RA_hour": "02",
      "RA_min": 53,
      "RA_sec": 52.8,
      "dec_deg": -49,
      "dec_min": 53,
      "dec_sec": 25,
      "magnitude": 3.92
    },
    {
      "ID": 872,
      "greek_letter": "nu",
      "constellation": "Hyi",
      "RA_hour": "02",
      "RA_min": 50,
      "RA_sec": 28.7,
      "dec_deg": -75,
      "dec_min": "04",
      "dec_sec": "01",
      "magnitude": 4.75
    },
    {
      "ID": 874,
      "greek_letter": "eta",
      "constellation": "Eri",
      "RA_hour": "02",
      "RA_min": 56,
      "RA_sec": 25.6,
      "dec_deg": "-08",
      "dec_min": 53,
      "dec_sec": 53,
      "magnitude": 3.87
    },
    {
      "ID": 879,
      "greek_letter": "pi",
      "constellation": "Per",
      "RA_hour": "02",
      "RA_min": 58,
      "RA_sec": 45.6,
      "dec_deg": "+39",
      "dec_min": 39,
      "dec_sec": 46,
      "magnitude": 4.7
    },
    {
      "ID": 882,
      "greek_letter": "",
      "constellation": "Per",
      "RA_hour": "02",
      "RA_min": 59,
      "RA_sec": "03.6",
      "dec_deg": "+35",
      "dec_min": 10,
      "dec_sec": 59,
      "magnitude": 4.94
    },
    {
      "ID": 887,
      "greek_letter": "eps",
      "constellation": "Ari",
      "RA_hour": "02",
      "RA_min": 59,
      "RA_sec": 12.6,
      "dec_deg": "+21",
      "dec_min": 20,
      "dec_sec": 25,
      "magnitude": 4.63
    },
    {
      "ID": 888,
      "greek_letter": "eps",
      "constellation": "Ari",
      "RA_hour": "02",
      "RA_min": 59,
      "RA_sec": 12.6,
      "dec_deg": "+21",
      "dec_min": 20,
      "dec_sec": 25,
      "magnitude": 4.64
    },
    {
      "ID": 896,
      "greek_letter": "lam",
      "constellation": "Cet",
      "RA_hour": "02",
      "RA_min": 59,
      "RA_sec": 42.8,
      "dec_deg": "+08",
      "dec_min": 54,
      "dec_sec": 27,
      "magnitude": 4.7
    },
    {
      "ID": 897,
      "greek_letter": "tet1",
      "constellation": "Eri",
      "RA_hour": "02",
      "RA_min": 58,
      "RA_sec": 15.6,
      "dec_deg": -40,
      "dec_min": 18,
      "dec_sec": 17,
      "magnitude": 3.42
    },
    {
      "ID": 898,
      "greek_letter": "tet2",
      "constellation": "Eri",
      "RA_hour": "02",
      "RA_min": 58,
      "RA_sec": 16.2,
      "dec_deg": -40,
      "dec_min": 18,
      "dec_sec": 16,
      "magnitude": 4.42
    },
    {
      "ID": 909,
      "greek_letter": "bet",
      "constellation": "Hor",
      "RA_hour": "02",
      "RA_min": 58,
      "RA_sec": 47.8,
      "dec_deg": -64,
      "dec_min": "04",
      "dec_sec": 16,
      "magnitude": 4.99
    },
    {
      "ID": 911,
      "greek_letter": "alf",
      "constellation": "Cet",
      "RA_hour": "03",
      "RA_min": "02",
      "RA_sec": 16.7,
      "dec_deg": "+04",
      "dec_min": "05",
      "dec_sec": 23,
      "magnitude": 2.53
    },
    {
      "ID": 915,
      "greek_letter": "gam",
      "constellation": "Per",
      "RA_hour": "03",
      "RA_min": "04",
      "RA_sec": 47.7,
      "dec_deg": "+53",
      "dec_min": 30,
      "dec_sec": 23,
      "magnitude": 2.93
    },
    {
      "ID": 918,
      "greek_letter": "",
      "constellation": "",
      "RA_hour": "03",
      "RA_min": "05",
      "RA_sec": 32.4,
      "dec_deg": "+56",
      "dec_min": 42,
      "dec_sec": 21,
      "magnitude": 4.76
    },
    {
      "ID": 919,
      "greek_letter": "tau3",
      "constellation": "Eri",
      "RA_hour": "03",
      "RA_min": "02",
      "RA_sec": 23.5,
      "dec_deg": -23,
      "dec_min": 37,
      "dec_sec": 28,
      "magnitude": 4.09
    },
    {
      "ID": 921,
      "greek_letter": "ro",
      "constellation": "Per",
      "RA_hour": "03",
      "RA_min": "05",
      "RA_sec": 10.5,
      "dec_deg": "+38",
      "dec_min": 50,
      "dec_sec": 25,
      "magnitude": 3.39
    },
    {
      "ID": 932,
      "greek_letter": "",
      "constellation": "",
      "RA_hour": "03",
      "RA_min": 11,
      "RA_sec": 56.3,
      "dec_deg": "+74",
      "dec_min": 23,
      "dec_sec": 37,
      "magnitude": 4.88
    },
    {
      "ID": 936,
      "greek_letter": "bet",
      "constellation": "Per",
      "RA_hour": "03",
      "RA_min": "08",
      "RA_sec": 10.1,
      "dec_deg": "+40",
      "dec_min": 57,
      "dec_sec": 21,
      "magnitude": 2.12
    },
    {
      "ID": 937,
      "greek_letter": "iot",
      "constellation": "Per",
      "RA_hour": "03",
      "RA_min": "09",
      "RA_sec": "04.0",
      "dec_deg": "+49",
      "dec_min": 36,
      "dec_sec": 48,
      "magnitude": 4.05
    },
    {
      "ID": 941,
      "greek_letter": "kap",
      "constellation": "Per",
      "RA_hour": "03",
      "RA_min": "09",
      "RA_sec": 29.7,
      "dec_deg": "+44",
      "dec_min": 51,
      "dec_sec": 27,
      "magnitude": 3.81
    },
    {
      "ID": 947,
      "greek_letter": "omg",
      "constellation": "Per",
      "RA_hour": "03",
      "RA_min": 11,
      "RA_sec": 17.3,
      "dec_deg": "+39",
      "dec_min": 36,
      "dec_sec": 42,
      "magnitude": 4.64
    },
    {
      "ID": 951,
      "greek_letter": "del",
      "constellation": "Ari",
      "RA_hour": "03",
      "RA_min": 11,
      "RA_sec": 37.7,
      "dec_deg": "+19",
      "dec_min": 43,
      "dec_sec": 36,
      "magnitude": 4.37
    },
    {
      "ID": 963,
      "greek_letter": "alf",
      "constellation": "For",
      "RA_hour": "03",
      "RA_min": 12,
      "RA_sec": "04.2",
      "dec_deg": -28,
      "dec_min": 59,
      "dec_sec": 14,
      "magnitude": 3.85
    },
    {
      "ID": 972,
      "greek_letter": "zet",
      "constellation": "Ari",
      "RA_hour": "03",
      "RA_min": 14,
      "RA_sec": 54,
      "dec_deg": "+21",
      "dec_min": "02",
      "dec_sec": 40,
      "magnitude": 4.89
    },
    {
      "ID": 984,
      "greek_letter": "zet",
      "constellation": "Eri",
      "RA_hour": "03",
      "RA_min": 15,
      "RA_sec": 49.9,
      "dec_deg": "-08",
      "dec_min": 49,
      "dec_sec": 11,
      "magnitude": 4.8
    },
    {
      "ID": 985,
      "greek_letter": "",
      "constellation": "",
      "RA_hour": "03",
      "RA_min": 19,
      "RA_sec": 59.3,
      "dec_deg": "+65",
      "dec_min": 39,
      "dec_sec": "09",
      "magnitude": 4.85
    },
    {
      "ID": 991,
      "greek_letter": "",
      "constellation": "",
      "RA_hour": "03",
      "RA_min": 18,
      "RA_sec": 43.7,
      "dec_deg": "+34",
      "dec_min": 13,
      "dec_sec": 21,
      "magnitude": 4.82
    },
    {
      "ID": 994,
      "greek_letter": "",
      "constellation": "Eri",
      "RA_hour": "03",
      "RA_min": 18,
      "RA_sec": 22.1,
      "dec_deg": -22,
      "dec_min": 30,
      "dec_sec": 41,
      "magnitude": 4.88
    },
    {
      "ID": 996,
      "greek_letter": "kap1",
      "constellation": "Cet",
      "RA_hour": "03",
      "RA_min": 19,
      "RA_sec": 21.6,
      "dec_deg": "+03",
      "dec_min": 22,
      "dec_sec": 13,
      "magnitude": 4.84
    },
    {
      "ID": 999,
      "greek_letter": "",
      "constellation": "",
      "RA_hour": "03",
      "RA_min": 20,
      "RA_sec": 20.3,
      "dec_deg": "+29",
      "dec_min": "02",
      "dec_sec": 55,
      "magnitude": 4.47
    },
    {
      "ID": 1002,
      "greek_letter": "",
      "constellation": "Per",
      "RA_hour": "03",
      "RA_min": 21,
      "RA_sec": 26.5,
      "dec_deg": "+43",
      "dec_min": 19,
      "dec_sec": 47,
      "magnitude": 4.95
    },
    {
      "ID": 1003,
      "greek_letter": "tau4",
      "constellation": "Eri",
      "RA_hour": "03",
      "RA_min": 19,
      "RA_sec": 30.9,
      "dec_deg": -21,
      "dec_min": 45,
      "dec_sec": 28,
      "magnitude": 3.7
    },
    {
      "ID": 1008,
      "greek_letter": "",
      "constellation": "",
      "RA_hour": "03",
      "RA_min": 19,
      "RA_sec": 55.6,
      "dec_deg": -43,
      "dec_min": "04",
      "dec_sec": 11,
      "magnitude": 4.27
    },
    {
      "ID": 1017,
      "greek_letter": "alf",
      "constellation": "Per",
      "RA_hour": "03",
      "RA_min": 24,
      "RA_sec": 19.3,
      "dec_deg": "+49",
      "dec_min": 51,
      "dec_sec": 41,
      "magnitude": 1.79
    },
    {
      "ID": 1030,
      "greek_letter": "omi",
      "constellation": "Tau",
      "RA_hour": "03",
      "RA_min": 24,
      "RA_sec": 48.7,
      "dec_deg": "+09",
      "dec_min": "01",
      "dec_sec": 44,
      "magnitude": 3.6
    },
    {
      "ID": 1034,
      "greek_letter": "",
      "constellation": "",
      "RA_hour": "03",
      "RA_min": 28,
      "RA_sec": "03.0",
      "dec_deg": "+49",
      "dec_min": "03",
      "dec_sec": 46,
      "magnitude": 4.98
    },
    {
      "ID": 1035,
      "greek_letter": "",
      "constellation": "",
      "RA_hour": "03",
      "RA_min": 29,
      "RA_sec": "04.1",
      "dec_deg": "+59",
      "dec_min": 56,
      "dec_sec": 25,
      "magnitude": 4.22
    },
    {
      "ID": 1038,
      "greek_letter": "xi",
      "constellation": "Tau",
      "RA_hour": "03",
      "RA_min": 27,
      "RA_sec": 10.1,
      "dec_deg": "+09",
      "dec_min": 43,
      "dec_sec": 58,
      "magnitude": 3.75
    },
    {
      "ID": 1040,
      "greek_letter": "",
      "constellation": "",
      "RA_hour": "03",
      "RA_min": 29,
      "RA_sec": 54.8,
      "dec_deg": "+58",
      "dec_min": 52,
      "dec_sec": 44,
      "magnitude": 4.54
    },
    {
      "ID": 1044,
      "greek_letter": "",
      "constellation": "Per",
      "RA_hour": "03",
      "RA_min": 29,
      "RA_sec": 22,
      "dec_deg": "+49",
      "dec_min": 30,
      "dec_sec": 32,
      "magnitude": 4.67
    },
    {
      "ID": 1052,
      "greek_letter": "sig",
      "constellation": "Per",
      "RA_hour": "03",
      "RA_min": 30,
      "RA_sec": 34.4,
      "dec_deg": "+47",
      "dec_min": 59,
      "dec_sec": 43,
      "magnitude": 4.38
    },
    {
      "ID": 1066,
      "greek_letter": "",
      "constellation": "Tau",
      "RA_hour": "03",
      "RA_min": 30,
      "RA_sec": 52.3,
      "dec_deg": "+12",
      "dec_min": 56,
      "dec_sec": 12,
      "magnitude": 4.1
    },
    {
      "ID": 1070,
      "greek_letter": "",
      "constellation": "Eri",
      "RA_hour": "03",
      "RA_min": 30,
      "RA_sec": 37,
      "dec_deg": "-05",
      "dec_min": "04",
      "dec_sec": 31,
      "magnitude": 4.73
    },
    {
      "ID": 1083,
      "greek_letter": "kap",
      "constellation": "Ret",
      "RA_hour": "03",
      "RA_min": 29,
      "RA_sec": 22.6,
      "dec_deg": -62,
      "dec_min": 56,
      "dec_sec": 16,
      "magnitude": 4.72
    },
    {
      "ID": 1084,
      "greek_letter": "eps",
      "constellation": "Eri",
      "RA_hour": "03",
      "RA_min": 32,
      "RA_sec": 55.8,
      "dec_deg": "-09",
      "dec_min": 27,
      "dec_sec": 30,
      "magnitude": 3.73
    },
    {
      "ID": 1087,
      "greek_letter": "psi",
      "constellation": "Per",
      "RA_hour": "03",
      "RA_min": 36,
      "RA_sec": 29.3,
      "dec_deg": "+48",
      "dec_min": 11,
      "dec_sec": 34,
      "magnitude": 4.23
    },
    {
      "ID": 1088,
      "greek_letter": "tau5",
      "constellation": "Eri",
      "RA_hour": "03",
      "RA_min": 33,
      "RA_sec": 47.2,
      "dec_deg": -21,
      "dec_min": 37,
      "dec_sec": 59,
      "magnitude": 4.28
    },
    {
      "ID": 1101,
      "greek_letter": "",
      "constellation": "Tau",
      "RA_hour": "03",
      "RA_min": 36,
      "RA_sec": 52.3,
      "dec_deg": "+00",
      "dec_min": 24,
      "dec_sec": "06",
      "magnitude": 4.28
    },
    {
      "ID": 1106,
      "greek_letter": "",
      "constellation": "",
      "RA_hour": "03",
      "RA_min": 37,
      "RA_sec": "05.6",
      "dec_deg": -40,
      "dec_min": 16,
      "dec_sec": 29,
      "magnitude": 4.58
    },
    {
      "ID": 1122,
      "greek_letter": "del",
      "constellation": "Per",
      "RA_hour": "03",
      "RA_min": 42,
      "RA_sec": 55.4,
      "dec_deg": "+47",
      "dec_min": 47,
      "dec_sec": 15,
      "magnitude": 3.01
    },
    {
      "ID": 1123,
      "greek_letter": "",
      "constellation": "Per",
      "RA_hour": "03",
      "RA_min": 42,
      "RA_sec": 22.5,
      "dec_deg": "+33",
      "dec_min": 57,
      "dec_sec": 54,
      "magnitude": 4.97
    },
    {
      "ID": 1129,
      "greek_letter": "",
      "constellation": "",
      "RA_hour": "03",
      "RA_min": 46,
      "RA_sec": "02.3",
      "dec_deg": "+63",
      "dec_min": 20,
      "dec_sec": 42,
      "magnitude": 4.79
    },
    {
      "ID": 1131,
      "greek_letter": "omi",
      "constellation": "Per",
      "RA_hour": "03",
      "RA_min": 44,
      "RA_sec": 19.1,
      "dec_deg": "+32",
      "dec_min": 17,
      "dec_sec": 18,
      "magnitude": 3.83
    },
    {
      "ID": 1134,
      "greek_letter": "del",
      "constellation": "For",
      "RA_hour": "03",
      "RA_min": 42,
      "RA_sec": 14.9,
      "dec_deg": -31,
      "dec_min": 56,
      "dec_sec": 18,
      "magnitude": 5
    },
    {
      "ID": 1135,
      "greek_letter": "nu",
      "constellation": "Per",
      "RA_hour": "03",
      "RA_min": 45,
      "RA_sec": 11.6,
      "dec_deg": "+42",
      "dec_min": 34,
      "dec_sec": 43,
      "magnitude": 3.8
    },
    {
      "ID": 1136,
      "greek_letter": "del",
      "constellation": "Eri",
      "RA_hour": "03",
      "RA_min": 43,
      "RA_sec": 14.8,
      "dec_deg": "-09",
      "dec_min": 45,
      "dec_sec": 48,
      "magnitude": 3.54
    },
    {
      "ID": 1142,
      "greek_letter": "",
      "constellation": "Tau",
      "RA_hour": "03",
      "RA_min": 44,
      "RA_sec": 52.5,
      "dec_deg": "+24",
      "dec_min": "06",
      "dec_sec": 48,
      "magnitude": 3.7
    },
    {
      "ID": 1143,
      "greek_letter": "",
      "constellation": "",
      "RA_hour": "03",
      "RA_min": 42,
      "RA_sec": 50,
      "dec_deg": -37,
      "dec_min": 18,
      "dec_sec": 49,
      "magnitude": 4.59
    },
    {
      "ID": 1145,
      "greek_letter": "",
      "constellation": "Tau",
      "RA_hour": "03",
      "RA_min": 45,
      "RA_sec": 12.4,
      "dec_deg": "+24",
      "dec_min": 28,
      "dec_sec": "02",
      "magnitude": 4.3
    },
    {
      "ID": 1148,
      "greek_letter": "gam",
      "constellation": "Cam",
      "RA_hour": "03",
      "RA_min": 50,
      "RA_sec": 21.5,
      "dec_deg": "+71",
      "dec_min": 19,
      "dec_sec": 57,
      "magnitude": 4.66
    },
    {
      "ID": 1149,
      "greek_letter": "",
      "constellation": "Tau",
      "RA_hour": "03",
      "RA_min": 45,
      "RA_sec": 49.5,
      "dec_deg": "+24",
      "dec_min": 22,
      "dec_sec": "04",
      "magnitude": 3.87
    },
    {
      "ID": 1155,
      "greek_letter": "",
      "constellation": "",
      "RA_hour": "03",
      "RA_min": 49,
      "RA_sec": 31.2,
      "dec_deg": "+65",
      "dec_min": 31,
      "dec_sec": 34,
      "magnitude": 4.48
    },
    {
      "ID": 1156,
      "greek_letter": "",
      "constellation": "Tau",
      "RA_hour": "03",
      "RA_min": 46,
      "RA_sec": 19.5,
      "dec_deg": "+23",
      "dec_min": 56,
      "dec_sec": 54,
      "magnitude": 4.18
    },
    {
      "ID": 1162,
      "greek_letter": "pi",
      "constellation": "Eri",
      "RA_hour": "03",
      "RA_min": 46,
      "RA_sec": "08.4",
      "dec_deg": -12,
      "dec_min": "06",
      "dec_sec": "06",
      "magnitude": 4.42
    },
    {
      "ID": 1165,
      "greek_letter": "eta",
      "constellation": "Tau",
      "RA_hour": "03",
      "RA_min": 47,
      "RA_sec": 29,
      "dec_deg": "+24",
      "dec_min": "06",
      "dec_sec": 18,
      "magnitude": 2.87
    },
    {
      "ID": 1173,
      "greek_letter": "tau6",
      "constellation": "Eri",
      "RA_hour": "03",
      "RA_min": 46,
      "RA_sec": 50.8,
      "dec_deg": -23,
      "dec_min": 14,
      "dec_sec": 59,
      "magnitude": 4.23
    },
    {
      "ID": 1175,
      "greek_letter": "bet",
      "constellation": "Ret",
      "RA_hour": "03",
      "RA_min": 44,
      "RA_sec": 12,
      "dec_deg": -64,
      "dec_min": 48,
      "dec_sec": 26,
      "magnitude": 3.85
    },
    {
      "ID": 1178,
      "greek_letter": "",
      "constellation": "Tau",
      "RA_hour": "03",
      "RA_min": 49,
      "RA_sec": "09.7",
      "dec_deg": "+24",
      "dec_min": "03",
      "dec_sec": 12,
      "magnitude": 3.62
    },
    {
      "ID": 1190,
      "greek_letter": "",
      "constellation": "",
      "RA_hour": "03",
      "RA_min": 48,
      "RA_sec": 35.8,
      "dec_deg": -37,
      "dec_min": 37,
      "dec_sec": 14,
      "magnitude": 4.86
    },
    {
      "ID": 1195,
      "greek_letter": "",
      "constellation": "",
      "RA_hour": "03",
      "RA_min": 49,
      "RA_sec": 27.2,
      "dec_deg": -36,
      "dec_min": 12,
      "dec_sec": "01",
      "magnitude": 4.17
    },
    {
      "ID": 1203,
      "greek_letter": "zet",
      "constellation": "Per",
      "RA_hour": "03",
      "RA_min": 54,
      "RA_sec": "07.9",
      "dec_deg": "+31",
      "dec_min": 53,
      "dec_sec": "01",
      "magnitude": 2.85
    },
    {
      "ID": 1205,
      "greek_letter": "",
      "constellation": "",
      "RA_hour": "03",
      "RA_min": 57,
      "RA_sec": "08.2",
      "dec_deg": "+61",
      "dec_min": "06",
      "dec_sec": 32,
      "magnitude": 5
    },
    {
      "ID": 1208,
      "greek_letter": "gam",
      "constellation": "Hyi",
      "RA_hour": "03",
      "RA_min": 47,
      "RA_sec": 14.5,
      "dec_deg": -74,
      "dec_min": 14,
      "dec_sec": 21,
      "magnitude": 3.24
    },
    {
      "ID": 1212,
      "greek_letter": "",
      "constellation": "Eri",
      "RA_hour": "03",
      "RA_min": 54,
      "RA_sec": 17.4,
      "dec_deg": "-02",
      "dec_min": 57,
      "dec_sec": 17,
      "magnitude": 4.79
    },
    {
      "ID": 1213,
      "greek_letter": "tau8",
      "constellation": "Eri",
      "RA_hour": "03",
      "RA_min": 53,
      "RA_sec": 42.6,
      "dec_deg": -24,
      "dec_min": 36,
      "dec_sec": 45,
      "magnitude": 4.65
    },
    {
      "ID": 1220,
      "greek_letter": "eps",
      "constellation": "Per",
      "RA_hour": "03",
      "RA_min": 57,
      "RA_sec": 51.2,
      "dec_deg": "+40",
      "dec_min": "00",
      "dec_sec": 37,
      "magnitude": 2.89
    },
    {
      "ID": 1228,
      "greek_letter": "xi",
      "constellation": "Per",
      "RA_hour": "03",
      "RA_min": 58,
      "RA_sec": 57.8,
      "dec_deg": "+35",
      "dec_min": 47,
      "dec_sec": 28,
      "magnitude": 4.04
    },
    {
      "ID": 1231,
      "greek_letter": "gam",
      "constellation": "Eri",
      "RA_hour": "03",
      "RA_min": 58,
      "RA_sec": "01.7",
      "dec_deg": -13,
      "dec_min": 30,
      "dec_sec": 31,
      "magnitude": 2.94
    },
    {
      "ID": 1239,
      "greek_letter": "lam",
      "constellation": "Tau",
      "RA_hour": "04",
      "RA_min": "00",
      "RA_sec": 40.8,
      "dec_deg": "+12",
      "dec_min": 29,
      "dec_sec": 25,
      "magnitude": 3.41
    },
    {
      "ID": 1240,
      "greek_letter": "tau9",
      "constellation": "Eri",
      "RA_hour": "03",
      "RA_min": 59,
      "RA_sec": 55.4,
      "dec_deg": -24,
      "dec_min": "00",
      "dec_sec": 59,
      "magnitude": 4.66
    },
    {
      "ID": 1247,
      "greek_letter": "del",
      "constellation": "Ret",
      "RA_hour": "03",
      "RA_min": 58,
      "RA_sec": 44.7,
      "dec_deg": -61,
      "dec_min": 24,
      "dec_sec": "01",
      "magnitude": 4.56
    },
    {
      "ID": 1251,
      "greek_letter": "nu",
      "constellation": "Tau",
      "RA_hour": "04",
      "RA_min": "03",
      "RA_sec": "09.3",
      "dec_deg": "+05",
      "dec_min": 59,
      "dec_sec": 22,
      "magnitude": 3.91
    },
    {
      "ID": 1256,
      "greek_letter": "",
      "constellation": "Tau",
      "RA_hour": "04",
      "RA_min": "04",
      "RA_sec": 41.7,
      "dec_deg": "+22",
      "dec_min": "04",
      "dec_sec": 55,
      "magnitude": 4.37
    },
    {
      "ID": 1261,
      "greek_letter": "lam",
      "constellation": "Per",
      "RA_hour": "04",
      "RA_min": "06",
      "RA_sec": 35,
      "dec_deg": "+50",
      "dec_min": 21,
      "dec_sec": "05",
      "magnitude": 4.29
    },
    {
      "ID": 1264,
      "greek_letter": "gam",
      "constellation": "Ret",
      "RA_hour": "04",
      "RA_min": "00",
      "RA_sec": 53.8,
      "dec_deg": -62,
      "dec_min": "09",
      "dec_sec": 34,
      "magnitude": 4.51
    },
    {
      "ID": 1266,
      "greek_letter": "iot",
      "constellation": "Ret",
      "RA_hour": "04",
      "RA_min": "01",
      "RA_sec": 18.2,
      "dec_deg": -61,
      "dec_min": "04",
      "dec_sec": 44,
      "magnitude": 4.97
    },
    {
      "ID": 1273,
      "greek_letter": "",
      "constellation": "Per",
      "RA_hour": "04",
      "RA_min": "08",
      "RA_sec": 39.6,
      "dec_deg": "+47",
      "dec_min": 42,
      "dec_sec": 45,
      "magnitude": 4.03
    },
    {
      "ID": 1298,
      "greek_letter": "omi1",
      "constellation": "Eri",
      "RA_hour": "04",
      "RA_min": 11,
      "RA_sec": 51.9,
      "dec_deg": "-06",
      "dec_min": 50,
      "dec_sec": 16,
      "magnitude": 4.05
    },
    {
      "ID": 1302,
      "greek_letter": "del",
      "constellation": "Hor",
      "RA_hour": "04",
      "RA_min": 10,
      "RA_sec": 50.5,
      "dec_deg": -41,
      "dec_min": 59,
      "dec_sec": 37,
      "magnitude": 4.93
    },
    {
      "ID": 1303,
      "greek_letter": "mu",
      "constellation": "Per",
      "RA_hour": "04",
      "RA_min": 14,
      "RA_sec": 53.8,
      "dec_deg": "+48",
      "dec_min": 24,
      "dec_sec": 34,
      "magnitude": 4.16
    },
    {
      "ID": 1306,
      "greek_letter": "",
      "constellation": "Per",
      "RA_hour": "04",
      "RA_min": 14,
      "RA_sec": 53.3,
      "dec_deg": "+40",
      "dec_min": 29,
      "dec_sec": "02",
      "magnitude": 4.71
    },
    {
      "ID": 1311,
      "greek_letter": "",
      "constellation": "Tau",
      "RA_hour": "04",
      "RA_min": 13,
      "RA_sec": 56.3,
      "dec_deg": "+09",
      "dec_min": 15,
      "dec_sec": 49,
      "magnitude": 4.84
    },
    {
      "ID": 1318,
      "greek_letter": "",
      "constellation": "Eri",
      "RA_hour": "04",
      "RA_min": 14,
      "RA_sec": 23.6,
      "dec_deg": -10,
      "dec_min": 15,
      "dec_sec": 23,
      "magnitude": 4.86
    },
    {
      "ID": 1320,
      "greek_letter": "mu",
      "constellation": "Tau",
      "RA_hour": "04",
      "RA_min": 15,
      "RA_sec": 32,
      "dec_deg": "+08",
      "dec_min": 53,
      "dec_sec": 32,
      "magnitude": 4.28
    },
    {
      "ID": 1324,
      "greek_letter": "",
      "constellation": "",
      "RA_hour": "04",
      "RA_min": 18,
      "RA_sec": 14.6,
      "dec_deg": "+50",
      "dec_min": 17,
      "dec_sec": 44,
      "magnitude": 4.61
    },
    {
      "ID": 1325,
      "greek_letter": "omi2",
      "constellation": "Eri",
      "RA_hour": "04",
      "RA_min": 15,
      "RA_sec": 16.3,
      "dec_deg": "-07",
      "dec_min": 39,
      "dec_sec": 10,
      "magnitude": 4.43
    },
    {
      "ID": 1326,
      "greek_letter": "alf",
      "constellation": "Hor",
      "RA_hour": "04",
      "RA_min": 14,
      "RA_sec": "00.1",
      "dec_deg": -42,
      "dec_min": 17,
      "dec_sec": 40,
      "magnitude": 3.86
    },
    {
      "ID": 1329,
      "greek_letter": "omg2",
      "constellation": "Tau",
      "RA_hour": "04",
      "RA_min": 17,
      "RA_sec": 15.6,
      "dec_deg": "+20",
      "dec_min": 34,
      "dec_sec": 43,
      "magnitude": 4.95
    },
    {
      "ID": 1336,
      "greek_letter": "alf",
      "constellation": "Ret",
      "RA_hour": "04",
      "RA_min": 14,
      "RA_sec": 25.5,
      "dec_deg": -62,
      "dec_min": 28,
      "dec_sec": 26,
      "magnitude": 3.35
    },
    {
      "ID": 1338,
      "greek_letter": "gam",
      "constellation": "Dor",
      "RA_hour": "04",
      "RA_min": 16,
      "RA_sec": "01.6",
      "dec_deg": -51,
      "dec_min": 29,
      "dec_sec": 12,
      "magnitude": 4.25
    },
    {
      "ID": 1343,
      "greek_letter": "",
      "constellation": "Per",
      "RA_hour": "04",
      "RA_min": 20,
      "RA_sec": 24.6,
      "dec_deg": "+34",
      "dec_min": 34,
      "dec_sec": "00",
      "magnitude": 4.93
    },
    {
      "ID": 1346,
      "greek_letter": "gam",
      "constellation": "Tau",
      "RA_hour": "04",
      "RA_min": 19,
      "RA_sec": 47.5,
      "dec_deg": "+15",
      "dec_min": 37,
      "dec_sec": 39,
      "magnitude": 3.65
    },
    {
      "ID": 1347,
      "greek_letter": "ups4",
      "constellation": "Eri",
      "RA_hour": "04",
      "RA_min": 17,
      "RA_sec": 53.6,
      "dec_deg": -33,
      "dec_min": 47,
      "dec_sec": 54,
      "magnitude": 3.56
    },
    {
      "ID": 1348,
      "greek_letter": "phi",
      "constellation": "Tau",
      "RA_hour": "04",
      "RA_min": 20,
      "RA_sec": 21.2,
      "dec_deg": "+27",
      "dec_min": 21,
      "dec_sec": "03",
      "magnitude": 4.95
    },
    {
      "ID": 1350,
      "greek_letter": "",
      "constellation": "Per",
      "RA_hour": "04",
      "RA_min": 21,
      "RA_sec": 33.1,
      "dec_deg": "+46",
      "dec_min": 29,
      "dec_sec": 56,
      "magnitude": 4.86
    },
    {
      "ID": 1355,
      "greek_letter": "eps",
      "constellation": "Ret",
      "RA_hour": "04",
      "RA_min": 16,
      "RA_sec": 28.9,
      "dec_deg": -59,
      "dec_min": 18,
      "dec_sec": "07",
      "magnitude": 4.44
    },
    {
      "ID": 1373,
      "greek_letter": "del1",
      "constellation": "Tau",
      "RA_hour": "04",
      "RA_min": 22,
      "RA_sec": 56,
      "dec_deg": "+17",
      "dec_min": 32,
      "dec_sec": 33,
      "magnitude": 3.76
    },
    {
      "ID": 1380,
      "greek_letter": "del2",
      "constellation": "Tau",
      "RA_hour": "04",
      "RA_min": 24,
      "RA_sec": "05.7",
      "dec_deg": "+17",
      "dec_min": 26,
      "dec_sec": 38,
      "magnitude": 4.8
    },
    {
      "ID": 1387,
      "greek_letter": "kap1",
      "constellation": "Tau",
      "RA_hour": "04",
      "RA_min": 25,
      "RA_sec": 22.1,
      "dec_deg": "+22",
      "dec_min": 17,
      "dec_sec": 38,
      "magnitude": 4.22
    },
    {
      "ID": 1389,
      "greek_letter": "del3",
      "constellation": "Tau",
      "RA_hour": "04",
      "RA_min": 25,
      "RA_sec": 29.3,
      "dec_deg": "+17",
      "dec_min": 55,
      "dec_sec": 41,
      "magnitude": 4.28
    },
    {
      "ID": 1392,
      "greek_letter": "ups",
      "constellation": "Tau",
      "RA_hour": "04",
      "RA_min": 26,
      "RA_sec": 18.4,
      "dec_deg": "+22",
      "dec_min": 48,
      "dec_sec": 49,
      "magnitude": 4.28
    },
    {
      "ID": 1393,
      "greek_letter": "",
      "constellation": "Eri",
      "RA_hour": "04",
      "RA_min": 24,
      "RA_sec": "02.1",
      "dec_deg": -34,
      "dec_min": "01",
      "dec_sec": "01",
      "magnitude": 3.96
    },
    {
      "ID": 1394,
      "greek_letter": "",
      "constellation": "Tau",
      "RA_hour": "04",
      "RA_min": 26,
      "RA_sec": 20.7,
      "dec_deg": "+15",
      "dec_min": 37,
      "dec_sec": "06",
      "magnitude": 4.5
    },
    {
      "ID": 1396,
      "greek_letter": "pi",
      "constellation": "Tau",
      "RA_hour": "04",
      "RA_min": 26,
      "RA_sec": 36.4,
      "dec_deg": "+14",
      "dec_min": 42,
      "dec_sec": 49,
      "magnitude": 4.69
    },
    {
      "ID": 1407,
      "greek_letter": "",
      "constellation": "Tau",
      "RA_hour": "04",
      "RA_min": 28,
      "RA_sec": 26.3,
      "dec_deg": "+16",
      "dec_min": 21,
      "dec_sec": 35,
      "magnitude": 4.97
    },
    {
      "ID": 1409,
      "greek_letter": "eps",
      "constellation": "Tau",
      "RA_hour": "04",
      "RA_min": 28,
      "RA_sec": 36.9,
      "dec_deg": "+19",
      "dec_min": 10,
      "dec_sec": 49,
      "magnitude": 3.54
    },
    {
      "ID": 1411,
      "greek_letter": "tet1",
      "constellation": "Tau",
      "RA_hour": "04",
      "RA_min": 28,
      "RA_sec": 34.4,
      "dec_deg": "+15",
      "dec_min": 57,
      "dec_sec": 44,
      "magnitude": 3.84
    },
    {
      "ID": 1412,
      "greek_letter": "tet2",
      "constellation": "Tau",
      "RA_hour": "04",
      "RA_min": 28,
      "RA_sec": 39.7,
      "dec_deg": "+15",
      "dec_min": 52,
      "dec_sec": 15,
      "magnitude": 3.39
    },
    {
      "ID": 1427,
      "greek_letter": "",
      "constellation": "",
      "RA_hour": "04",
      "RA_min": 30,
      "RA_sec": 33.6,
      "dec_deg": "+16",
      "dec_min": 11,
      "dec_sec": 38,
      "magnitude": 4.78
    },
    {
      "ID": 1437,
      "greek_letter": "",
      "constellation": "Eri",
      "RA_hour": "04",
      "RA_min": 31,
      "RA_sec": 52.6,
      "dec_deg": "-00",
      "dec_min": "02",
      "dec_sec": 39,
      "magnitude": 4.89
    },
    {
      "ID": 1444,
      "greek_letter": "ro",
      "constellation": "Tau",
      "RA_hour": "04",
      "RA_min": 33,
      "RA_sec": 50.8,
      "dec_deg": "+14",
      "dec_min": 50,
      "dec_sec": 40,
      "magnitude": 4.65
    },
    {
      "ID": 1453,
      "greek_letter": "ups1",
      "constellation": "Eri",
      "RA_hour": "04",
      "RA_min": 33,
      "RA_sec": 30.6,
      "dec_deg": -29,
      "dec_min": 46,
      "dec_sec": "00",
      "magnitude": 4.51
    },
    {
      "ID": 1454,
      "greek_letter": "",
      "constellation": "Per",
      "RA_hour": "04",
      "RA_min": 36,
      "RA_sec": 41.3,
      "dec_deg": "+41",
      "dec_min": 15,
      "dec_sec": 53,
      "magnitude": 4.26
    },
    {
      "ID": 1457,
      "greek_letter": "alf",
      "constellation": "Tau",
      "RA_hour": "04",
      "RA_min": 35,
      "RA_sec": 55.2,
      "dec_deg": "+16",
      "dec_min": 30,
      "dec_sec": 33,
      "magnitude": 0.86
    },
    {
      "ID": 1458,
      "greek_letter": "",
      "constellation": "Tau",
      "RA_hour": "04",
      "RA_min": 35,
      "RA_sec": 39.2,
      "dec_deg": "+10",
      "dec_min": "09",
      "dec_sec": 39,
      "magnitude": 4.25
    },
    {
      "ID": 1463,
      "greek_letter": "nu",
      "constellation": "Eri",
      "RA_hour": "04",
      "RA_min": 36,
      "RA_sec": 19.1,
      "dec_deg": "-03",
      "dec_min": 21,
      "dec_sec": "09",
      "magnitude": 3.92
    },
    {
      "ID": 1464,
      "greek_letter": "ups2",
      "constellation": "Eri",
      "RA_hour": "04",
      "RA_min": 35,
      "RA_sec": 33,
      "dec_deg": -30,
      "dec_min": 33,
      "dec_sec": 45,
      "magnitude": 3.82
    },
    {
      "ID": 1465,
      "greek_letter": "alf",
      "constellation": "Dor",
      "RA_hour": "04",
      "RA_min": 33,
      "RA_sec": 59.8,
      "dec_deg": -55,
      "dec_min": "02",
      "dec_sec": 42,
      "magnitude": 3.27
    },
    {
      "ID": 1473,
      "greek_letter": "",
      "constellation": "Tau",
      "RA_hour": "04",
      "RA_min": 38,
      "RA_sec": "09.4",
      "dec_deg": "+12",
      "dec_min": 30,
      "dec_sec": 39,
      "magnitude": 4.27
    },
    {
      "ID": 1479,
      "greek_letter": "sig2",
      "constellation": "Tau",
      "RA_hour": "04",
      "RA_min": 39,
      "RA_sec": 16.4,
      "dec_deg": "+15",
      "dec_min": 55,
      "dec_sec": "05",
      "magnitude": 4.7
    },
    {
      "ID": 1481,
      "greek_letter": "",
      "constellation": "Eri",
      "RA_hour": "04",
      "RA_min": 38,
      "RA_sec": 10.7,
      "dec_deg": -14,
      "dec_min": 18,
      "dec_sec": 15,
      "magnitude": 3.87
    },
    {
      "ID": 1496,
      "greek_letter": "",
      "constellation": "Eri",
      "RA_hour": "04",
      "RA_min": 40,
      "RA_sec": 26.4,
      "dec_deg": -19,
      "dec_min": 40,
      "dec_sec": 18,
      "magnitude": 4.3
    },
    {
      "ID": 1497,
      "greek_letter": "tau",
      "constellation": "Tau",
      "RA_hour": "04",
      "RA_min": 42,
      "RA_sec": 14.6,
      "dec_deg": "+22",
      "dec_min": 57,
      "dec_sec": 25,
      "magnitude": 4.29
    },
    {
      "ID": 1502,
      "greek_letter": "alf",
      "constellation": "Cae",
      "RA_hour": "04",
      "RA_min": 40,
      "RA_sec": 33.6,
      "dec_deg": -41,
      "dec_min": 51,
      "dec_sec": 50,
      "magnitude": 4.45
    },
    {
      "ID": 1520,
      "greek_letter": "mu",
      "constellation": "Eri",
      "RA_hour": "04",
      "RA_min": 45,
      "RA_sec": 30.1,
      "dec_deg": "-03",
      "dec_min": 15,
      "dec_sec": 17,
      "magnitude": 4.02
    },
    {
      "ID": 1533,
      "greek_letter": "",
      "constellation": "",
      "RA_hour": "04",
      "RA_min": 49,
      "RA_sec": 54.6,
      "dec_deg": "+37",
      "dec_min": 29,
      "dec_sec": 18,
      "magnitude": 4.91
    },
    {
      "ID": 1542,
      "greek_letter": "alf",
      "constellation": "Cam",
      "RA_hour": "04",
      "RA_min": 54,
      "RA_sec": "03.0",
      "dec_deg": "+66",
      "dec_min": 20,
      "dec_sec": 34,
      "magnitude": 4.29
    },
    {
      "ID": 1543,
      "greek_letter": "pi3",
      "constellation": "Ori",
      "RA_hour": "04",
      "RA_min": 49,
      "RA_sec": 50.3,
      "dec_deg": "+06",
      "dec_min": 57,
      "dec_sec": 41,
      "magnitude": 3.18
    },
    {
      "ID": 1544,
      "greek_letter": "pi2",
      "constellation": "Ori",
      "RA_hour": "04",
      "RA_min": 50,
      "RA_sec": 36.7,
      "dec_deg": "+08",
      "dec_min": 54,
      "dec_sec": "01",
      "magnitude": 4.35
    },
    {
      "ID": 1551,
      "greek_letter": "",
      "constellation": "Aur",
      "RA_hour": "04",
      "RA_min": 52,
      "RA_sec": 37.9,
      "dec_deg": "+36",
      "dec_min": 42,
      "dec_sec": 11,
      "magnitude": 4.77
    },
    {
      "ID": 1552,
      "greek_letter": "pi4",
      "constellation": "Ori",
      "RA_hour": "04",
      "RA_min": 51,
      "RA_sec": 12.3,
      "dec_deg": "+05",
      "dec_min": 36,
      "dec_sec": 18,
      "magnitude": 3.68
    },
    {
      "ID": 1556,
      "greek_letter": "omi1",
      "constellation": "Ori",
      "RA_hour": "04",
      "RA_min": 52,
      "RA_sec": 31.9,
      "dec_deg": "+14",
      "dec_min": 15,
      "dec_sec": "02",
      "magnitude": 4.74
    },
    {
      "ID": 1560,
      "greek_letter": "omg",
      "constellation": "Eri",
      "RA_hour": "04",
      "RA_min": 52,
      "RA_sec": 53.6,
      "dec_deg": "-05",
      "dec_min": 27,
      "dec_sec": 10,
      "magnitude": 4.39
    },
    {
      "ID": 1567,
      "greek_letter": "pi5",
      "constellation": "Ori",
      "RA_hour": "04",
      "RA_min": 54,
      "RA_sec": 15,
      "dec_deg": "+02",
      "dec_min": 26,
      "dec_sec": 26,
      "magnitude": 3.73
    },
    {
      "ID": 1568,
      "greek_letter": "",
      "constellation": "Cam",
      "RA_hour": "04",
      "RA_min": 57,
      "RA_sec": 17.1,
      "dec_deg": "+53",
      "dec_min": 45,
      "dec_sec": "08",
      "magnitude": 4.47
    },
    {
      "ID": 1570,
      "greek_letter": "pi1",
      "constellation": "Ori",
      "RA_hour": "04",
      "RA_min": 54,
      "RA_sec": 53.7,
      "dec_deg": "+10",
      "dec_min": "09",
      "dec_sec": "03",
      "magnitude": 4.67
    },
    {
      "ID": 1577,
      "greek_letter": "iot",
      "constellation": "Aur",
      "RA_hour": "04",
      "RA_min": 56,
      "RA_sec": 59.6,
      "dec_deg": "+33",
      "dec_min": "09",
      "dec_sec": 58,
      "magnitude": 2.69
    },
    {
      "ID": 1580,
      "greek_letter": "omi2",
      "constellation": "Ori",
      "RA_hour": "04",
      "RA_min": 56,
      "RA_sec": 22.2,
      "dec_deg": "+13",
      "dec_min": 30,
      "dec_sec": 52,
      "magnitude": 4.06
    },
    {
      "ID": 1592,
      "greek_letter": "omg",
      "constellation": "Aur",
      "RA_hour": "04",
      "RA_min": 59,
      "RA_sec": 15.3,
      "dec_deg": "+37",
      "dec_min": 53,
      "dec_sec": 25,
      "magnitude": 4.95
    },
    {
      "ID": 1601,
      "greek_letter": "pi6",
      "constellation": "Ori",
      "RA_hour": "04",
      "RA_min": 58,
      "RA_sec": 32.8,
      "dec_deg": "+01",
      "dec_min": 42,
      "dec_sec": 51,
      "magnitude": 4.47
    },
    {
      "ID": 1603,
      "greek_letter": "bet",
      "constellation": "Cam",
      "RA_hour": "05",
      "RA_min": "03",
      "RA_sec": 25.1,
      "dec_deg": "+60",
      "dec_min": 26,
      "dec_sec": 32,
      "magnitude": 4.02
    },
    {
      "ID": 1605,
      "greek_letter": "eps",
      "constellation": "Aur",
      "RA_hour": "05",
      "RA_min": "01",
      "RA_sec": 58.1,
      "dec_deg": "+43",
      "dec_min": 49,
      "dec_sec": 24,
      "magnitude": 2.99
    },
    {
      "ID": 1611,
      "greek_letter": "",
      "constellation": "Eri",
      "RA_hour": "04",
      "RA_min": 59,
      "RA_sec": 55.7,
      "dec_deg": -12,
      "dec_min": 32,
      "dec_sec": 15,
      "magnitude": 4.78
    },
    {
      "ID": 1612,
      "greek_letter": "zet",
      "constellation": "Aur",
      "RA_hour": "05",
      "RA_min": "02",
      "RA_sec": 28.6,
      "dec_deg": "+41",
      "dec_min": "04",
      "dec_sec": 33,
      "magnitude": 3.75
    },
    {
      "ID": 1617,
      "greek_letter": "psi",
      "constellation": "Eri",
      "RA_hour": "05",
      "RA_min": "01",
      "RA_sec": 26.3,
      "dec_deg": "-07",
      "dec_min": 10,
      "dec_sec": 26,
      "magnitude": 4.81
    },
    {
      "ID": 1620,
      "greek_letter": "iot",
      "constellation": "Tau",
      "RA_hour": "05",
      "RA_min": "03",
      "RA_sec": "05.7",
      "dec_deg": "+21",
      "dec_min": 35,
      "dec_sec": 24,
      "magnitude": 4.64
    },
    {
      "ID": 1621,
      "greek_letter": "",
      "constellation": "",
      "RA_hour": "05",
      "RA_min": "01",
      "RA_sec": 25.5,
      "dec_deg": -20,
      "dec_min": "03",
      "dec_sec": "07",
      "magnitude": 4.92
    },
    {
      "ID": 1637,
      "greek_letter": "",
      "constellation": "Aur",
      "RA_hour": "05",
      "RA_min": "06",
      "RA_sec": 40.6,
      "dec_deg": "+51",
      "dec_min": 35,
      "dec_sec": 52,
      "magnitude": 5
    },
    {
      "ID": 1638,
      "greek_letter": "",
      "constellation": "Ori",
      "RA_hour": "05",
      "RA_min": "04",
      "RA_sec": 34.1,
      "dec_deg": "+15",
      "dec_min": 24,
      "dec_sec": 14,
      "magnitude": 4.68
    },
    {
      "ID": 1641,
      "greek_letter": "eta",
      "constellation": "Aur",
      "RA_hour": "05",
      "RA_min": "06",
      "RA_sec": 30.8,
      "dec_deg": "+41",
      "dec_min": 14,
      "dec_sec": "04",
      "magnitude": 3.18
    },
    {
      "ID": 1652,
      "greek_letter": "gam1",
      "constellation": "Cae",
      "RA_hour": "05",
      "RA_min": "04",
      "RA_sec": 24.3,
      "dec_deg": -35,
      "dec_min": 29,
      "dec_sec": "00",
      "magnitude": 4.55
    },
    {
      "ID": 1654,
      "greek_letter": "eps",
      "constellation": "Lep",
      "RA_hour": "05",
      "RA_min": "05",
      "RA_sec": 27.6,
      "dec_deg": -22,
      "dec_min": 22,
      "dec_sec": 16,
      "magnitude": 3.18
    },
    {
      "ID": 1656,
      "greek_letter": "",
      "constellation": "Tau",
      "RA_hour": "05",
      "RA_min": "07",
      "RA_sec": 27,
      "dec_deg": "+18",
      "dec_min": 38,
      "dec_sec": 42,
      "magnitude": 5
    },
    {
      "ID": 1666,
      "greek_letter": "bet",
      "constellation": "Eri",
      "RA_hour": "05",
      "RA_min": "07",
      "RA_sec": 50.9,
      "dec_deg": "-05",
      "dec_min": "05",
      "dec_sec": 11,
      "magnitude": 2.79
    },
    {
      "ID": 1674,
      "greek_letter": "zet",
      "constellation": "Dor",
      "RA_hour": "05",
      "RA_min": "05",
      "RA_sec": 30.6,
      "dec_deg": -57,
      "dec_min": 28,
      "dec_sec": 22,
      "magnitude": 4.72
    },
    {
      "ID": 1676,
      "greek_letter": "",
      "constellation": "Ori",
      "RA_hour": "05",
      "RA_min": "09",
      "RA_sec": 41.9,
      "dec_deg": "+15",
      "dec_min": 35,
      "dec_sec": 50,
      "magnitude": 4.82
    },
    {
      "ID": 1679,
      "greek_letter": "lam",
      "constellation": "Eri",
      "RA_hour": "05",
      "RA_min": "09",
      "RA_sec": "08.7",
      "dec_deg": "-08",
      "dec_min": 45,
      "dec_sec": 15,
      "magnitude": 4.27
    },
    {
      "ID": 1689,
      "greek_letter": "mu",
      "constellation": "Aur",
      "RA_hour": "05",
      "RA_min": 13,
      "RA_sec": 25.6,
      "dec_deg": "+38",
      "dec_min": 29,
      "dec_sec": "04",
      "magnitude": 4.88
    },
    {
      "ID": 1696,
      "greek_letter": "iot",
      "constellation": "Lep",
      "RA_hour": "05",
      "RA_min": 12,
      "RA_sec": 17.8,
      "dec_deg": -11,
      "dec_min": 52,
      "dec_sec": "09",
      "magnitude": 4.44
    },
    {
      "ID": 1698,
      "greek_letter": "ro",
      "constellation": "Ori",
      "RA_hour": "05",
      "RA_min": 13,
      "RA_sec": 17.4,
      "dec_deg": "+02",
      "dec_min": 51,
      "dec_sec": 40,
      "magnitude": 4.44
    },
    {
      "ID": 1702,
      "greek_letter": "mu",
      "constellation": "Lep",
      "RA_hour": "05",
      "RA_min": 12,
      "RA_sec": 55.8,
      "dec_deg": -16,
      "dec_min": 12,
      "dec_sec": 20,
      "magnitude": 3.29
    },
    {
      "ID": 1705,
      "greek_letter": "kap",
      "constellation": "Lep",
      "RA_hour": "05",
      "RA_min": 13,
      "RA_sec": 13.8,
      "dec_deg": -12,
      "dec_min": 56,
      "dec_sec": 30,
      "magnitude": 4.36
    },
    {
      "ID": 1708,
      "greek_letter": "alf",
      "constellation": "Aur",
      "RA_hour": "05",
      "RA_min": 16,
      "RA_sec": 41.3,
      "dec_deg": "+45",
      "dec_min": 59,
      "dec_sec": 53,
      "magnitude": 0.08
    },
    {
      "ID": 1713,
      "greek_letter": "bet",
      "constellation": "Ori",
      "RA_hour": "05",
      "RA_min": 14,
      "RA_sec": 32.2,
      "dec_deg": "-08",
      "dec_min": 12,
      "dec_sec": "06",
      "magnitude": 0.13
    },
    {
      "ID": 1726,
      "greek_letter": "",
      "constellation": "Aur",
      "RA_hour": "05",
      "RA_min": 18,
      "RA_sec": 10.6,
      "dec_deg": "+33",
      "dec_min": 22,
      "dec_sec": 18,
      "magnitude": 4.54
    },
    {
      "ID": 1729,
      "greek_letter": "lam",
      "constellation": "Aur",
      "RA_hour": "05",
      "RA_min": 19,
      "RA_sec": "08.4",
      "dec_deg": "+40",
      "dec_min": "05",
      "dec_sec": 57,
      "magnitude": 4.71
    },
    {
      "ID": 1735,
      "greek_letter": "tau",
      "constellation": "Ori",
      "RA_hour": "05",
      "RA_min": 17,
      "RA_sec": 36.3,
      "dec_deg": "-06",
      "dec_min": 50,
      "dec_sec": 40,
      "magnitude": 3.59
    },
    {
      "ID": 1739,
      "greek_letter": "",
      "constellation": "Tau",
      "RA_hour": "05",
      "RA_min": 19,
      "RA_sec": 16.5,
      "dec_deg": "+22",
      "dec_min": "05",
      "dec_sec": 47,
      "magnitude": 4.94
    },
    {
      "ID": 1743,
      "greek_letter": "omi",
      "constellation": "Col",
      "RA_hour": "05",
      "RA_min": 17,
      "RA_sec": 29,
      "dec_deg": -34,
      "dec_min": 53,
      "dec_sec": 43,
      "magnitude": 4.83
    },
    {
      "ID": 1744,
      "greek_letter": "tet",
      "constellation": "Dor",
      "RA_hour": "05",
      "RA_min": 13,
      "RA_sec": 45.4,
      "dec_deg": -67,
      "dec_min": 11,
      "dec_sec": "08",
      "magnitude": 4.83
    },
    {
      "ID": 1756,
      "greek_letter": "lam",
      "constellation": "Lep",
      "RA_hour": "05",
      "RA_min": 19,
      "RA_sec": 34.4,
      "dec_deg": -13,
      "dec_min": 10,
      "dec_sec": 37,
      "magnitude": 4.29
    },
    {
      "ID": 1762,
      "greek_letter": "",
      "constellation": "",
      "RA_hour": "05",
      "RA_min": 20,
      "RA_sec": 26.8,
      "dec_deg": -21,
      "dec_min": 14,
      "dec_sec": 23,
      "magnitude": 4.71
    },
    {
      "ID": 1765,
      "greek_letter": "",
      "constellation": "Ori",
      "RA_hour": "05",
      "RA_min": 21,
      "RA_sec": 45.7,
      "dec_deg": "-00",
      "dec_min": 22,
      "dec_sec": 57,
      "magnitude": 4.74
    },
    {
      "ID": 1770,
      "greek_letter": "",
      "constellation": "Ori",
      "RA_hour": "05",
      "RA_min": 22,
      "RA_sec": 49.9,
      "dec_deg": "+03",
      "dec_min": 32,
      "dec_sec": 40,
      "magnitude": 5
    },
    {
      "ID": 1773,
      "greek_letter": "sig",
      "constellation": "Aur",
      "RA_hour": "05",
      "RA_min": 24,
      "RA_sec": 39.1,
      "dec_deg": "+37",
      "dec_min": 23,
      "dec_sec": "08",
      "magnitude": 4.99
    },
    {
      "ID": 1780,
      "greek_letter": "",
      "constellation": "Tau",
      "RA_hour": "05",
      "RA_min": 24,
      "RA_sec": 25.4,
      "dec_deg": "+17",
      "dec_min": 23,
      "dec_sec": "00",
      "magnitude": 4.99
    },
    {
      "ID": 1784,
      "greek_letter": "",
      "constellation": "Ori",
      "RA_hour": "05",
      "RA_min": 23,
      "RA_sec": 56.8,
      "dec_deg": "-07",
      "dec_min": 48,
      "dec_sec": 29,
      "magnitude": 4.12
    },
    {
      "ID": 1788,
      "greek_letter": "eta",
      "constellation": "Ori",
      "RA_hour": "05",
      "RA_min": 24,
      "RA_sec": 28.6,
      "dec_deg": "-02",
      "dec_min": 23,
      "dec_sec": 49,
      "magnitude": 3.35
    },
    {
      "ID": 1789,
      "greek_letter": "psi1",
      "constellation": "Ori",
      "RA_hour": "05",
      "RA_min": 24,
      "RA_sec": 44.8,
      "dec_deg": "+01",
      "dec_min": 50,
      "dec_sec": 47,
      "magnitude": 4.96
    },
    {
      "ID": 1790,
      "greek_letter": "gam",
      "constellation": "Ori",
      "RA_hour": "05",
      "RA_min": 25,
      "RA_sec": "07.8",
      "dec_deg": "+06",
      "dec_min": 20,
      "dec_sec": 59,
      "magnitude": 1.64
    },
    {
      "ID": 1791,
      "greek_letter": "bet",
      "constellation": "Tau",
      "RA_hour": "05",
      "RA_min": 26,
      "RA_sec": 17.5,
      "dec_deg": "+28",
      "dec_min": 36,
      "dec_sec": 27,
      "magnitude": 1.65
    },
    {
      "ID": 1810,
      "greek_letter": "",
      "constellation": "Tau",
      "RA_hour": "05",
      "RA_min": 27,
      "RA_sec": 38,
      "dec_deg": "+21",
      "dec_min": 56,
      "dec_sec": 13,
      "magnitude": 4.89
    },
    {
      "ID": 1811,
      "greek_letter": "psi2",
      "constellation": "Ori",
      "RA_hour": "05",
      "RA_min": 26,
      "RA_sec": 50.2,
      "dec_deg": "+03",
      "dec_min": "05",
      "dec_sec": 44,
      "magnitude": 4.59
    },
    {
      "ID": 1829,
      "greek_letter": "bet",
      "constellation": "Lep",
      "RA_hour": "05",
      "RA_min": 28,
      "RA_sec": 14.7,
      "dec_deg": -20,
      "dec_min": 45,
      "dec_sec": 34,
      "magnitude": 2.84
    },
    {
      "ID": 1834,
      "greek_letter": "",
      "constellation": "Ori",
      "RA_hour": "05",
      "RA_min": 29,
      "RA_sec": 43.9,
      "dec_deg": "-01",
      "dec_min": "05",
      "dec_sec": 32,
      "magnitude": 4.71
    },
    {
      "ID": 1839,
      "greek_letter": "",
      "constellation": "Ori",
      "RA_hour": "05",
      "RA_min": 30,
      "RA_sec": 47,
      "dec_deg": "+05",
      "dec_min": 56,
      "dec_sec": 53,
      "magnitude": 4.2
    },
    {
      "ID": 1843,
      "greek_letter": "chi",
      "constellation": "Aur",
      "RA_hour": "05",
      "RA_min": 32,
      "RA_sec": 43.6,
      "dec_deg": "+32",
      "dec_min": 11,
      "dec_sec": 31,
      "magnitude": 4.79
    },
    {
      "ID": 1845,
      "greek_letter": "",
      "constellation": "Tau",
      "RA_hour": "05",
      "RA_min": 32,
      "RA_sec": 12.7,
      "dec_deg": "+18",
      "dec_min": 35,
      "dec_sec": 39,
      "magnitude": 4.33
    },
    {
      "ID": 1852,
      "greek_letter": "del",
      "constellation": "Ori",
      "RA_hour": "05",
      "RA_min": 32,
      "RA_sec": "00.3",
      "dec_deg": "-00",
      "dec_min": 17,
      "dec_sec": 57,
      "magnitude": 2.24
    },
    {
      "ID": 1855,
      "greek_letter": "ups",
      "constellation": "Ori",
      "RA_hour": "05",
      "RA_min": 31,
      "RA_sec": 55.8,
      "dec_deg": "-07",
      "dec_min": 18,
      "dec_sec": "06",
      "magnitude": 4.63
    },
    {
      "ID": 1862,
      "greek_letter": "eps",
      "constellation": "Col",
      "RA_hour": "05",
      "RA_min": 31,
      "RA_sec": 12.7,
      "dec_deg": -35,
      "dec_min": 28,
      "dec_sec": 14,
      "magnitude": 3.87
    },
    {
      "ID": 1865,
      "greek_letter": "alf",
      "constellation": "Lep",
      "RA_hour": "05",
      "RA_min": 32,
      "RA_sec": 43.7,
      "dec_deg": -17,
      "dec_min": 49,
      "dec_sec": 20,
      "magnitude": 2.57
    },
    {
      "ID": 1876,
      "greek_letter": "phi1",
      "constellation": "Ori",
      "RA_hour": "05",
      "RA_min": 34,
      "RA_sec": 49.2,
      "dec_deg": "+09",
      "dec_min": 29,
      "dec_sec": 22,
      "magnitude": 4.41
    },
    {
      "ID": 1879,
      "greek_letter": "lam",
      "constellation": "Ori",
      "RA_hour": "05",
      "RA_min": 35,
      "RA_sec": "08.2",
      "dec_deg": "+09",
      "dec_min": 56,
      "dec_sec": "03",
      "magnitude": 3.66
    },
    {
      "ID": 1887,
      "greek_letter": "",
      "constellation": "",
      "RA_hour": "05",
      "RA_min": 35,
      "RA_sec": "02.6",
      "dec_deg": "-06",
      "dec_min": "00",
      "dec_sec": "07",
      "magnitude": 4.78
    },
    {
      "ID": 1892,
      "greek_letter": "",
      "constellation": "Ori",
      "RA_hour": "05",
      "RA_min": 35,
      "RA_sec": 23.1,
      "dec_deg": "-04",
      "dec_min": 50,
      "dec_sec": 18,
      "magnitude": 4.59
    },
    {
      "ID": 1899,
      "greek_letter": "iot",
      "constellation": "Ori",
      "RA_hour": "05",
      "RA_min": 35,
      "RA_sec": 25.9,
      "dec_deg": "-05",
      "dec_min": 54,
      "dec_sec": 36,
      "magnitude": 2.76
    },
    {
      "ID": 1903,
      "greek_letter": "eps",
      "constellation": "Ori",
      "RA_hour": "05",
      "RA_min": 36,
      "RA_sec": 12.7,
      "dec_deg": "-01",
      "dec_min": 12,
      "dec_sec": "07",
      "magnitude": 1.69
    },
    {
      "ID": 1907,
      "greek_letter": "phi2",
      "constellation": "Ori",
      "RA_hour": "05",
      "RA_min": 36,
      "RA_sec": 54.3,
      "dec_deg": "+09",
      "dec_min": 17,
      "dec_sec": 26,
      "magnitude": 4.09
    },
    {
      "ID": 1910,
      "greek_letter": "zet",
      "constellation": "Tau",
      "RA_hour": "05",
      "RA_min": 37,
      "RA_sec": 38.6,
      "dec_deg": "+21",
      "dec_min": "08",
      "dec_sec": 33,
      "magnitude": 3.03
    },
    {
      "ID": 1922,
      "greek_letter": "bet",
      "constellation": "Dor",
      "RA_hour": "05",
      "RA_min": 33,
      "RA_sec": 37.5,
      "dec_deg": -62,
      "dec_min": 29,
      "dec_sec": 24,
      "magnitude": 3.76
    },
    {
      "ID": 1931,
      "greek_letter": "sig",
      "constellation": "Ori",
      "RA_hour": "05",
      "RA_min": 38,
      "RA_sec": 44.7,
      "dec_deg": "-02",
      "dec_min": 36,
      "dec_sec": "00",
      "magnitude": 3.8
    },
    {
      "ID": 1934,
      "greek_letter": "omg",
      "constellation": "Ori",
      "RA_hour": "05",
      "RA_min": 39,
      "RA_sec": 11.1,
      "dec_deg": "+04",
      "dec_min": "07",
      "dec_sec": 17,
      "magnitude": 4.59
    },
    {
      "ID": 1937,
      "greek_letter": "",
      "constellation": "Ori",
      "RA_hour": "05",
      "RA_min": 38,
      "RA_sec": 53,
      "dec_deg": "-07",
      "dec_min": 12,
      "dec_sec": 47,
      "magnitude": 4.81
    },
    {
      "ID": 1946,
      "greek_letter": "",
      "constellation": "Tau",
      "RA_hour": "05",
      "RA_min": 41,
      "RA_sec": 17.7,
      "dec_deg": "+16",
      "dec_min": 32,
      "dec_sec": "02",
      "magnitude": 4.86
    },
    {
      "ID": 1948,
      "greek_letter": "zet",
      "constellation": "Ori",
      "RA_hour": "05",
      "RA_min": 40,
      "RA_sec": 45.5,
      "dec_deg": "-01",
      "dec_min": 56,
      "dec_sec": 34,
      "magnitude": 2.05
    },
    {
      "ID": 1949,
      "greek_letter": "zet",
      "constellation": "Ori",
      "RA_hour": "05",
      "RA_min": 40,
      "RA_sec": 45.5,
      "dec_deg": "-01",
      "dec_min": 56,
      "dec_sec": 34,
      "magnitude": 4.21
    },
    {
      "ID": 1952,
      "greek_letter": "",
      "constellation": "",
      "RA_hour": "05",
      "RA_min": 40,
      "RA_sec": 50.6,
      "dec_deg": "-01",
      "dec_min": "07",
      "dec_sec": 44,
      "magnitude": 4.95
    },
    {
      "ID": 1956,
      "greek_letter": "alf",
      "constellation": "Col",
      "RA_hour": "05",
      "RA_min": 39,
      "RA_sec": 38.9,
      "dec_deg": -34,
      "dec_min": "04",
      "dec_sec": 27,
      "magnitude": 2.65
    },
    {
      "ID": 1963,
      "greek_letter": "",
      "constellation": "Ori",
      "RA_hour": "05",
      "RA_min": 42,
      "RA_sec": 28.6,
      "dec_deg": "+01",
      "dec_min": 28,
      "dec_sec": 29,
      "magnitude": 4.9
    },
    {
      "ID": 1983,
      "greek_letter": "gam",
      "constellation": "Lep",
      "RA_hour": "05",
      "RA_min": 44,
      "RA_sec": 27.8,
      "dec_deg": -22,
      "dec_min": 26,
      "dec_sec": 54,
      "magnitude": 3.6
    },
    {
      "ID": 1995,
      "greek_letter": "tau",
      "constellation": "Aur",
      "RA_hour": "05",
      "RA_min": 49,
      "RA_sec": 10.4,
      "dec_deg": "+39",
      "dec_min": 10,
      "dec_sec": 52,
      "magnitude": 4.53
    },
    {
      "ID": 1998,
      "greek_letter": "zet",
      "constellation": "Lep",
      "RA_hour": "05",
      "RA_min": 46,
      "RA_sec": 57.3,
      "dec_deg": -14,
      "dec_min": 49,
      "dec_sec": 19,
      "magnitude": 3.54
    },
    {
      "ID": 2002,
      "greek_letter": "",
      "constellation": "Tau",
      "RA_hour": "05",
      "RA_min": 49,
      "RA_sec": "00.9",
      "dec_deg": "+24",
      "dec_min": 34,
      "dec_sec": "03",
      "magnitude": 4.86
    },
    {
      "ID": 2004,
      "greek_letter": "kap",
      "constellation": "Ori",
      "RA_hour": "05",
      "RA_min": 47,
      "RA_sec": 45.3,
      "dec_deg": "-09",
      "dec_min": 40,
      "dec_sec": 11,
      "magnitude": 2.06
    },
    {
      "ID": 2010,
      "greek_letter": "",
      "constellation": "Tau",
      "RA_hour": "05",
      "RA_min": 49,
      "RA_sec": 32.9,
      "dec_deg": "+12",
      "dec_min": 39,
      "dec_sec": "04",
      "magnitude": 4.91
    },
    {
      "ID": 2011,
      "greek_letter": "ups",
      "constellation": "Aur",
      "RA_hour": "05",
      "RA_min": 51,
      "RA_sec": "02.4",
      "dec_deg": "+37",
      "dec_min": 18,
      "dec_sec": 20,
      "magnitude": 4.74
    },
    {
      "ID": 2012,
      "greek_letter": "nu",
      "constellation": "Aur",
      "RA_hour": "05",
      "RA_min": 51,
      "RA_sec": 29.3,
      "dec_deg": "+39",
      "dec_min": "08",
      "dec_sec": 55,
      "magnitude": 3.97
    },
    {
      "ID": 2015,
      "greek_letter": "del",
      "constellation": "Dor",
      "RA_hour": "05",
      "RA_min": 44,
      "RA_sec": 46.5,
      "dec_deg": -65,
      "dec_min": 44,
      "dec_sec": "08",
      "magnitude": 4.35
    },
    {
      "ID": 2020,
      "greek_letter": "bet",
      "constellation": "Pic",
      "RA_hour": "05",
      "RA_min": 47,
      "RA_sec": 17.1,
      "dec_deg": -51,
      "dec_min": "03",
      "dec_sec": 59,
      "magnitude": 3.85
    },
    {
      "ID": 2029,
      "greek_letter": "xi",
      "constellation": "Aur",
      "RA_hour": "05",
      "RA_min": 54,
      "RA_sec": 50.7,
      "dec_deg": "+55",
      "dec_min": 42,
      "dec_sec": 25,
      "magnitude": 5
    },
    {
      "ID": 2034,
      "greek_letter": "",
      "constellation": "Tau",
      "RA_hour": "05",
      "RA_min": 53,
      "RA_sec": 19.6,
      "dec_deg": "+27",
      "dec_min": 36,
      "dec_sec": 44,
      "magnitude": 4.59
    },
    {
      "ID": 2035,
      "greek_letter": "del",
      "constellation": "Lep",
      "RA_hour": "05",
      "RA_min": 51,
      "RA_sec": 19.2,
      "dec_deg": -20,
      "dec_min": 52,
      "dec_sec": 45,
      "magnitude": 3.85
    },
    {
      "ID": 2037,
      "greek_letter": "",
      "constellation": "Ori",
      "RA_hour": "05",
      "RA_min": 52,
      "RA_sec": 26.4,
      "dec_deg": "+01",
      "dec_min": 51,
      "dec_sec": 19,
      "magnitude": 4.78
    },
    {
      "ID": 2040,
      "greek_letter": "bet",
      "constellation": "Col",
      "RA_hour": "05",
      "RA_min": 50,
      "RA_sec": 57.5,
      "dec_deg": -35,
      "dec_min": 46,
      "dec_sec": "06",
      "magnitude": 3.12
    },
    {
      "ID": 2042,
      "greek_letter": "gam",
      "constellation": "Pic",
      "RA_hour": "05",
      "RA_min": 49,
      "RA_sec": 49.6,
      "dec_deg": -56,
      "dec_min": 10,
      "dec_sec": "00",
      "magnitude": 4.51
    },
    {
      "ID": 2047,
      "greek_letter": "chi1",
      "constellation": "Ori",
      "RA_hour": "05",
      "RA_min": 54,
      "RA_sec": 22.9,
      "dec_deg": "+20",
      "dec_min": 16,
      "dec_sec": 34,
      "magnitude": 4.41
    },
    {
      "ID": 2056,
      "greek_letter": "lam",
      "constellation": "Col",
      "RA_hour": "05",
      "RA_min": 53,
      "RA_sec": "06.8",
      "dec_deg": -33,
      "dec_min": 48,
      "dec_sec": "05",
      "magnitude": 4.87
    },
    {
      "ID": 2061,
      "greek_letter": "alf",
      "constellation": "Ori",
      "RA_hour": "05",
      "RA_min": 55,
      "RA_sec": 10.3,
      "dec_deg": "+07",
      "dec_min": 24,
      "dec_sec": 25,
      "magnitude": 0.5
    },
    {
      "ID": 2077,
      "greek_letter": "del",
      "constellation": "Aur",
      "RA_hour": "05",
      "RA_min": 59,
      "RA_sec": 31.6,
      "dec_deg": "+54",
      "dec_min": 17,
      "dec_sec": "05",
      "magnitude": 3.72
    },
    {
      "ID": 2084,
      "greek_letter": "",
      "constellation": "Tau",
      "RA_hour": "05",
      "RA_min": 57,
      "RA_sec": 59.6,
      "dec_deg": "+25",
      "dec_min": 57,
      "dec_sec": 14,
      "magnitude": 4.82
    },
    {
      "ID": 2085,
      "greek_letter": "eta",
      "constellation": "Lep",
      "RA_hour": "05",
      "RA_min": 56,
      "RA_sec": 24.2,
      "dec_deg": -14,
      "dec_min": 10,
      "dec_sec": "04",
      "magnitude": 3.72
    },
    {
      "ID": 2087,
      "greek_letter": "xi",
      "constellation": "Col",
      "RA_hour": "05",
      "RA_min": 55,
      "RA_sec": 29.8,
      "dec_deg": -37,
      "dec_min": "07",
      "dec_sec": 15,
      "magnitude": 4.97
    },
    {
      "ID": 2088,
      "greek_letter": "bet",
      "constellation": "Aur",
      "RA_hour": "05",
      "RA_min": 59,
      "RA_sec": 31.7,
      "dec_deg": "+44",
      "dec_min": 56,
      "dec_sec": 51,
      "magnitude": 1.9
    },
    {
      "ID": 2091,
      "greek_letter": "pi",
      "constellation": "Aur",
      "RA_hour": "05",
      "RA_min": 59,
      "RA_sec": 56.1,
      "dec_deg": "+45",
      "dec_min": 56,
      "dec_sec": 13,
      "magnitude": 4.25
    },
    {
      "ID": 2095,
      "greek_letter": "tet",
      "constellation": "Aur",
      "RA_hour": "05",
      "RA_min": 59,
      "RA_sec": 43.2,
      "dec_deg": "+37",
      "dec_min": 12,
      "dec_sec": 45,
      "magnitude": 2.62
    },
    {
      "ID": 2102,
      "greek_letter": "",
      "constellation": "",
      "RA_hour": "05",
      "RA_min": 54,
      "RA_sec": "06.1",
      "dec_deg": -63,
      "dec_min": "05",
      "dec_sec": 23,
      "magnitude": 4.65
    },
    {
      "ID": 2106,
      "greek_letter": "gam",
      "constellation": "Col",
      "RA_hour": "05",
      "RA_min": 57,
      "RA_sec": 32.2,
      "dec_deg": -35,
      "dec_min": 17,
      "dec_sec": "00",
      "magnitude": 4.36
    },
    {
      "ID": 2113,
      "greek_letter": "",
      "constellation": "",
      "RA_hour": "06",
      "RA_min": "00",
      "RA_sec": "03.3",
      "dec_deg": "-03",
      "dec_min": "04",
      "dec_sec": 27,
      "magnitude": 4.52
    },
    {
      "ID": 2120,
      "greek_letter": "eta",
      "constellation": "Col",
      "RA_hour": "05",
      "RA_min": 59,
      "RA_sec": "08.7",
      "dec_deg": -42,
      "dec_min": 48,
      "dec_sec": 55,
      "magnitude": 3.96
    },
    {
      "ID": 2124,
      "greek_letter": "mu",
      "constellation": "Ori",
      "RA_hour": "06",
      "RA_min": "02",
      "RA_sec": 23,
      "dec_deg": "+09",
      "dec_min": 38,
      "dec_sec": 51,
      "magnitude": 4.12
    },
    {
      "ID": 2128,
      "greek_letter": "",
      "constellation": "Mon",
      "RA_hour": "06",
      "RA_min": "01",
      "RA_sec": 50.3,
      "dec_deg": -10,
      "dec_min": 35,
      "dec_sec": 53,
      "magnitude": 4.94
    },
    {
      "ID": 2134,
      "greek_letter": "",
      "constellation": "Gem",
      "RA_hour": "06",
      "RA_min": "04",
      "RA_sec": "07.2",
      "dec_deg": "+23",
      "dec_min": 15,
      "dec_sec": 48,
      "magnitude": 4.15
    },
    {
      "ID": 2135,
      "greek_letter": "chi2",
      "constellation": "Ori",
      "RA_hour": "06",
      "RA_min": "03",
      "RA_sec": 55.2,
      "dec_deg": "+20",
      "dec_min": "08",
      "dec_sec": 18,
      "magnitude": 4.63
    },
    {
      "ID": 2148,
      "greek_letter": "",
      "constellation": "Lep",
      "RA_hour": "06",
      "RA_min": "04",
      "RA_sec": 59,
      "dec_deg": -16,
      "dec_min": 29,
      "dec_sec": "04",
      "magnitude": 4.93
    },
    {
      "ID": 2155,
      "greek_letter": "tet",
      "constellation": "Lep",
      "RA_hour": "06",
      "RA_min": "06",
      "RA_sec": "09.3",
      "dec_deg": -14,
      "dec_min": 56,
      "dec_sec": "07",
      "magnitude": 4.67
    },
    {
      "ID": 2159,
      "greek_letter": "nu",
      "constellation": "Ori",
      "RA_hour": "06",
      "RA_min": "07",
      "RA_sec": 34.3,
      "dec_deg": "+14",
      "dec_min": 46,
      "dec_sec": "06",
      "magnitude": 4.42
    },
    {
      "ID": 2198,
      "greek_letter": "",
      "constellation": "Ori",
      "RA_hour": "06",
      "RA_min": 12,
      "RA_sec": "03.3",
      "dec_deg": "+16",
      "dec_min": "07",
      "dec_sec": 50,
      "magnitude": 4.92
    },
    {
      "ID": 2199,
      "greek_letter": "xi",
      "constellation": "Ori",
      "RA_hour": "06",
      "RA_min": 11,
      "RA_sec": 56.4,
      "dec_deg": "+14",
      "dec_min": 12,
      "dec_sec": 31,
      "magnitude": 4.48
    },
    {
      "ID": 2209,
      "greek_letter": "",
      "constellation": "",
      "RA_hour": "06",
      "RA_min": 18,
      "RA_sec": 50.8,
      "dec_deg": "+69",
      "dec_min": 19,
      "dec_sec": 12,
      "magnitude": 4.8
    },
    {
      "ID": 2212,
      "greek_letter": "del",
      "constellation": "Pic",
      "RA_hour": "06",
      "RA_min": 10,
      "RA_sec": 17.9,
      "dec_deg": -54,
      "dec_min": 58,
      "dec_sec": "07",
      "magnitude": 4.81
    },
    {
      "ID": 2215,
      "greek_letter": "",
      "constellation": "Lyn",
      "RA_hour": "06",
      "RA_min": 17,
      "RA_sec": 54.9,
      "dec_deg": "+61",
      "dec_min": 30,
      "dec_sec": 55,
      "magnitude": 4.98
    },
    {
      "ID": 2216,
      "greek_letter": "eta",
      "constellation": "Gem",
      "RA_hour": "06",
      "RA_min": 14,
      "RA_sec": 52.6,
      "dec_deg": "+22",
      "dec_min": 30,
      "dec_sec": 24,
      "magnitude": 3.28
    },
    {
      "ID": 2219,
      "greek_letter": "kap",
      "constellation": "Aur",
      "RA_hour": "06",
      "RA_min": 15,
      "RA_sec": 22.6,
      "dec_deg": "+29",
      "dec_min": 29,
      "dec_sec": 53,
      "magnitude": 4.35
    },
    {
      "ID": 2227,
      "greek_letter": "gam",
      "constellation": "Mon",
      "RA_hour": "06",
      "RA_min": 14,
      "RA_sec": 51.3,
      "dec_deg": "-06",
      "dec_min": 16,
      "dec_sec": 29,
      "magnitude": 3.96
    },
    {
      "ID": 2238,
      "greek_letter": "",
      "constellation": "Lyn",
      "RA_hour": "06",
      "RA_min": 19,
      "RA_sec": 37.3,
      "dec_deg": "+59",
      "dec_min": "00",
      "dec_sec": 39,
      "magnitude": 4.48
    },
    {
      "ID": 2256,
      "greek_letter": "kap",
      "constellation": "Col",
      "RA_hour": "06",
      "RA_min": 16,
      "RA_sec": 33,
      "dec_deg": -35,
      "dec_min": "08",
      "dec_sec": 26,
      "magnitude": 4.37
    },
    {
      "ID": 2275,
      "greek_letter": "",
      "constellation": "",
      "RA_hour": "06",
      "RA_min": 19,
      "RA_sec": 59.5,
      "dec_deg": "-02",
      "dec_min": 56,
      "dec_sec": 40,
      "magnitude": 4.9
    },
    {
      "ID": 2282,
      "greek_letter": "zet",
      "constellation": "CMa",
      "RA_hour": "06",
      "RA_min": 20,
      "RA_sec": 18.7,
      "dec_deg": -30,
      "dec_min": "03",
      "dec_sec": 48,
      "magnitude": 3.02
    },
    {
      "ID": 2286,
      "greek_letter": "mu",
      "constellation": "Gem",
      "RA_hour": "06",
      "RA_min": 22,
      "RA_sec": 57.6,
      "dec_deg": "+22",
      "dec_min": 30,
      "dec_sec": 49,
      "magnitude": 2.87
    },
    {
      "ID": 2289,
      "greek_letter": "psi1",
      "constellation": "Aur",
      "RA_hour": "06",
      "RA_min": 24,
      "RA_sec": 53.8,
      "dec_deg": "+49",
      "dec_min": 17,
      "dec_sec": 17,
      "magnitude": 4.75
    },
    {
      "ID": 2294,
      "greek_letter": "bet",
      "constellation": "CMa",
      "RA_hour": "06",
      "RA_min": 22,
      "RA_sec": 41.9,
      "dec_deg": -17,
      "dec_min": 57,
      "dec_sec": 22,
      "magnitude": 1.97
    },
    {
      "ID": 2296,
      "greek_letter": "del",
      "constellation": "Col",
      "RA_hour": "06",
      "RA_min": 22,
      "RA_sec": "06.7",
      "dec_deg": -33,
      "dec_min": 26,
      "dec_sec": 11,
      "magnitude": 3.85
    },
    {
      "ID": 2298,
      "greek_letter": "eps",
      "constellation": "Mon",
      "RA_hour": "06",
      "RA_min": 23,
      "RA_sec": 46,
      "dec_deg": "+04",
      "dec_min": 35,
      "dec_sec": 34,
      "magnitude": 4.44
    },
    {
      "ID": 2326,
      "greek_letter": "alf",
      "constellation": "Car",
      "RA_hour": "06",
      "RA_min": 23,
      "RA_sec": 57.2,
      "dec_deg": -52,
      "dec_min": 41,
      "dec_sec": 44,
      "magnitude": -0.72
    },
    {
      "ID": 2343,
      "greek_letter": "nu",
      "constellation": "Gem",
      "RA_hour": "06",
      "RA_min": 28,
      "RA_sec": 57.7,
      "dec_deg": "+20",
      "dec_min": 12,
      "dec_sec": 43,
      "magnitude": 4.14
    },
    {
      "ID": 2356,
      "greek_letter": "bet",
      "constellation": "Mon",
      "RA_hour": "06",
      "RA_min": 28,
      "RA_sec": 48.9,
      "dec_deg": "-07",
      "dec_min": "01",
      "dec_sec": 59,
      "magnitude": 4.6
    },
    {
      "ID": 2361,
      "greek_letter": "lam",
      "constellation": "CMa",
      "RA_hour": "06",
      "RA_min": 28,
      "RA_sec": 10.1,
      "dec_deg": -32,
      "dec_min": 34,
      "dec_sec": 49,
      "magnitude": 4.48
    },
    {
      "ID": 2385,
      "greek_letter": "",
      "constellation": "Mon",
      "RA_hour": "06",
      "RA_min": 32,
      "RA_sec": 54.2,
      "dec_deg": "+07",
      "dec_min": 19,
      "dec_sec": 58,
      "magnitude": 4.5
    },
    {
      "ID": 2387,
      "greek_letter": "xi1",
      "constellation": "CMa",
      "RA_hour": "06",
      "RA_min": 31,
      "RA_sec": 51.3,
      "dec_deg": -23,
      "dec_min": 25,
      "dec_sec": "06",
      "magnitude": 4.33
    },
    {
      "ID": 2414,
      "greek_letter": "xi2",
      "constellation": "CMa",
      "RA_hour": "06",
      "RA_min": 35,
      "RA_sec": "03.3",
      "dec_deg": -22,
      "dec_min": 57,
      "dec_sec": 53,
      "magnitude": 4.54
    },
    {
      "ID": 2421,
      "greek_letter": "gam",
      "constellation": "Gem",
      "RA_hour": "06",
      "RA_min": 37,
      "RA_sec": 42.7,
      "dec_deg": "+16",
      "dec_min": 23,
      "dec_sec": 57,
      "magnitude": 1.92
    },
    {
      "ID": 2427,
      "greek_letter": "psi2",
      "constellation": "Aur",
      "RA_hour": "06",
      "RA_min": 39,
      "RA_sec": 19.8,
      "dec_deg": "+42",
      "dec_min": 29,
      "dec_sec": 20,
      "magnitude": 4.82
    },
    {
      "ID": 2429,
      "greek_letter": "nu2",
      "constellation": "CMa",
      "RA_hour": "06",
      "RA_min": 36,
      "RA_sec": 41,
      "dec_deg": -19,
      "dec_min": 15,
      "dec_sec": 22,
      "magnitude": 3.91
    },
    {
      "ID": 2435,
      "greek_letter": "",
      "constellation": "",
      "RA_hour": "06",
      "RA_min": 34,
      "RA_sec": 58.5,
      "dec_deg": -52,
      "dec_min": 58,
      "dec_sec": 32,
      "magnitude": 4.39
    },
    {
      "ID": 2443,
      "greek_letter": "nu3",
      "constellation": "CMa",
      "RA_hour": "06",
      "RA_min": 37,
      "RA_sec": 53.3,
      "dec_deg": -18,
      "dec_min": 14,
      "dec_sec": 15,
      "magnitude": 4.42
    },
    {
      "ID": 2450,
      "greek_letter": "",
      "constellation": "",
      "RA_hour": "06",
      "RA_min": 39,
      "RA_sec": 16.6,
      "dec_deg": -14,
      "dec_min": "08",
      "dec_sec": 45,
      "magnitude": 4.82
    },
    {
      "ID": 2451,
      "greek_letter": "nu",
      "constellation": "Pup",
      "RA_hour": "06",
      "RA_min": 37,
      "RA_sec": 45.6,
      "dec_deg": -43,
      "dec_min": 11,
      "dec_sec": 45,
      "magnitude": 3.17
    },
    {
      "ID": 2456,
      "greek_letter": "",
      "constellation": "Mon",
      "RA_hour": "06",
      "RA_min": 40,
      "RA_sec": 58.6,
      "dec_deg": "+09",
      "dec_min": 53,
      "dec_sec": 44,
      "magnitude": 4.66
    },
    {
      "ID": 2462,
      "greek_letter": "",
      "constellation": "",
      "RA_hour": "06",
      "RA_min": 38,
      "RA_sec": 37.6,
      "dec_deg": -48,
      "dec_min": 13,
      "dec_sec": 13,
      "magnitude": 4.93
    },
    {
      "ID": 2470,
      "greek_letter": "",
      "constellation": "Lyn",
      "RA_hour": "06",
      "RA_min": 46,
      "RA_sec": 14.1,
      "dec_deg": "+59",
      "dec_min": 26,
      "dec_sec": 30,
      "magnitude": 4.87
    },
    {
      "ID": 2473,
      "greek_letter": "eps",
      "constellation": "Gem",
      "RA_hour": "06",
      "RA_min": 43,
      "RA_sec": 55.9,
      "dec_deg": "+25",
      "dec_min": "07",
      "dec_sec": 52,
      "magnitude": 2.98
    },
    {
      "ID": 2478,
      "greek_letter": "",
      "constellation": "Gem",
      "RA_hour": "06",
      "RA_min": 43,
      "RA_sec": 59.2,
      "dec_deg": "+13",
      "dec_min": 13,
      "dec_sec": 40,
      "magnitude": 4.49
    },
    {
      "ID": 2484,
      "greek_letter": "xi",
      "constellation": "Gem",
      "RA_hour": "06",
      "RA_min": 45,
      "RA_sec": 17.3,
      "dec_deg": "+12",
      "dec_min": 53,
      "dec_sec": 44,
      "magnitude": 3.36
    },
    {
      "ID": 2491,
      "greek_letter": "alf",
      "constellation": "CMa",
      "RA_hour": "06",
      "RA_min": 45,
      "RA_sec": "08.9",
      "dec_deg": -16,
      "dec_min": 42,
      "dec_sec": 58,
      "magnitude": -1.46
    },
    {
      "ID": 2503,
      "greek_letter": "",
      "constellation": "Mon",
      "RA_hour": "06",
      "RA_min": 47,
      "RA_sec": 19.8,
      "dec_deg": "+08",
      "dec_min": "02",
      "dec_sec": 14,
      "magnitude": 4.76
    },
    {
      "ID": 2506,
      "greek_letter": "",
      "constellation": "Mon",
      "RA_hour": "06",
      "RA_min": 47,
      "RA_sec": 51.6,
      "dec_deg": "+02",
      "dec_min": 24,
      "dec_sec": 44,
      "magnitude": 4.46
    },
    {
      "ID": 2527,
      "greek_letter": "",
      "constellation": "",
      "RA_hour": "07",
      "RA_min": "00",
      "RA_sec": "04.0",
      "dec_deg": "+76",
      "dec_min": 58,
      "dec_sec": 39,
      "magnitude": 4.55
    },
    {
      "ID": 2538,
      "greek_letter": "kap",
      "constellation": "CMa",
      "RA_hour": "06",
      "RA_min": 49,
      "RA_sec": 50.4,
      "dec_deg": -32,
      "dec_min": 30,
      "dec_sec": 31,
      "magnitude": 3.89
    },
    {
      "ID": 2540,
      "greek_letter": "tet",
      "constellation": "Gem",
      "RA_hour": "06",
      "RA_min": 52,
      "RA_sec": 47.3,
      "dec_deg": "+33",
      "dec_min": 57,
      "dec_sec": 40,
      "magnitude": 3.6
    },
    {
      "ID": 2549,
      "greek_letter": "",
      "constellation": "",
      "RA_hour": "06",
      "RA_min": 50,
      "RA_sec": 52.3,
      "dec_deg": -34,
      "dec_min": 22,
      "dec_sec": "02",
      "magnitude": 4.99
    },
    {
      "ID": 2550,
      "greek_letter": "alf",
      "constellation": "Pic",
      "RA_hour": "06",
      "RA_min": 48,
      "RA_sec": 11.4,
      "dec_deg": -61,
      "dec_min": 56,
      "dec_sec": 29,
      "magnitude": 3.27
    },
    {
      "ID": 2553,
      "greek_letter": "tau",
      "constellation": "Pup",
      "RA_hour": "06",
      "RA_min": 49,
      "RA_sec": 56.1,
      "dec_deg": -50,
      "dec_min": 36,
      "dec_sec": 53,
      "magnitude": 2.93
    },
    {
      "ID": 2554,
      "greek_letter": "",
      "constellation": "",
      "RA_hour": "06",
      "RA_min": 49,
      "RA_sec": 51.3,
      "dec_deg": -53,
      "dec_min": 37,
      "dec_sec": 20,
      "magnitude": 4.4
    },
    {
      "ID": 2560,
      "greek_letter": "",
      "constellation": "Lyn",
      "RA_hour": "06",
      "RA_min": 57,
      "RA_sec": 16.5,
      "dec_deg": "+58",
      "dec_min": 25,
      "dec_sec": 21,
      "magnitude": 4.35
    },
    {
      "ID": 2564,
      "greek_letter": "",
      "constellation": "Gem",
      "RA_hour": "06",
      "RA_min": 54,
      "RA_sec": 38.6,
      "dec_deg": "+13",
      "dec_min": 10,
      "dec_sec": 40,
      "magnitude": 4.65
    },
    {
      "ID": 2571,
      "greek_letter": "",
      "constellation": "CMa",
      "RA_hour": "06",
      "RA_min": 53,
      "RA_sec": 32.8,
      "dec_deg": -20,
      "dec_min": 13,
      "dec_sec": 27,
      "magnitude": 4.83
    },
    {
      "ID": 2574,
      "greek_letter": "tet",
      "constellation": "CMa",
      "RA_hour": "06",
      "RA_min": 54,
      "RA_sec": 11.3,
      "dec_deg": -12,
      "dec_min": "02",
      "dec_sec": 19,
      "magnitude": 4.08
    },
    {
      "ID": 2580,
      "greek_letter": "omi1",
      "constellation": "CMa",
      "RA_hour": "06",
      "RA_min": 54,
      "RA_sec": "07.8",
      "dec_deg": -24,
      "dec_min": 11,
      "dec_sec": "02",
      "magnitude": 3.87
    },
    {
      "ID": 2585,
      "greek_letter": "",
      "constellation": "Lyn",
      "RA_hour": "06",
      "RA_min": 57,
      "RA_sec": 37,
      "dec_deg": "+45",
      "dec_min": "05",
      "dec_sec": 39,
      "magnitude": 4.9
    },
    {
      "ID": 2590,
      "greek_letter": "pi",
      "constellation": "CMa",
      "RA_hour": "06",
      "RA_min": 55,
      "RA_sec": 37.3,
      "dec_deg": -20,
      "dec_min": "08",
      "dec_sec": 11,
      "magnitude": 4.69
    },
    {
      "ID": 2593,
      "greek_letter": "mu",
      "constellation": "CMa",
      "RA_hour": "06",
      "RA_min": 56,
      "RA_sec": "06.6",
      "dec_deg": -14,
      "dec_min": "02",
      "dec_sec": 37,
      "magnitude": 5
    },
    {
      "ID": 2596,
      "greek_letter": "iot",
      "constellation": "CMa",
      "RA_hour": "06",
      "RA_min": 56,
      "RA_sec": "08.1",
      "dec_deg": -17,
      "dec_min": "03",
      "dec_sec": 15,
      "magnitude": 4.37
    },
    {
      "ID": 2608,
      "greek_letter": "",
      "constellation": "",
      "RA_hour": "06",
      "RA_min": 56,
      "RA_sec": 16,
      "dec_deg": -48,
      "dec_min": 43,
      "dec_sec": 16,
      "magnitude": 4.95
    },
    {
      "ID": 2618,
      "greek_letter": "eps",
      "constellation": "CMa",
      "RA_hour": "06",
      "RA_min": 58,
      "RA_sec": 37.5,
      "dec_deg": -28,
      "dec_min": 58,
      "dec_sec": 20,
      "magnitude": 1.5
    },
    {
      "ID": 2646,
      "greek_letter": "sig",
      "constellation": "CMa",
      "RA_hour": "07",
      "RA_min": "01",
      "RA_sec": 43.1,
      "dec_deg": -27,
      "dec_min": 56,
      "dec_sec": "06",
      "magnitude": 3.43
    },
    {
      "ID": 2648,
      "greek_letter": "",
      "constellation": "Mon",
      "RA_hour": "07",
      "RA_min": "02",
      "RA_sec": 54.6,
      "dec_deg": "-04",
      "dec_min": 14,
      "dec_sec": 21,
      "magnitude": 5
    },
    {
      "ID": 2650,
      "greek_letter": "zet",
      "constellation": "Gem",
      "RA_hour": "07",
      "RA_min": "04",
      "RA_sec": "06.5",
      "dec_deg": "+20",
      "dec_min": 34,
      "dec_sec": 13,
      "magnitude": 3.79
    },
    {
      "ID": 2653,
      "greek_letter": "omi2",
      "constellation": "CMa",
      "RA_hour": "07",
      "RA_min": "03",
      "RA_sec": "01.4",
      "dec_deg": -23,
      "dec_min": 50,
      "dec_sec": "00",
      "magnitude": 3.01
    },
    {
      "ID": 2657,
      "greek_letter": "gam",
      "constellation": "CMa",
      "RA_hour": "07",
      "RA_min": "03",
      "RA_sec": 45.4,
      "dec_deg": -15,
      "dec_min": 38,
      "dec_sec": "00",
      "magnitude": 4.11
    },
    {
      "ID": 2672,
      "greek_letter": "",
      "constellation": "",
      "RA_hour": "07",
      "RA_min": "03",
      "RA_sec": 53.7,
      "dec_deg": -49,
      "dec_min": 35,
      "dec_sec": "02",
      "magnitude": 4.93
    },
    {
      "ID": 2693,
      "greek_letter": "del",
      "constellation": "CMa",
      "RA_hour": "07",
      "RA_min": "08",
      "RA_sec": 23.4,
      "dec_deg": -26,
      "dec_min": 23,
      "dec_sec": 35,
      "magnitude": 1.84
    },
    {
      "ID": 2696,
      "greek_letter": "",
      "constellation": "Aur",
      "RA_hour": "07",
      "RA_min": 11,
      "RA_sec": 39.3,
      "dec_deg": "+39",
      "dec_min": 19,
      "dec_sec": 14,
      "magnitude": 4.99
    },
    {
      "ID": 2697,
      "greek_letter": "tau",
      "constellation": "Gem",
      "RA_hour": "07",
      "RA_min": 11,
      "RA_sec": "08.3",
      "dec_deg": "+30",
      "dec_min": 14,
      "dec_sec": 43,
      "magnitude": 4.42
    },
    {
      "ID": 2701,
      "greek_letter": "",
      "constellation": "Mon",
      "RA_hour": "07",
      "RA_min": 10,
      "RA_sec": 13.6,
      "dec_deg": "-04",
      "dec_min": 14,
      "dec_sec": 14,
      "magnitude": 4.92
    },
    {
      "ID": 2702,
      "greek_letter": "",
      "constellation": "",
      "RA_hour": "07",
      "RA_min": "08",
      "RA_sec": 51,
      "dec_deg": -39,
      "dec_min": 39,
      "dec_sec": 21,
      "magnitude": 4.83
    },
    {
      "ID": 2714,
      "greek_letter": "del",
      "constellation": "Mon",
      "RA_hour": "07",
      "RA_min": 11,
      "RA_sec": 51.8,
      "dec_deg": "-00",
      "dec_min": 29,
      "dec_sec": 34,
      "magnitude": 4.15
    },
    {
      "ID": 2717,
      "greek_letter": "",
      "constellation": "Gem",
      "RA_hour": "07",
      "RA_min": 13,
      "RA_sec": 22.2,
      "dec_deg": "+16",
      "dec_min": "09",
      "dec_sec": 32,
      "magnitude": 5
    },
    {
      "ID": 2736,
      "greek_letter": "gam2",
      "constellation": "Vol",
      "RA_hour": "07",
      "RA_min": "08",
      "RA_sec": 45,
      "dec_deg": -70,
      "dec_min": 29,
      "dec_sec": 57,
      "magnitude": 3.78
    },
    {
      "ID": 2740,
      "greek_letter": "",
      "constellation": "",
      "RA_hour": "07",
      "RA_min": 12,
      "RA_sec": 33.6,
      "dec_deg": -46,
      "dec_min": 45,
      "dec_sec": 34,
      "magnitude": 4.49
    },
    {
      "ID": 2742,
      "greek_letter": "",
      "constellation": "",
      "RA_hour": "07",
      "RA_min": 31,
      "RA_sec": "04.5",
      "dec_deg": "+82",
      "dec_min": 24,
      "dec_sec": 42,
      "magnitude": 4.96
    },
    {
      "ID": 2745,
      "greek_letter": "",
      "constellation": "CMa",
      "RA_hour": "07",
      "RA_min": 14,
      "RA_sec": 15.1,
      "dec_deg": -26,
      "dec_min": 21,
      "dec_sec": "09",
      "magnitude": 4.65
    },
    {
      "ID": 2746,
      "greek_letter": "",
      "constellation": "",
      "RA_hour": "07",
      "RA_min": 13,
      "RA_sec": 13.3,
      "dec_deg": -45,
      "dec_min": 10,
      "dec_sec": 59,
      "magnitude": 4.89
    },
    {
      "ID": 2749,
      "greek_letter": "omg",
      "constellation": "CMa",
      "RA_hour": "07",
      "RA_min": 14,
      "RA_sec": 48.6,
      "dec_deg": -26,
      "dec_min": 46,
      "dec_sec": 22,
      "magnitude": 3.82
    },
    {
      "ID": 2762,
      "greek_letter": "",
      "constellation": "",
      "RA_hour": "07",
      "RA_min": 14,
      "RA_sec": 38.1,
      "dec_deg": -48,
      "dec_min": 16,
      "dec_sec": 18,
      "magnitude": 4.76
    },
    {
      "ID": 2763,
      "greek_letter": "lam",
      "constellation": "Gem",
      "RA_hour": "07",
      "RA_min": 18,
      "RA_sec": "05.5",
      "dec_deg": "+16",
      "dec_min": 32,
      "dec_sec": 25,
      "magnitude": 3.58
    },
    {
      "ID": 2764,
      "greek_letter": "",
      "constellation": "",
      "RA_hour": "07",
      "RA_min": 16,
      "RA_sec": 36.7,
      "dec_deg": -23,
      "dec_min": 18,
      "dec_sec": 56,
      "magnitude": 4.79
    },
    {
      "ID": 2766,
      "greek_letter": "",
      "constellation": "",
      "RA_hour": "07",
      "RA_min": 16,
      "RA_sec": 34.9,
      "dec_deg": -27,
      "dec_min": 52,
      "dec_sec": 52,
      "magnitude": 4.6
    },
    {
      "ID": 2773,
      "greek_letter": "pi",
      "constellation": "Pup",
      "RA_hour": "07",
      "RA_min": 17,
      "RA_sec": "08.5",
      "dec_deg": -37,
      "dec_min": "05",
      "dec_sec": 51,
      "magnitude": 2.7
    },
    {
      "ID": 2777,
      "greek_letter": "del",
      "constellation": "Gem",
      "RA_hour": "07",
      "RA_min": 20,
      "RA_sec": "07.3",
      "dec_deg": "+21",
      "dec_min": 58,
      "dec_sec": 56,
      "magnitude": 3.53
    },
    {
      "ID": 2781,
      "greek_letter": "",
      "constellation": "CMa",
      "RA_hour": "07",
      "RA_min": 18,
      "RA_sec": 40.3,
      "dec_deg": -24,
      "dec_min": 33,
      "dec_sec": 32,
      "magnitude": 4.95
    },
    {
      "ID": 2782,
      "greek_letter": "tau",
      "constellation": "CMa",
      "RA_hour": "07",
      "RA_min": 18,
      "RA_sec": 42.4,
      "dec_deg": -24,
      "dec_min": 57,
      "dec_sec": 15,
      "magnitude": 4.4
    },
    {
      "ID": 2787,
      "greek_letter": "",
      "constellation": "",
      "RA_hour": "07",
      "RA_min": 18,
      "RA_sec": 18.4,
      "dec_deg": -36,
      "dec_min": 44,
      "dec_sec": "03",
      "magnitude": 4.67
    },
    {
      "ID": 2803,
      "greek_letter": "del",
      "constellation": "Vol",
      "RA_hour": "07",
      "RA_min": 16,
      "RA_sec": 49.8,
      "dec_deg": -67,
      "dec_min": 57,
      "dec_sec": 27,
      "magnitude": 3.98
    },
    {
      "ID": 2812,
      "greek_letter": "",
      "constellation": "",
      "RA_hour": "07",
      "RA_min": 22,
      "RA_sec": 13.5,
      "dec_deg": -19,
      "dec_min": "01",
      "dec_sec": "00",
      "magnitude": 4.96
    },
    {
      "ID": 2818,
      "greek_letter": "",
      "constellation": "Lyn",
      "RA_hour": "07",
      "RA_min": 26,
      "RA_sec": 42.8,
      "dec_deg": "+49",
      "dec_min": 12,
      "dec_sec": 42,
      "magnitude": 4.63
    },
    {
      "ID": 2821,
      "greek_letter": "iot",
      "constellation": "Gem",
      "RA_hour": "07",
      "RA_min": 25,
      "RA_sec": 43.5,
      "dec_deg": "+27",
      "dec_min": 47,
      "dec_sec": 53,
      "magnitude": 3.79
    },
    {
      "ID": 2827,
      "greek_letter": "eta",
      "constellation": "CMa",
      "RA_hour": "07",
      "RA_min": 24,
      "RA_sec": "05.6",
      "dec_deg": -29,
      "dec_min": 18,
      "dec_sec": 11,
      "magnitude": 2.44
    },
    {
      "ID": 2828,
      "greek_letter": "eps",
      "constellation": "CMi",
      "RA_hour": "07",
      "RA_min": 25,
      "RA_sec": 38.8,
      "dec_deg": "+09",
      "dec_min": 16,
      "dec_sec": 34,
      "magnitude": 4.99
    },
    {
      "ID": 2845,
      "greek_letter": "bet",
      "constellation": "CMi",
      "RA_hour": "07",
      "RA_min": 27,
      "RA_sec": "09.0",
      "dec_deg": "+08",
      "dec_min": 17,
      "dec_sec": 21,
      "magnitude": 2.89
    },
    {
      "ID": 2852,
      "greek_letter": "ro",
      "constellation": "Gem",
      "RA_hour": "07",
      "RA_min": 29,
      "RA_sec": "06.6",
      "dec_deg": "+31",
      "dec_min": 47,
      "dec_sec": "04",
      "magnitude": 4.18
    },
    {
      "ID": 2854,
      "greek_letter": "gam",
      "constellation": "CMi",
      "RA_hour": "07",
      "RA_min": 28,
      "RA_sec": "09.7",
      "dec_deg": "+08",
      "dec_min": 55,
      "dec_sec": 32,
      "magnitude": 4.3
    },
    {
      "ID": 2864,
      "greek_letter": "",
      "constellation": "CMi",
      "RA_hour": "07",
      "RA_min": 29,
      "RA_sec": 47.7,
      "dec_deg": "+12",
      "dec_min": "00",
      "dec_sec": 24,
      "magnitude": 4.55
    },
    {
      "ID": 2874,
      "greek_letter": "",
      "constellation": "",
      "RA_hour": "07",
      "RA_min": 29,
      "RA_sec": 51.4,
      "dec_deg": -23,
      "dec_min": "01",
      "dec_sec": 28,
      "magnitude": 4.86
    },
    {
      "ID": 2878,
      "greek_letter": "sig",
      "constellation": "Pup",
      "RA_hour": "07",
      "RA_min": 29,
      "RA_sec": 13.8,
      "dec_deg": -43,
      "dec_min": 18,
      "dec_sec": "05",
      "magnitude": 3.25
    },
    {
      "ID": 2881,
      "greek_letter": "",
      "constellation": "",
      "RA_hour": "07",
      "RA_min": 30,
      "RA_sec": 42.5,
      "dec_deg": -30,
      "dec_min": 57,
      "dec_sec": 44,
      "magnitude": 4.65
    },
    {
      "ID": 2890,
      "greek_letter": "alf",
      "constellation": "Gem",
      "RA_hour": "07",
      "RA_min": 34,
      "RA_sec": 35.9,
      "dec_deg": "+31",
      "dec_min": 53,
      "dec_sec": 18,
      "magnitude": 1.58
    },
    {
      "ID": 2891,
      "greek_letter": "alf",
      "constellation": "Gem",
      "RA_hour": "07",
      "RA_min": 34,
      "RA_sec": 35.9,
      "dec_deg": "+31",
      "dec_min": 53,
      "dec_sec": 18,
      "magnitude": 1.58
    },
    {
      "ID": 2902,
      "greek_letter": "",
      "constellation": "",
      "RA_hour": "07",
      "RA_min": 33,
      "RA_sec": 47.8,
      "dec_deg": -14,
      "dec_min": 31,
      "dec_sec": 26,
      "magnitude": 4.98
    },
    {
      "ID": 2905,
      "greek_letter": "ups",
      "constellation": "Gem",
      "RA_hour": "07",
      "RA_min": 35,
      "RA_sec": 55.3,
      "dec_deg": "+26",
      "dec_min": 53,
      "dec_sec": 44,
      "magnitude": 4.06
    },
    {
      "ID": 2906,
      "greek_letter": "",
      "constellation": "",
      "RA_hour": "07",
      "RA_min": 34,
      "RA_sec": "03.1",
      "dec_deg": -22,
      "dec_min": 17,
      "dec_sec": 46,
      "magnitude": 4.45
    },
    {
      "ID": 2922,
      "greek_letter": "",
      "constellation": "",
      "RA_hour": "07",
      "RA_min": 35,
      "RA_sec": 22.8,
      "dec_deg": -28,
      "dec_min": 22,
      "dec_sec": 10,
      "magnitude": 4.63
    },
    {
      "ID": 2930,
      "greek_letter": "omi",
      "constellation": "Gem",
      "RA_hour": "07",
      "RA_min": 39,
      "RA_sec": "09.9",
      "dec_deg": "+34",
      "dec_min": 35,
      "dec_sec": "04",
      "magnitude": 4.91
    },
    {
      "ID": 2934,
      "greek_letter": "",
      "constellation": "",
      "RA_hour": "07",
      "RA_min": 35,
      "RA_sec": 39.7,
      "dec_deg": -52,
      "dec_min": 32,
      "dec_sec": "02",
      "magnitude": 4.94
    },
    {
      "ID": 2937,
      "greek_letter": "",
      "constellation": "",
      "RA_hour": "07",
      "RA_min": 37,
      "RA_sec": 22,
      "dec_deg": -34,
      "dec_min": 58,
      "dec_sec": "06",
      "magnitude": 4.53
    },
    {
      "ID": 2943,
      "greek_letter": "alf",
      "constellation": "CMi",
      "RA_hour": "07",
      "RA_min": 39,
      "RA_sec": 18.1,
      "dec_deg": "+05",
      "dec_min": 13,
      "dec_sec": 30,
      "magnitude": 0.37
    },
    {
      "ID": 2944,
      "greek_letter": "",
      "constellation": "",
      "RA_hour": "07",
      "RA_min": 38,
      "RA_sec": 17.9,
      "dec_deg": -25,
      "dec_min": 21,
      "dec_sec": 54,
      "magnitude": 4.7
    },
    {
      "ID": 2946,
      "greek_letter": "",
      "constellation": "Lyn",
      "RA_hour": "07",
      "RA_min": 43,
      "RA_sec": "00.4",
      "dec_deg": "+58",
      "dec_min": 42,
      "dec_sec": 37,
      "magnitude": 4.99
    },
    {
      "ID": 2948,
      "greek_letter": "",
      "constellation": "",
      "RA_hour": "07",
      "RA_min": 38,
      "RA_sec": 49.3,
      "dec_deg": -26,
      "dec_min": 48,
      "dec_sec": "07",
      "magnitude": 4.5
    },
    {
      "ID": 2949,
      "greek_letter": "",
      "constellation": "",
      "RA_hour": "07",
      "RA_min": 38,
      "RA_sec": 49.7,
      "dec_deg": -26,
      "dec_min": 48,
      "dec_sec": 13,
      "magnitude": 4.62
    },
    {
      "ID": 2959,
      "greek_letter": "",
      "constellation": "",
      "RA_hour": "07",
      "RA_min": 40,
      "RA_sec": 23.1,
      "dec_deg": -15,
      "dec_min": 15,
      "dec_sec": 49,
      "magnitude": 4.96
    },
    {
      "ID": 2961,
      "greek_letter": "",
      "constellation": "",
      "RA_hour": "07",
      "RA_min": 39,
      "RA_sec": 27.3,
      "dec_deg": -38,
      "dec_min": 18,
      "dec_sec": 30,
      "magnitude": 4.85
    },
    {
      "ID": 2970,
      "greek_letter": "alf",
      "constellation": "Mon",
      "RA_hour": "07",
      "RA_min": 41,
      "RA_sec": 14.8,
      "dec_deg": "-09",
      "dec_min": 33,
      "dec_sec": "04",
      "magnitude": 3.93
    },
    {
      "ID": 2973,
      "greek_letter": "sig",
      "constellation": "Gem",
      "RA_hour": "07",
      "RA_min": 43,
      "RA_sec": 18.7,
      "dec_deg": "+28",
      "dec_min": 53,
      "dec_sec": "00",
      "magnitude": 4.29
    },
    {
      "ID": 2985,
      "greek_letter": "kap",
      "constellation": "Gem",
      "RA_hour": "07",
      "RA_min": 44,
      "RA_sec": 26.8,
      "dec_deg": "+24",
      "dec_min": 23,
      "dec_sec": 53,
      "magnitude": 3.57
    },
    {
      "ID": 2990,
      "greek_letter": "bet",
      "constellation": "Gem",
      "RA_hour": "07",
      "RA_min": 45,
      "RA_sec": 18.9,
      "dec_deg": "+28",
      "dec_min": "01",
      "dec_sec": 34,
      "magnitude": 1.14
    },
    {
      "ID": 2993,
      "greek_letter": "",
      "constellation": "Pup",
      "RA_hour": "07",
      "RA_min": 43,
      "RA_sec": 32.3,
      "dec_deg": -28,
      "dec_min": 24,
      "dec_sec": 40,
      "magnitude": 4.59
    },
    {
      "ID": 2996,
      "greek_letter": "",
      "constellation": "Pup",
      "RA_hour": "07",
      "RA_min": 43,
      "RA_sec": 48.4,
      "dec_deg": -28,
      "dec_min": 57,
      "dec_sec": 18,
      "magnitude": 3.95
    },
    {
      "ID": 3003,
      "greek_letter": "",
      "constellation": "Gem",
      "RA_hour": "07",
      "RA_min": 46,
      "RA_sec": "07.4",
      "dec_deg": "+18",
      "dec_min": 30,
      "dec_sec": 36,
      "magnitude": 4.87
    },
    {
      "ID": 3017,
      "greek_letter": "",
      "constellation": "",
      "RA_hour": "07",
      "RA_min": 45,
      "RA_sec": 15.2,
      "dec_deg": -37,
      "dec_min": 58,
      "dec_sec": "07",
      "magnitude": 3.61
    },
    {
      "ID": 3024,
      "greek_letter": "zet",
      "constellation": "Vol",
      "RA_hour": "07",
      "RA_min": 41,
      "RA_sec": 49.3,
      "dec_deg": -72,
      "dec_min": 36,
      "dec_sec": 22,
      "magnitude": 3.95
    },
    {
      "ID": 3034,
      "greek_letter": "omi",
      "constellation": "Pup",
      "RA_hour": "07",
      "RA_min": 48,
      "RA_sec": "05.1",
      "dec_deg": -25,
      "dec_min": 56,
      "dec_sec": 14,
      "magnitude": 4.49
    },
    {
      "ID": 3045,
      "greek_letter": "xi",
      "constellation": "Pup",
      "RA_hour": "07",
      "RA_min": 49,
      "RA_sec": 17.6,
      "dec_deg": -24,
      "dec_min": 51,
      "dec_sec": 35,
      "magnitude": 3.3
    },
    {
      "ID": 3046,
      "greek_letter": "",
      "constellation": "",
      "RA_hour": "07",
      "RA_min": 48,
      "RA_sec": 20.2,
      "dec_deg": -47,
      "dec_min": "04",
      "dec_sec": 40,
      "magnitude": 4.71
    },
    {
      "ID": 3055,
      "greek_letter": "",
      "constellation": "",
      "RA_hour": "07",
      "RA_min": 49,
      "RA_sec": 14.3,
      "dec_deg": -46,
      "dec_min": 22,
      "dec_sec": 24,
      "magnitude": 4.11
    },
    {
      "ID": 3067,
      "greek_letter": "phi",
      "constellation": "Gem",
      "RA_hour": "07",
      "RA_min": 53,
      "RA_sec": 29.7,
      "dec_deg": "+26",
      "dec_min": 45,
      "dec_sec": 57,
      "magnitude": 4.98
    },
    {
      "ID": 3080,
      "greek_letter": "",
      "constellation": "",
      "RA_hour": "07",
      "RA_min": 52,
      "RA_sec": 13,
      "dec_deg": -40,
      "dec_min": 34,
      "dec_sec": 33,
      "magnitude": 3.73
    },
    {
      "ID": 3084,
      "greek_letter": "",
      "constellation": "",
      "RA_hour": "07",
      "RA_min": 52,
      "RA_sec": 38.6,
      "dec_deg": -38,
      "dec_min": 51,
      "dec_sec": 47,
      "magnitude": 4.49
    },
    {
      "ID": 3089,
      "greek_letter": "",
      "constellation": "",
      "RA_hour": "07",
      "RA_min": 53,
      "RA_sec": "03.7",
      "dec_deg": -49,
      "dec_min": 36,
      "dec_sec": 47,
      "magnitude": 4.63
    },
    {
      "ID": 3090,
      "greek_letter": "",
      "constellation": "",
      "RA_hour": "07",
      "RA_min": 53,
      "RA_sec": 18.2,
      "dec_deg": -48,
      "dec_min": "06",
      "dec_sec": 11,
      "magnitude": 4.24
    },
    {
      "ID": 3102,
      "greek_letter": "",
      "constellation": "Pup",
      "RA_hour": "07",
      "RA_min": 56,
      "RA_sec": 51.5,
      "dec_deg": -22,
      "dec_min": 52,
      "dec_sec": 49,
      "magnitude": 4.2
    },
    {
      "ID": 3113,
      "greek_letter": "",
      "constellation": "",
      "RA_hour": "07",
      "RA_min": 57,
      "RA_sec": 40.1,
      "dec_deg": -30,
      "dec_min": 20,
      "dec_sec": "04",
      "magnitude": 4.79
    },
    {
      "ID": 3117,
      "greek_letter": "chi",
      "constellation": "Car",
      "RA_hour": "07",
      "RA_min": 56,
      "RA_sec": 46.7,
      "dec_deg": -52,
      "dec_min": 58,
      "dec_sec": 56,
      "magnitude": 3.47
    },
    {
      "ID": 3122,
      "greek_letter": "",
      "constellation": "Mon",
      "RA_hour": "07",
      "RA_min": 59,
      "RA_sec": 44.1,
      "dec_deg": "-03",
      "dec_min": 40,
      "dec_sec": 47,
      "magnitude": 4.93
    },
    {
      "ID": 3129,
      "greek_letter": "",
      "constellation": "",
      "RA_hour": "07",
      "RA_min": 58,
      "RA_sec": 14.3,
      "dec_deg": -49,
      "dec_min": 14,
      "dec_sec": 42,
      "magnitude": 4.41
    },
    {
      "ID": 3131,
      "greek_letter": "",
      "constellation": "",
      "RA_hour": "07",
      "RA_min": 59,
      "RA_sec": 52,
      "dec_deg": -18,
      "dec_min": 23,
      "dec_sec": 58,
      "magnitude": 4.61
    },
    {
      "ID": 3141,
      "greek_letter": "",
      "constellation": "Mon",
      "RA_hour": "08",
      "RA_min": "01",
      "RA_sec": 13.2,
      "dec_deg": "-01",
      "dec_min": 23,
      "dec_sec": 33,
      "magnitude": 4.67
    },
    {
      "ID": 3145,
      "greek_letter": "",
      "constellation": "",
      "RA_hour": "08",
      "RA_min": "02",
      "RA_sec": 15.9,
      "dec_deg": "+02",
      "dec_min": 20,
      "dec_sec": "04",
      "magnitude": 4.38
    },
    {
      "ID": 3149,
      "greek_letter": "chi",
      "constellation": "Gem",
      "RA_hour": "08",
      "RA_min": "03",
      "RA_sec": 31,
      "dec_deg": "+27",
      "dec_min": 47,
      "dec_sec": 39,
      "magnitude": 4.94
    },
    {
      "ID": 3159,
      "greek_letter": "",
      "constellation": "",
      "RA_hour": "08",
      "RA_min": "00",
      "RA_sec": 20,
      "dec_deg": -63,
      "dec_min": 34,
      "dec_sec": "03",
      "magnitude": 4.82
    },
    {
      "ID": 3165,
      "greek_letter": "zet",
      "constellation": "Pup",
      "RA_hour": "08",
      "RA_min": "03",
      "RA_sec": 35,
      "dec_deg": -40,
      "dec_min": "00",
      "dec_sec": 11,
      "magnitude": 2.25
    },
    {
      "ID": 3173,
      "greek_letter": "",
      "constellation": "Lyn",
      "RA_hour": "08",
      "RA_min": "08",
      "RA_sec": 27.4,
      "dec_deg": "+51",
      "dec_min": 30,
      "dec_sec": 24,
      "magnitude": 4.84
    },
    {
      "ID": 3185,
      "greek_letter": "ro",
      "constellation": "Pup",
      "RA_hour": "08",
      "RA_min": "07",
      "RA_sec": 32.6,
      "dec_deg": -24,
      "dec_min": 18,
      "dec_sec": 15,
      "magnitude": 2.81
    },
    {
      "ID": 3188,
      "greek_letter": "zet",
      "constellation": "Mon",
      "RA_hour": "08",
      "RA_min": "08",
      "RA_sec": 35.6,
      "dec_deg": "-02",
      "dec_min": 59,
      "dec_sec": "02",
      "magnitude": 4.33
    },
    {
      "ID": 3192,
      "greek_letter": "",
      "constellation": "Pup",
      "RA_hour": "08",
      "RA_min": "09",
      "RA_sec": "01.5",
      "dec_deg": -19,
      "dec_min": 14,
      "dec_sec": 42,
      "magnitude": 4.4
    },
    {
      "ID": 3206,
      "greek_letter": "gam1",
      "constellation": "Vel",
      "RA_hour": "08",
      "RA_min": "09",
      "RA_sec": 29.2,
      "dec_deg": -47,
      "dec_min": 20,
      "dec_sec": 44,
      "magnitude": 4.27
    },
    {
      "ID": 3207,
      "greek_letter": "gam2",
      "constellation": "Vel",
      "RA_hour": "08",
      "RA_min": "09",
      "RA_sec": 31.9,
      "dec_deg": -47,
      "dec_min": 20,
      "dec_sec": 12,
      "magnitude": 1.83
    },
    {
      "ID": 3211,
      "greek_letter": "",
      "constellation": "Pup",
      "RA_hour": "08",
      "RA_min": 11,
      "RA_sec": 16.2,
      "dec_deg": -12,
      "dec_min": 55,
      "dec_sec": 37,
      "magnitude": 4.72
    },
    {
      "ID": 3220,
      "greek_letter": "",
      "constellation": "",
      "RA_hour": "08",
      "RA_min": "09",
      "RA_sec": "00.7",
      "dec_deg": -61,
      "dec_min": 18,
      "dec_sec": "07",
      "magnitude": 4.76
    },
    {
      "ID": 3223,
      "greek_letter": "eps",
      "constellation": "Vol",
      "RA_hour": "08",
      "RA_min": "07",
      "RA_sec": 55.9,
      "dec_deg": -68,
      "dec_min": 37,
      "dec_sec": "02",
      "magnitude": 4.35
    },
    {
      "ID": 3225,
      "greek_letter": "",
      "constellation": "",
      "RA_hour": "08",
      "RA_min": 11,
      "RA_sec": 21.5,
      "dec_deg": -39,
      "dec_min": 37,
      "dec_sec": "07",
      "magnitude": 4.42
    },
    {
      "ID": 3226,
      "greek_letter": "",
      "constellation": "",
      "RA_hour": "08",
      "RA_min": 11,
      "RA_sec": 25.9,
      "dec_deg": -42,
      "dec_min": 59,
      "dec_sec": 14,
      "magnitude": 4.75
    },
    {
      "ID": 3229,
      "greek_letter": "",
      "constellation": "Pup",
      "RA_hour": "08",
      "RA_min": 13,
      "RA_sec": 19.9,
      "dec_deg": -15,
      "dec_min": 47,
      "dec_sec": 18,
      "magnitude": 5.01
    },
    {
      "ID": 3237,
      "greek_letter": "",
      "constellation": "",
      "RA_hour": "08",
      "RA_min": 13,
      "RA_sec": 29.5,
      "dec_deg": -35,
      "dec_min": 53,
      "dec_sec": 59,
      "magnitude": 4.77
    },
    {
      "ID": 3243,
      "greek_letter": "",
      "constellation": "",
      "RA_hour": "08",
      "RA_min": 14,
      "RA_sec": "02.8",
      "dec_deg": -40,
      "dec_min": 20,
      "dec_sec": 53,
      "magnitude": 4.44
    },
    {
      "ID": 3249,
      "greek_letter": "bet",
      "constellation": "Cnc",
      "RA_hour": "08",
      "RA_min": 16,
      "RA_sec": 30.9,
      "dec_deg": "+09",
      "dec_min": 11,
      "dec_sec": "08",
      "magnitude": 3.54
    },
    {
      "ID": 3270,
      "greek_letter": "",
      "constellation": "",
      "RA_hour": "08",
      "RA_min": 18,
      "RA_sec": 33.3,
      "dec_deg": -36,
      "dec_min": 39,
      "dec_sec": 34,
      "magnitude": 4.45
    },
    {
      "ID": 3275,
      "greek_letter": "",
      "constellation": "Lyn",
      "RA_hour": "08",
      "RA_min": 22,
      "RA_sec": 50.1,
      "dec_deg": "+43",
      "dec_min": 11,
      "dec_sec": 17,
      "magnitude": 4.25
    },
    {
      "ID": 3282,
      "greek_letter": "",
      "constellation": "",
      "RA_hour": "08",
      "RA_min": 21,
      "RA_sec": 23,
      "dec_deg": -33,
      "dec_min": "03",
      "dec_sec": 16,
      "magnitude": 4.83
    },
    {
      "ID": 3294,
      "greek_letter": "",
      "constellation": "",
      "RA_hour": "08",
      "RA_min": 22,
      "RA_sec": 31.5,
      "dec_deg": -48,
      "dec_min": 29,
      "dec_sec": 25,
      "magnitude": 4.82
    },
    {
      "ID": 3307,
      "greek_letter": "eps",
      "constellation": "Car",
      "RA_hour": "08",
      "RA_min": 22,
      "RA_sec": 30.8,
      "dec_deg": -59,
      "dec_min": 30,
      "dec_sec": 34,
      "magnitude": 1.86
    },
    {
      "ID": 3314,
      "greek_letter": "",
      "constellation": "",
      "RA_hour": "08",
      "RA_min": 25,
      "RA_sec": 39.6,
      "dec_deg": "-03",
      "dec_min": 54,
      "dec_sec": 23,
      "magnitude": 3.9
    },
    {
      "ID": 3318,
      "greek_letter": "alf",
      "constellation": "Cha",
      "RA_hour": "08",
      "RA_min": 18,
      "RA_sec": 31.7,
      "dec_deg": -76,
      "dec_min": 55,
      "dec_sec": 11,
      "magnitude": 4.07
    },
    {
      "ID": 3323,
      "greek_letter": "omi",
      "constellation": "UMa",
      "RA_hour": "08",
      "RA_min": 30,
      "RA_sec": 15.8,
      "dec_deg": "+60",
      "dec_min": 43,
      "dec_sec": "05",
      "magnitude": 3.42
    },
    {
      "ID": 3340,
      "greek_letter": "tet",
      "constellation": "Cha",
      "RA_hour": "08",
      "RA_min": 20,
      "RA_sec": 38.7,
      "dec_deg": -77,
      "dec_min": 29,
      "dec_sec": "04",
      "magnitude": 4.35
    },
    {
      "ID": 3347,
      "greek_letter": "bet",
      "constellation": "Vol",
      "RA_hour": "08",
      "RA_min": 25,
      "RA_sec": 44.3,
      "dec_deg": -66,
      "dec_min": "08",
      "dec_sec": 13,
      "magnitude": 3.77
    },
    {
      "ID": 3359,
      "greek_letter": "",
      "constellation": "",
      "RA_hour": "08",
      "RA_min": 29,
      "RA_sec": 27.5,
      "dec_deg": -44,
      "dec_min": 43,
      "dec_sec": 30,
      "magnitude": 4.99
    },
    {
      "ID": 3403,
      "greek_letter": "pi2",
      "constellation": "UMa",
      "RA_hour": "08",
      "RA_min": 40,
      "RA_sec": 12.9,
      "dec_deg": "+64",
      "dec_min": 19,
      "dec_sec": 41,
      "magnitude": 4.61
    },
    {
      "ID": 3410,
      "greek_letter": "del",
      "constellation": "Hya",
      "RA_hour": "08",
      "RA_min": 37,
      "RA_sec": 39.3,
      "dec_deg": "+05",
      "dec_min": 42,
      "dec_sec": 13,
      "magnitude": 4.17
    },
    {
      "ID": 3414,
      "greek_letter": "",
      "constellation": "",
      "RA_hour": "08",
      "RA_min": 35,
      "RA_sec": 19.6,
      "dec_deg": -58,
      "dec_min": "00",
      "dec_sec": 33,
      "magnitude": 4.86
    },
    {
      "ID": 3418,
      "greek_letter": "sig",
      "constellation": "Hya",
      "RA_hour": "08",
      "RA_min": 38,
      "RA_sec": 45.4,
      "dec_deg": "+03",
      "dec_min": 20,
      "dec_sec": 29,
      "magnitude": 4.43
    },
    {
      "ID": 3426,
      "greek_letter": "",
      "constellation": "",
      "RA_hour": "08",
      "RA_min": 37,
      "RA_sec": 38.6,
      "dec_deg": -42,
      "dec_min": 59,
      "dec_sec": 21,
      "magnitude": 4.14
    },
    {
      "ID": 3431,
      "greek_letter": "",
      "constellation": "Hya",
      "RA_hour": "08",
      "RA_min": 40,
      "RA_sec": "01.4",
      "dec_deg": -12,
      "dec_min": 28,
      "dec_sec": 32,
      "magnitude": 4.98
    },
    {
      "ID": 3433,
      "greek_letter": "zet",
      "constellation": "Pyx",
      "RA_hour": "08",
      "RA_min": 39,
      "RA_sec": 42.5,
      "dec_deg": -29,
      "dec_min": 33,
      "dec_sec": 40,
      "magnitude": 4.89
    },
    {
      "ID": 3438,
      "greek_letter": "bet",
      "constellation": "Pyx",
      "RA_hour": "08",
      "RA_min": 40,
      "RA_sec": "06.2",
      "dec_deg": -35,
      "dec_min": 18,
      "dec_sec": 29,
      "magnitude": 3.98
    },
    {
      "ID": 3441,
      "greek_letter": "",
      "constellation": "Hya",
      "RA_hour": "08",
      "RA_min": 41,
      "RA_sec": 43.2,
      "dec_deg": -15,
      "dec_min": 56,
      "dec_sec": 36,
      "magnitude": 4.88
    },
    {
      "ID": 3445,
      "greek_letter": "",
      "constellation": "",
      "RA_hour": "08",
      "RA_min": 40,
      "RA_sec": 37.6,
      "dec_deg": -46,
      "dec_min": 38,
      "dec_sec": 55,
      "magnitude": 3.81
    },
    {
      "ID": 3447,
      "greek_letter": "omi",
      "constellation": "Vel",
      "RA_hour": "08",
      "RA_min": 40,
      "RA_sec": 17.6,
      "dec_deg": -52,
      "dec_min": 55,
      "dec_sec": 19,
      "magnitude": 3.6
    },
    {
      "ID": 3449,
      "greek_letter": "gam",
      "constellation": "Cnc",
      "RA_hour": "08",
      "RA_min": 43,
      "RA_sec": 17.1,
      "dec_deg": "+21",
      "dec_min": 28,
      "dec_sec": "06",
      "magnitude": 4.66
    },
    {
      "ID": 3452,
      "greek_letter": "",
      "constellation": "",
      "RA_hour": "08",
      "RA_min": 41,
      "RA_sec": 13,
      "dec_deg": -47,
      "dec_min": 19,
      "dec_sec": "01",
      "magnitude": 4.77
    },
    {
      "ID": 3454,
      "greek_letter": "eta",
      "constellation": "Hya",
      "RA_hour": "08",
      "RA_min": 43,
      "RA_sec": 13.4,
      "dec_deg": "+03",
      "dec_min": 23,
      "dec_sec": 55,
      "magnitude": 4.3
    },
    {
      "ID": 3457,
      "greek_letter": "",
      "constellation": "",
      "RA_hour": "08",
      "RA_min": 40,
      "RA_sec": 37,
      "dec_deg": -59,
      "dec_min": 45,
      "dec_sec": 40,
      "magnitude": 4.33
    },
    {
      "ID": 3459,
      "greek_letter": "",
      "constellation": "",
      "RA_hour": "08",
      "RA_min": 43,
      "RA_sec": 40.4,
      "dec_deg": "-07",
      "dec_min": 14,
      "dec_sec": "01",
      "magnitude": 4.62
    },
    {
      "ID": 3461,
      "greek_letter": "del",
      "constellation": "Cnc",
      "RA_hour": "08",
      "RA_min": 44,
      "RA_sec": 41,
      "dec_deg": "+18",
      "dec_min": "09",
      "dec_sec": 15,
      "magnitude": 3.94
    },
    {
      "ID": 3467,
      "greek_letter": "",
      "constellation": "",
      "RA_hour": "08",
      "RA_min": 42,
      "RA_sec": 25.4,
      "dec_deg": -53,
      "dec_min": "06",
      "dec_sec": 50,
      "magnitude": 4.86
    },
    {
      "ID": 3468,
      "greek_letter": "alf",
      "constellation": "Pyx",
      "RA_hour": "08",
      "RA_min": 43,
      "RA_sec": 35.5,
      "dec_deg": -33,
      "dec_min": 11,
      "dec_sec": 11,
      "magnitude": 3.68
    },
    {
      "ID": 3475,
      "greek_letter": "iot",
      "constellation": "Cnc",
      "RA_hour": "08",
      "RA_min": 46,
      "RA_sec": 41.8,
      "dec_deg": "+28",
      "dec_min": 45,
      "dec_sec": 36,
      "magnitude": 4.02
    },
    {
      "ID": 3477,
      "greek_letter": "",
      "constellation": "",
      "RA_hour": "08",
      "RA_min": 44,
      "RA_sec": 23.9,
      "dec_deg": -42,
      "dec_min": 38,
      "dec_sec": 57,
      "magnitude": 4.07
    },
    {
      "ID": 3482,
      "greek_letter": "eps",
      "constellation": "Hya",
      "RA_hour": "08",
      "RA_min": 46,
      "RA_sec": 46.5,
      "dec_deg": "+06",
      "dec_min": 25,
      "dec_sec": "08",
      "magnitude": 3.38
    },
    {
      "ID": 3484,
      "greek_letter": "",
      "constellation": "Hya",
      "RA_hour": "08",
      "RA_min": 46,
      "RA_sec": 22.5,
      "dec_deg": -13,
      "dec_min": 32,
      "dec_sec": 52,
      "magnitude": 4.32
    },
    {
      "ID": 3485,
      "greek_letter": "del",
      "constellation": "Vel",
      "RA_hour": "08",
      "RA_min": 44,
      "RA_sec": 42.2,
      "dec_deg": -54,
      "dec_min": 42,
      "dec_sec": 30,
      "magnitude": 1.96
    },
    {
      "ID": 3487,
      "greek_letter": "",
      "constellation": "",
      "RA_hour": "08",
      "RA_min": 46,
      "RA_sec": "01.7",
      "dec_deg": -46,
      "dec_min": "02",
      "dec_sec": 30,
      "magnitude": 3.91
    },
    {
      "ID": 3492,
      "greek_letter": "ro",
      "constellation": "Hya",
      "RA_hour": "08",
      "RA_min": 48,
      "RA_sec": 25.9,
      "dec_deg": "+05",
      "dec_min": 50,
      "dec_sec": 16,
      "magnitude": 4.37
    },
    {
      "ID": 3498,
      "greek_letter": "",
      "constellation": "",
      "RA_hour": "08",
      "RA_min": 46,
      "RA_sec": 42.7,
      "dec_deg": -56,
      "dec_min": 46,
      "dec_sec": 11,
      "magnitude": 4.49
    },
    {
      "ID": 3518,
      "greek_letter": "gam",
      "constellation": "Pyx",
      "RA_hour": "08",
      "RA_min": 50,
      "RA_sec": 31.9,
      "dec_deg": -27,
      "dec_min": 42,
      "dec_sec": 36,
      "magnitude": 4.01
    },
    {
      "ID": 3520,
      "greek_letter": "",
      "constellation": "",
      "RA_hour": "08",
      "RA_min": 49,
      "RA_sec": 47.7,
      "dec_deg": -45,
      "dec_min": 18,
      "dec_sec": 28,
      "magnitude": 4.93
    },
    {
      "ID": 3547,
      "greek_letter": "zet",
      "constellation": "Hya",
      "RA_hour": "08",
      "RA_min": 55,
      "RA_sec": 23.6,
      "dec_deg": "+05",
      "dec_min": 56,
      "dec_sec": 44,
      "magnitude": 3.1
    },
    {
      "ID": 3556,
      "greek_letter": "del",
      "constellation": "Pyx",
      "RA_hour": "08",
      "RA_min": 55,
      "RA_sec": 31.5,
      "dec_deg": -27,
      "dec_min": 40,
      "dec_sec": 55,
      "magnitude": 4.89
    },
    {
      "ID": 3569,
      "greek_letter": "iot",
      "constellation": "UMa",
      "RA_hour": "08",
      "RA_min": 59,
      "RA_sec": 12.4,
      "dec_deg": "+48",
      "dec_min": "02",
      "dec_sec": 30,
      "magnitude": 3.14
    },
    {
      "ID": 3571,
      "greek_letter": "",
      "constellation": "",
      "RA_hour": "08",
      "RA_min": 55,
      "RA_sec": "02.8",
      "dec_deg": -60,
      "dec_min": 38,
      "dec_sec": 40,
      "magnitude": 3.84
    },
    {
      "ID": 3572,
      "greek_letter": "alf",
      "constellation": "Cnc",
      "RA_hour": "08",
      "RA_min": 58,
      "RA_sec": 29.2,
      "dec_deg": "+11",
      "dec_min": 51,
      "dec_sec": 28,
      "magnitude": 4.26
    },
    {
      "ID": 3574,
      "greek_letter": "",
      "constellation": "",
      "RA_hour": "08",
      "RA_min": 56,
      "RA_sec": 19.4,
      "dec_deg": -52,
      "dec_min": 43,
      "dec_sec": 25,
      "magnitude": 4.69
    },
    {
      "ID": 3576,
      "greek_letter": "ro",
      "constellation": "UMa",
      "RA_hour": "09",
      "RA_min": "02",
      "RA_sec": 32.7,
      "dec_deg": "+67",
      "dec_min": 37,
      "dec_sec": 47,
      "magnitude": 4.76
    },
    {
      "ID": 3579,
      "greek_letter": "",
      "constellation": "",
      "RA_hour": "09",
      "RA_min": "00",
      "RA_sec": 38.3,
      "dec_deg": "+41",
      "dec_min": 46,
      "dec_sec": 58,
      "magnitude": 3.97
    },
    {
      "ID": 3582,
      "greek_letter": "",
      "constellation": "",
      "RA_hour": "08",
      "RA_min": 56,
      "RA_sec": 58.3,
      "dec_deg": -59,
      "dec_min": 13,
      "dec_sec": 46,
      "magnitude": 4.92
    },
    {
      "ID": 3591,
      "greek_letter": "",
      "constellation": "",
      "RA_hour": "09",
      "RA_min": "00",
      "RA_sec": "05.4",
      "dec_deg": -41,
      "dec_min": 15,
      "dec_sec": 14,
      "magnitude": 4.45
    },
    {
      "ID": 3594,
      "greek_letter": "kap",
      "constellation": "UMa",
      "RA_hour": "09",
      "RA_min": "03",
      "RA_sec": 37.5,
      "dec_deg": "+47",
      "dec_min": "09",
      "dec_sec": 24,
      "magnitude": 3.6
    },
    {
      "ID": 3612,
      "greek_letter": "",
      "constellation": "",
      "RA_hour": "09",
      "RA_min": "06",
      "RA_sec": 31.7,
      "dec_deg": "+38",
      "dec_min": 27,
      "dec_sec": "08",
      "magnitude": 4.58
    },
    {
      "ID": 3613,
      "greek_letter": "omg",
      "constellation": "Hya",
      "RA_hour": "09",
      "RA_min": "05",
      "RA_sec": 58.3,
      "dec_deg": "+05",
      "dec_min": "05",
      "dec_sec": 32,
      "magnitude": 4.89
    },
    {
      "ID": 3614,
      "greek_letter": "",
      "constellation": "",
      "RA_hour": "09",
      "RA_min": "04",
      "RA_sec": "09.2",
      "dec_deg": -47,
      "dec_min": "05",
      "dec_sec": 52,
      "magnitude": 3.75
    },
    {
      "ID": 3615,
      "greek_letter": "alf",
      "constellation": "Vol",
      "RA_hour": "09",
      "RA_min": "02",
      "RA_sec": 26.9,
      "dec_deg": -66,
      "dec_min": 23,
      "dec_sec": 46,
      "magnitude": 4
    },
    {
      "ID": 3616,
      "greek_letter": "sig2",
      "constellation": "UMa",
      "RA_hour": "09",
      "RA_min": 10,
      "RA_sec": 23.1,
      "dec_deg": "+67",
      "dec_min": "08",
      "dec_sec": "04",
      "magnitude": 4.81
    },
    {
      "ID": 3619,
      "greek_letter": "",
      "constellation": "UMa",
      "RA_hour": "09",
      "RA_min": "08",
      "RA_sec": 52.2,
      "dec_deg": "+51",
      "dec_min": 36,
      "dec_sec": 16,
      "magnitude": 4.48
    },
    {
      "ID": 3624,
      "greek_letter": "tau",
      "constellation": "UMa",
      "RA_hour": "09",
      "RA_min": 10,
      "RA_sec": 55,
      "dec_deg": "+63",
      "dec_min": 30,
      "dec_sec": 49,
      "magnitude": 4.67
    },
    {
      "ID": 3628,
      "greek_letter": "kap",
      "constellation": "Pyx",
      "RA_hour": "09",
      "RA_min": "08",
      "RA_sec": "02.8",
      "dec_deg": -25,
      "dec_min": 51,
      "dec_sec": 30,
      "magnitude": 4.56
    },
    {
      "ID": 3634,
      "greek_letter": "lam",
      "constellation": "Vel",
      "RA_hour": "09",
      "RA_min": "07",
      "RA_sec": 59.7,
      "dec_deg": -43,
      "dec_min": 25,
      "dec_sec": 57,
      "magnitude": 2.21
    },
    {
      "ID": 3642,
      "greek_letter": "",
      "constellation": "",
      "RA_hour": "09",
      "RA_min": "05",
      "RA_sec": 38.4,
      "dec_deg": -70,
      "dec_min": 32,
      "dec_sec": 19,
      "magnitude": 4.57
    },
    {
      "ID": 3643,
      "greek_letter": "",
      "constellation": "",
      "RA_hour": "09",
      "RA_min": "05",
      "RA_sec": "09.3",
      "dec_deg": -72,
      "dec_min": 36,
      "dec_sec": 10,
      "magnitude": 4.48
    },
    {
      "ID": 3654,
      "greek_letter": "",
      "constellation": "",
      "RA_hour": "09",
      "RA_min": 11,
      "RA_sec": "04.3",
      "dec_deg": -44,
      "dec_min": 52,
      "dec_sec": "04",
      "magnitude": 5
    },
    {
      "ID": 3659,
      "greek_letter": "",
      "constellation": "",
      "RA_hour": "09",
      "RA_min": 10,
      "RA_sec": 57.9,
      "dec_deg": -58,
      "dec_min": 58,
      "dec_sec": "01",
      "magnitude": 3.45
    },
    {
      "ID": 3662,
      "greek_letter": "",
      "constellation": "UMa",
      "RA_hour": "09",
      "RA_min": 16,
      "RA_sec": 11.3,
      "dec_deg": "+54",
      "dec_min": "01",
      "dec_sec": 18,
      "magnitude": 4.84
    },
    {
      "ID": 3663,
      "greek_letter": "",
      "constellation": "",
      "RA_hour": "09",
      "RA_min": 11,
      "RA_sec": 16.7,
      "dec_deg": -62,
      "dec_min": 19,
      "dec_sec": "02",
      "magnitude": 3.98
    },
    {
      "ID": 3665,
      "greek_letter": "tet",
      "constellation": "Hya",
      "RA_hour": "09",
      "RA_min": 14,
      "RA_sec": 21.8,
      "dec_deg": "+02",
      "dec_min": 18,
      "dec_sec": 51,
      "magnitude": 3.88
    },
    {
      "ID": 3682,
      "greek_letter": "",
      "constellation": "",
      "RA_hour": "09",
      "RA_min": 15,
      "RA_sec": 36.7,
      "dec_deg": -38,
      "dec_min": 34,
      "dec_sec": 12,
      "magnitude": 4.94
    },
    {
      "ID": 3684,
      "greek_letter": "",
      "constellation": "",
      "RA_hour": "09",
      "RA_min": 15,
      "RA_sec": 45.1,
      "dec_deg": -37,
      "dec_min": 24,
      "dec_sec": 48,
      "magnitude": 4.62
    },
    {
      "ID": 3685,
      "greek_letter": "bet",
      "constellation": "Car",
      "RA_hour": "09",
      "RA_min": 13,
      "RA_sec": 12.1,
      "dec_deg": -69,
      "dec_min": 43,
      "dec_sec": "02",
      "magnitude": 1.69
    },
    {
      "ID": 3690,
      "greek_letter": "",
      "constellation": "Lyn",
      "RA_hour": "09",
      "RA_min": 18,
      "RA_sec": 50.6,
      "dec_deg": "+36",
      "dec_min": 48,
      "dec_sec": "09",
      "magnitude": 3.82
    },
    {
      "ID": 3696,
      "greek_letter": "",
      "constellation": "",
      "RA_hour": "09",
      "RA_min": 16,
      "RA_sec": 12.2,
      "dec_deg": -57,
      "dec_min": 32,
      "dec_sec": 28,
      "magnitude": 4.34
    },
    {
      "ID": 3699,
      "greek_letter": "iot",
      "constellation": "Car",
      "RA_hour": "09",
      "RA_min": 17,
      "RA_sec": "05.4",
      "dec_deg": -59,
      "dec_min": 16,
      "dec_sec": 31,
      "magnitude": 2.25
    },
    {
      "ID": 3705,
      "greek_letter": "alf",
      "constellation": "Lyn",
      "RA_hour": "09",
      "RA_min": 21,
      "RA_sec": "03.2",
      "dec_deg": "+34",
      "dec_min": 23,
      "dec_sec": 33,
      "magnitude": 3.14
    },
    {
      "ID": 3706,
      "greek_letter": "",
      "constellation": "Hya",
      "RA_hour": "09",
      "RA_min": 19,
      "RA_sec": 46.3,
      "dec_deg": -11,
      "dec_min": 58,
      "dec_sec": 30,
      "magnitude": 4.81
    },
    {
      "ID": 3709,
      "greek_letter": "",
      "constellation": "Hya",
      "RA_hour": "09",
      "RA_min": 20,
      "RA_sec": 28.9,
      "dec_deg": "-09",
      "dec_min": 33,
      "dec_sec": 21,
      "magnitude": 4.79
    },
    {
      "ID": 3718,
      "greek_letter": "tet",
      "constellation": "Pyx",
      "RA_hour": "09",
      "RA_min": 21,
      "RA_sec": 29.6,
      "dec_deg": -25,
      "dec_min": 57,
      "dec_sec": 56,
      "magnitude": 4.72
    },
    {
      "ID": 3728,
      "greek_letter": "",
      "constellation": "",
      "RA_hour": "09",
      "RA_min": 20,
      "RA_sec": 57.1,
      "dec_deg": -62,
      "dec_min": 24,
      "dec_sec": 17,
      "magnitude": 4.81
    },
    {
      "ID": 3731,
      "greek_letter": "kap",
      "constellation": "Leo",
      "RA_hour": "09",
      "RA_min": 24,
      "RA_sec": 39.2,
      "dec_deg": "+26",
      "dec_min": 10,
      "dec_sec": 56,
      "magnitude": 4.46
    },
    {
      "ID": 3733,
      "greek_letter": "lam",
      "constellation": "Pyx",
      "RA_hour": "09",
      "RA_min": 23,
      "RA_sec": 12.1,
      "dec_deg": -28,
      "dec_min": 50,
      "dec_sec": "02",
      "magnitude": 4.68
    },
    {
      "ID": 3734,
      "greek_letter": "kap",
      "constellation": "Vel",
      "RA_hour": "09",
      "RA_min": 22,
      "RA_sec": "06.8",
      "dec_deg": -55,
      "dec_min": "00",
      "dec_sec": 38,
      "magnitude": 2.5
    },
    {
      "ID": 3748,
      "greek_letter": "alf",
      "constellation": "Hya",
      "RA_hour": "09",
      "RA_min": 27,
      "RA_sec": 35.2,
      "dec_deg": "-08",
      "dec_min": 39,
      "dec_sec": 31,
      "magnitude": 1.97
    },
    {
      "ID": 3749,
      "greek_letter": "",
      "constellation": "",
      "RA_hour": "09",
      "RA_min": 27,
      "RA_sec": 18.3,
      "dec_deg": -22,
      "dec_min": 20,
      "dec_sec": 38,
      "magnitude": 4.68
    },
    {
      "ID": 3751,
      "greek_letter": "",
      "constellation": "",
      "RA_hour": "09",
      "RA_min": 37,
      "RA_sec": "05.2",
      "dec_deg": "+81",
      "dec_min": 19,
      "dec_sec": 35,
      "magnitude": 4.3
    },
    {
      "ID": 3757,
      "greek_letter": "",
      "constellation": "UMa",
      "RA_hour": "09",
      "RA_min": 31,
      "RA_sec": 31.7,
      "dec_deg": "+63",
      "dec_min": "03",
      "dec_sec": 43,
      "magnitude": 3.67
    },
    {
      "ID": 3759,
      "greek_letter": "tau1",
      "constellation": "Hya",
      "RA_hour": "09",
      "RA_min": 29,
      "RA_sec": "08.8",
      "dec_deg": "-02",
      "dec_min": 46,
      "dec_sec": "08",
      "magnitude": 4.61
    },
    {
      "ID": 3765,
      "greek_letter": "eps",
      "constellation": "Ant",
      "RA_hour": "09",
      "RA_min": 29,
      "RA_sec": 14.7,
      "dec_deg": -35,
      "dec_min": 57,
      "dec_sec": "06",
      "magnitude": 4.51
    },
    {
      "ID": 3771,
      "greek_letter": "",
      "constellation": "UMa",
      "RA_hour": "09",
      "RA_min": 34,
      "RA_sec": 28.8,
      "dec_deg": "+69",
      "dec_min": 49,
      "dec_sec": 49,
      "magnitude": 4.57
    },
    {
      "ID": 3773,
      "greek_letter": "lam",
      "constellation": "Leo",
      "RA_hour": "09",
      "RA_min": 31,
      "RA_sec": 43.1,
      "dec_deg": "+22",
      "dec_min": 58,
      "dec_sec": "04",
      "magnitude": 4.31
    },
    {
      "ID": 3775,
      "greek_letter": "tet",
      "constellation": "UMa",
      "RA_hour": "09",
      "RA_min": 32,
      "RA_sec": 51.3,
      "dec_deg": "+51",
      "dec_min": 40,
      "dec_sec": 38,
      "magnitude": 3.18
    },
    {
      "ID": 3782,
      "greek_letter": "xi",
      "constellation": "Leo",
      "RA_hour": "09",
      "RA_min": 31,
      "RA_sec": 56.7,
      "dec_deg": "+11",
      "dec_min": 17,
      "dec_sec": 59,
      "magnitude": 4.97
    },
    {
      "ID": 3786,
      "greek_letter": "psi",
      "constellation": "Vel",
      "RA_hour": "09",
      "RA_min": 30,
      "RA_sec": 41.9,
      "dec_deg": -40,
      "dec_min": 28,
      "dec_sec": "00",
      "magnitude": 3.6
    },
    {
      "ID": 3787,
      "greek_letter": "tau2",
      "constellation": "Hya",
      "RA_hour": "09",
      "RA_min": 31,
      "RA_sec": 58.9,
      "dec_deg": "-01",
      "dec_min": 11,
      "dec_sec": "05",
      "magnitude": 4.57
    },
    {
      "ID": 3799,
      "greek_letter": "",
      "constellation": "UMa",
      "RA_hour": "09",
      "RA_min": 34,
      "RA_sec": 49.4,
      "dec_deg": "+52",
      "dec_min": "03",
      "dec_sec": "05",
      "magnitude": 4.51
    },
    {
      "ID": 3800,
      "greek_letter": "",
      "constellation": "LMi",
      "RA_hour": "09",
      "RA_min": 34,
      "RA_sec": 13.3,
      "dec_deg": "+36",
      "dec_min": 23,
      "dec_sec": 51,
      "magnitude": 4.55
    },
    {
      "ID": 3803,
      "greek_letter": "",
      "constellation": "",
      "RA_hour": "09",
      "RA_min": 31,
      "RA_sec": 13.3,
      "dec_deg": -57,
      "dec_min": "02",
      "dec_sec": "04",
      "magnitude": 3.13
    },
    {
      "ID": 3809,
      "greek_letter": "",
      "constellation": "",
      "RA_hour": "09",
      "RA_min": 35,
      "RA_sec": "03.8",
      "dec_deg": "+39",
      "dec_min": 37,
      "dec_sec": 17,
      "magnitude": 4.81
    },
    {
      "ID": 3825,
      "greek_letter": "",
      "constellation": "",
      "RA_hour": "09",
      "RA_min": 34,
      "RA_sec": 26.6,
      "dec_deg": -59,
      "dec_min": 13,
      "dec_sec": 46,
      "magnitude": 4.09
    },
    {
      "ID": 3827,
      "greek_letter": "",
      "constellation": "Leo",
      "RA_hour": "09",
      "RA_min": 37,
      "RA_sec": 12.6,
      "dec_deg": "+06",
      "dec_min": 50,
      "dec_sec": "09",
      "magnitude": 5
    },
    {
      "ID": 3834,
      "greek_letter": "",
      "constellation": "",
      "RA_hour": "09",
      "RA_min": 38,
      "RA_sec": 27.2,
      "dec_deg": "+04",
      "dec_min": 38,
      "dec_sec": 57,
      "magnitude": 4.68
    },
    {
      "ID": 3836,
      "greek_letter": "",
      "constellation": "",
      "RA_hour": "09",
      "RA_min": 36,
      "RA_sec": 49.7,
      "dec_deg": -49,
      "dec_min": 21,
      "dec_sec": 18,
      "magnitude": 4.35
    },
    {
      "ID": 3845,
      "greek_letter": "iot",
      "constellation": "Hya",
      "RA_hour": "09",
      "RA_min": 39,
      "RA_sec": 51.3,
      "dec_deg": "-01",
      "dec_min": "08",
      "dec_sec": 34,
      "magnitude": 3.91
    },
    {
      "ID": 3852,
      "greek_letter": "omi",
      "constellation": "Leo",
      "RA_hour": "09",
      "RA_min": 41,
      "RA_sec": "09.0",
      "dec_deg": "+09",
      "dec_min": 53,
      "dec_sec": 32,
      "magnitude": 3.52
    },
    {
      "ID": 3856,
      "greek_letter": "",
      "constellation": "",
      "RA_hour": "09",
      "RA_min": 39,
      "RA_sec": 21,
      "dec_deg": -61,
      "dec_min": 19,
      "dec_sec": 41,
      "magnitude": 4.53
    },
    {
      "ID": 3858,
      "greek_letter": "",
      "constellation": "",
      "RA_hour": "09",
      "RA_min": 41,
      "RA_sec": 16.9,
      "dec_deg": -23,
      "dec_min": 35,
      "dec_sec": 30,
      "magnitude": 4.76
    },
    {
      "ID": 3862,
      "greek_letter": "",
      "constellation": "",
      "RA_hour": "09",
      "RA_min": 42,
      "RA_sec": 14.4,
      "dec_deg": -23,
      "dec_min": 54,
      "dec_sec": 56,
      "magnitude": 4.91
    },
    {
      "ID": 3871,
      "greek_letter": "tet",
      "constellation": "Ant",
      "RA_hour": "09",
      "RA_min": 44,
      "RA_sec": 12.1,
      "dec_deg": -27,
      "dec_min": 46,
      "dec_sec": 10,
      "magnitude": 4.79
    },
    {
      "ID": 3873,
      "greek_letter": "eps",
      "constellation": "Leo",
      "RA_hour": "09",
      "RA_min": 45,
      "RA_sec": 51,
      "dec_deg": "+23",
      "dec_min": 46,
      "dec_sec": 27,
      "magnitude": 2.98
    },
    {
      "ID": 3884,
      "greek_letter": "",
      "constellation": "",
      "RA_hour": "09",
      "RA_min": 45,
      "RA_sec": 14.8,
      "dec_deg": -62,
      "dec_min": 30,
      "dec_sec": 28,
      "magnitude": 3.69
    },
    {
      "ID": 3888,
      "greek_letter": "ups",
      "constellation": "UMa",
      "RA_hour": "09",
      "RA_min": 50,
      "RA_sec": 59.3,
      "dec_deg": "+59",
      "dec_min": "02",
      "dec_sec": 19,
      "magnitude": 3.81
    },
    {
      "ID": 3890,
      "greek_letter": "ups",
      "constellation": "Car",
      "RA_hour": "09",
      "RA_min": 47,
      "RA_sec": "06.1",
      "dec_deg": -65,
      "dec_min": "04",
      "dec_sec": 18,
      "magnitude": 2.96
    },
    {
      "ID": 3894,
      "greek_letter": "phi",
      "constellation": "UMa",
      "RA_hour": "09",
      "RA_min": 52,
      "RA_sec": "06.3",
      "dec_deg": "+54",
      "dec_min": "03",
      "dec_sec": 51,
      "magnitude": 4.6
    },
    {
      "ID": 3903,
      "greek_letter": "ups1",
      "constellation": "Hya",
      "RA_hour": "09",
      "RA_min": 51,
      "RA_sec": 28.6,
      "dec_deg": -14,
      "dec_min": 50,
      "dec_sec": 48,
      "magnitude": 4.11
    },
    {
      "ID": 3905,
      "greek_letter": "mu",
      "constellation": "Leo",
      "RA_hour": "09",
      "RA_min": 52,
      "RA_sec": 45.8,
      "dec_deg": "+26",
      "dec_min": "00",
      "dec_sec": 25,
      "magnitude": 3.88
    },
    {
      "ID": 3912,
      "greek_letter": "",
      "constellation": "",
      "RA_hour": "09",
      "RA_min": 51,
      "RA_sec": 40.7,
      "dec_deg": -46,
      "dec_min": 32,
      "dec_sec": 52,
      "magnitude": 4.58
    },
    {
      "ID": 3919,
      "greek_letter": "",
      "constellation": "",
      "RA_hour": "09",
      "RA_min": 54,
      "RA_sec": 12.2,
      "dec_deg": -25,
      "dec_min": 55,
      "dec_sec": 55,
      "magnitude": 4.88
    },
    {
      "ID": 3923,
      "greek_letter": "",
      "constellation": "",
      "RA_hour": "09",
      "RA_min": 54,
      "RA_sec": 52.1,
      "dec_deg": -19,
      "dec_min": "00",
      "dec_sec": 34,
      "magnitude": 4.94
    },
    {
      "ID": 3940,
      "greek_letter": "phi",
      "constellation": "Vel",
      "RA_hour": "09",
      "RA_min": 56,
      "RA_sec": 51.7,
      "dec_deg": -54,
      "dec_min": 34,
      "dec_sec": "04",
      "magnitude": 3.53
    },
    {
      "ID": 3950,
      "greek_letter": "pi",
      "constellation": "Leo",
      "RA_hour": 10,
      "RA_min": "00",
      "RA_sec": 12.7,
      "dec_deg": "+08",
      "dec_min": "02",
      "dec_sec": 39,
      "magnitude": 4.7
    },
    {
      "ID": 3970,
      "greek_letter": "ups2",
      "constellation": "Hya",
      "RA_hour": 10,
      "RA_min": "05",
      "RA_sec": "07.4",
      "dec_deg": -13,
      "dec_min": "03",
      "dec_sec": 53,
      "magnitude": 4.59
    },
    {
      "ID": 3974,
      "greek_letter": "",
      "constellation": "LMi",
      "RA_hour": 10,
      "RA_min": "07",
      "RA_sec": 25.7,
      "dec_deg": "+35",
      "dec_min": 14,
      "dec_sec": 41,
      "magnitude": 4.49
    },
    {
      "ID": 3975,
      "greek_letter": "eta",
      "constellation": "Leo",
      "RA_hour": 10,
      "RA_min": "07",
      "RA_sec": 19.9,
      "dec_deg": "+16",
      "dec_min": 45,
      "dec_sec": 45,
      "magnitude": 3.41
    },
    {
      "ID": 3980,
      "greek_letter": "",
      "constellation": "Leo",
      "RA_hour": 10,
      "RA_min": "07",
      "RA_sec": 54.2,
      "dec_deg": "+09",
      "dec_min": 59,
      "dec_sec": 51,
      "magnitude": 4.38
    },
    {
      "ID": 3981,
      "greek_letter": "alf",
      "constellation": "Sex",
      "RA_hour": 10,
      "RA_min": "07",
      "RA_sec": 56.2,
      "dec_deg": "-00",
      "dec_min": 22,
      "dec_sec": 18,
      "magnitude": 4.5
    },
    {
      "ID": 3982,
      "greek_letter": "alf",
      "constellation": "Leo",
      "RA_hour": 10,
      "RA_min": "08",
      "RA_sec": 22.3,
      "dec_deg": "+11",
      "dec_min": 58,
      "dec_sec": "02",
      "magnitude": 1.35
    },
    {
      "ID": 3990,
      "greek_letter": "",
      "constellation": "",
      "RA_hour": 10,
      "RA_min": "08",
      "RA_sec": 56.2,
      "dec_deg": -51,
      "dec_min": 48,
      "dec_sec": 40,
      "magnitude": 4.87
    },
    {
      "ID": 3994,
      "greek_letter": "lam",
      "constellation": "Hya",
      "RA_hour": 10,
      "RA_min": 10,
      "RA_sec": 35.2,
      "dec_deg": -12,
      "dec_min": 21,
      "dec_sec": 15,
      "magnitude": 3.61
    },
    {
      "ID": 4023,
      "greek_letter": "",
      "constellation": "",
      "RA_hour": 10,
      "RA_min": 14,
      "RA_sec": 44.1,
      "dec_deg": -42,
      "dec_min": "07",
      "dec_sec": 19,
      "magnitude": 3.85
    },
    {
      "ID": 4031,
      "greek_letter": "zet",
      "constellation": "Leo",
      "RA_hour": 10,
      "RA_min": 16,
      "RA_sec": 41.3,
      "dec_deg": "+23",
      "dec_min": 25,
      "dec_sec": "02",
      "magnitude": 3.41
    },
    {
      "ID": 4033,
      "greek_letter": "lam",
      "constellation": "UMa",
      "RA_hour": 10,
      "RA_min": 17,
      "RA_sec": "05.7",
      "dec_deg": "+42",
      "dec_min": 54,
      "dec_sec": 52,
      "magnitude": 3.45
    },
    {
      "ID": 4037,
      "greek_letter": "omg",
      "constellation": "Car",
      "RA_hour": 10,
      "RA_min": 13,
      "RA_sec": 44.3,
      "dec_deg": -70,
      "dec_min": "02",
      "dec_sec": 16,
      "magnitude": 3.33
    },
    {
      "ID": 4050,
      "greek_letter": "",
      "constellation": "",
      "RA_hour": 10,
      "RA_min": 17,
      "RA_sec": "04.9",
      "dec_deg": -61,
      "dec_min": 19,
      "dec_sec": 56,
      "magnitude": 3.4
    },
    {
      "ID": 4054,
      "greek_letter": "",
      "constellation": "Leo",
      "RA_hour": 10,
      "RA_min": 19,
      "RA_sec": 44.1,
      "dec_deg": "+19",
      "dec_min": 28,
      "dec_sec": 15,
      "magnitude": 4.8
    },
    {
      "ID": 4057,
      "greek_letter": "gam1",
      "constellation": "Leo",
      "RA_hour": 10,
      "RA_min": 19,
      "RA_sec": 58.3,
      "dec_deg": "+19",
      "dec_min": 50,
      "dec_sec": 30,
      "magnitude": 2.61
    },
    {
      "ID": 4058,
      "greek_letter": "gam2",
      "constellation": "Leo",
      "RA_hour": 10,
      "RA_min": 19,
      "RA_sec": 58.6,
      "dec_deg": "+19",
      "dec_min": 50,
      "dec_sec": 25,
      "magnitude": 3.8
    },
    {
      "ID": 4063,
      "greek_letter": "",
      "constellation": "",
      "RA_hour": 10,
      "RA_min": 19,
      "RA_sec": 36.8,
      "dec_deg": -55,
      "dec_min": "01",
      "dec_sec": 46,
      "magnitude": 4.57
    },
    {
      "ID": 4069,
      "greek_letter": "mu",
      "constellation": "UMa",
      "RA_hour": 10,
      "RA_min": 22,
      "RA_sec": 19.7,
      "dec_deg": "+41",
      "dec_min": 29,
      "dec_sec": 58,
      "magnitude": 3.05
    },
    {
      "ID": 4072,
      "greek_letter": "",
      "constellation": "",
      "RA_hour": 10,
      "RA_min": 24,
      "RA_sec": "07.8",
      "dec_deg": "+65",
      "dec_min": 33,
      "dec_sec": 59,
      "magnitude": 4.99
    },
    {
      "ID": 4074,
      "greek_letter": "",
      "constellation": "",
      "RA_hour": 10,
      "RA_min": 20,
      "RA_sec": 55.4,
      "dec_deg": -56,
      "dec_min": "02",
      "dec_sec": 36,
      "magnitude": 4.5
    },
    {
      "ID": 4080,
      "greek_letter": "",
      "constellation": "",
      "RA_hour": 10,
      "RA_min": 22,
      "RA_sec": 19.5,
      "dec_deg": -41,
      "dec_min": 39,
      "dec_sec": "00",
      "magnitude": 4.83
    },
    {
      "ID": 4089,
      "greek_letter": "",
      "constellation": "",
      "RA_hour": 10,
      "RA_min": 22,
      "RA_sec": 58.1,
      "dec_deg": -66,
      "dec_min": 54,
      "dec_sec": "06",
      "magnitude": 4.99
    },
    {
      "ID": 4090,
      "greek_letter": "",
      "constellation": "LMi",
      "RA_hour": 10,
      "RA_min": 25,
      "RA_sec": 54.8,
      "dec_deg": "+33",
      "dec_min": 47,
      "dec_sec": 46,
      "magnitude": 4.74
    },
    {
      "ID": 4094,
      "greek_letter": "mu",
      "constellation": "Hya",
      "RA_hour": 10,
      "RA_min": 26,
      "RA_sec": "05.4",
      "dec_deg": -16,
      "dec_min": 50,
      "dec_sec": 11,
      "magnitude": 3.79
    },
    {
      "ID": 4100,
      "greek_letter": "bet",
      "constellation": "LMi",
      "RA_hour": 10,
      "RA_min": 27,
      "RA_sec": 52.9,
      "dec_deg": "+36",
      "dec_min": 42,
      "dec_sec": 26,
      "magnitude": 4.21
    },
    {
      "ID": 4102,
      "greek_letter": "",
      "constellation": "",
      "RA_hour": 10,
      "RA_min": 24,
      "RA_sec": 23.7,
      "dec_deg": -74,
      "dec_min": "01",
      "dec_sec": 54,
      "magnitude": 4
    },
    {
      "ID": 4104,
      "greek_letter": "alf",
      "constellation": "Ant",
      "RA_hour": 10,
      "RA_min": 27,
      "RA_sec": "09.1",
      "dec_deg": -31,
      "dec_min": "04",
      "dec_sec": "04",
      "magnitude": 4.25
    },
    {
      "ID": 4110,
      "greek_letter": "",
      "constellation": "",
      "RA_hour": 10,
      "RA_min": 27,
      "RA_sec": 24.4,
      "dec_deg": -57,
      "dec_min": 38,
      "dec_sec": 20,
      "magnitude": 4.66
    },
    {
      "ID": 4112,
      "greek_letter": "",
      "constellation": "UMa",
      "RA_hour": 10,
      "RA_min": 30,
      "RA_sec": 37.5,
      "dec_deg": "+55",
      "dec_min": 58,
      "dec_sec": 50,
      "magnitude": 4.84
    },
    {
      "ID": 4114,
      "greek_letter": "",
      "constellation": "",
      "RA_hour": 10,
      "RA_min": 27,
      "RA_sec": 52.7,
      "dec_deg": -58,
      "dec_min": 44,
      "dec_sec": 22,
      "magnitude": 3.81
    },
    {
      "ID": 4126,
      "greek_letter": "",
      "constellation": "",
      "RA_hour": 10,
      "RA_min": 35,
      "RA_sec": "05.5",
      "dec_deg": "+75",
      "dec_min": 42,
      "dec_sec": 46,
      "magnitude": 4.84
    },
    {
      "ID": 4132,
      "greek_letter": "",
      "constellation": "",
      "RA_hour": 10,
      "RA_min": 33,
      "RA_sec": 13.8,
      "dec_deg": "+40",
      "dec_min": 25,
      "dec_sec": 31,
      "magnitude": 4.75
    },
    {
      "ID": 4133,
      "greek_letter": "ro",
      "constellation": "Leo",
      "RA_hour": 10,
      "RA_min": 32,
      "RA_sec": 48.6,
      "dec_deg": "+09",
      "dec_min": 18,
      "dec_sec": 24,
      "magnitude": 3.85
    },
    {
      "ID": 4134,
      "greek_letter": "",
      "constellation": "",
      "RA_hour": 10,
      "RA_min": 31,
      "RA_sec": 21.8,
      "dec_deg": -53,
      "dec_min": 42,
      "dec_sec": 56,
      "magnitude": 4.89
    },
    {
      "ID": 4138,
      "greek_letter": "",
      "constellation": "",
      "RA_hour": 10,
      "RA_min": 30,
      "RA_sec": 20,
      "dec_deg": -71,
      "dec_min": 59,
      "dec_sec": 34,
      "magnitude": 4.75
    },
    {
      "ID": 4140,
      "greek_letter": "",
      "constellation": "",
      "RA_hour": 10,
      "RA_min": 32,
      "RA_sec": "01.4",
      "dec_deg": -61,
      "dec_min": 41,
      "dec_sec": "07",
      "magnitude": 3.32
    },
    {
      "ID": 4142,
      "greek_letter": "",
      "constellation": "",
      "RA_hour": 10,
      "RA_min": 31,
      "RA_sec": "02.0",
      "dec_deg": -73,
      "dec_min": 13,
      "dec_sec": 18,
      "magnitude": 4.93
    },
    {
      "ID": 4159,
      "greek_letter": "",
      "constellation": "",
      "RA_hour": 10,
      "RA_min": 35,
      "RA_sec": 35.2,
      "dec_deg": -57,
      "dec_min": 33,
      "dec_sec": 27,
      "magnitude": 4.45
    },
    {
      "ID": 4162,
      "greek_letter": "",
      "constellation": "",
      "RA_hour": 10,
      "RA_min": 37,
      "RA_sec": 13.7,
      "dec_deg": -27,
      "dec_min": 24,
      "dec_sec": 46,
      "magnitude": 4.89
    },
    {
      "ID": 4163,
      "greek_letter": "",
      "constellation": "",
      "RA_hour": 10,
      "RA_min": 37,
      "RA_sec": 33.1,
      "dec_deg": -13,
      "dec_min": 23,
      "dec_sec": "04",
      "magnitude": 4.82
    },
    {
      "ID": 4166,
      "greek_letter": "",
      "constellation": "LMi",
      "RA_hour": 10,
      "RA_min": 38,
      "RA_sec": 43.2,
      "dec_deg": "+31",
      "dec_min": 58,
      "dec_sec": 34,
      "magnitude": 4.72
    },
    {
      "ID": 4167,
      "greek_letter": "",
      "constellation": "",
      "RA_hour": 10,
      "RA_min": 37,
      "RA_sec": 18,
      "dec_deg": -48,
      "dec_min": 13,
      "dec_sec": 33,
      "magnitude": 3.84
    },
    {
      "ID": 4171,
      "greek_letter": "phi3",
      "constellation": "Hya",
      "RA_hour": 10,
      "RA_min": 38,
      "RA_sec": 34.9,
      "dec_deg": -16,
      "dec_min": 52,
      "dec_sec": 36,
      "magnitude": 4.91
    },
    {
      "ID": 4174,
      "greek_letter": "gam",
      "constellation": "Cha",
      "RA_hour": 10,
      "RA_min": 35,
      "RA_sec": 28.1,
      "dec_deg": -78,
      "dec_min": 36,
      "dec_sec": 27,
      "magnitude": 4.11
    },
    {
      "ID": 4177,
      "greek_letter": "",
      "constellation": "",
      "RA_hour": 10,
      "RA_min": 38,
      "RA_sec": 45.1,
      "dec_deg": -59,
      "dec_min": 10,
      "dec_sec": 59,
      "magnitude": 4.66
    },
    {
      "ID": 4180,
      "greek_letter": "",
      "constellation": "",
      "RA_hour": 10,
      "RA_min": 39,
      "RA_sec": 18.3,
      "dec_deg": -55,
      "dec_min": 36,
      "dec_sec": 12,
      "magnitude": 4.28
    },
    {
      "ID": 4181,
      "greek_letter": "",
      "constellation": "",
      "RA_hour": 10,
      "RA_min": 43,
      "RA_sec": "04.0",
      "dec_deg": "+69",
      "dec_min": "04",
      "dec_sec": 34,
      "magnitude": 5
    },
    {
      "ID": 4196,
      "greek_letter": "",
      "constellation": "",
      "RA_hour": 10,
      "RA_min": 42,
      "RA_sec": 14,
      "dec_deg": -64,
      "dec_min": 27,
      "dec_sec": 58,
      "magnitude": 4.82
    },
    {
      "ID": 4199,
      "greek_letter": "tet",
      "constellation": "Car",
      "RA_hour": 10,
      "RA_min": 42,
      "RA_sec": 57.4,
      "dec_deg": -64,
      "dec_min": 23,
      "dec_sec": 40,
      "magnitude": 2.77
    },
    {
      "ID": 4200,
      "greek_letter": "",
      "constellation": "",
      "RA_hour": 10,
      "RA_min": 43,
      "RA_sec": 32.1,
      "dec_deg": -60,
      "dec_min": 33,
      "dec_sec": 59,
      "magnitude": 4.58
    },
    {
      "ID": 4205,
      "greek_letter": "",
      "constellation": "",
      "RA_hour": 10,
      "RA_min": 44,
      "RA_sec": "06.9",
      "dec_deg": -63,
      "dec_min": 57,
      "dec_sec": 40,
      "magnitude": 4.83
    },
    {
      "ID": 4216,
      "greek_letter": "mu",
      "constellation": "Vel",
      "RA_hour": 10,
      "RA_min": 46,
      "RA_sec": 46.1,
      "dec_deg": -49,
      "dec_min": 25,
      "dec_sec": 12,
      "magnitude": 2.69
    },
    {
      "ID": 4222,
      "greek_letter": "",
      "constellation": "",
      "RA_hour": 10,
      "RA_min": 46,
      "RA_sec": 51.2,
      "dec_deg": -64,
      "dec_min": 23,
      "dec_sec": "00",
      "magnitude": 4.86
    },
    {
      "ID": 4232,
      "greek_letter": "nu",
      "constellation": "Hya",
      "RA_hour": 10,
      "RA_min": 49,
      "RA_sec": 37.4,
      "dec_deg": -16,
      "dec_min": 11,
      "dec_sec": 37,
      "magnitude": 3.11
    },
    {
      "ID": 4234,
      "greek_letter": "del2",
      "constellation": "Cha",
      "RA_hour": 10,
      "RA_min": 45,
      "RA_sec": 46.6,
      "dec_deg": -80,
      "dec_min": 32,
      "dec_sec": 24,
      "magnitude": 4.46
    },
    {
      "ID": 4247,
      "greek_letter": "",
      "constellation": "LMi",
      "RA_hour": 10,
      "RA_min": 53,
      "RA_sec": 18.6,
      "dec_deg": "+34",
      "dec_min": 12,
      "dec_sec": 53,
      "magnitude": 3.83
    },
    {
      "ID": 4248,
      "greek_letter": "omg",
      "constellation": "UMa",
      "RA_hour": 10,
      "RA_min": 53,
      "RA_sec": 58.7,
      "dec_deg": "+43",
      "dec_min": 11,
      "dec_sec": 24,
      "magnitude": 4.71
    },
    {
      "ID": 4257,
      "greek_letter": "",
      "constellation": "",
      "RA_hour": 10,
      "RA_min": 53,
      "RA_sec": 29.6,
      "dec_deg": -58,
      "dec_min": 51,
      "dec_sec": 12,
      "magnitude": 3.78
    },
    {
      "ID": 4259,
      "greek_letter": "",
      "constellation": "Leo",
      "RA_hour": 10,
      "RA_min": 55,
      "RA_sec": 36.7,
      "dec_deg": "+24",
      "dec_min": 44,
      "dec_sec": 59,
      "magnitude": 4.5
    },
    {
      "ID": 4273,
      "greek_letter": "iot",
      "constellation": "Ant",
      "RA_hour": 10,
      "RA_min": 56,
      "RA_sec": 43,
      "dec_deg": -37,
      "dec_min": "08",
      "dec_sec": 16,
      "magnitude": 4.6
    },
    {
      "ID": 4287,
      "greek_letter": "alf",
      "constellation": "Crt",
      "RA_hour": 10,
      "RA_min": 59,
      "RA_sec": 46.4,
      "dec_deg": -18,
      "dec_min": 17,
      "dec_sec": 56,
      "magnitude": 4.07
    },
    {
      "ID": 4291,
      "greek_letter": "",
      "constellation": "Leo",
      "RA_hour": 11,
      "RA_min": "00",
      "RA_sec": 33.6,
      "dec_deg": "+03",
      "dec_min": 37,
      "dec_sec": "03",
      "magnitude": 4.84
    },
    {
      "ID": 4293,
      "greek_letter": "",
      "constellation": "",
      "RA_hour": 11,
      "RA_min": "00",
      "RA_sec": "09.2",
      "dec_deg": -42,
      "dec_min": 13,
      "dec_sec": 33,
      "magnitude": 4.39
    },
    {
      "ID": 4294,
      "greek_letter": "",
      "constellation": "Leo",
      "RA_hour": 11,
      "RA_min": "00",
      "RA_sec": 44.7,
      "dec_deg": "+06",
      "dec_min": "06",
      "dec_sec": "05",
      "magnitude": 4.99
    },
    {
      "ID": 4295,
      "greek_letter": "bet",
      "constellation": "UMa",
      "RA_hour": 11,
      "RA_min": "01",
      "RA_sec": 50.4,
      "dec_deg": "+56",
      "dec_min": 22,
      "dec_sec": 56,
      "magnitude": 2.37
    },
    {
      "ID": 4299,
      "greek_letter": "",
      "constellation": "Leo",
      "RA_hour": 11,
      "RA_min": "01",
      "RA_sec": 49.6,
      "dec_deg": "-02",
      "dec_min": 29,
      "dec_sec": "04",
      "magnitude": 4.75
    },
    {
      "ID": 4300,
      "greek_letter": "",
      "constellation": "Leo",
      "RA_hour": 11,
      "RA_min": "02",
      "RA_sec": 19.7,
      "dec_deg": "+20",
      "dec_min": 10,
      "dec_sec": 47,
      "magnitude": 4.42
    },
    {
      "ID": 4301,
      "greek_letter": "alf",
      "constellation": "UMa",
      "RA_hour": 11,
      "RA_min": "03",
      "RA_sec": 43.6,
      "dec_deg": "+61",
      "dec_min": 45,
      "dec_sec": "03",
      "magnitude": 1.79
    },
    {
      "ID": 4310,
      "greek_letter": "chi",
      "constellation": "Leo",
      "RA_hour": 11,
      "RA_min": "05",
      "RA_sec": "01.0",
      "dec_deg": "+07",
      "dec_min": 20,
      "dec_sec": 10,
      "magnitude": 4.63
    },
    {
      "ID": 4314,
      "greek_letter": "chi1",
      "constellation": "Hya",
      "RA_hour": 11,
      "RA_min": "05",
      "RA_sec": 19.9,
      "dec_deg": -27,
      "dec_min": 17,
      "dec_sec": 36,
      "magnitude": 4.94
    },
    {
      "ID": 4325,
      "greek_letter": "",
      "constellation": "",
      "RA_hour": 11,
      "RA_min": "06",
      "RA_sec": 32.4,
      "dec_deg": -62,
      "dec_min": 25,
      "dec_sec": 26,
      "magnitude": 4.61
    },
    {
      "ID": 4335,
      "greek_letter": "psi",
      "constellation": "UMa",
      "RA_hour": 11,
      "RA_min": "09",
      "RA_sec": 39.7,
      "dec_deg": "+44",
      "dec_min": 29,
      "dec_sec": 54,
      "magnitude": 3.01
    },
    {
      "ID": 4337,
      "greek_letter": "",
      "constellation": "",
      "RA_hour": 11,
      "RA_min": "08",
      "RA_sec": 35.3,
      "dec_deg": -58,
      "dec_min": 58,
      "dec_sec": 30,
      "magnitude": 3.83
    },
    {
      "ID": 4343,
      "greek_letter": "bet",
      "constellation": "Crt",
      "RA_hour": 11,
      "RA_min": 11,
      "RA_sec": 39.4,
      "dec_deg": -22,
      "dec_min": 49,
      "dec_sec": 33,
      "magnitude": 4.48
    },
    {
      "ID": 4352,
      "greek_letter": "",
      "constellation": "",
      "RA_hour": 11,
      "RA_min": 12,
      "RA_sec": 36,
      "dec_deg": -60,
      "dec_min": 19,
      "dec_sec": "03",
      "magnitude": 4.62
    },
    {
      "ID": 4357,
      "greek_letter": "del",
      "constellation": "Leo",
      "RA_hour": 11,
      "RA_min": 14,
      "RA_sec": "06.4",
      "dec_deg": "+20",
      "dec_min": 31,
      "dec_sec": 25,
      "magnitude": 2.56
    },
    {
      "ID": 4359,
      "greek_letter": "tet",
      "constellation": "Leo",
      "RA_hour": 11,
      "RA_min": 14,
      "RA_sec": 14.3,
      "dec_deg": "+15",
      "dec_min": 25,
      "dec_sec": 46,
      "magnitude": 3.35
    },
    {
      "ID": 4362,
      "greek_letter": "",
      "constellation": "Leo",
      "RA_hour": 11,
      "RA_min": 15,
      "RA_sec": 12.2,
      "dec_deg": "+23",
      "dec_min": "05",
      "dec_sec": 44,
      "magnitude": 4.63
    },
    {
      "ID": 4368,
      "greek_letter": "phi",
      "constellation": "Leo",
      "RA_hour": 11,
      "RA_min": 16,
      "RA_sec": 39.6,
      "dec_deg": "-03",
      "dec_min": 39,
      "dec_sec": "06",
      "magnitude": 4.47
    },
    {
      "ID": 4374,
      "greek_letter": "xi",
      "constellation": "UMa",
      "RA_hour": 11,
      "RA_min": 18,
      "RA_sec": 10.9,
      "dec_deg": "+31",
      "dec_min": 31,
      "dec_sec": 45,
      "magnitude": 4.87
    },
    {
      "ID": 4375,
      "greek_letter": "xi",
      "constellation": "UMa",
      "RA_hour": 11,
      "RA_min": 18,
      "RA_sec": 10.9,
      "dec_deg": "+31",
      "dec_min": 31,
      "dec_sec": 45,
      "magnitude": 4.41
    },
    {
      "ID": 4377,
      "greek_letter": "nu",
      "constellation": "UMa",
      "RA_hour": 11,
      "RA_min": 18,
      "RA_sec": 28.7,
      "dec_deg": "+33",
      "dec_min": "05",
      "dec_sec": 39,
      "magnitude": 3.49
    },
    {
      "ID": 4380,
      "greek_letter": "",
      "constellation": "UMa",
      "RA_hour": 11,
      "RA_min": 19,
      "RA_sec": "07.8",
      "dec_deg": "+38",
      "dec_min": 11,
      "dec_sec": "08",
      "magnitude": 4.79
    },
    {
      "ID": 4382,
      "greek_letter": "del",
      "constellation": "Crt",
      "RA_hour": 11,
      "RA_min": 19,
      "RA_sec": 20.4,
      "dec_deg": -14,
      "dec_min": 46,
      "dec_sec": 43,
      "magnitude": 3.56
    },
    {
      "ID": 4386,
      "greek_letter": "sig",
      "constellation": "Leo",
      "RA_hour": 11,
      "RA_min": 21,
      "RA_sec": "08.1",
      "dec_deg": "+06",
      "dec_min": "01",
      "dec_sec": 46,
      "magnitude": 4.05
    },
    {
      "ID": 4390,
      "greek_letter": "pi",
      "constellation": "Cen",
      "RA_hour": 11,
      "RA_min": 21,
      "RA_sec": "00.4",
      "dec_deg": -54,
      "dec_min": 29,
      "dec_sec": 27,
      "magnitude": 3.9
    },
    {
      "ID": 4392,
      "greek_letter": "",
      "constellation": "UMa",
      "RA_hour": 11,
      "RA_min": 22,
      "RA_sec": 49.5,
      "dec_deg": "+43",
      "dec_min": 28,
      "dec_sec": 58,
      "magnitude": 5.03
    },
    {
      "ID": 4396,
      "greek_letter": "",
      "constellation": "",
      "RA_hour": 11,
      "RA_min": 23,
      "RA_sec": 12.5,
      "dec_deg": -36,
      "dec_min": "09",
      "dec_sec": 54,
      "magnitude": 5
    },
    {
      "ID": 4399,
      "greek_letter": "iot",
      "constellation": "Leo",
      "RA_hour": 11,
      "RA_min": 23,
      "RA_sec": 55.4,
      "dec_deg": "+10",
      "dec_min": 31,
      "dec_sec": 45,
      "magnitude": 3.94
    },
    {
      "ID": 4402,
      "greek_letter": "eps",
      "constellation": "Crt",
      "RA_hour": 11,
      "RA_min": 24,
      "RA_sec": 36.5,
      "dec_deg": -10,
      "dec_min": 51,
      "dec_sec": 34,
      "magnitude": 4.83
    },
    {
      "ID": 4405,
      "greek_letter": "gam",
      "constellation": "Crt",
      "RA_hour": 11,
      "RA_min": 24,
      "RA_sec": 52.8,
      "dec_deg": -17,
      "dec_min": 41,
      "dec_sec": "03",
      "magnitude": 4.08
    },
    {
      "ID": 4418,
      "greek_letter": "tau",
      "constellation": "Leo",
      "RA_hour": 11,
      "RA_min": 27,
      "RA_sec": 56.2,
      "dec_deg": "+02",
      "dec_min": 51,
      "dec_sec": 22,
      "magnitude": 4.91
    },
    {
      "ID": 4432,
      "greek_letter": "",
      "constellation": "Leo",
      "RA_hour": 11,
      "RA_min": 30,
      "RA_sec": 18.8,
      "dec_deg": "-03",
      "dec_min": "00",
      "dec_sec": 13,
      "magnitude": 4.77
    },
    {
      "ID": 4434,
      "greek_letter": "lam",
      "constellation": "Dra",
      "RA_hour": 11,
      "RA_min": 31,
      "RA_sec": 24.2,
      "dec_deg": "+69",
      "dec_min": 19,
      "dec_sec": 52,
      "magnitude": 3.85
    },
    {
      "ID": 4450,
      "greek_letter": "xi",
      "constellation": "Hya",
      "RA_hour": 11,
      "RA_min": 33,
      "RA_sec": "00.1",
      "dec_deg": -31,
      "dec_min": 51,
      "dec_sec": 27,
      "magnitude": 3.54
    },
    {
      "ID": 4460,
      "greek_letter": "",
      "constellation": "",
      "RA_hour": 11,
      "RA_min": 34,
      "RA_sec": 45.6,
      "dec_deg": -54,
      "dec_min": 15,
      "dec_sec": 51,
      "magnitude": 4.62
    },
    {
      "ID": 4467,
      "greek_letter": "lam",
      "constellation": "Cen",
      "RA_hour": 11,
      "RA_min": 35,
      "RA_sec": 46.8,
      "dec_deg": -63,
      "dec_min": "01",
      "dec_sec": 11,
      "magnitude": 3.13
    },
    {
      "ID": 4468,
      "greek_letter": "tet",
      "constellation": "Crt",
      "RA_hour": 11,
      "RA_min": 36,
      "RA_sec": 40.8,
      "dec_deg": "-09",
      "dec_min": 48,
      "dec_sec": "08",
      "magnitude": 4.7
    },
    {
      "ID": 4471,
      "greek_letter": "ups",
      "constellation": "Leo",
      "RA_hour": 11,
      "RA_min": 36,
      "RA_sec": 56.9,
      "dec_deg": "-00",
      "dec_min": 49,
      "dec_sec": 26,
      "magnitude": 4.3
    },
    {
      "ID": 4494,
      "greek_letter": "omi",
      "constellation": "Hya",
      "RA_hour": 11,
      "RA_min": 40,
      "RA_sec": 12.7,
      "dec_deg": -34,
      "dec_min": 44,
      "dec_sec": 41,
      "magnitude": 4.7
    },
    {
      "ID": 4499,
      "greek_letter": "",
      "constellation": "",
      "RA_hour": 11,
      "RA_min": 40,
      "RA_sec": 53.6,
      "dec_deg": -62,
      "dec_min": "05",
      "dec_sec": 23,
      "magnitude": 4.94
    },
    {
      "ID": 4514,
      "greek_letter": "zet",
      "constellation": "Crt",
      "RA_hour": 11,
      "RA_min": 44,
      "RA_sec": 45.7,
      "dec_deg": -18,
      "dec_min": 21,
      "dec_sec": "03",
      "magnitude": 4.72
    },
    {
      "ID": 4515,
      "greek_letter": "xi",
      "constellation": "Vir",
      "RA_hour": 11,
      "RA_min": 45,
      "RA_sec": 17,
      "dec_deg": "+08",
      "dec_min": 15,
      "dec_sec": 30,
      "magnitude": 4.85
    },
    {
      "ID": 4517,
      "greek_letter": "nu",
      "constellation": "Vir",
      "RA_hour": 11,
      "RA_min": 45,
      "RA_sec": 51.5,
      "dec_deg": "+06",
      "dec_min": 31,
      "dec_sec": 46,
      "magnitude": 4.04
    },
    {
      "ID": 4518,
      "greek_letter": "chi",
      "constellation": "UMa",
      "RA_hour": 11,
      "RA_min": 46,
      "RA_sec": "03.0",
      "dec_deg": "+47",
      "dec_min": 46,
      "dec_sec": 46,
      "magnitude": 3.72
    },
    {
      "ID": 4520,
      "greek_letter": "lam",
      "constellation": "Mus",
      "RA_hour": 11,
      "RA_min": 45,
      "RA_sec": 36.4,
      "dec_deg": -66,
      "dec_min": 43,
      "dec_sec": 43,
      "magnitude": 3.64
    },
    {
      "ID": 4522,
      "greek_letter": "",
      "constellation": "",
      "RA_hour": 11,
      "RA_min": 46,
      "RA_sec": 30.7,
      "dec_deg": -61,
      "dec_min": 10,
      "dec_sec": 42,
      "magnitude": 4.1
    },
    {
      "ID": 4523,
      "greek_letter": "",
      "constellation": "",
      "RA_hour": 11,
      "RA_min": 46,
      "RA_sec": 31,
      "dec_deg": -40,
      "dec_min": 30,
      "dec_sec": "01",
      "magnitude": 4.88
    },
    {
      "ID": 4527,
      "greek_letter": "",
      "constellation": "Leo",
      "RA_hour": 11,
      "RA_min": 47,
      "RA_sec": 59.1,
      "dec_deg": "+20",
      "dec_min": 13,
      "dec_sec": "08",
      "magnitude": 4.53
    },
    {
      "ID": 4530,
      "greek_letter": "mu",
      "constellation": "Mus",
      "RA_hour": 11,
      "RA_min": 48,
      "RA_sec": 14.4,
      "dec_deg": -66,
      "dec_min": 48,
      "dec_sec": 53,
      "magnitude": 4.72
    },
    {
      "ID": 4534,
      "greek_letter": "bet",
      "constellation": "Leo",
      "RA_hour": 11,
      "RA_min": 49,
      "RA_sec": "03.5",
      "dec_deg": "+14",
      "dec_min": 34,
      "dec_sec": 19,
      "magnitude": 2.14
    },
    {
      "ID": 4537,
      "greek_letter": "",
      "constellation": "",
      "RA_hour": 11,
      "RA_min": 49,
      "RA_sec": 41,
      "dec_deg": -63,
      "dec_min": 47,
      "dec_sec": 18,
      "magnitude": 4.34
    },
    {
      "ID": 4538,
      "greek_letter": "",
      "constellation": "",
      "RA_hour": 11,
      "RA_min": 49,
      "RA_sec": 56.3,
      "dec_deg": -70,
      "dec_min": 13,
      "dec_sec": 32,
      "magnitude": 4.98
    },
    {
      "ID": 4540,
      "greek_letter": "bet",
      "constellation": "Vir",
      "RA_hour": 11,
      "RA_min": 50,
      "RA_sec": 41.6,
      "dec_deg": "+01",
      "dec_min": 45,
      "dec_sec": 53,
      "magnitude": 3.6
    },
    {
      "ID": 4546,
      "greek_letter": "",
      "constellation": "",
      "RA_hour": 11,
      "RA_min": 51,
      "RA_sec": "08.1",
      "dec_deg": -45,
      "dec_min": 10,
      "dec_sec": 26,
      "magnitude": 4.46
    },
    {
      "ID": 4549,
      "greek_letter": "",
      "constellation": "",
      "RA_hour": 11,
      "RA_min": 51,
      "RA_sec": 51.2,
      "dec_deg": -65,
      "dec_min": 12,
      "dec_sec": 22,
      "magnitude": 4.91
    },
    {
      "ID": 4552,
      "greek_letter": "bet",
      "constellation": "Hya",
      "RA_hour": 11,
      "RA_min": 52,
      "RA_sec": 54.5,
      "dec_deg": -33,
      "dec_min": 54,
      "dec_sec": 28,
      "magnitude": 4.28
    },
    {
      "ID": 4554,
      "greek_letter": "gam",
      "constellation": "UMa",
      "RA_hour": 11,
      "RA_min": 53,
      "RA_sec": 49.8,
      "dec_deg": "+53",
      "dec_min": 41,
      "dec_sec": 41,
      "magnitude": 2.44
    },
    {
      "ID": 4583,
      "greek_letter": "eps",
      "constellation": "Cha",
      "RA_hour": 11,
      "RA_min": 59,
      "RA_sec": 37.3,
      "dec_deg": -78,
      "dec_min": 13,
      "dec_sec": 18,
      "magnitude": 4.91
    },
    {
      "ID": 4589,
      "greek_letter": "pi",
      "constellation": "Vir",
      "RA_hour": 12,
      "RA_min": "00",
      "RA_sec": 52.3,
      "dec_deg": "+06",
      "dec_min": 36,
      "dec_sec": 51,
      "magnitude": 4.67
    },
    {
      "ID": 4599,
      "greek_letter": "tet1",
      "constellation": "Cru",
      "RA_hour": 12,
      "RA_min": "03",
      "RA_sec": "01.5",
      "dec_deg": -63,
      "dec_min": 18,
      "dec_sec": 46,
      "magnitude": 4.34
    },
    {
      "ID": 4603,
      "greek_letter": "tet2",
      "constellation": "Cru",
      "RA_hour": 12,
      "RA_min": "04",
      "RA_sec": 19.2,
      "dec_deg": -63,
      "dec_min": "09",
      "dec_sec": 56,
      "magnitude": 4.73
    },
    {
      "ID": 4608,
      "greek_letter": "omi",
      "constellation": "Vir",
      "RA_hour": 12,
      "RA_min": "05",
      "RA_sec": 12.5,
      "dec_deg": "+08",
      "dec_min": 43,
      "dec_sec": 59,
      "magnitude": 4.12
    },
    {
      "ID": 4616,
      "greek_letter": "eta",
      "constellation": "Cru",
      "RA_hour": 12,
      "RA_min": "06",
      "RA_sec": 52.8,
      "dec_deg": -64,
      "dec_min": 36,
      "dec_sec": 49,
      "magnitude": 4.15
    },
    {
      "ID": 4618,
      "greek_letter": "",
      "constellation": "",
      "RA_hour": 12,
      "RA_min": "08",
      "RA_sec": "05.1",
      "dec_deg": -50,
      "dec_min": 39,
      "dec_sec": 40,
      "magnitude": 4.47
    },
    {
      "ID": 4621,
      "greek_letter": "del",
      "constellation": "Cen",
      "RA_hour": 12,
      "RA_min": "08",
      "RA_sec": 21.5,
      "dec_deg": -50,
      "dec_min": 43,
      "dec_sec": 20,
      "magnitude": 2.6
    },
    {
      "ID": 4623,
      "greek_letter": "alf",
      "constellation": "Crv",
      "RA_hour": 12,
      "RA_min": "08",
      "RA_sec": 24.7,
      "dec_deg": -24,
      "dec_min": 43,
      "dec_sec": 44,
      "magnitude": 4.02
    },
    {
      "ID": 4630,
      "greek_letter": "eps",
      "constellation": "Crv",
      "RA_hour": 12,
      "RA_min": 10,
      "RA_sec": "07.4",
      "dec_deg": -22,
      "dec_min": 37,
      "dec_sec": 11,
      "magnitude": 2.98
    },
    {
      "ID": 4638,
      "greek_letter": "ro",
      "constellation": "Cen",
      "RA_hour": 12,
      "RA_min": 11,
      "RA_sec": 39.1,
      "dec_deg": -52,
      "dec_min": 22,
      "dec_sec": "06",
      "magnitude": 3.96
    },
    {
      "ID": 4656,
      "greek_letter": "del",
      "constellation": "Cru",
      "RA_hour": 12,
      "RA_min": 15,
      "RA_sec": "08.6",
      "dec_deg": -58,
      "dec_min": 44,
      "dec_sec": 56,
      "magnitude": 2.79
    },
    {
      "ID": 4660,
      "greek_letter": "del",
      "constellation": "UMa",
      "RA_hour": 12,
      "RA_min": 15,
      "RA_sec": 25.5,
      "dec_deg": "+57",
      "dec_min": "01",
      "dec_sec": 57,
      "magnitude": 3.31
    },
    {
      "ID": 4662,
      "greek_letter": "gam",
      "constellation": "Crv",
      "RA_hour": 12,
      "RA_min": 15,
      "RA_sec": 48.3,
      "dec_deg": -17,
      "dec_min": 32,
      "dec_sec": 31,
      "magnitude": 2.58
    },
    {
      "ID": 4667,
      "greek_letter": "",
      "constellation": "Com",
      "RA_hour": 12,
      "RA_min": 16,
      "RA_sec": 20.5,
      "dec_deg": "+23",
      "dec_min": 56,
      "dec_sec": 43,
      "magnitude": 4.95
    },
    {
      "ID": 4668,
      "greek_letter": "",
      "constellation": "",
      "RA_hour": 12,
      "RA_min": 16,
      "RA_sec": 30.1,
      "dec_deg": "+33",
      "dec_min": "03",
      "dec_sec": 41,
      "magnitude": 4.98
    },
    {
      "ID": 4671,
      "greek_letter": "eps",
      "constellation": "Mus",
      "RA_hour": 12,
      "RA_min": 17,
      "RA_sec": 34.2,
      "dec_deg": -67,
      "dec_min": 57,
      "dec_sec": 38,
      "magnitude": 4.02
    },
    {
      "ID": 4674,
      "greek_letter": "bet",
      "constellation": "Cha",
      "RA_hour": 12,
      "RA_min": 18,
      "RA_sec": 20.7,
      "dec_deg": -79,
      "dec_min": 18,
      "dec_sec": 43,
      "magnitude": 4.26
    },
    {
      "ID": 4679,
      "greek_letter": "zet",
      "constellation": "Cru",
      "RA_hour": 12,
      "RA_min": 18,
      "RA_sec": 26.1,
      "dec_deg": -64,
      "dec_min": "00",
      "dec_sec": 11,
      "magnitude": 4.05
    },
    {
      "ID": 4682,
      "greek_letter": "",
      "constellation": "",
      "RA_hour": 12,
      "RA_min": 18,
      "RA_sec": 59.7,
      "dec_deg": -55,
      "dec_min": "08",
      "dec_sec": 35,
      "magnitude": 5
    },
    {
      "ID": 4689,
      "greek_letter": "eta",
      "constellation": "Vir",
      "RA_hour": 12,
      "RA_min": 19,
      "RA_sec": 54.3,
      "dec_deg": "-00",
      "dec_min": 40,
      "dec_sec": "00",
      "magnitude": 3.9
    },
    {
      "ID": 4695,
      "greek_letter": "",
      "constellation": "Vir",
      "RA_hour": 12,
      "RA_min": 20,
      "RA_sec": 20.9,
      "dec_deg": "+03",
      "dec_min": 18,
      "dec_sec": 45,
      "magnitude": 4.96
    },
    {
      "ID": 4697,
      "greek_letter": "",
      "constellation": "Com",
      "RA_hour": 12,
      "RA_min": 20,
      "RA_sec": 42.9,
      "dec_deg": "+17",
      "dec_min": 47,
      "dec_sec": 34,
      "magnitude": 4.74
    },
    {
      "ID": 4700,
      "greek_letter": "eps",
      "constellation": "Cru",
      "RA_hour": 12,
      "RA_min": 21,
      "RA_sec": 21.5,
      "dec_deg": -60,
      "dec_min": 24,
      "dec_sec": "04",
      "magnitude": 3.59
    },
    {
      "ID": 4707,
      "greek_letter": "",
      "constellation": "Com",
      "RA_hour": 12,
      "RA_min": 22,
      "RA_sec": 30.2,
      "dec_deg": "+25",
      "dec_min": 50,
      "dec_sec": 46,
      "magnitude": 4.81
    },
    {
      "ID": 4716,
      "greek_letter": "",
      "constellation": "CVn",
      "RA_hour": 12,
      "RA_min": 24,
      "RA_sec": "01.4",
      "dec_deg": "+51",
      "dec_min": 33,
      "dec_sec": 44,
      "magnitude": 4.8
    },
    {
      "ID": 4729,
      "greek_letter": "",
      "constellation": "",
      "RA_hour": 12,
      "RA_min": 26,
      "RA_sec": 30.9,
      "dec_deg": -63,
      "dec_min": "07",
      "dec_sec": 21,
      "magnitude": 4.86
    },
    {
      "ID": 4730,
      "greek_letter": "alf1",
      "constellation": "Cru",
      "RA_hour": 12,
      "RA_min": 26,
      "RA_sec": 35.9,
      "dec_deg": -63,
      "dec_min": "05",
      "dec_sec": 56,
      "magnitude": 1.58
    },
    {
      "ID": 4731,
      "greek_letter": "alf2",
      "constellation": "Cru",
      "RA_hour": 12,
      "RA_min": 26,
      "RA_sec": 36.5,
      "dec_deg": -63,
      "dec_min": "05",
      "dec_sec": 58,
      "magnitude": 2.09
    },
    {
      "ID": 4732,
      "greek_letter": "",
      "constellation": "",
      "RA_hour": 12,
      "RA_min": 26,
      "RA_sec": 31.5,
      "dec_deg": -51,
      "dec_min": 27,
      "dec_sec": "02",
      "magnitude": 4.83
    },
    {
      "ID": 4733,
      "greek_letter": "",
      "constellation": "Com",
      "RA_hour": 12,
      "RA_min": 26,
      "RA_sec": 24,
      "dec_deg": "+27",
      "dec_min": 16,
      "dec_sec": "05",
      "magnitude": 4.95
    },
    {
      "ID": 4737,
      "greek_letter": "gam",
      "constellation": "Com",
      "RA_hour": 12,
      "RA_min": 26,
      "RA_sec": 56.2,
      "dec_deg": "+28",
      "dec_min": 16,
      "dec_sec": "06",
      "magnitude": 4.36
    },
    {
      "ID": 4738,
      "greek_letter": "",
      "constellation": "Com",
      "RA_hour": 12,
      "RA_min": 26,
      "RA_sec": 59.3,
      "dec_deg": "+26",
      "dec_min": 49,
      "dec_sec": 32,
      "magnitude": 4.99
    },
    {
      "ID": 4743,
      "greek_letter": "sig",
      "constellation": "Cen",
      "RA_hour": 12,
      "RA_min": 28,
      "RA_sec": "02.3",
      "dec_deg": -50,
      "dec_min": 13,
      "dec_sec": 51,
      "magnitude": 3.91
    },
    {
      "ID": 4757,
      "greek_letter": "del",
      "constellation": "Crv",
      "RA_hour": 12,
      "RA_min": 29,
      "RA_sec": 51.8,
      "dec_deg": -16,
      "dec_min": 30,
      "dec_sec": 56,
      "magnitude": 2.94
    },
    {
      "ID": 4763,
      "greek_letter": "gam",
      "constellation": "Cru",
      "RA_hour": 12,
      "RA_min": 31,
      "RA_sec": "09.9",
      "dec_deg": -57,
      "dec_min": "06",
      "dec_sec": 47,
      "magnitude": 1.63
    },
    {
      "ID": 4765,
      "greek_letter": "",
      "constellation": "Dra",
      "RA_hour": 12,
      "RA_min": 30,
      "RA_sec": "06.6",
      "dec_deg": "+69",
      "dec_min": 12,
      "dec_sec": "04",
      "magnitude": 4.95
    },
    {
      "ID": 4773,
      "greek_letter": "gam",
      "constellation": "Mus",
      "RA_hour": 12,
      "RA_min": 32,
      "RA_sec": 28,
      "dec_deg": -72,
      "dec_min": "07",
      "dec_sec": 58,
      "magnitude": 3.88
    },
    {
      "ID": 4775,
      "greek_letter": "eta",
      "constellation": "Crv",
      "RA_hour": 12,
      "RA_min": 32,
      "RA_sec": "04.1",
      "dec_deg": -16,
      "dec_min": 11,
      "dec_sec": 46,
      "magnitude": 4.32
    },
    {
      "ID": 4785,
      "greek_letter": "bet",
      "constellation": "CVn",
      "RA_hour": 12,
      "RA_min": 33,
      "RA_sec": 44.5,
      "dec_deg": "+41",
      "dec_min": 21,
      "dec_sec": 27,
      "magnitude": 4.27
    },
    {
      "ID": 4786,
      "greek_letter": "bet",
      "constellation": "Crv",
      "RA_hour": 12,
      "RA_min": 34,
      "RA_sec": 23.2,
      "dec_deg": -23,
      "dec_min": 23,
      "dec_sec": 48,
      "magnitude": 2.64
    },
    {
      "ID": 4787,
      "greek_letter": "kap",
      "constellation": "Dra",
      "RA_hour": 12,
      "RA_min": 33,
      "RA_sec": 28.9,
      "dec_deg": "+69",
      "dec_min": 47,
      "dec_sec": 17,
      "magnitude": 3.89
    },
    {
      "ID": 4789,
      "greek_letter": "",
      "constellation": "Com",
      "RA_hour": 12,
      "RA_min": 34,
      "RA_sec": 51,
      "dec_deg": "+22",
      "dec_min": 37,
      "dec_sec": 45,
      "magnitude": 4.81
    },
    {
      "ID": 4795,
      "greek_letter": "",
      "constellation": "Dra",
      "RA_hour": 12,
      "RA_min": 34,
      "RA_sec": 43.9,
      "dec_deg": "+70",
      "dec_min": "01",
      "dec_sec": 18,
      "magnitude": 4.94
    },
    {
      "ID": 4798,
      "greek_letter": "alf",
      "constellation": "Mus",
      "RA_hour": 12,
      "RA_min": 37,
      "RA_sec": 11,
      "dec_deg": -69,
      "dec_min": "08",
      "dec_sec": "08",
      "magnitude": 2.7
    },
    {
      "ID": 4802,
      "greek_letter": "tau",
      "constellation": "Cen",
      "RA_hour": 12,
      "RA_min": 37,
      "RA_sec": 42.1,
      "dec_deg": -48,
      "dec_min": 32,
      "dec_sec": 28,
      "magnitude": 3.86
    },
    {
      "ID": 4813,
      "greek_letter": "chi",
      "constellation": "Vir",
      "RA_hour": 12,
      "RA_min": 39,
      "RA_sec": 14.7,
      "dec_deg": "-07",
      "dec_min": 59,
      "dec_sec": 44,
      "magnitude": 4.67
    },
    {
      "ID": 4817,
      "greek_letter": "",
      "constellation": "",
      "RA_hour": 12,
      "RA_min": 39,
      "RA_sec": 52.4,
      "dec_deg": -39,
      "dec_min": 59,
      "dec_sec": 15,
      "magnitude": 4.64
    },
    {
      "ID": 4819,
      "greek_letter": "gam",
      "constellation": "Cen",
      "RA_hour": 12,
      "RA_min": 41,
      "RA_sec": 30.9,
      "dec_deg": -48,
      "dec_min": 57,
      "dec_sec": 34,
      "magnitude": 2.17
    },
    {
      "ID": 4823,
      "greek_letter": "",
      "constellation": "",
      "RA_hour": 12,
      "RA_min": 41,
      "RA_sec": 56.6,
      "dec_deg": -59,
      "dec_min": 41,
      "dec_sec": "08",
      "magnitude": 4.94
    },
    {
      "ID": 4825,
      "greek_letter": "gam",
      "constellation": "Vir",
      "RA_hour": 12,
      "RA_min": 41,
      "RA_sec": 39.5,
      "dec_deg": "-01",
      "dec_min": 26,
      "dec_sec": 58,
      "magnitude": 3.65
    },
    {
      "ID": 4826,
      "greek_letter": "gam",
      "constellation": "Vir",
      "RA_hour": 12,
      "RA_min": 41,
      "RA_sec": 39.5,
      "dec_deg": "-01",
      "dec_min": 26,
      "dec_sec": 58,
      "magnitude": 3.68
    },
    {
      "ID": 4828,
      "greek_letter": "ro",
      "constellation": "Vir",
      "RA_hour": 12,
      "RA_min": 41,
      "RA_sec": 53,
      "dec_deg": "+10",
      "dec_min": 14,
      "dec_sec": "08",
      "magnitude": 4.88
    },
    {
      "ID": 4831,
      "greek_letter": "",
      "constellation": "",
      "RA_hour": 12,
      "RA_min": 42,
      "RA_sec": 35.3,
      "dec_deg": -48,
      "dec_min": 48,
      "dec_sec": 47,
      "magnitude": 4.66
    },
    {
      "ID": 4842,
      "greek_letter": "iot",
      "constellation": "Cru",
      "RA_hour": 12,
      "RA_min": 45,
      "RA_sec": 37.8,
      "dec_deg": -60,
      "dec_min": 58,
      "dec_sec": 52,
      "magnitude": 4.69
    },
    {
      "ID": 4844,
      "greek_letter": "bet",
      "constellation": "Mus",
      "RA_hour": 12,
      "RA_min": 46,
      "RA_sec": 16.9,
      "dec_deg": -68,
      "dec_min": "06",
      "dec_sec": 29,
      "magnitude": 3.06
    },
    {
      "ID": 4846,
      "greek_letter": "",
      "constellation": "",
      "RA_hour": 12,
      "RA_min": 45,
      "RA_sec": "07.8",
      "dec_deg": "+45",
      "dec_min": 26,
      "dec_sec": 25,
      "magnitude": 4.87
    },
    {
      "ID": 4848,
      "greek_letter": "",
      "constellation": "",
      "RA_hour": 12,
      "RA_min": 46,
      "RA_sec": 22.6,
      "dec_deg": -56,
      "dec_min": 29,
      "dec_sec": 20,
      "magnitude": 4.66
    },
    {
      "ID": 4853,
      "greek_letter": "bet",
      "constellation": "Cru",
      "RA_hour": 12,
      "RA_min": 47,
      "RA_sec": 43.3,
      "dec_deg": -59,
      "dec_min": 41,
      "dec_sec": 19,
      "magnitude": 1.25
    },
    {
      "ID": 4874,
      "greek_letter": "",
      "constellation": "",
      "RA_hour": 12,
      "RA_min": 50,
      "RA_sec": 41.1,
      "dec_deg": -33,
      "dec_min": 59,
      "dec_sec": 57,
      "magnitude": 4.91
    },
    {
      "ID": 4883,
      "greek_letter": "",
      "constellation": "Com",
      "RA_hour": 12,
      "RA_min": 51,
      "RA_sec": 41.8,
      "dec_deg": "+27",
      "dec_min": 32,
      "dec_sec": 26,
      "magnitude": 4.94
    },
    {
      "ID": 4888,
      "greek_letter": "",
      "constellation": "",
      "RA_hour": 12,
      "RA_min": 53,
      "RA_sec": "06.8",
      "dec_deg": -48,
      "dec_min": 56,
      "dec_sec": 35,
      "magnitude": 4.33
    },
    {
      "ID": 4889,
      "greek_letter": "",
      "constellation": "",
      "RA_hour": 12,
      "RA_min": 53,
      "RA_sec": 26.1,
      "dec_deg": -40,
      "dec_min": 10,
      "dec_sec": 44,
      "magnitude": 4.27
    },
    {
      "ID": 4894,
      "greek_letter": "",
      "constellation": "Com",
      "RA_hour": 12,
      "RA_min": 53,
      "RA_sec": 19.3,
      "dec_deg": "+21",
      "dec_min": 14,
      "dec_sec": 25,
      "magnitude": 4.9
    },
    {
      "ID": 4897,
      "greek_letter": "lam",
      "constellation": "Cru",
      "RA_hour": 12,
      "RA_min": 54,
      "RA_sec": 39.1,
      "dec_deg": -59,
      "dec_min": "08",
      "dec_sec": 47,
      "magnitude": 4.63
    },
    {
      "ID": 4898,
      "greek_letter": "mu1",
      "constellation": "Cru",
      "RA_hour": 12,
      "RA_min": 54,
      "RA_sec": 35.6,
      "dec_deg": -57,
      "dec_min": 10,
      "dec_sec": 40,
      "magnitude": 4.04
    },
    {
      "ID": 4902,
      "greek_letter": "psi",
      "constellation": "Vir",
      "RA_hour": 12,
      "RA_min": 54,
      "RA_sec": 21.1,
      "dec_deg": "-09",
      "dec_min": 32,
      "dec_sec": 20,
      "magnitude": 4.8
    },
    {
      "ID": 4905,
      "greek_letter": "eps",
      "constellation": "UMa",
      "RA_hour": 12,
      "RA_min": 54,
      "RA_sec": "01.7",
      "dec_deg": "+55",
      "dec_min": 57,
      "dec_sec": 35,
      "magnitude": 1.77
    },
    {
      "ID": 4910,
      "greek_letter": "del",
      "constellation": "Vir",
      "RA_hour": 12,
      "RA_min": 55,
      "RA_sec": 36.1,
      "dec_deg": "+03",
      "dec_min": 23,
      "dec_sec": 51,
      "magnitude": 3.38
    },
    {
      "ID": 4915,
      "greek_letter": "alf2",
      "constellation": "CVn",
      "RA_hour": 12,
      "RA_min": 56,
      "RA_sec": "01.6",
      "dec_deg": "+38",
      "dec_min": 19,
      "dec_sec": "06",
      "magnitude": 2.88
    },
    {
      "ID": 4920,
      "greek_letter": "",
      "constellation": "Com",
      "RA_hour": 12,
      "RA_min": 58,
      "RA_sec": 55.4,
      "dec_deg": "+17",
      "dec_min": 24,
      "dec_sec": 33,
      "magnitude": 4.79
    },
    {
      "ID": 4923,
      "greek_letter": "del",
      "constellation": "Mus",
      "RA_hour": 13,
      "RA_min": "02",
      "RA_sec": 16.3,
      "dec_deg": -71,
      "dec_min": 32,
      "dec_sec": 56,
      "magnitude": 3.62
    },
    {
      "ID": 4924,
      "greek_letter": "",
      "constellation": "Com",
      "RA_hour": 13,
      "RA_min": "00",
      "RA_sec": 16.4,
      "dec_deg": "+30",
      "dec_min": 47,
      "dec_sec": "06",
      "magnitude": 4.9
    },
    {
      "ID": 4931,
      "greek_letter": "",
      "constellation": "UMa",
      "RA_hour": 13,
      "RA_min": "00",
      "RA_sec": 43.7,
      "dec_deg": "+56",
      "dec_min": 21,
      "dec_sec": 59,
      "magnitude": 4.93
    },
    {
      "ID": 4932,
      "greek_letter": "eps",
      "constellation": "Vir",
      "RA_hour": 13,
      "RA_min": "02",
      "RA_sec": 10.5,
      "dec_deg": "+10",
      "dec_min": 57,
      "dec_sec": 33,
      "magnitude": 2.79
    },
    {
      "ID": 4933,
      "greek_letter": "xi1",
      "constellation": "Cen",
      "RA_hour": 13,
      "RA_min": "03",
      "RA_sec": 33.1,
      "dec_deg": -49,
      "dec_min": 31,
      "dec_sec": 38,
      "magnitude": 4.85
    },
    {
      "ID": 4940,
      "greek_letter": "",
      "constellation": "",
      "RA_hour": 13,
      "RA_min": "06",
      "RA_sec": 16.6,
      "dec_deg": -48,
      "dec_min": 27,
      "dec_sec": 48,
      "magnitude": 4.71
    },
    {
      "ID": 4942,
      "greek_letter": "xi2",
      "constellation": "Cen",
      "RA_hour": 13,
      "RA_min": "06",
      "RA_sec": 54.5,
      "dec_deg": -49,
      "dec_min": 54,
      "dec_sec": 22,
      "magnitude": 4.27
    },
    {
      "ID": 4954,
      "greek_letter": "",
      "constellation": "Com",
      "RA_hour": 13,
      "RA_min": "07",
      "RA_sec": 10.6,
      "dec_deg": "+27",
      "dec_min": 37,
      "dec_sec": 29,
      "magnitude": 4.82
    },
    {
      "ID": 4958,
      "greek_letter": "psi",
      "constellation": "Hya",
      "RA_hour": 13,
      "RA_min": "09",
      "RA_sec": "03.2",
      "dec_deg": -23,
      "dec_min": "07",
      "dec_sec": "05",
      "magnitude": 4.95
    },
    {
      "ID": 4963,
      "greek_letter": "tet",
      "constellation": "Vir",
      "RA_hour": 13,
      "RA_min": "09",
      "RA_sec": 56.9,
      "dec_deg": "-05",
      "dec_min": 32,
      "dec_sec": 20,
      "magnitude": 4.38
    },
    {
      "ID": 4975,
      "greek_letter": "",
      "constellation": "",
      "RA_hour": 13,
      "RA_min": 12,
      "RA_sec": 17.4,
      "dec_deg": -59,
      "dec_min": 55,
      "dec_sec": 15,
      "magnitude": 4.6
    },
    {
      "ID": 4979,
      "greek_letter": "",
      "constellation": "",
      "RA_hour": 13,
      "RA_min": 12,
      "RA_sec": "03.1",
      "dec_deg": -37,
      "dec_min": 48,
      "dec_sec": 11,
      "magnitude": 4.85
    },
    {
      "ID": 4983,
      "greek_letter": "bet",
      "constellation": "Com",
      "RA_hour": 13,
      "RA_min": 11,
      "RA_sec": 52.3,
      "dec_deg": "+27",
      "dec_min": 52,
      "dec_sec": 41,
      "magnitude": 4.26
    },
    {
      "ID": 4989,
      "greek_letter": "",
      "constellation": "",
      "RA_hour": 13,
      "RA_min": 14,
      "RA_sec": 14.7,
      "dec_deg": -59,
      "dec_min": "06",
      "dec_sec": 12,
      "magnitude": 4.92
    },
    {
      "ID": 4993,
      "greek_letter": "eta",
      "constellation": "Mus",
      "RA_hour": 13,
      "RA_min": 15,
      "RA_sec": 14.9,
      "dec_deg": -67,
      "dec_min": 53,
      "dec_sec": 41,
      "magnitude": 4.8
    },
    {
      "ID": 4997,
      "greek_letter": "",
      "constellation": "",
      "RA_hour": 13,
      "RA_min": 13,
      "RA_sec": 42.9,
      "dec_deg": "+40",
      "dec_min": "09",
      "dec_sec": 10,
      "magnitude": 4.92
    },
    {
      "ID": 5002,
      "greek_letter": "",
      "constellation": "",
      "RA_hour": 13,
      "RA_min": 17,
      "RA_sec": 13,
      "dec_deg": -66,
      "dec_min": 47,
      "dec_sec": "01",
      "magnitude": 4.87
    },
    {
      "ID": 5015,
      "greek_letter": "sig",
      "constellation": "Vir",
      "RA_hour": 13,
      "RA_min": 17,
      "RA_sec": 36.2,
      "dec_deg": "+05",
      "dec_min": 28,
      "dec_sec": 12,
      "magnitude": 4.8
    },
    {
      "ID": 5017,
      "greek_letter": "",
      "constellation": "CVn",
      "RA_hour": 13,
      "RA_min": 17,
      "RA_sec": 32.5,
      "dec_deg": "+40",
      "dec_min": 34,
      "dec_sec": 21,
      "magnitude": 4.73
    },
    {
      "ID": 5019,
      "greek_letter": "",
      "constellation": "Vir",
      "RA_hour": 13,
      "RA_min": 18,
      "RA_sec": 24.2,
      "dec_deg": -18,
      "dec_min": 18,
      "dec_sec": 41,
      "magnitude": 4.74
    },
    {
      "ID": 5020,
      "greek_letter": "gam",
      "constellation": "Hya",
      "RA_hour": 13,
      "RA_min": 18,
      "RA_sec": 55.2,
      "dec_deg": -23,
      "dec_min": 10,
      "dec_sec": 18,
      "magnitude": 3
    },
    {
      "ID": 5028,
      "greek_letter": "iot",
      "constellation": "Cen",
      "RA_hour": 13,
      "RA_min": 20,
      "RA_sec": 35.7,
      "dec_deg": -36,
      "dec_min": 42,
      "dec_sec": 44,
      "magnitude": 2.73
    },
    {
      "ID": 5035,
      "greek_letter": "",
      "constellation": "",
      "RA_hour": 13,
      "RA_min": 22,
      "RA_sec": 37.9,
      "dec_deg": -60,
      "dec_min": 59,
      "dec_sec": 18,
      "magnitude": 4.54
    },
    {
      "ID": 5041,
      "greek_letter": "",
      "constellation": "",
      "RA_hour": 13,
      "RA_min": 24,
      "RA_sec": "00.5",
      "dec_deg": -64,
      "dec_min": 32,
      "dec_sec": "09",
      "magnitude": 4.53
    },
    {
      "ID": 5054,
      "greek_letter": "zet",
      "constellation": "UMa",
      "RA_hour": 13,
      "RA_min": 23,
      "RA_sec": 55.5,
      "dec_deg": "+54",
      "dec_min": 55,
      "dec_sec": 31,
      "magnitude": 2.27
    },
    {
      "ID": 5055,
      "greek_letter": "zet",
      "constellation": "UMa",
      "RA_hour": 13,
      "RA_min": 23,
      "RA_sec": 56.3,
      "dec_deg": "+54",
      "dec_min": 55,
      "dec_sec": 18,
      "magnitude": 3.95
    },
    {
      "ID": 5056,
      "greek_letter": "alf",
      "constellation": "Vir",
      "RA_hour": 13,
      "RA_min": 25,
      "RA_sec": 11.5,
      "dec_deg": -11,
      "dec_min": "09",
      "dec_sec": 41,
      "magnitude": 0.97
    },
    {
      "ID": 5062,
      "greek_letter": "",
      "constellation": "UMa",
      "RA_hour": 13,
      "RA_min": 25,
      "RA_sec": 13.4,
      "dec_deg": "+54",
      "dec_min": 59,
      "dec_sec": 17,
      "magnitude": 4.02
    },
    {
      "ID": 5068,
      "greek_letter": "",
      "constellation": "Vir",
      "RA_hour": 13,
      "RA_min": 27,
      "RA_sec": 27.1,
      "dec_deg": -15,
      "dec_min": 58,
      "dec_sec": 25,
      "magnitude": 4.75
    },
    {
      "ID": 5072,
      "greek_letter": "",
      "constellation": "Vir",
      "RA_hour": 13,
      "RA_min": 28,
      "RA_sec": 25.7,
      "dec_deg": "+13",
      "dec_min": 46,
      "dec_sec": 43,
      "magnitude": 4.98
    },
    {
      "ID": 5080,
      "greek_letter": "",
      "constellation": "",
      "RA_hour": 13,
      "RA_min": 29,
      "RA_sec": 42.7,
      "dec_deg": -23,
      "dec_min": 16,
      "dec_sec": 52,
      "magnitude": 4.97
    },
    {
      "ID": 5089,
      "greek_letter": "",
      "constellation": "",
      "RA_hour": 13,
      "RA_min": 31,
      "RA_sec": "02.6",
      "dec_deg": -39,
      "dec_min": 24,
      "dec_sec": 26,
      "magnitude": 3.88
    },
    {
      "ID": 5095,
      "greek_letter": "",
      "constellation": "Vir",
      "RA_hour": 13,
      "RA_min": 31,
      "RA_sec": 57.8,
      "dec_deg": "-06",
      "dec_min": 15,
      "dec_sec": 21,
      "magnitude": 4.69
    },
    {
      "ID": 5105,
      "greek_letter": "",
      "constellation": "Vir",
      "RA_hour": 13,
      "RA_min": 34,
      "RA_sec": "07.8",
      "dec_deg": "+03",
      "dec_min": 39,
      "dec_sec": 32,
      "magnitude": 4.94
    },
    {
      "ID": 5107,
      "greek_letter": "zet",
      "constellation": "Vir",
      "RA_hour": 13,
      "RA_min": 34,
      "RA_sec": 41.5,
      "dec_deg": "-00",
      "dec_min": 35,
      "dec_sec": 46,
      "magnitude": 3.38
    },
    {
      "ID": 5110,
      "greek_letter": "",
      "constellation": "",
      "RA_hour": 13,
      "RA_min": 34,
      "RA_sec": 47.7,
      "dec_deg": "+37",
      "dec_min": 10,
      "dec_sec": 57,
      "magnitude": 4.98
    },
    {
      "ID": 5112,
      "greek_letter": "",
      "constellation": "CVn",
      "RA_hour": 13,
      "RA_min": 34,
      "RA_sec": 27.2,
      "dec_deg": "+49",
      "dec_min": "00",
      "dec_sec": 57,
      "magnitude": 4.7
    },
    {
      "ID": 5127,
      "greek_letter": "",
      "constellation": "CVn",
      "RA_hour": 13,
      "RA_min": 37,
      "RA_sec": 27.5,
      "dec_deg": "+36",
      "dec_min": 17,
      "dec_sec": 41,
      "magnitude": 4.83
    },
    {
      "ID": 5132,
      "greek_letter": "eps",
      "constellation": "Cen",
      "RA_hour": 13,
      "RA_min": 39,
      "RA_sec": 53.2,
      "dec_deg": -53,
      "dec_min": 27,
      "dec_sec": 59,
      "magnitude": 2.3
    },
    {
      "ID": 5154,
      "greek_letter": "",
      "constellation": "UMa",
      "RA_hour": 13,
      "RA_min": 40,
      "RA_sec": 44.1,
      "dec_deg": "+54",
      "dec_min": 40,
      "dec_sec": 54,
      "magnitude": 4.66
    },
    {
      "ID": 5168,
      "greek_letter": "",
      "constellation": "Cen",
      "RA_hour": 13,
      "RA_min": 45,
      "RA_sec": 41.2,
      "dec_deg": -33,
      "dec_min": "02",
      "dec_sec": 37,
      "magnitude": 4.23
    },
    {
      "ID": 5172,
      "greek_letter": "",
      "constellation": "",
      "RA_hour": 13,
      "RA_min": 46,
      "RA_sec": 39.3,
      "dec_deg": -51,
      "dec_min": 25,
      "dec_sec": 58,
      "magnitude": 4.65
    },
    {
      "ID": 5185,
      "greek_letter": "tau",
      "constellation": "Boo",
      "RA_hour": 13,
      "RA_min": 47,
      "RA_sec": 15.7,
      "dec_deg": "+17",
      "dec_min": 27,
      "dec_sec": 24,
      "magnitude": 4.5
    },
    {
      "ID": 5190,
      "greek_letter": "nu",
      "constellation": "Cen",
      "RA_hour": 13,
      "RA_min": 49,
      "RA_sec": 30.2,
      "dec_deg": -41,
      "dec_min": 41,
      "dec_sec": 16,
      "magnitude": 3.41
    },
    {
      "ID": 5191,
      "greek_letter": "eta",
      "constellation": "UMa",
      "RA_hour": 13,
      "RA_min": 47,
      "RA_sec": 32.3,
      "dec_deg": "+49",
      "dec_min": 18,
      "dec_sec": 48,
      "magnitude": 1.86
    },
    {
      "ID": 5192,
      "greek_letter": "",
      "constellation": "Cen",
      "RA_hour": 13,
      "RA_min": 49,
      "RA_sec": 26.6,
      "dec_deg": -34,
      "dec_min": 27,
      "dec_sec": "02",
      "magnitude": 4.19
    },
    {
      "ID": 5193,
      "greek_letter": "mu",
      "constellation": "Cen",
      "RA_hour": 13,
      "RA_min": 49,
      "RA_sec": 36.9,
      "dec_deg": -42,
      "dec_min": 28,
      "dec_sec": 26,
      "magnitude": 3.04
    },
    {
      "ID": 5196,
      "greek_letter": "",
      "constellation": "Vir",
      "RA_hour": 13,
      "RA_min": 49,
      "RA_sec": 52.2,
      "dec_deg": -18,
      "dec_min": "08",
      "dec_sec": "03",
      "magnitude": 4.97
    },
    {
      "ID": 5200,
      "greek_letter": "ups",
      "constellation": "Boo",
      "RA_hour": 13,
      "RA_min": 49,
      "RA_sec": 28.5,
      "dec_deg": "+15",
      "dec_min": 47,
      "dec_sec": 52,
      "magnitude": 4.07
    },
    {
      "ID": 5201,
      "greek_letter": "",
      "constellation": "Boo",
      "RA_hour": 13,
      "RA_min": 49,
      "RA_sec": 42.7,
      "dec_deg": "+21",
      "dec_min": 15,
      "dec_sec": 51,
      "magnitude": 4.91
    },
    {
      "ID": 5210,
      "greek_letter": "",
      "constellation": "Cen",
      "RA_hour": 13,
      "RA_min": 51,
      "RA_sec": 49.5,
      "dec_deg": -32,
      "dec_min": 59,
      "dec_sec": 40,
      "magnitude": 4.56
    },
    {
      "ID": 5219,
      "greek_letter": "",
      "constellation": "",
      "RA_hour": 13,
      "RA_min": 51,
      "RA_sec": 47.4,
      "dec_deg": "+34",
      "dec_min": 26,
      "dec_sec": 39,
      "magnitude": 4.75
    },
    {
      "ID": 5221,
      "greek_letter": "",
      "constellation": "Cen",
      "RA_hour": 13,
      "RA_min": 53,
      "RA_sec": 12.4,
      "dec_deg": -31,
      "dec_min": 55,
      "dec_sec": 39,
      "magnitude": 4.74
    },
    {
      "ID": 5226,
      "greek_letter": "",
      "constellation": "Dra",
      "RA_hour": 13,
      "RA_min": 51,
      "RA_sec": 25.8,
      "dec_deg": "+64",
      "dec_min": 43,
      "dec_sec": 23,
      "magnitude": 4.66
    },
    {
      "ID": 5231,
      "greek_letter": "zet",
      "constellation": "Cen",
      "RA_hour": 13,
      "RA_min": 55,
      "RA_sec": 32.3,
      "dec_deg": -47,
      "dec_min": 17,
      "dec_sec": 18,
      "magnitude": 2.55
    },
    {
      "ID": 5235,
      "greek_letter": "eta",
      "constellation": "Boo",
      "RA_hour": 13,
      "RA_min": 54,
      "RA_sec": 41,
      "dec_deg": "+18",
      "dec_min": 23,
      "dec_sec": 52,
      "magnitude": 2.68
    },
    {
      "ID": 5241,
      "greek_letter": "",
      "constellation": "",
      "RA_hour": 13,
      "RA_min": 57,
      "RA_sec": 38.9,
      "dec_deg": -63,
      "dec_min": 41,
      "dec_sec": 12,
      "magnitude": 4.71
    },
    {
      "ID": 5248,
      "greek_letter": "phi",
      "constellation": "Cen",
      "RA_hour": 13,
      "RA_min": 58,
      "RA_sec": 16.2,
      "dec_deg": -42,
      "dec_min": "06",
      "dec_sec": "03",
      "magnitude": 3.83
    },
    {
      "ID": 5249,
      "greek_letter": "ups1",
      "constellation": "Cen",
      "RA_hour": 13,
      "RA_min": 58,
      "RA_sec": 40.7,
      "dec_deg": -44,
      "dec_min": 48,
      "dec_sec": 13,
      "magnitude": 3.87
    },
    {
      "ID": 5260,
      "greek_letter": "ups2",
      "constellation": "Cen",
      "RA_hour": 14,
      "RA_min": "01",
      "RA_sec": 43.3,
      "dec_deg": -45,
      "dec_min": 36,
      "dec_sec": 12,
      "magnitude": 4.33
    },
    {
      "ID": 5264,
      "greek_letter": "tau",
      "constellation": "Vir",
      "RA_hour": 14,
      "RA_min": "01",
      "RA_sec": 38.7,
      "dec_deg": "+01",
      "dec_min": 32,
      "dec_sec": 40,
      "magnitude": 4.26
    },
    {
      "ID": 5267,
      "greek_letter": "bet",
      "constellation": "Cen",
      "RA_hour": 14,
      "RA_min": "03",
      "RA_sec": 49.4,
      "dec_deg": -60,
      "dec_min": 22,
      "dec_sec": 22,
      "magnitude": 0.61
    },
    {
      "ID": 5285,
      "greek_letter": "chi",
      "constellation": "Cen",
      "RA_hour": 14,
      "RA_min": "06",
      "RA_sec": "02.7",
      "dec_deg": -41,
      "dec_min": 10,
      "dec_sec": 46,
      "magnitude": 4.36
    },
    {
      "ID": 5287,
      "greek_letter": "pi",
      "constellation": "Hya",
      "RA_hour": 14,
      "RA_min": "06",
      "RA_sec": 22.2,
      "dec_deg": -26,
      "dec_min": 40,
      "dec_sec": 56,
      "magnitude": 3.28
    },
    {
      "ID": 5288,
      "greek_letter": "tet",
      "constellation": "Cen",
      "RA_hour": 14,
      "RA_min": "06",
      "RA_sec": 40.8,
      "dec_deg": -36,
      "dec_min": 22,
      "dec_sec": 12,
      "magnitude": 2.05
    },
    {
      "ID": 5291,
      "greek_letter": "alf",
      "constellation": "Dra",
      "RA_hour": 14,
      "RA_min": "04",
      "RA_sec": 23.2,
      "dec_deg": "+64",
      "dec_min": 22,
      "dec_sec": 33,
      "magnitude": 3.65
    },
    {
      "ID": 5297,
      "greek_letter": "",
      "constellation": "",
      "RA_hour": 14,
      "RA_min": "09",
      "RA_sec": 54.7,
      "dec_deg": -53,
      "dec_min": 26,
      "dec_sec": 20,
      "magnitude": 4.75
    },
    {
      "ID": 5301,
      "greek_letter": "",
      "constellation": "",
      "RA_hour": 14,
      "RA_min": 10,
      "RA_sec": 50.4,
      "dec_deg": -16,
      "dec_min": 18,
      "dec_sec": "07",
      "magnitude": 4.91
    },
    {
      "ID": 5303,
      "greek_letter": "eta",
      "constellation": "Aps",
      "RA_hour": 14,
      "RA_min": 18,
      "RA_sec": 13.6,
      "dec_deg": -81,
      "dec_min": "00",
      "dec_sec": 27,
      "magnitude": 4.91
    },
    {
      "ID": 5304,
      "greek_letter": "",
      "constellation": "Boo",
      "RA_hour": 14,
      "RA_min": 10,
      "RA_sec": 23.9,
      "dec_deg": "+25",
      "dec_min": "05",
      "dec_sec": 30,
      "magnitude": 4.83
    },
    {
      "ID": 5315,
      "greek_letter": "kap",
      "constellation": "Vir",
      "RA_hour": 14,
      "RA_min": 12,
      "RA_sec": 53.7,
      "dec_deg": -10,
      "dec_min": 16,
      "dec_sec": 25,
      "magnitude": 4.21
    },
    {
      "ID": 5321,
      "greek_letter": "",
      "constellation": "UMi",
      "RA_hour": 14,
      "RA_min": "08",
      "RA_sec": 50.8,
      "dec_deg": "+77",
      "dec_min": 32,
      "dec_sec": 51,
      "magnitude": 4.82
    },
    {
      "ID": 5329,
      "greek_letter": "kap2",
      "constellation": "Boo",
      "RA_hour": 14,
      "RA_min": 13,
      "RA_sec": 28.9,
      "dec_deg": "+51",
      "dec_min": 47,
      "dec_sec": 24,
      "magnitude": 4.54
    },
    {
      "ID": 5338,
      "greek_letter": "iot",
      "constellation": "Vir",
      "RA_hour": 14,
      "RA_min": 16,
      "RA_sec": "00.8",
      "dec_deg": "-06",
      "dec_min": "00",
      "dec_sec": "02",
      "magnitude": 4.09
    },
    {
      "ID": 5339,
      "greek_letter": "del",
      "constellation": "Oct",
      "RA_hour": 14,
      "RA_min": 26,
      "RA_sec": 54.8,
      "dec_deg": -83,
      "dec_min": 40,
      "dec_sec": "04",
      "magnitude": 4.32
    },
    {
      "ID": 5340,
      "greek_letter": "alf",
      "constellation": "Boo",
      "RA_hour": 14,
      "RA_min": 15,
      "RA_sec": 39.6,
      "dec_deg": "+19",
      "dec_min": 10,
      "dec_sec": 57,
      "magnitude": -0.05
    },
    {
      "ID": 5350,
      "greek_letter": "iot",
      "constellation": "Boo",
      "RA_hour": 14,
      "RA_min": 16,
      "RA_sec": "09.8",
      "dec_deg": "+51",
      "dec_min": 22,
      "dec_sec": "02",
      "magnitude": 4.75
    },
    {
      "ID": 5351,
      "greek_letter": "lam",
      "constellation": "Boo",
      "RA_hour": 14,
      "RA_min": 16,
      "RA_sec": 22.9,
      "dec_deg": "+46",
      "dec_min": "05",
      "dec_sec": 18,
      "magnitude": 4.18
    },
    {
      "ID": 5354,
      "greek_letter": "iot",
      "constellation": "Lup",
      "RA_hour": 14,
      "RA_min": 19,
      "RA_sec": 24.1,
      "dec_deg": -46,
      "dec_min": "03",
      "dec_sec": 28,
      "magnitude": 3.55
    },
    {
      "ID": 5358,
      "greek_letter": "",
      "constellation": "",
      "RA_hour": 14,
      "RA_min": 20,
      "RA_sec": 19.4,
      "dec_deg": -56,
      "dec_min": 23,
      "dec_sec": 12,
      "magnitude": 4.35
    },
    {
      "ID": 5359,
      "greek_letter": "lam",
      "constellation": "Vir",
      "RA_hour": 14,
      "RA_min": 19,
      "RA_sec": "06.5",
      "dec_deg": -13,
      "dec_min": 22,
      "dec_sec": 16,
      "magnitude": 4.52
    },
    {
      "ID": 5361,
      "greek_letter": "",
      "constellation": "",
      "RA_hour": 14,
      "RA_min": 17,
      "RA_sec": 59.7,
      "dec_deg": "+35",
      "dec_min": 30,
      "dec_sec": 34,
      "magnitude": 4.81
    },
    {
      "ID": 5364,
      "greek_letter": "",
      "constellation": "",
      "RA_hour": 14,
      "RA_min": 20,
      "RA_sec": 42.4,
      "dec_deg": -45,
      "dec_min": 11,
      "dec_sec": 14,
      "magnitude": 4.77
    },
    {
      "ID": 5367,
      "greek_letter": "psi",
      "constellation": "Cen",
      "RA_hour": 14,
      "RA_min": 20,
      "RA_sec": 33.3,
      "dec_deg": -37,
      "dec_min": 53,
      "dec_sec": "07",
      "magnitude": 4.05
    },
    {
      "ID": 5370,
      "greek_letter": "",
      "constellation": "Boo",
      "RA_hour": 14,
      "RA_min": 19,
      "RA_sec": 45.1,
      "dec_deg": "+16",
      "dec_min": 18,
      "dec_sec": 25,
      "magnitude": 4.86
    },
    {
      "ID": 5371,
      "greek_letter": "",
      "constellation": "",
      "RA_hour": 14,
      "RA_min": 22,
      "RA_sec": 36.9,
      "dec_deg": -58,
      "dec_min": 27,
      "dec_sec": 34,
      "magnitude": 4.92
    },
    {
      "ID": 5378,
      "greek_letter": "",
      "constellation": "",
      "RA_hour": 14,
      "RA_min": 23,
      "RA_sec": "02.1",
      "dec_deg": -39,
      "dec_min": 30,
      "dec_sec": 44,
      "magnitude": 4.42
    },
    {
      "ID": 5381,
      "greek_letter": "",
      "constellation": "Hya",
      "RA_hour": 14,
      "RA_min": 23,
      "RA_sec": "05.7",
      "dec_deg": -27,
      "dec_min": 45,
      "dec_sec": 14,
      "magnitude": 4.75
    },
    {
      "ID": 5395,
      "greek_letter": "tau1",
      "constellation": "Lup",
      "RA_hour": 14,
      "RA_min": 26,
      "RA_sec": "08.1",
      "dec_deg": -45,
      "dec_min": 13,
      "dec_sec": 17,
      "magnitude": 4.56
    },
    {
      "ID": 5396,
      "greek_letter": "tau2",
      "constellation": "Lup",
      "RA_hour": 14,
      "RA_min": 26,
      "RA_sec": 10.7,
      "dec_deg": -45,
      "dec_min": 22,
      "dec_sec": 46,
      "magnitude": 4.35
    },
    {
      "ID": 5404,
      "greek_letter": "tet",
      "constellation": "Boo",
      "RA_hour": 14,
      "RA_min": 25,
      "RA_sec": 11.7,
      "dec_deg": "+51",
      "dec_min": 51,
      "dec_sec": "03",
      "magnitude": 4.06
    },
    {
      "ID": 5407,
      "greek_letter": "",
      "constellation": "Hya",
      "RA_hour": 14,
      "RA_min": 28,
      "RA_sec": 10.3,
      "dec_deg": -29,
      "dec_min": 29,
      "dec_sec": 30,
      "magnitude": 4.97
    },
    {
      "ID": 5409,
      "greek_letter": "phi",
      "constellation": "Vir",
      "RA_hour": 14,
      "RA_min": 28,
      "RA_sec": 12.1,
      "dec_deg": "-02",
      "dec_min": 13,
      "dec_sec": 41,
      "magnitude": 4.82
    },
    {
      "ID": 5425,
      "greek_letter": "sig",
      "constellation": "Lup",
      "RA_hour": 14,
      "RA_min": 32,
      "RA_sec": 36.8,
      "dec_deg": -50,
      "dec_min": 27,
      "dec_sec": 25,
      "magnitude": 4.42
    },
    {
      "ID": 5429,
      "greek_letter": "ro",
      "constellation": "Boo",
      "RA_hour": 14,
      "RA_min": 31,
      "RA_sec": 49.7,
      "dec_deg": "+30",
      "dec_min": 22,
      "dec_sec": 17,
      "magnitude": 3.59
    },
    {
      "ID": 5430,
      "greek_letter": "",
      "constellation": "UMi",
      "RA_hour": 14,
      "RA_min": 27,
      "RA_sec": 31.4,
      "dec_deg": "+75",
      "dec_min": 41,
      "dec_sec": 45,
      "magnitude": 4.25
    },
    {
      "ID": 5435,
      "greek_letter": "gam",
      "constellation": "Boo",
      "RA_hour": 14,
      "RA_min": 32,
      "RA_sec": "04.6",
      "dec_deg": "+38",
      "dec_min": 18,
      "dec_sec": 29,
      "magnitude": 3.02
    },
    {
      "ID": 5440,
      "greek_letter": "eta",
      "constellation": "Cen",
      "RA_hour": 14,
      "RA_min": 35,
      "RA_sec": 30.3,
      "dec_deg": -42,
      "dec_min": "09",
      "dec_sec": 28,
      "magnitude": 2.31
    },
    {
      "ID": 5447,
      "greek_letter": "sig",
      "constellation": "Boo",
      "RA_hour": 14,
      "RA_min": 34,
      "RA_sec": 40.7,
      "dec_deg": "+29",
      "dec_min": 44,
      "dec_sec": 42,
      "magnitude": 4.47
    },
    {
      "ID": 5453,
      "greek_letter": "ro",
      "constellation": "Lup",
      "RA_hour": 14,
      "RA_min": 37,
      "RA_sec": 53.1,
      "dec_deg": -49,
      "dec_min": 25,
      "dec_sec": 32,
      "magnitude": 4.05
    },
    {
      "ID": 5459,
      "greek_letter": "alf1",
      "constellation": "Cen",
      "RA_hour": 14,
      "RA_min": 39,
      "RA_sec": 36.2,
      "dec_deg": -60,
      "dec_min": 50,
      "dec_sec": "07",
      "magnitude": -0.01
    },
    {
      "ID": 5460,
      "greek_letter": "alf2",
      "constellation": "Cen",
      "RA_hour": 14,
      "RA_min": 39,
      "RA_sec": 36.2,
      "dec_deg": -60,
      "dec_min": 50,
      "dec_sec": "07",
      "magnitude": 1.33
    },
    {
      "ID": 5463,
      "greek_letter": "alf",
      "constellation": "Cir",
      "RA_hour": 14,
      "RA_min": 42,
      "RA_sec": 30.3,
      "dec_deg": -64,
      "dec_min": 58,
      "dec_sec": 31,
      "magnitude": 3.19
    },
    {
      "ID": 5469,
      "greek_letter": "alf",
      "constellation": "Lup",
      "RA_hour": 14,
      "RA_min": 41,
      "RA_sec": 55.7,
      "dec_deg": -47,
      "dec_min": 23,
      "dec_sec": 17,
      "magnitude": 2.3
    },
    {
      "ID": 5470,
      "greek_letter": "alf",
      "constellation": "Aps",
      "RA_hour": 14,
      "RA_min": 47,
      "RA_sec": 51.6,
      "dec_deg": -79,
      "dec_min": "02",
      "dec_sec": 41,
      "magnitude": 3.83
    },
    {
      "ID": 5471,
      "greek_letter": "",
      "constellation": "",
      "RA_hour": 14,
      "RA_min": 41,
      "RA_sec": 57.5,
      "dec_deg": -37,
      "dec_min": 47,
      "dec_sec": 37,
      "magnitude": 4
    },
    {
      "ID": 5475,
      "greek_letter": "pi1",
      "constellation": "Boo",
      "RA_hour": 14,
      "RA_min": 40,
      "RA_sec": 43.5,
      "dec_deg": "+16",
      "dec_min": 25,
      "dec_sec": "06",
      "magnitude": 4.94
    },
    {
      "ID": 5477,
      "greek_letter": "zet",
      "constellation": "Boo",
      "RA_hour": 14,
      "RA_min": 41,
      "RA_sec": "08.8",
      "dec_deg": "+13",
      "dec_min": 43,
      "dec_sec": 42,
      "magnitude": 4.83
    },
    {
      "ID": 5478,
      "greek_letter": "zet",
      "constellation": "Boo",
      "RA_hour": 14,
      "RA_min": 41,
      "RA_sec": "08.8",
      "dec_deg": "+13",
      "dec_min": 43,
      "dec_sec": 42,
      "magnitude": 4.43
    },
    {
      "ID": 5480,
      "greek_letter": "",
      "constellation": "Boo",
      "RA_hour": 14,
      "RA_min": 41,
      "RA_sec": 38.7,
      "dec_deg": "+08",
      "dec_min": "09",
      "dec_sec": 42,
      "magnitude": 4.86
    },
    {
      "ID": 5485,
      "greek_letter": "",
      "constellation": "",
      "RA_hour": 14,
      "RA_min": 43,
      "RA_sec": 39.3,
      "dec_deg": -35,
      "dec_min": 10,
      "dec_sec": 26,
      "magnitude": 4.05
    },
    {
      "ID": 5487,
      "greek_letter": "mu",
      "constellation": "Vir",
      "RA_hour": 14,
      "RA_min": 43,
      "RA_sec": "03.5",
      "dec_deg": "-05",
      "dec_min": 39,
      "dec_sec": 30,
      "magnitude": 3.88
    },
    {
      "ID": 5489,
      "greek_letter": "",
      "constellation": "",
      "RA_hour": 14,
      "RA_min": 44,
      "RA_sec": 59.1,
      "dec_deg": -35,
      "dec_min": 11,
      "dec_sec": 31,
      "magnitude": 4.92
    },
    {
      "ID": 5490,
      "greek_letter": "",
      "constellation": "Boo",
      "RA_hour": 14,
      "RA_min": 43,
      "RA_sec": 25.3,
      "dec_deg": "+26",
      "dec_min": 31,
      "dec_sec": 40,
      "magnitude": 4.79
    },
    {
      "ID": 5497,
      "greek_letter": "",
      "constellation": "Hya",
      "RA_hour": 14,
      "RA_min": 46,
      "RA_sec": "00.0",
      "dec_deg": -25,
      "dec_min": 26,
      "dec_sec": 35,
      "magnitude": 4.94
    },
    {
      "ID": 5502,
      "greek_letter": "omi",
      "constellation": "Boo",
      "RA_hour": 14,
      "RA_min": 45,
      "RA_sec": 14.4,
      "dec_deg": "+16",
      "dec_min": 57,
      "dec_sec": 52,
      "magnitude": 4.6
    },
    {
      "ID": 5506,
      "greek_letter": "eps",
      "constellation": "Boo",
      "RA_hour": 14,
      "RA_min": 44,
      "RA_sec": 59.1,
      "dec_deg": "+27",
      "dec_min": "04",
      "dec_sec": 27,
      "magnitude": 2.7
    },
    {
      "ID": 5511,
      "greek_letter": "",
      "constellation": "Vir",
      "RA_hour": 14,
      "RA_min": 46,
      "RA_sec": 14.9,
      "dec_deg": "+01",
      "dec_min": 53,
      "dec_sec": 34,
      "magnitude": 3.73
    },
    {
      "ID": 5526,
      "greek_letter": "",
      "constellation": "Hya",
      "RA_hour": 14,
      "RA_min": 50,
      "RA_sec": 17.2,
      "dec_deg": -27,
      "dec_min": 57,
      "dec_sec": 37,
      "magnitude": 4.41
    },
    {
      "ID": 5528,
      "greek_letter": "omi",
      "constellation": "Lup",
      "RA_hour": 14,
      "RA_min": 51,
      "RA_sec": 38.3,
      "dec_deg": -43,
      "dec_min": 34,
      "dec_sec": 31,
      "magnitude": 4.33
    },
    {
      "ID": 5531,
      "greek_letter": "alf2",
      "constellation": "Lib",
      "RA_hour": 14,
      "RA_min": 50,
      "RA_sec": 52.6,
      "dec_deg": -16,
      "dec_min": "02",
      "dec_sec": 31,
      "magnitude": 2.75
    },
    {
      "ID": 5535,
      "greek_letter": "",
      "constellation": "Lib",
      "RA_hour": 14,
      "RA_min": 51,
      "RA_sec": "00.9",
      "dec_deg": "-02",
      "dec_min": 17,
      "dec_sec": 57,
      "magnitude": 4.94
    },
    {
      "ID": 5544,
      "greek_letter": "xi",
      "constellation": "Boo",
      "RA_hour": 14,
      "RA_min": 51,
      "RA_sec": 23.2,
      "dec_deg": "+19",
      "dec_min": "06",
      "dec_sec": "04",
      "magnitude": 4.54
    },
    {
      "ID": 5563,
      "greek_letter": "bet",
      "constellation": "UMi",
      "RA_hour": 14,
      "RA_min": 50,
      "RA_sec": 42.2,
      "dec_deg": "+74",
      "dec_min": "09",
      "dec_sec": 20,
      "magnitude": 2.08
    },
    {
      "ID": 5570,
      "greek_letter": "",
      "constellation": "Lib",
      "RA_hour": 14,
      "RA_min": 57,
      "RA_sec": 10.9,
      "dec_deg": "-04",
      "dec_min": 20,
      "dec_sec": 47,
      "magnitude": 4.49
    },
    {
      "ID": 5571,
      "greek_letter": "bet",
      "constellation": "Lup",
      "RA_hour": 14,
      "RA_min": 58,
      "RA_sec": 31.8,
      "dec_deg": -43,
      "dec_min": "08",
      "dec_sec": "02",
      "magnitude": 2.68
    },
    {
      "ID": 5576,
      "greek_letter": "kap",
      "constellation": "Cen",
      "RA_hour": 14,
      "RA_min": 59,
      "RA_sec": "09.6",
      "dec_deg": -42,
      "dec_min": "06",
      "dec_sec": 15,
      "magnitude": 3.13
    },
    {
      "ID": 5586,
      "greek_letter": "del",
      "constellation": "Lib",
      "RA_hour": 15,
      "RA_min": "00",
      "RA_sec": 58.3,
      "dec_deg": "-08",
      "dec_min": 31,
      "dec_sec": "08",
      "magnitude": 4.93
    },
    {
      "ID": 5589,
      "greek_letter": "",
      "constellation": "",
      "RA_hour": 14,
      "RA_min": 57,
      "RA_sec": 34.9,
      "dec_deg": "+65",
      "dec_min": 55,
      "dec_sec": 56,
      "magnitude": 4.54
    },
    {
      "ID": 5600,
      "greek_letter": "omg",
      "constellation": "Boo",
      "RA_hour": 15,
      "RA_min": "02",
      "RA_sec": "06.4",
      "dec_deg": "+25",
      "dec_min": "00",
      "dec_sec": 29,
      "magnitude": 4.82
    },
    {
      "ID": 5601,
      "greek_letter": "",
      "constellation": "Vir",
      "RA_hour": 15,
      "RA_min": "02",
      "RA_sec": 54,
      "dec_deg": "+02",
      "dec_min": "05",
      "dec_sec": 28,
      "magnitude": 4.4
    },
    {
      "ID": 5602,
      "greek_letter": "bet",
      "constellation": "Boo",
      "RA_hour": 15,
      "RA_min": "01",
      "RA_sec": 56.6,
      "dec_deg": "+40",
      "dec_min": 23,
      "dec_sec": 26,
      "magnitude": 3.52
    },
    {
      "ID": 5603,
      "greek_letter": "sig",
      "constellation": "Lib",
      "RA_hour": 15,
      "RA_min": "04",
      "RA_sec": "04.1",
      "dec_deg": -25,
      "dec_min": 16,
      "dec_sec": 55,
      "magnitude": 3.21
    },
    {
      "ID": 5605,
      "greek_letter": "pi",
      "constellation": "Lup",
      "RA_hour": 15,
      "RA_min": "05",
      "RA_sec": "07.1",
      "dec_deg": -47,
      "dec_min": "03",
      "dec_sec": "04",
      "magnitude": 4.72
    },
    {
      "ID": 5606,
      "greek_letter": "pi",
      "constellation": "Lup",
      "RA_hour": 15,
      "RA_min": "05",
      "RA_sec": "07.1",
      "dec_deg": -47,
      "dec_min": "03",
      "dec_sec": "04",
      "magnitude": 4.82
    },
    {
      "ID": 5616,
      "greek_letter": "psi",
      "constellation": "Boo",
      "RA_hour": 15,
      "RA_min": "04",
      "RA_sec": 26.7,
      "dec_deg": "+26",
      "dec_min": 56,
      "dec_sec": 51,
      "magnitude": 4.55
    },
    {
      "ID": 5618,
      "greek_letter": "",
      "constellation": "Boo",
      "RA_hour": 15,
      "RA_min": "03",
      "RA_sec": 47.3,
      "dec_deg": "+47",
      "dec_min": 39,
      "dec_sec": 16,
      "magnitude": 4.76
    },
    {
      "ID": 5626,
      "greek_letter": "lam",
      "constellation": "Lup",
      "RA_hour": 15,
      "RA_min": "08",
      "RA_sec": 50.5,
      "dec_deg": -45,
      "dec_min": 16,
      "dec_sec": 47,
      "magnitude": 4.05
    },
    {
      "ID": 5634,
      "greek_letter": "",
      "constellation": "Boo",
      "RA_hour": 15,
      "RA_min": "07",
      "RA_sec": 18,
      "dec_deg": "+24",
      "dec_min": 52,
      "dec_sec": "09",
      "magnitude": 4.93
    },
    {
      "ID": 5646,
      "greek_letter": "kap1",
      "constellation": "Lup",
      "RA_hour": 15,
      "RA_min": 11,
      "RA_sec": 56,
      "dec_deg": -48,
      "dec_min": 44,
      "dec_sec": 16,
      "magnitude": 3.87
    },
    {
      "ID": 5649,
      "greek_letter": "zet",
      "constellation": "Lup",
      "RA_hour": 15,
      "RA_min": 12,
      "RA_sec": 17,
      "dec_deg": -52,
      "dec_min": "05",
      "dec_sec": 57,
      "magnitude": 3.41
    },
    {
      "ID": 5651,
      "greek_letter": "",
      "constellation": "",
      "RA_hour": 15,
      "RA_min": 12,
      "RA_sec": 49.4,
      "dec_deg": -44,
      "dec_min": 30,
      "dec_sec": "02",
      "magnitude": 4.82
    },
    {
      "ID": 5652,
      "greek_letter": "iot1",
      "constellation": "Lib",
      "RA_hour": 15,
      "RA_min": 12,
      "RA_sec": 13.2,
      "dec_deg": -19,
      "dec_min": 47,
      "dec_sec": 30,
      "magnitude": 4.54
    },
    {
      "ID": 5660,
      "greek_letter": "",
      "constellation": "Lup",
      "RA_hour": 15,
      "RA_min": 14,
      "RA_sec": 37.2,
      "dec_deg": -31,
      "dec_min": 31,
      "dec_sec": "09",
      "magnitude": 4.91
    },
    {
      "ID": 5666,
      "greek_letter": "eps",
      "constellation": "Cir",
      "RA_hour": 15,
      "RA_min": 17,
      "RA_sec": 38.8,
      "dec_deg": -63,
      "dec_min": 36,
      "dec_sec": 38,
      "magnitude": 4.86
    },
    {
      "ID": 5670,
      "greek_letter": "bet",
      "constellation": "Cir",
      "RA_hour": 15,
      "RA_min": 17,
      "RA_sec": 30.8,
      "dec_deg": -58,
      "dec_min": 48,
      "dec_sec": "04",
      "magnitude": 4.07
    },
    {
      "ID": 5671,
      "greek_letter": "gam",
      "constellation": "TrA",
      "RA_hour": 15,
      "RA_min": 18,
      "RA_sec": 54.6,
      "dec_deg": -68,
      "dec_min": 40,
      "dec_sec": 46,
      "magnitude": 2.89
    },
    {
      "ID": 5681,
      "greek_letter": "del",
      "constellation": "Boo",
      "RA_hour": 15,
      "RA_min": 15,
      "RA_sec": 30.1,
      "dec_deg": "+33",
      "dec_min": 18,
      "dec_sec": 53,
      "magnitude": 3.49
    },
    {
      "ID": 5683,
      "greek_letter": "mu",
      "constellation": "Lup",
      "RA_hour": 15,
      "RA_min": 18,
      "RA_sec": 31.9,
      "dec_deg": -47,
      "dec_min": 52,
      "dec_sec": 30,
      "magnitude": 4.27
    },
    {
      "ID": 5685,
      "greek_letter": "bet",
      "constellation": "Lib",
      "RA_hour": 15,
      "RA_min": 17,
      "RA_sec": "00.3",
      "dec_deg": "-09",
      "dec_min": 22,
      "dec_sec": 59,
      "magnitude": 2.62
    },
    {
      "ID": 5686,
      "greek_letter": "",
      "constellation": "Lup",
      "RA_hour": 15,
      "RA_min": 17,
      "RA_sec": 49.7,
      "dec_deg": -30,
      "dec_min": "08",
      "dec_sec": 55,
      "magnitude": 4.33
    },
    {
      "ID": 5695,
      "greek_letter": "del",
      "constellation": "Lup",
      "RA_hour": 15,
      "RA_min": 21,
      "RA_sec": 22.2,
      "dec_deg": -40,
      "dec_min": 38,
      "dec_sec": 52,
      "magnitude": 3.22
    },
    {
      "ID": 5698,
      "greek_letter": "nu1",
      "constellation": "Lup",
      "RA_hour": 15,
      "RA_min": 22,
      "RA_sec": "08.2",
      "dec_deg": -47,
      "dec_min": 55,
      "dec_sec": 40,
      "magnitude": 5
    },
    {
      "ID": 5704,
      "greek_letter": "gam",
      "constellation": "Cir",
      "RA_hour": 15,
      "RA_min": 23,
      "RA_sec": 22.6,
      "dec_deg": -59,
      "dec_min": 19,
      "dec_sec": 15,
      "magnitude": 4.51
    },
    {
      "ID": 5705,
      "greek_letter": "phi1",
      "constellation": "Lup",
      "RA_hour": 15,
      "RA_min": 21,
      "RA_sec": 48.3,
      "dec_deg": -36,
      "dec_min": 15,
      "dec_sec": 41,
      "magnitude": 3.56
    },
    {
      "ID": 5708,
      "greek_letter": "eps",
      "constellation": "Lup",
      "RA_hour": 15,
      "RA_min": 22,
      "RA_sec": 40.8,
      "dec_deg": -44,
      "dec_min": 41,
      "dec_sec": 22,
      "magnitude": 3.37
    },
    {
      "ID": 5712,
      "greek_letter": "phi2",
      "constellation": "Lup",
      "RA_hour": 15,
      "RA_min": 23,
      "RA_sec": "09.2",
      "dec_deg": -36,
      "dec_min": 51,
      "dec_sec": 30,
      "magnitude": 4.54
    },
    {
      "ID": 5723,
      "greek_letter": "eps",
      "constellation": "Lib",
      "RA_hour": 15,
      "RA_min": 24,
      "RA_sec": 11.8,
      "dec_deg": -10,
      "dec_min": 19,
      "dec_sec": 20,
      "magnitude": 4.94
    },
    {
      "ID": 5724,
      "greek_letter": "",
      "constellation": "",
      "RA_hour": 15,
      "RA_min": 25,
      "RA_sec": 20.1,
      "dec_deg": -38,
      "dec_min": 44,
      "dec_sec": "01",
      "magnitude": 4.6
    },
    {
      "ID": 5733,
      "greek_letter": "mu1",
      "constellation": "Boo",
      "RA_hour": 15,
      "RA_min": 24,
      "RA_sec": 29.3,
      "dec_deg": "+37",
      "dec_min": 22,
      "dec_sec": 38,
      "magnitude": 4.32
    },
    {
      "ID": 5735,
      "greek_letter": "gam",
      "constellation": "UMi",
      "RA_hour": 15,
      "RA_min": 20,
      "RA_sec": 43.6,
      "dec_deg": "+71",
      "dec_min": 50,
      "dec_sec": "02",
      "magnitude": 3.05
    },
    {
      "ID": 5744,
      "greek_letter": "iot",
      "constellation": "Dra",
      "RA_hour": 15,
      "RA_min": 24,
      "RA_sec": 55.6,
      "dec_deg": "+58",
      "dec_min": 57,
      "dec_sec": 57,
      "magnitude": 3.29
    },
    {
      "ID": 5747,
      "greek_letter": "bet",
      "constellation": "CrB",
      "RA_hour": 15,
      "RA_min": 27,
      "RA_sec": 49.7,
      "dec_deg": "+29",
      "dec_min": "06",
      "dec_sec": 20,
      "magnitude": 3.68
    },
    {
      "ID": 5771,
      "greek_letter": "eps",
      "constellation": "TrA",
      "RA_hour": 15,
      "RA_min": 36,
      "RA_sec": 43.1,
      "dec_deg": -66,
      "dec_min": 19,
      "dec_sec": "02",
      "magnitude": 4.11
    },
    {
      "ID": 5776,
      "greek_letter": "gam",
      "constellation": "Lup",
      "RA_hour": 15,
      "RA_min": 35,
      "RA_sec": "08.3",
      "dec_deg": -41,
      "dec_min": 10,
      "dec_sec": "00",
      "magnitude": 2.78
    },
    {
      "ID": 5777,
      "greek_letter": "",
      "constellation": "Lib",
      "RA_hour": 15,
      "RA_min": 34,
      "RA_sec": 10.6,
      "dec_deg": -10,
      "dec_min": "03",
      "dec_sec": 53,
      "magnitude": 4.62
    },
    {
      "ID": 5778,
      "greek_letter": "tet",
      "constellation": "CrB",
      "RA_hour": 15,
      "RA_min": 32,
      "RA_sec": 55.7,
      "dec_deg": "+31",
      "dec_min": 21,
      "dec_sec": 32,
      "magnitude": 4.13
    },
    {
      "ID": 5781,
      "greek_letter": "",
      "constellation": "",
      "RA_hour": 15,
      "RA_min": 35,
      "RA_sec": 53.1,
      "dec_deg": -44,
      "dec_min": 57,
      "dec_sec": 31,
      "magnitude": 4.54
    },
    {
      "ID": 5787,
      "greek_letter": "gam",
      "constellation": "Lib",
      "RA_hour": 15,
      "RA_min": 35,
      "RA_sec": 31.5,
      "dec_deg": -14,
      "dec_min": 47,
      "dec_sec": 22,
      "magnitude": 3.91
    },
    {
      "ID": 5788,
      "greek_letter": "del",
      "constellation": "Ser",
      "RA_hour": 15,
      "RA_min": 34,
      "RA_sec": 48,
      "dec_deg": "+10",
      "dec_min": 32,
      "dec_sec": 15,
      "magnitude": 3.8
    },
    {
      "ID": 5789,
      "greek_letter": "del",
      "constellation": "Ser",
      "RA_hour": 15,
      "RA_min": 34,
      "RA_sec": 48.1,
      "dec_deg": "+10",
      "dec_min": 32,
      "dec_sec": 21,
      "magnitude": 3.8
    },
    {
      "ID": 5793,
      "greek_letter": "alf",
      "constellation": "CrB",
      "RA_hour": 15,
      "RA_min": 34,
      "RA_sec": 41.2,
      "dec_deg": "+26",
      "dec_min": 42,
      "dec_sec": 53,
      "magnitude": 2.24
    },
    {
      "ID": 5794,
      "greek_letter": "ups",
      "constellation": "Lib",
      "RA_hour": 15,
      "RA_min": 37,
      "RA_sec": "01.4",
      "dec_deg": -28,
      "dec_min": "08",
      "dec_sec": "06",
      "magnitude": 3.57
    },
    {
      "ID": 5797,
      "greek_letter": "omg",
      "constellation": "Lup",
      "RA_hour": 15,
      "RA_min": 38,
      "RA_sec": "03.1",
      "dec_deg": -42,
      "dec_min": 34,
      "dec_sec": "02",
      "magnitude": 4.33
    },
    {
      "ID": 5812,
      "greek_letter": "tau",
      "constellation": "Lib",
      "RA_hour": 15,
      "RA_min": 38,
      "RA_sec": 39.3,
      "dec_deg": -29,
      "dec_min": 46,
      "dec_sec": 40,
      "magnitude": 3.65
    },
    {
      "ID": 5820,
      "greek_letter": "psi1",
      "constellation": "Lup",
      "RA_hour": 15,
      "RA_min": 39,
      "RA_sec": 45.9,
      "dec_deg": -34,
      "dec_min": 24,
      "dec_sec": 42,
      "magnitude": 4.67
    },
    {
      "ID": 5824,
      "greek_letter": "",
      "constellation": "Lib",
      "RA_hour": 15,
      "RA_min": 40,
      "RA_sec": 16.8,
      "dec_deg": -23,
      "dec_min": 49,
      "dec_sec": "05",
      "magnitude": 4.96
    },
    {
      "ID": 5825,
      "greek_letter": "",
      "constellation": "",
      "RA_hour": 15,
      "RA_min": 41,
      "RA_sec": 11.2,
      "dec_deg": -44,
      "dec_min": 39,
      "dec_sec": 40,
      "magnitude": 4.64
    },
    {
      "ID": 5826,
      "greek_letter": "tet",
      "constellation": "UMi",
      "RA_hour": 15,
      "RA_min": 31,
      "RA_sec": 24.7,
      "dec_deg": "+77",
      "dec_min": 20,
      "dec_sec": 57,
      "magnitude": 4.96
    },
    {
      "ID": 5838,
      "greek_letter": "kap",
      "constellation": "Lib",
      "RA_hour": 15,
      "RA_min": 41,
      "RA_sec": 56.7,
      "dec_deg": -19,
      "dec_min": 40,
      "dec_sec": 44,
      "magnitude": 4.72
    },
    {
      "ID": 5839,
      "greek_letter": "psi2",
      "constellation": "Lup",
      "RA_hour": 15,
      "RA_min": 42,
      "RA_sec": 40.9,
      "dec_deg": -34,
      "dec_min": 42,
      "dec_sec": 38,
      "magnitude": 4.75
    },
    {
      "ID": 5842,
      "greek_letter": "iot",
      "constellation": "Ser",
      "RA_hour": 15,
      "RA_min": 41,
      "RA_sec": 33,
      "dec_deg": "+19",
      "dec_min": 40,
      "dec_sec": 13,
      "magnitude": 4.53
    },
    {
      "ID": 5849,
      "greek_letter": "gam",
      "constellation": "CrB",
      "RA_hour": 15,
      "RA_min": 42,
      "RA_sec": 44.5,
      "dec_deg": "+26",
      "dec_min": 17,
      "dec_sec": 44,
      "magnitude": 3.85
    },
    {
      "ID": 5854,
      "greek_letter": "alf",
      "constellation": "Ser",
      "RA_hour": 15,
      "RA_min": 44,
      "RA_sec": 16,
      "dec_deg": "+06",
      "dec_min": 25,
      "dec_sec": 32,
      "magnitude": 2.65
    },
    {
      "ID": 5867,
      "greek_letter": "bet",
      "constellation": "Ser",
      "RA_hour": 15,
      "RA_min": 46,
      "RA_sec": 11.2,
      "dec_deg": "+15",
      "dec_min": 25,
      "dec_sec": 18,
      "magnitude": 3.67
    },
    {
      "ID": 5868,
      "greek_letter": "lam",
      "constellation": "Ser",
      "RA_hour": 15,
      "RA_min": 46,
      "RA_sec": 26.5,
      "dec_deg": "+07",
      "dec_min": 21,
      "dec_sec": 11,
      "magnitude": 4.43
    },
    {
      "ID": 5879,
      "greek_letter": "kap",
      "constellation": "Ser",
      "RA_hour": 15,
      "RA_min": 48,
      "RA_sec": 44.3,
      "dec_deg": "+18",
      "dec_min": "08",
      "dec_sec": 29,
      "magnitude": 4.09
    },
    {
      "ID": 5881,
      "greek_letter": "mu",
      "constellation": "Ser",
      "RA_hour": 15,
      "RA_min": 49,
      "RA_sec": 37.1,
      "dec_deg": "-03",
      "dec_min": 25,
      "dec_sec": 49,
      "magnitude": 3.53
    },
    {
      "ID": 5883,
      "greek_letter": "chi",
      "constellation": "Lup",
      "RA_hour": 15,
      "RA_min": 50,
      "RA_sec": 57.4,
      "dec_deg": -33,
      "dec_min": 37,
      "dec_sec": 38,
      "magnitude": 3.95
    },
    {
      "ID": 5885,
      "greek_letter": "",
      "constellation": "Sco",
      "RA_hour": 15,
      "RA_min": 50,
      "RA_sec": 58.6,
      "dec_deg": -25,
      "dec_min": 45,
      "dec_sec": "05",
      "magnitude": 4.68
    },
    {
      "ID": 5889,
      "greek_letter": "del",
      "constellation": "CrB",
      "RA_hour": 15,
      "RA_min": 49,
      "RA_sec": 35.6,
      "dec_deg": "+26",
      "dec_min": "04",
      "dec_sec": "06",
      "magnitude": 4.63
    },
    {
      "ID": 5892,
      "greek_letter": "eps",
      "constellation": "Ser",
      "RA_hour": 15,
      "RA_min": 50,
      "RA_sec": 48.9,
      "dec_deg": "+04",
      "dec_min": 28,
      "dec_sec": 40,
      "magnitude": 3.7
    },
    {
      "ID": 5897,
      "greek_letter": "bet",
      "constellation": "TrA",
      "RA_hour": 15,
      "RA_min": 55,
      "RA_sec": "08.4",
      "dec_deg": -63,
      "dec_min": 25,
      "dec_sec": 50,
      "magnitude": 2.85
    },
    {
      "ID": 5899,
      "greek_letter": "ro",
      "constellation": "Ser",
      "RA_hour": 15,
      "RA_min": 51,
      "RA_sec": 15.8,
      "dec_deg": "+20",
      "dec_min": 58,
      "dec_sec": 40,
      "magnitude": 4.78
    },
    {
      "ID": 5901,
      "greek_letter": "kap",
      "constellation": "CrB",
      "RA_hour": 15,
      "RA_min": 51,
      "RA_sec": 13.8,
      "dec_deg": "+35",
      "dec_min": 39,
      "dec_sec": 26,
      "magnitude": 4.82
    },
    {
      "ID": 5903,
      "greek_letter": "zet",
      "constellation": "UMi",
      "RA_hour": 15,
      "RA_min": 44,
      "RA_sec": "03.3",
      "dec_deg": "+77",
      "dec_min": 47,
      "dec_sec": 40,
      "magnitude": 4.32
    },
    {
      "ID": 5904,
      "greek_letter": "",
      "constellation": "Sco",
      "RA_hour": 15,
      "RA_min": 53,
      "RA_sec": 36.6,
      "dec_deg": -25,
      "dec_min": 19,
      "dec_sec": 38,
      "magnitude": 4.59
    },
    {
      "ID": 5908,
      "greek_letter": "tet",
      "constellation": "Lib",
      "RA_hour": 15,
      "RA_min": 53,
      "RA_sec": 49.4,
      "dec_deg": -16,
      "dec_min": 43,
      "dec_sec": 46,
      "magnitude": 4.16
    },
    {
      "ID": 5914,
      "greek_letter": "chi",
      "constellation": "Her",
      "RA_hour": 15,
      "RA_min": 52,
      "RA_sec": 40.4,
      "dec_deg": "+42",
      "dec_min": 27,
      "dec_sec": "06",
      "magnitude": 4.62
    },
    {
      "ID": 5928,
      "greek_letter": "ro",
      "constellation": "Sco",
      "RA_hour": 15,
      "RA_min": 56,
      "RA_sec": 53,
      "dec_deg": -29,
      "dec_min": 12,
      "dec_sec": 50,
      "magnitude": 3.86
    },
    {
      "ID": 5933,
      "greek_letter": "gam",
      "constellation": "Ser",
      "RA_hour": 15,
      "RA_min": 56,
      "RA_sec": 27.1,
      "dec_deg": "+15",
      "dec_min": 39,
      "dec_sec": 42,
      "magnitude": 3.86
    },
    {
      "ID": 5941,
      "greek_letter": "",
      "constellation": "Lib",
      "RA_hour": 15,
      "RA_min": 58,
      "RA_sec": 11.3,
      "dec_deg": -14,
      "dec_min": 16,
      "dec_sec": 46,
      "magnitude": 4.87
    },
    {
      "ID": 5943,
      "greek_letter": "",
      "constellation": "",
      "RA_hour": 15,
      "RA_min": 59,
      "RA_sec": 30.2,
      "dec_deg": -41,
      "dec_min": 44,
      "dec_sec": 39,
      "magnitude": 4.99
    },
    {
      "ID": 5944,
      "greek_letter": "pi",
      "constellation": "Sco",
      "RA_hour": 15,
      "RA_min": 58,
      "RA_sec": 51,
      "dec_deg": -26,
      "dec_min": "06",
      "dec_sec": 51,
      "magnitude": 2.91
    },
    {
      "ID": 5947,
      "greek_letter": "eps",
      "constellation": "CrB",
      "RA_hour": 15,
      "RA_min": 57,
      "RA_sec": 35.2,
      "dec_deg": "+26",
      "dec_min": 52,
      "dec_sec": 40,
      "magnitude": 4.16
    },
    {
      "ID": 5948,
      "greek_letter": "eta",
      "constellation": "Lup",
      "RA_hour": 16,
      "RA_min": "00",
      "RA_sec": "07.2",
      "dec_deg": -38,
      "dec_min": 23,
      "dec_sec": 49,
      "magnitude": 3.41
    },
    {
      "ID": 5953,
      "greek_letter": "del",
      "constellation": "Sco",
      "RA_hour": 16,
      "RA_min": "00",
      "RA_sec": 19.9,
      "dec_deg": -22,
      "dec_min": 37,
      "dec_sec": 18,
      "magnitude": 2.32
    },
    {
      "ID": 5958,
      "greek_letter": "",
      "constellation": "",
      "RA_hour": 15,
      "RA_min": 59,
      "RA_sec": 30.1,
      "dec_deg": "+25",
      "dec_min": 55,
      "dec_sec": 13,
      "magnitude": 2
    },
    {
      "ID": 5960,
      "greek_letter": "",
      "constellation": "",
      "RA_hour": 15,
      "RA_min": 57,
      "RA_sec": 47.3,
      "dec_deg": "+54",
      "dec_min": 44,
      "dec_sec": 59,
      "magnitude": 4.95
    },
    {
      "ID": 5961,
      "greek_letter": "iot1",
      "constellation": "Nor",
      "RA_hour": 16,
      "RA_min": "03",
      "RA_sec": 31.9,
      "dec_deg": -57,
      "dec_min": 46,
      "dec_sec": 31,
      "magnitude": 4.63
    },
    {
      "ID": 5962,
      "greek_letter": "eta",
      "constellation": "Nor",
      "RA_hour": 16,
      "RA_min": "03",
      "RA_sec": 12.7,
      "dec_deg": -49,
      "dec_min": 13,
      "dec_sec": 47,
      "magnitude": 4.65
    },
    {
      "ID": 5967,
      "greek_letter": "",
      "constellation": "",
      "RA_hour": 16,
      "RA_min": "03",
      "RA_sec": 24,
      "dec_deg": -38,
      "dec_min": 36,
      "dec_sec": "09",
      "magnitude": 4.89
    },
    {
      "ID": 5969,
      "greek_letter": "",
      "constellation": "",
      "RA_hour": 16,
      "RA_min": "03",
      "RA_sec": 20.5,
      "dec_deg": -25,
      "dec_min": 51,
      "dec_sec": 55,
      "magnitude": 5
    },
    {
      "ID": 5971,
      "greek_letter": "iot",
      "constellation": "CrB",
      "RA_hour": 16,
      "RA_min": "01",
      "RA_sec": 26.6,
      "dec_deg": "+29",
      "dec_min": 51,
      "dec_sec": "04",
      "magnitude": 4.98
    },
    {
      "ID": 5972,
      "greek_letter": "pi",
      "constellation": "Ser",
      "RA_hour": 16,
      "RA_min": "02",
      "RA_sec": 17.7,
      "dec_deg": "+22",
      "dec_min": 48,
      "dec_sec": 16,
      "magnitude": 4.83
    },
    {
      "ID": 5978,
      "greek_letter": "xi",
      "constellation": "Sco",
      "RA_hour": 16,
      "RA_min": "04",
      "RA_sec": 22,
      "dec_deg": -11,
      "dec_min": 22,
      "dec_sec": 23,
      "magnitude": 4.77
    },
    {
      "ID": 5980,
      "greek_letter": "del",
      "constellation": "Nor",
      "RA_hour": 16,
      "RA_min": "06",
      "RA_sec": 29.3,
      "dec_deg": -45,
      "dec_min": 10,
      "dec_sec": 23,
      "magnitude": 4.73
    },
    {
      "ID": 5982,
      "greek_letter": "ups",
      "constellation": "Her",
      "RA_hour": 16,
      "RA_min": "02",
      "RA_sec": 47.8,
      "dec_deg": "+46",
      "dec_min": "02",
      "dec_sec": 12,
      "magnitude": 4.76
    },
    {
      "ID": 5984,
      "greek_letter": "bet1",
      "constellation": "Sco",
      "RA_hour": 16,
      "RA_min": "05",
      "RA_sec": 26.1,
      "dec_deg": -19,
      "dec_min": 48,
      "dec_sec": 19,
      "magnitude": 2.58
    },
    {
      "ID": 5985,
      "greek_letter": "bet2",
      "constellation": "Sco",
      "RA_hour": 16,
      "RA_min": "05",
      "RA_sec": 26.4,
      "dec_deg": -19,
      "dec_min": 48,
      "dec_sec": "07",
      "magnitude": 4.92
    },
    {
      "ID": 5986,
      "greek_letter": "tet",
      "constellation": "Dra",
      "RA_hour": 16,
      "RA_min": "01",
      "RA_sec": 53.2,
      "dec_deg": "+58",
      "dec_min": 33,
      "dec_sec": 55,
      "magnitude": 4.03
    },
    {
      "ID": 5987,
      "greek_letter": "tet",
      "constellation": "Lup",
      "RA_hour": 16,
      "RA_min": "06",
      "RA_sec": 35.4,
      "dec_deg": -36,
      "dec_min": 48,
      "dec_sec": "08",
      "magnitude": 4.23
    },
    {
      "ID": 5993,
      "greek_letter": "omg1",
      "constellation": "Sco",
      "RA_hour": 16,
      "RA_min": "06",
      "RA_sec": 48.3,
      "dec_deg": -20,
      "dec_min": 40,
      "dec_sec": "09",
      "magnitude": 3.97
    },
    {
      "ID": 5997,
      "greek_letter": "omg2",
      "constellation": "Sco",
      "RA_hour": 16,
      "RA_min": "07",
      "RA_sec": 24.2,
      "dec_deg": -20,
      "dec_min": 52,
      "dec_sec": "07",
      "magnitude": 4.33
    },
    {
      "ID": 6008,
      "greek_letter": "kap",
      "constellation": "Her",
      "RA_hour": 16,
      "RA_min": "08",
      "RA_sec": "04.4",
      "dec_deg": "+17",
      "dec_min": "02",
      "dec_sec": 49,
      "magnitude": 5
    },
    {
      "ID": 6018,
      "greek_letter": "tau",
      "constellation": "CrB",
      "RA_hour": 16,
      "RA_min": "08",
      "RA_sec": 58.2,
      "dec_deg": "+36",
      "dec_min": 29,
      "dec_sec": 27,
      "magnitude": 4.76
    },
    {
      "ID": 6020,
      "greek_letter": "del1",
      "constellation": "Aps",
      "RA_hour": 16,
      "RA_min": 20,
      "RA_sec": 20.7,
      "dec_deg": -78,
      "dec_min": 41,
      "dec_sec": 45,
      "magnitude": 4.68
    },
    {
      "ID": 6023,
      "greek_letter": "phi",
      "constellation": "Her",
      "RA_hour": 16,
      "RA_min": "08",
      "RA_sec": 46.1,
      "dec_deg": "+44",
      "dec_min": 56,
      "dec_sec": "06",
      "magnitude": 4.27
    },
    {
      "ID": 6024,
      "greek_letter": "kap",
      "constellation": "Nor",
      "RA_hour": 16,
      "RA_min": 13,
      "RA_sec": 28.6,
      "dec_deg": -54,
      "dec_min": 37,
      "dec_sec": 50,
      "magnitude": 4.94
    },
    {
      "ID": 6027,
      "greek_letter": "nu",
      "constellation": "Sco",
      "RA_hour": 16,
      "RA_min": 11,
      "RA_sec": 59.6,
      "dec_deg": -19,
      "dec_min": 27,
      "dec_sec": 38,
      "magnitude": 4.01
    },
    {
      "ID": 6028,
      "greek_letter": "",
      "constellation": "Sco",
      "RA_hour": 16,
      "RA_min": 12,
      "RA_sec": 18.1,
      "dec_deg": -27,
      "dec_min": 55,
      "dec_sec": 35,
      "magnitude": 4.59
    },
    {
      "ID": 6030,
      "greek_letter": "del",
      "constellation": "TrA",
      "RA_hour": 16,
      "RA_min": 15,
      "RA_sec": 26.2,
      "dec_deg": -63,
      "dec_min": 41,
      "dec_sec": "08",
      "magnitude": 3.85
    },
    {
      "ID": 6031,
      "greek_letter": "psi",
      "constellation": "Sco",
      "RA_hour": 16,
      "RA_min": 11,
      "RA_sec": 59.9,
      "dec_deg": -10,
      "dec_min": "03",
      "dec_sec": 51,
      "magnitude": 4.93
    },
    {
      "ID": 6056,
      "greek_letter": "del",
      "constellation": "Oph",
      "RA_hour": 16,
      "RA_min": 14,
      "RA_sec": 20.6,
      "dec_deg": "-03",
      "dec_min": 41,
      "dec_sec": 40,
      "magnitude": 2.75
    },
    {
      "ID": 6058,
      "greek_letter": "gam1",
      "constellation": "Nor",
      "RA_hour": 16,
      "RA_min": 17,
      "RA_sec": "00.8",
      "dec_deg": -50,
      "dec_min": "04",
      "dec_sec": "05",
      "magnitude": 4.98
    },
    {
      "ID": 6070,
      "greek_letter": "",
      "constellation": "",
      "RA_hour": 16,
      "RA_min": 18,
      "RA_sec": 17.8,
      "dec_deg": -28,
      "dec_min": 36,
      "dec_sec": 51,
      "magnitude": 4.77
    },
    {
      "ID": 6072,
      "greek_letter": "gam2",
      "constellation": "Nor",
      "RA_hour": 16,
      "RA_min": 19,
      "RA_sec": 50.3,
      "dec_deg": -50,
      "dec_min": "09",
      "dec_sec": 20,
      "magnitude": 4.02
    },
    {
      "ID": 6075,
      "greek_letter": "eps",
      "constellation": "Oph",
      "RA_hour": 16,
      "RA_min": 18,
      "RA_sec": 19.2,
      "dec_deg": "-04",
      "dec_min": 41,
      "dec_sec": 33,
      "magnitude": 3.23
    },
    {
      "ID": 6081,
      "greek_letter": "omi",
      "constellation": "Sco",
      "RA_hour": 16,
      "RA_min": 20,
      "RA_sec": 38.1,
      "dec_deg": -24,
      "dec_min": 10,
      "dec_sec": 10,
      "magnitude": 4.57
    },
    {
      "ID": 6084,
      "greek_letter": "sig",
      "constellation": "Sco",
      "RA_hour": 16,
      "RA_min": 21,
      "RA_sec": 11.2,
      "dec_deg": -25,
      "dec_min": 35,
      "dec_sec": 34,
      "magnitude": 2.88
    },
    {
      "ID": 6092,
      "greek_letter": "tau",
      "constellation": "Her",
      "RA_hour": 16,
      "RA_min": 19,
      "RA_sec": 44.3,
      "dec_deg": "+46",
      "dec_min": 18,
      "dec_sec": 48,
      "magnitude": 3.91
    },
    {
      "ID": 6093,
      "greek_letter": "sig",
      "constellation": "Ser",
      "RA_hour": 16,
      "RA_min": 22,
      "RA_sec": "04.3",
      "dec_deg": "+01",
      "dec_min": "01",
      "dec_sec": 45,
      "magnitude": 4.82
    },
    {
      "ID": 6095,
      "greek_letter": "gam",
      "constellation": "Her",
      "RA_hour": 16,
      "RA_min": 21,
      "RA_sec": 55.1,
      "dec_deg": "+19",
      "dec_min": "09",
      "dec_sec": 11,
      "magnitude": 3.76
    },
    {
      "ID": 6098,
      "greek_letter": "zet",
      "constellation": "TrA",
      "RA_hour": 16,
      "RA_min": 28,
      "RA_sec": 28.1,
      "dec_deg": -70,
      "dec_min": "05",
      "dec_sec": "04",
      "magnitude": 4.91
    },
    {
      "ID": 6102,
      "greek_letter": "gam",
      "constellation": "Aps",
      "RA_hour": 16,
      "RA_min": 33,
      "RA_sec": 27.1,
      "dec_deg": -78,
      "dec_min": 53,
      "dec_sec": 49,
      "magnitude": 3.89
    },
    {
      "ID": 6103,
      "greek_letter": "xi",
      "constellation": "CrB",
      "RA_hour": 16,
      "RA_min": 22,
      "RA_sec": "05.7",
      "dec_deg": "+30",
      "dec_min": 53,
      "dec_sec": 32,
      "magnitude": 4.85
    },
    {
      "ID": 6104,
      "greek_letter": "psi",
      "constellation": "Oph",
      "RA_hour": 16,
      "RA_min": 24,
      "RA_sec": "06.1",
      "dec_deg": -20,
      "dec_min": "02",
      "dec_sec": 15,
      "magnitude": 4.5
    },
    {
      "ID": 6115,
      "greek_letter": "eps",
      "constellation": "Nor",
      "RA_hour": 16,
      "RA_min": 27,
      "RA_sec": 11,
      "dec_deg": -47,
      "dec_min": 33,
      "dec_sec": 18,
      "magnitude": 4.47
    },
    {
      "ID": 6116,
      "greek_letter": "eta",
      "constellation": "UMi",
      "RA_hour": 16,
      "RA_min": 17,
      "RA_sec": 30.2,
      "dec_deg": "+75",
      "dec_min": 45,
      "dec_sec": 19,
      "magnitude": 4.95
    },
    {
      "ID": 6117,
      "greek_letter": "omg",
      "constellation": "Her",
      "RA_hour": 16,
      "RA_min": 25,
      "RA_sec": 24.9,
      "dec_deg": "+14",
      "dec_min": "02",
      "dec_sec": "00",
      "magnitude": 4.58
    },
    {
      "ID": 6118,
      "greek_letter": "chi",
      "constellation": "Oph",
      "RA_hour": 16,
      "RA_min": 27,
      "RA_sec": "01.3",
      "dec_deg": -18,
      "dec_min": 27,
      "dec_sec": 23,
      "magnitude": 4.43
    },
    {
      "ID": 6129,
      "greek_letter": "ups",
      "constellation": "Oph",
      "RA_hour": 16,
      "RA_min": 27,
      "RA_sec": 48.1,
      "dec_deg": "-08",
      "dec_min": 22,
      "dec_sec": 18,
      "magnitude": 4.63
    },
    {
      "ID": 6132,
      "greek_letter": "eta",
      "constellation": "Dra",
      "RA_hour": 16,
      "RA_min": 23,
      "RA_sec": 59.3,
      "dec_deg": "+61",
      "dec_min": 30,
      "dec_sec": 51,
      "magnitude": 2.74
    },
    {
      "ID": 6134,
      "greek_letter": "alf",
      "constellation": "Sco",
      "RA_hour": 16,
      "RA_min": 29,
      "RA_sec": 24.4,
      "dec_deg": -26,
      "dec_min": 25,
      "dec_sec": 55,
      "magnitude": 0.91
    },
    {
      "ID": 6141,
      "greek_letter": "",
      "constellation": "Sco",
      "RA_hour": 16,
      "RA_min": 30,
      "RA_sec": 12.4,
      "dec_deg": -25,
      "dec_min": "06",
      "dec_sec": 54,
      "magnitude": 4.79
    },
    {
      "ID": 6143,
      "greek_letter": "",
      "constellation": "",
      "RA_hour": 16,
      "RA_min": 31,
      "RA_sec": 22.8,
      "dec_deg": -34,
      "dec_min": 42,
      "dec_sec": 16,
      "magnitude": 4.23
    },
    {
      "ID": 6147,
      "greek_letter": "phi",
      "constellation": "Oph",
      "RA_hour": 16,
      "RA_min": 31,
      "RA_sec": "08.2",
      "dec_deg": -16,
      "dec_min": 36,
      "dec_sec": 46,
      "magnitude": 4.27
    },
    {
      "ID": 6148,
      "greek_letter": "bet",
      "constellation": "Her",
      "RA_hour": 16,
      "RA_min": 30,
      "RA_sec": 13.1,
      "dec_deg": "+21",
      "dec_min": 29,
      "dec_sec": 22,
      "magnitude": 2.77
    },
    {
      "ID": 6149,
      "greek_letter": "lam",
      "constellation": "Oph",
      "RA_hour": 16,
      "RA_min": 30,
      "RA_sec": 54.7,
      "dec_deg": "+01",
      "dec_min": 59,
      "dec_sec": "02",
      "magnitude": 3.83
    },
    {
      "ID": 6153,
      "greek_letter": "omg",
      "constellation": "Oph",
      "RA_hour": 16,
      "RA_min": 32,
      "RA_sec": "08.0",
      "dec_deg": -21,
      "dec_min": 27,
      "dec_sec": 59,
      "magnitude": 4.45
    },
    {
      "ID": 6155,
      "greek_letter": "mu",
      "constellation": "Nor",
      "RA_hour": 16,
      "RA_min": 34,
      "RA_sec": "04.8",
      "dec_deg": -44,
      "dec_min": "02",
      "dec_sec": 43,
      "magnitude": 4.91
    },
    {
      "ID": 6159,
      "greek_letter": "",
      "constellation": "Her",
      "RA_hour": 16,
      "RA_min": 32,
      "RA_sec": 36.2,
      "dec_deg": "+11",
      "dec_min": 29,
      "dec_sec": 17,
      "magnitude": 4.85
    },
    {
      "ID": 6161,
      "greek_letter": "",
      "constellation": "Dra",
      "RA_hour": 16,
      "RA_min": 27,
      "RA_sec": 58.8,
      "dec_deg": "+68",
      "dec_min": 46,
      "dec_sec": "05",
      "magnitude": 5.01
    },
    {
      "ID": 6163,
      "greek_letter": "bet",
      "constellation": "Aps",
      "RA_hour": 16,
      "RA_min": 43,
      "RA_sec": "04.4",
      "dec_deg": -77,
      "dec_min": 31,
      "dec_sec": "03",
      "magnitude": 4.24
    },
    {
      "ID": 6165,
      "greek_letter": "tau",
      "constellation": "Sco",
      "RA_hour": 16,
      "RA_min": 35,
      "RA_sec": 52.9,
      "dec_deg": -28,
      "dec_min": 12,
      "dec_sec": 58,
      "magnitude": 2.81
    },
    {
      "ID": 6166,
      "greek_letter": "",
      "constellation": "",
      "RA_hour": 16,
      "RA_min": 36,
      "RA_sec": 22.4,
      "dec_deg": -35,
      "dec_min": 15,
      "dec_sec": 20,
      "magnitude": 4.16
    },
    {
      "ID": 6168,
      "greek_letter": "sig",
      "constellation": "Her",
      "RA_hour": 16,
      "RA_min": 34,
      "RA_sec": "06.1",
      "dec_deg": "+42",
      "dec_min": 26,
      "dec_sec": 13,
      "magnitude": 4.2
    },
    {
      "ID": 6175,
      "greek_letter": "zet",
      "constellation": "Oph",
      "RA_hour": 16,
      "RA_min": 37,
      "RA_sec": "09.4",
      "dec_deg": -10,
      "dec_min": 34,
      "dec_sec": "02",
      "magnitude": 2.56
    },
    {
      "ID": 6196,
      "greek_letter": "",
      "constellation": "",
      "RA_hour": 16,
      "RA_min": 41,
      "RA_sec": 34.3,
      "dec_deg": -17,
      "dec_min": 44,
      "dec_sec": 32,
      "magnitude": 4.96
    },
    {
      "ID": 6200,
      "greek_letter": "",
      "constellation": "Her",
      "RA_hour": 16,
      "RA_min": 38,
      "RA_sec": 44.7,
      "dec_deg": "+48",
      "dec_min": 55,
      "dec_sec": 42,
      "magnitude": 4.9
    },
    {
      "ID": 6212,
      "greek_letter": "zet",
      "constellation": "Her",
      "RA_hour": 16,
      "RA_min": 41,
      "RA_sec": 17.1,
      "dec_deg": "+31",
      "dec_min": 36,
      "dec_sec": 10,
      "magnitude": 2.81
    },
    {
      "ID": 6217,
      "greek_letter": "alf",
      "constellation": "TrA",
      "RA_hour": 16,
      "RA_min": 48,
      "RA_sec": 39.9,
      "dec_deg": -69,
      "dec_min": "01",
      "dec_sec": 40,
      "magnitude": 1.92
    },
    {
      "ID": 6220,
      "greek_letter": "eta",
      "constellation": "Her",
      "RA_hour": 16,
      "RA_min": 42,
      "RA_sec": 53.7,
      "dec_deg": "+38",
      "dec_min": 55,
      "dec_sec": 20,
      "magnitude": 3.5
    },
    {
      "ID": 6223,
      "greek_letter": "",
      "constellation": "Dra",
      "RA_hour": 16,
      "RA_min": 40,
      "RA_sec": 55,
      "dec_deg": "+64",
      "dec_min": 35,
      "dec_sec": 20,
      "magnitude": 4.83
    },
    {
      "ID": 6229,
      "greek_letter": "eta",
      "constellation": "Ara",
      "RA_hour": 16,
      "RA_min": 49,
      "RA_sec": 47,
      "dec_deg": -59,
      "dec_min": "02",
      "dec_sec": 29,
      "magnitude": 3.76
    },
    {
      "ID": 6237,
      "greek_letter": "",
      "constellation": "",
      "RA_hour": 16,
      "RA_min": 45,
      "RA_sec": 17.7,
      "dec_deg": "+56",
      "dec_min": 46,
      "dec_sec": 55,
      "magnitude": 4.84
    },
    {
      "ID": 6241,
      "greek_letter": "eps",
      "constellation": "Sco",
      "RA_hour": 16,
      "RA_min": 50,
      "RA_sec": "09.7",
      "dec_deg": -34,
      "dec_min": 17,
      "dec_sec": 36,
      "magnitude": 2.29
    },
    {
      "ID": 6243,
      "greek_letter": "",
      "constellation": "Oph",
      "RA_hour": 16,
      "RA_min": 49,
      "RA_sec": 49.9,
      "dec_deg": -10,
      "dec_min": 46,
      "dec_sec": 59,
      "magnitude": 4.66
    },
    {
      "ID": 6247,
      "greek_letter": "mu1",
      "constellation": "Sco",
      "RA_hour": 16,
      "RA_min": 51,
      "RA_sec": 52.1,
      "dec_deg": -38,
      "dec_min": "02",
      "dec_sec": 51,
      "magnitude": 3.04
    },
    {
      "ID": 6252,
      "greek_letter": "mu2",
      "constellation": "Sco",
      "RA_hour": 16,
      "RA_min": 52,
      "RA_sec": 20,
      "dec_deg": -38,
      "dec_min": "01",
      "dec_sec": "03",
      "magnitude": 3.57
    },
    {
      "ID": 6254,
      "greek_letter": "",
      "constellation": "Her",
      "RA_hour": 16,
      "RA_min": 49,
      "RA_sec": 14.1,
      "dec_deg": "+45",
      "dec_min": 59,
      "dec_sec": "00",
      "magnitude": 4.82
    },
    {
      "ID": 6262,
      "greek_letter": "zet1",
      "constellation": "Sco",
      "RA_hour": 16,
      "RA_min": 53,
      "RA_sec": 59.6,
      "dec_deg": -42,
      "dec_min": 21,
      "dec_sec": 43,
      "magnitude": 4.73
    },
    {
      "ID": 6271,
      "greek_letter": "zet2",
      "constellation": "Sco",
      "RA_hour": 16,
      "RA_min": 54,
      "RA_sec": 34.9,
      "dec_deg": -42,
      "dec_min": 21,
      "dec_sec": 41,
      "magnitude": 3.59
    },
    {
      "ID": 6281,
      "greek_letter": "iot",
      "constellation": "Oph",
      "RA_hour": 16,
      "RA_min": 54,
      "RA_sec": "00.4",
      "dec_deg": "+10",
      "dec_min": "09",
      "dec_sec": 55,
      "magnitude": 4.38
    },
    {
      "ID": 6285,
      "greek_letter": "zet",
      "constellation": "Ara",
      "RA_hour": 16,
      "RA_min": 58,
      "RA_sec": 37.1,
      "dec_deg": -55,
      "dec_min": 59,
      "dec_sec": 24,
      "magnitude": 3.13
    },
    {
      "ID": 6295,
      "greek_letter": "eps1",
      "constellation": "Ara",
      "RA_hour": 16,
      "RA_min": 59,
      "RA_sec": 35,
      "dec_deg": -53,
      "dec_min": "09",
      "dec_sec": 38,
      "magnitude": 4.06
    },
    {
      "ID": 6299,
      "greek_letter": "kap",
      "constellation": "Oph",
      "RA_hour": 16,
      "RA_min": 57,
      "RA_sec": 40,
      "dec_deg": "+09",
      "dec_min": 22,
      "dec_sec": 30,
      "magnitude": 3.2
    },
    {
      "ID": 6315,
      "greek_letter": "",
      "constellation": "Dra",
      "RA_hour": 16,
      "RA_min": 56,
      "RA_sec": "01.6",
      "dec_deg": "+65",
      "dec_min": "08",
      "dec_sec": "05",
      "magnitude": 4.9
    },
    {
      "ID": 6318,
      "greek_letter": "",
      "constellation": "Oph",
      "RA_hour": 17,
      "RA_min": "01",
      "RA_sec": "03.5",
      "dec_deg": "-04",
      "dec_min": 13,
      "dec_sec": 21,
      "magnitude": 4.82
    },
    {
      "ID": 6322,
      "greek_letter": "eps",
      "constellation": "UMi",
      "RA_hour": 16,
      "RA_min": 45,
      "RA_sec": 57.8,
      "dec_deg": "+82",
      "dec_min": "02",
      "dec_sec": 14,
      "magnitude": 4.23
    },
    {
      "ID": 6324,
      "greek_letter": "eps",
      "constellation": "Her",
      "RA_hour": 17,
      "RA_min": "00",
      "RA_sec": 17.3,
      "dec_deg": "+30",
      "dec_min": 55,
      "dec_sec": 35,
      "magnitude": 3.92
    },
    {
      "ID": 6334,
      "greek_letter": "",
      "constellation": "",
      "RA_hour": 17,
      "RA_min": "04",
      "RA_sec": 49.3,
      "dec_deg": -34,
      "dec_min": "07",
      "dec_sec": 23,
      "magnitude": 4.87
    },
    {
      "ID": 6337,
      "greek_letter": "",
      "constellation": "",
      "RA_hour": 17,
      "RA_min": "03",
      "RA_sec": "07.8",
      "dec_deg": "+14",
      "dec_min": "05",
      "dec_sec": 31,
      "magnitude": 4.98
    },
    {
      "ID": 6355,
      "greek_letter": "",
      "constellation": "Her",
      "RA_hour": 17,
      "RA_min": "05",
      "RA_sec": 22.6,
      "dec_deg": "+12",
      "dec_min": 44,
      "dec_sec": 27,
      "magnitude": 4.91
    },
    {
      "ID": 6378,
      "greek_letter": "eta",
      "constellation": "Oph",
      "RA_hour": 17,
      "RA_min": 10,
      "RA_sec": 22.6,
      "dec_deg": -15,
      "dec_min": 43,
      "dec_sec": 29,
      "magnitude": 2.42
    },
    {
      "ID": 6380,
      "greek_letter": "eta",
      "constellation": "Sco",
      "RA_hour": 17,
      "RA_min": 12,
      "RA_sec": "09.1",
      "dec_deg": -43,
      "dec_min": 14,
      "dec_sec": 21,
      "magnitude": 3.34
    },
    {
      "ID": 6396,
      "greek_letter": "zet",
      "constellation": "Dra",
      "RA_hour": 17,
      "RA_min": "08",
      "RA_sec": 47.1,
      "dec_deg": "+65",
      "dec_min": 42,
      "dec_sec": 53,
      "magnitude": 3.17
    },
    {
      "ID": 6406,
      "greek_letter": "alf1",
      "constellation": "Her",
      "RA_hour": 17,
      "RA_min": 14,
      "RA_sec": 38.8,
      "dec_deg": "+14",
      "dec_min": 23,
      "dec_sec": 25,
      "magnitude": 3.48
    },
    {
      "ID": 6410,
      "greek_letter": "del",
      "constellation": "Her",
      "RA_hour": 17,
      "RA_min": 15,
      "RA_sec": "01.8",
      "dec_deg": "+24",
      "dec_min": 50,
      "dec_sec": 21,
      "magnitude": 3.13
    },
    {
      "ID": 6415,
      "greek_letter": "",
      "constellation": "Oph",
      "RA_hour": 17,
      "RA_min": 16,
      "RA_sec": 36.6,
      "dec_deg": "-00",
      "dec_min": 26,
      "dec_sec": 43,
      "magnitude": 4.72
    },
    {
      "ID": 6417,
      "greek_letter": "zet",
      "constellation": "Aps",
      "RA_hour": 17,
      "RA_min": 21,
      "RA_sec": 59.5,
      "dec_deg": -67,
      "dec_min": 46,
      "dec_sec": 13,
      "magnitude": 4.78
    },
    {
      "ID": 6418,
      "greek_letter": "pi",
      "constellation": "Her",
      "RA_hour": 17,
      "RA_min": 15,
      "RA_sec": "02.7",
      "dec_deg": "+36",
      "dec_min": 48,
      "dec_sec": 33,
      "magnitude": 3.18
    },
    {
      "ID": 6431,
      "greek_letter": "",
      "constellation": "Her",
      "RA_hour": 17,
      "RA_min": 17,
      "RA_sec": 19.4,
      "dec_deg": "+33",
      "dec_min": "06",
      "dec_sec": "00",
      "magnitude": 4.78
    },
    {
      "ID": 6436,
      "greek_letter": "",
      "constellation": "Her",
      "RA_hour": 17,
      "RA_min": 17,
      "RA_sec": 40.2,
      "dec_deg": "+37",
      "dec_min": 17,
      "dec_sec": 29,
      "magnitude": 4.66
    },
    {
      "ID": 6445,
      "greek_letter": "xi",
      "constellation": "Oph",
      "RA_hour": 17,
      "RA_min": 21,
      "RA_sec": "00.1",
      "dec_deg": -21,
      "dec_min": "06",
      "dec_sec": 46,
      "magnitude": 4.38
    },
    {
      "ID": 6446,
      "greek_letter": "nu",
      "constellation": "Ser",
      "RA_hour": 17,
      "RA_min": 20,
      "RA_sec": 49.5,
      "dec_deg": -12,
      "dec_min": 50,
      "dec_sec": 48,
      "magnitude": 4.31
    },
    {
      "ID": 6452,
      "greek_letter": "",
      "constellation": "",
      "RA_hour": 17,
      "RA_min": 20,
      "RA_sec": 18.8,
      "dec_deg": "+18",
      "dec_min": "03",
      "dec_sec": 25,
      "magnitude": 5
    },
    {
      "ID": 6453,
      "greek_letter": "tet",
      "constellation": "Oph",
      "RA_hour": 17,
      "RA_min": 22,
      "RA_sec": "00.5",
      "dec_deg": -24,
      "dec_min": 59,
      "dec_sec": 58,
      "magnitude": 3.26
    },
    {
      "ID": 6461,
      "greek_letter": "bet",
      "constellation": "Ara",
      "RA_hour": 17,
      "RA_min": 25,
      "RA_sec": 17.9,
      "dec_deg": -55,
      "dec_min": 31,
      "dec_sec": 47,
      "magnitude": 2.85
    },
    {
      "ID": 6462,
      "greek_letter": "gam",
      "constellation": "Ara",
      "RA_hour": 17,
      "RA_min": 25,
      "RA_sec": 23.5,
      "dec_deg": -56,
      "dec_min": 22,
      "dec_sec": 39,
      "magnitude": 3.34
    },
    {
      "ID": 6485,
      "greek_letter": "ro",
      "constellation": "Her",
      "RA_hour": 17,
      "RA_min": 23,
      "RA_sec": 40.9,
      "dec_deg": "+37",
      "dec_min": "08",
      "dec_sec": 45,
      "magnitude": 4.52
    },
    {
      "ID": 6486,
      "greek_letter": "",
      "constellation": "Oph",
      "RA_hour": 17,
      "RA_min": 26,
      "RA_sec": 22.1,
      "dec_deg": -24,
      "dec_min": 10,
      "dec_sec": 31,
      "magnitude": 4.16
    },
    {
      "ID": 6492,
      "greek_letter": "",
      "constellation": "Oph",
      "RA_hour": 17,
      "RA_min": 27,
      "RA_sec": 21.2,
      "dec_deg": -29,
      "dec_min": 52,
      "dec_sec": "01",
      "magnitude": 4.27
    },
    {
      "ID": 6493,
      "greek_letter": "",
      "constellation": "",
      "RA_hour": 17,
      "RA_min": 26,
      "RA_sec": 37.8,
      "dec_deg": "-05",
      "dec_min": "05",
      "dec_sec": 12,
      "magnitude": 4.54
    },
    {
      "ID": 6498,
      "greek_letter": "sig",
      "constellation": "Oph",
      "RA_hour": 17,
      "RA_min": 26,
      "RA_sec": 30.8,
      "dec_deg": "+04",
      "dec_min": "08",
      "dec_sec": 25,
      "magnitude": 4.31
    },
    {
      "ID": 6500,
      "greek_letter": "del",
      "constellation": "Ara",
      "RA_hour": 17,
      "RA_min": 31,
      "RA_sec": "05.9",
      "dec_deg": -60,
      "dec_min": 41,
      "dec_sec": "01",
      "magnitude": 3.62
    },
    {
      "ID": 6508,
      "greek_letter": "ups",
      "constellation": "Sco",
      "RA_hour": 17,
      "RA_min": 30,
      "RA_sec": 45.7,
      "dec_deg": -37,
      "dec_min": 17,
      "dec_sec": 45,
      "magnitude": 2.68
    },
    {
      "ID": 6510,
      "greek_letter": "alf",
      "constellation": "Ara",
      "RA_hour": 17,
      "RA_min": 31,
      "RA_sec": 50.4,
      "dec_deg": -49,
      "dec_min": 52,
      "dec_sec": 34,
      "magnitude": 2.95
    },
    {
      "ID": 6519,
      "greek_letter": "",
      "constellation": "Oph",
      "RA_hour": 17,
      "RA_min": 31,
      "RA_sec": 24.8,
      "dec_deg": -23,
      "dec_min": 57,
      "dec_sec": 46,
      "magnitude": 4.81
    },
    {
      "ID": 6526,
      "greek_letter": "lam",
      "constellation": "Her",
      "RA_hour": 17,
      "RA_min": 30,
      "RA_sec": 44.2,
      "dec_deg": "+26",
      "dec_min": "06",
      "dec_sec": 38,
      "magnitude": 4.41
    },
    {
      "ID": 6527,
      "greek_letter": "lam",
      "constellation": "Sco",
      "RA_hour": 17,
      "RA_min": 33,
      "RA_sec": 36.4,
      "dec_deg": -37,
      "dec_min": "06",
      "dec_sec": 13,
      "magnitude": 1.63
    },
    {
      "ID": 6536,
      "greek_letter": "bet",
      "constellation": "Dra",
      "RA_hour": 17,
      "RA_min": 30,
      "RA_sec": 25.8,
      "dec_deg": "+52",
      "dec_min": 18,
      "dec_sec": "05",
      "magnitude": 2.81
    },
    {
      "ID": 6537,
      "greek_letter": "sig",
      "constellation": "Ara",
      "RA_hour": 17,
      "RA_min": 35,
      "RA_sec": 39.4,
      "dec_deg": -46,
      "dec_min": 30,
      "dec_sec": 20,
      "magnitude": 4.59
    },
    {
      "ID": 6546,
      "greek_letter": "",
      "constellation": "",
      "RA_hour": 17,
      "RA_min": 36,
      "RA_sec": 32.7,
      "dec_deg": -38,
      "dec_min": 38,
      "dec_sec": "07",
      "magnitude": 4.29
    },
    {
      "ID": 6553,
      "greek_letter": "tet",
      "constellation": "Sco",
      "RA_hour": 17,
      "RA_min": 37,
      "RA_sec": 19,
      "dec_deg": -42,
      "dec_min": 59,
      "dec_sec": 52,
      "magnitude": 1.87
    },
    {
      "ID": 6554,
      "greek_letter": "nu1",
      "constellation": "Dra",
      "RA_hour": 17,
      "RA_min": 32,
      "RA_sec": 10.4,
      "dec_deg": "+55",
      "dec_min": 11,
      "dec_sec": "03",
      "magnitude": 4.9
    },
    {
      "ID": 6555,
      "greek_letter": "nu2",
      "constellation": "Dra",
      "RA_hour": 17,
      "RA_min": 32,
      "RA_sec": 15.9,
      "dec_deg": "+55",
      "dec_min": 10,
      "dec_sec": 22,
      "magnitude": 4.87
    },
    {
      "ID": 6556,
      "greek_letter": "alf",
      "constellation": "Oph",
      "RA_hour": 17,
      "RA_min": 34,
      "RA_sec": 56,
      "dec_deg": "+12",
      "dec_min": 33,
      "dec_sec": 36,
      "magnitude": 2.07
    },
    {
      "ID": 6561,
      "greek_letter": "xi",
      "constellation": "Ser",
      "RA_hour": 17,
      "RA_min": 37,
      "RA_sec": 35.1,
      "dec_deg": -15,
      "dec_min": 23,
      "dec_sec": 55,
      "magnitude": 3.52
    },
    {
      "ID": 6567,
      "greek_letter": "mu",
      "constellation": "Oph",
      "RA_hour": 17,
      "RA_min": 37,
      "RA_sec": 50.6,
      "dec_deg": "-08",
      "dec_min": "07",
      "dec_sec": "08",
      "magnitude": 4.63
    },
    {
      "ID": 6569,
      "greek_letter": "lam",
      "constellation": "Ara",
      "RA_hour": 17,
      "RA_min": 40,
      "RA_sec": 23.4,
      "dec_deg": -49,
      "dec_min": 24,
      "dec_sec": 56,
      "magnitude": 4.77
    },
    {
      "ID": 6580,
      "greek_letter": "kap",
      "constellation": "Sco",
      "RA_hour": 17,
      "RA_min": 42,
      "RA_sec": 29.1,
      "dec_deg": -39,
      "dec_min": "01",
      "dec_sec": 48,
      "magnitude": 2.41
    },
    {
      "ID": 6581,
      "greek_letter": "omi",
      "constellation": "Ser",
      "RA_hour": 17,
      "RA_min": 41,
      "RA_sec": 24.8,
      "dec_deg": -12,
      "dec_min": 52,
      "dec_sec": 31,
      "magnitude": 4.24
    },
    {
      "ID": 6582,
      "greek_letter": "eta",
      "constellation": "Pav",
      "RA_hour": 17,
      "RA_min": 45,
      "RA_sec": 43.9,
      "dec_deg": -64,
      "dec_min": 43,
      "dec_sec": 26,
      "magnitude": 3.62
    },
    {
      "ID": 6588,
      "greek_letter": "iot",
      "constellation": "Her",
      "RA_hour": 17,
      "RA_min": 39,
      "RA_sec": 27.8,
      "dec_deg": "+46",
      "dec_min": "00",
      "dec_sec": 23,
      "magnitude": 3.8
    },
    {
      "ID": 6595,
      "greek_letter": "",
      "constellation": "Oph",
      "RA_hour": 17,
      "RA_min": 43,
      "RA_sec": 25.7,
      "dec_deg": -21,
      "dec_min": 41,
      "dec_sec": "00",
      "magnitude": 4.87
    },
    {
      "ID": 6596,
      "greek_letter": "omg",
      "constellation": "Dra",
      "RA_hour": 17,
      "RA_min": 36,
      "RA_sec": 56.9,
      "dec_deg": "+68",
      "dec_min": 45,
      "dec_sec": 29,
      "magnitude": 4.8
    },
    {
      "ID": 6603,
      "greek_letter": "bet",
      "constellation": "Oph",
      "RA_hour": 17,
      "RA_min": 43,
      "RA_sec": 28.3,
      "dec_deg": "+04",
      "dec_min": 34,
      "dec_sec": "02",
      "magnitude": 2.78
    },
    {
      "ID": 6615,
      "greek_letter": "iot1",
      "constellation": "Sco",
      "RA_hour": 17,
      "RA_min": 47,
      "RA_sec": 35,
      "dec_deg": -40,
      "dec_min": "07",
      "dec_sec": 37,
      "magnitude": 3.03
    },
    {
      "ID": 6616,
      "greek_letter": "",
      "constellation": "Sgr",
      "RA_hour": 17,
      "RA_min": 47,
      "RA_sec": 33.5,
      "dec_deg": -27,
      "dec_min": 49,
      "dec_sec": 51,
      "magnitude": 4.54
    },
    {
      "ID": 6623,
      "greek_letter": "mu",
      "constellation": "Her",
      "RA_hour": 17,
      "RA_min": 46,
      "RA_sec": 27.5,
      "dec_deg": "+27",
      "dec_min": 43,
      "dec_sec": 15,
      "magnitude": 3.42
    },
    {
      "ID": 6628,
      "greek_letter": "",
      "constellation": "",
      "RA_hour": 17,
      "RA_min": 49,
      "RA_sec": 10.4,
      "dec_deg": -31,
      "dec_min": 42,
      "dec_sec": 12,
      "magnitude": 4.83
    },
    {
      "ID": 6629,
      "greek_letter": "gam",
      "constellation": "Oph",
      "RA_hour": 17,
      "RA_min": 47,
      "RA_sec": 53.5,
      "dec_deg": "+02",
      "dec_min": 42,
      "dec_sec": 26,
      "magnitude": 3.75
    },
    {
      "ID": 6630,
      "greek_letter": "",
      "constellation": "",
      "RA_hour": 17,
      "RA_min": 49,
      "RA_sec": 51.4,
      "dec_deg": -37,
      "dec_min": "02",
      "dec_sec": 36,
      "magnitude": 3.21
    },
    {
      "ID": 6631,
      "greek_letter": "iot2",
      "constellation": "Sco",
      "RA_hour": 17,
      "RA_min": 50,
      "RA_sec": 11,
      "dec_deg": -40,
      "dec_min": "05",
      "dec_sec": 26,
      "magnitude": 4.81
    },
    {
      "ID": 6636,
      "greek_letter": "psi1",
      "constellation": "Dra",
      "RA_hour": 17,
      "RA_min": 41,
      "RA_sec": 56.2,
      "dec_deg": "+72",
      "dec_min": "08",
      "dec_sec": 56,
      "magnitude": 4.58
    },
    {
      "ID": 6675,
      "greek_letter": "",
      "constellation": "",
      "RA_hour": 17,
      "RA_min": 56,
      "RA_sec": 47.3,
      "dec_deg": -44,
      "dec_min": 20,
      "dec_sec": 32,
      "magnitude": 4.86
    },
    {
      "ID": 6682,
      "greek_letter": "",
      "constellation": "",
      "RA_hour": 17,
      "RA_min": 57,
      "RA_sec": 47.6,
      "dec_deg": -41,
      "dec_min": 42,
      "dec_sec": 58,
      "magnitude": 4.88
    },
    {
      "ID": 6688,
      "greek_letter": "xi",
      "constellation": "Dra",
      "RA_hour": 17,
      "RA_min": 53,
      "RA_sec": 31.6,
      "dec_deg": "+56",
      "dec_min": 52,
      "dec_sec": 21,
      "magnitude": 3.75
    },
    {
      "ID": 6695,
      "greek_letter": "tet",
      "constellation": "Her",
      "RA_hour": 17,
      "RA_min": 56,
      "RA_sec": 15.1,
      "dec_deg": "+37",
      "dec_min": 15,
      "dec_sec": "02",
      "magnitude": 3.88
    },
    {
      "ID": 6698,
      "greek_letter": "nu",
      "constellation": "Oph",
      "RA_hour": 17,
      "RA_min": 59,
      "RA_sec": "01.5",
      "dec_deg": "-09",
      "dec_min": 46,
      "dec_sec": 25,
      "magnitude": 3.34
    },
    {
      "ID": 6700,
      "greek_letter": "",
      "constellation": "Sgr",
      "RA_hour": 17,
      "RA_min": 59,
      "RA_sec": 47.5,
      "dec_deg": -23,
      "dec_min": 48,
      "dec_sec": 58,
      "magnitude": 4.75
    },
    {
      "ID": 6703,
      "greek_letter": "xi",
      "constellation": "Her",
      "RA_hour": 17,
      "RA_min": 57,
      "RA_sec": 45.8,
      "dec_deg": "+29",
      "dec_min": 14,
      "dec_sec": 52,
      "magnitude": 3.7
    },
    {
      "ID": 6705,
      "greek_letter": "gam",
      "constellation": "Dra",
      "RA_hour": 17,
      "RA_min": 56,
      "RA_sec": 36.3,
      "dec_deg": "+51",
      "dec_min": 29,
      "dec_sec": 20,
      "magnitude": 2.22
    },
    {
      "ID": 6707,
      "greek_letter": "nu",
      "constellation": "Her",
      "RA_hour": 17,
      "RA_min": 58,
      "RA_sec": 30.1,
      "dec_deg": "+30",
      "dec_min": 11,
      "dec_sec": 22,
      "magnitude": 4.41
    },
    {
      "ID": 6710,
      "greek_letter": "zet",
      "constellation": "Ser",
      "RA_hour": 18,
      "RA_min": "00",
      "RA_sec": 28.8,
      "dec_deg": "-03",
      "dec_min": 41,
      "dec_sec": 25,
      "magnitude": 4.62
    },
    {
      "ID": 6712,
      "greek_letter": "",
      "constellation": "Oph",
      "RA_hour": 18,
      "RA_min": "00",
      "RA_sec": 15.7,
      "dec_deg": "+04",
      "dec_min": 22,
      "dec_sec": "07",
      "magnitude": 4.6
    },
    {
      "ID": 6713,
      "greek_letter": "",
      "constellation": "Her",
      "RA_hour": 18,
      "RA_min": "00",
      "RA_sec": "03.3",
      "dec_deg": "+16",
      "dec_min": 45,
      "dec_sec": "03",
      "magnitude": 4.67
    },
    {
      "ID": 6714,
      "greek_letter": "",
      "constellation": "Oph",
      "RA_hour": 18,
      "RA_min": "00",
      "RA_sec": 38.6,
      "dec_deg": "+02",
      "dec_min": 55,
      "dec_sec": 53,
      "magnitude": 3.93
    },
    {
      "ID": 6723,
      "greek_letter": "",
      "constellation": "Oph",
      "RA_hour": 18,
      "RA_min": "01",
      "RA_sec": 45.1,
      "dec_deg": "+01",
      "dec_min": 18,
      "dec_sec": 19,
      "magnitude": 4.42
    },
    {
      "ID": 6730,
      "greek_letter": "",
      "constellation": "Her",
      "RA_hour": 18,
      "RA_min": "01",
      "RA_sec": 30.3,
      "dec_deg": "+21",
      "dec_min": 35,
      "dec_sec": 44,
      "magnitude": 4.96
    },
    {
      "ID": 6742,
      "greek_letter": "gam1",
      "constellation": "Sgr",
      "RA_hour": 18,
      "RA_min": "05",
      "RA_sec": "01.2",
      "dec_deg": -29,
      "dec_min": 34,
      "dec_sec": 48,
      "magnitude": 4.69
    },
    {
      "ID": 6743,
      "greek_letter": "tet",
      "constellation": "Ara",
      "RA_hour": 18,
      "RA_min": "06",
      "RA_sec": 37.7,
      "dec_deg": -50,
      "dec_min": "05",
      "dec_sec": 30,
      "magnitude": 3.66
    },
    {
      "ID": 6745,
      "greek_letter": "pi",
      "constellation": "Pav",
      "RA_hour": 18,
      "RA_min": "08",
      "RA_sec": 34.7,
      "dec_deg": -63,
      "dec_min": 40,
      "dec_sec": "06",
      "magnitude": 4.35
    },
    {
      "ID": 6746,
      "greek_letter": "gam2",
      "constellation": "Sgr",
      "RA_hour": 18,
      "RA_min": "05",
      "RA_sec": 48.4,
      "dec_deg": -30,
      "dec_min": 25,
      "dec_sec": 27,
      "magnitude": 2.99
    },
    {
      "ID": 6752,
      "greek_letter": "",
      "constellation": "Oph",
      "RA_hour": 18,
      "RA_min": "05",
      "RA_sec": 27.2,
      "dec_deg": "+02",
      "dec_min": 29,
      "dec_sec": 58,
      "magnitude": 4.03
    },
    {
      "ID": 6766,
      "greek_letter": "",
      "constellation": "",
      "RA_hour": 18,
      "RA_min": "08",
      "RA_sec": "04.9",
      "dec_deg": -28,
      "dec_min": 27,
      "dec_sec": 25,
      "magnitude": 4.56
    },
    {
      "ID": 6770,
      "greek_letter": "",
      "constellation": "Oph",
      "RA_hour": 18,
      "RA_min": "07",
      "RA_sec": 18.3,
      "dec_deg": "+08",
      "dec_min": 44,
      "dec_sec": "02",
      "magnitude": 4.63
    },
    {
      "ID": 6771,
      "greek_letter": "",
      "constellation": "Oph",
      "RA_hour": 18,
      "RA_min": "07",
      "RA_sec": 20.9,
      "dec_deg": "+09",
      "dec_min": 33,
      "dec_sec": 50,
      "magnitude": 3.73
    },
    {
      "ID": 6779,
      "greek_letter": "omi",
      "constellation": "Her",
      "RA_hour": 18,
      "RA_min": "07",
      "RA_sec": 32.5,
      "dec_deg": "+28",
      "dec_min": 45,
      "dec_sec": 45,
      "magnitude": 3.83
    },
    {
      "ID": 6783,
      "greek_letter": "eps",
      "constellation": "Tel",
      "RA_hour": 18,
      "RA_min": 11,
      "RA_sec": 13.7,
      "dec_deg": -45,
      "dec_min": 57,
      "dec_sec": 15,
      "magnitude": 4.53
    },
    {
      "ID": 6787,
      "greek_letter": "",
      "constellation": "Her",
      "RA_hour": 18,
      "RA_min": "08",
      "RA_sec": 45.4,
      "dec_deg": "+20",
      "dec_min": 48,
      "dec_sec": 52,
      "magnitude": 4.35
    },
    {
      "ID": 6789,
      "greek_letter": "del",
      "constellation": "UMi",
      "RA_hour": 17,
      "RA_min": 32,
      "RA_sec": 12.5,
      "dec_deg": "+86",
      "dec_min": 35,
      "dec_sec": 11,
      "magnitude": 4.36
    },
    {
      "ID": 6791,
      "greek_letter": "",
      "constellation": "",
      "RA_hour": 18,
      "RA_min": "07",
      "RA_sec": 28.7,
      "dec_deg": "+43",
      "dec_min": 27,
      "dec_sec": 42,
      "magnitude": 5
    },
    {
      "ID": 6801,
      "greek_letter": "",
      "constellation": "Sgr",
      "RA_hour": 18,
      "RA_min": 11,
      "RA_sec": 43.3,
      "dec_deg": -23,
      "dec_min": 42,
      "dec_sec": "04",
      "magnitude": 4.98
    },
    {
      "ID": 6812,
      "greek_letter": "mu",
      "constellation": "Sgr",
      "RA_hour": 18,
      "RA_min": 13,
      "RA_sec": 45.7,
      "dec_deg": -21,
      "dec_min": "03",
      "dec_sec": 32,
      "magnitude": 3.85
    },
    {
      "ID": 6815,
      "greek_letter": "",
      "constellation": "Her",
      "RA_hour": 18,
      "RA_min": 11,
      "RA_sec": 54.1,
      "dec_deg": "+31",
      "dec_min": 24,
      "dec_sec": 19,
      "magnitude": 4.97
    },
    {
      "ID": 6832,
      "greek_letter": "eta",
      "constellation": "Sgr",
      "RA_hour": 18,
      "RA_min": 17,
      "RA_sec": 37.5,
      "dec_deg": -36,
      "dec_min": 45,
      "dec_sec": 42,
      "magnitude": 3.11
    },
    {
      "ID": 6842,
      "greek_letter": "",
      "constellation": "",
      "RA_hour": 18,
      "RA_min": 18,
      "RA_sec": "03.1",
      "dec_deg": -27,
      "dec_min": "02",
      "dec_sec": 33,
      "magnitude": 4.63
    },
    {
      "ID": 6855,
      "greek_letter": "xi",
      "constellation": "Pav",
      "RA_hour": 18,
      "RA_min": 23,
      "RA_sec": 13.5,
      "dec_deg": -61,
      "dec_min": 29,
      "dec_sec": 38,
      "magnitude": 4.36
    },
    {
      "ID": 6859,
      "greek_letter": "del",
      "constellation": "Sgr",
      "RA_hour": 18,
      "RA_min": 20,
      "RA_sec": 59.6,
      "dec_deg": -29,
      "dec_min": 49,
      "dec_sec": 41,
      "magnitude": 2.7
    },
    {
      "ID": 6866,
      "greek_letter": "",
      "constellation": "Oph",
      "RA_hour": 18,
      "RA_min": 20,
      "RA_sec": 52,
      "dec_deg": "+03",
      "dec_min": 22,
      "dec_sec": 38,
      "magnitude": 4.84
    },
    {
      "ID": 6868,
      "greek_letter": "",
      "constellation": "Her",
      "RA_hour": 18,
      "RA_min": 20,
      "RA_sec": 17.8,
      "dec_deg": "+21",
      "dec_min": 57,
      "dec_sec": 41,
      "magnitude": 4.96
    },
    {
      "ID": 6869,
      "greek_letter": "eta",
      "constellation": "Ser",
      "RA_hour": 18,
      "RA_min": 21,
      "RA_sec": 18.5,
      "dec_deg": "-02",
      "dec_min": 53,
      "dec_sec": 56,
      "magnitude": 3.25
    },
    {
      "ID": 6872,
      "greek_letter": "kap",
      "constellation": "Lyr",
      "RA_hour": 18,
      "RA_min": 19,
      "RA_sec": 51.6,
      "dec_deg": "+36",
      "dec_min": "03",
      "dec_sec": 52,
      "magnitude": 4.34
    },
    {
      "ID": 6879,
      "greek_letter": "eps",
      "constellation": "Sgr",
      "RA_hour": 18,
      "RA_min": 24,
      "RA_sec": 10.3,
      "dec_deg": -34,
      "dec_min": 23,
      "dec_sec": "05",
      "magnitude": 1.85
    },
    {
      "ID": 6884,
      "greek_letter": "zet",
      "constellation": "Sct",
      "RA_hour": 18,
      "RA_min": 23,
      "RA_sec": 39.4,
      "dec_deg": "-08",
      "dec_min": 56,
      "dec_sec": "04",
      "magnitude": 4.68
    },
    {
      "ID": 6895,
      "greek_letter": "",
      "constellation": "Her",
      "RA_hour": 18,
      "RA_min": 23,
      "RA_sec": 41.8,
      "dec_deg": "+21",
      "dec_min": 46,
      "dec_sec": 11,
      "magnitude": 3.84
    },
    {
      "ID": 6896,
      "greek_letter": "",
      "constellation": "Sgr",
      "RA_hour": 18,
      "RA_min": 25,
      "RA_sec": 20.9,
      "dec_deg": -20,
      "dec_min": 32,
      "dec_sec": 30,
      "magnitude": 4.82
    },
    {
      "ID": 6897,
      "greek_letter": "alf",
      "constellation": "Tel",
      "RA_hour": 18,
      "RA_min": 26,
      "RA_sec": 58.3,
      "dec_deg": -45,
      "dec_min": 58,
      "dec_sec": "06",
      "magnitude": 3.51
    },
    {
      "ID": 6905,
      "greek_letter": "zet",
      "constellation": "Tel",
      "RA_hour": 18,
      "RA_min": 28,
      "RA_sec": 49.8,
      "dec_deg": -49,
      "dec_min": "04",
      "dec_sec": 15,
      "magnitude": 4.13
    },
    {
      "ID": 6913,
      "greek_letter": "lam",
      "constellation": "Sgr",
      "RA_hour": 18,
      "RA_min": 27,
      "RA_sec": 58.1,
      "dec_deg": -25,
      "dec_min": 25,
      "dec_sec": 18,
      "magnitude": 2.81
    },
    {
      "ID": 6916,
      "greek_letter": "nu",
      "constellation": "Pav",
      "RA_hour": 18,
      "RA_min": 31,
      "RA_sec": 22.3,
      "dec_deg": -62,
      "dec_min": 16,
      "dec_sec": 42,
      "magnitude": 4.64
    },
    {
      "ID": 6920,
      "greek_letter": "phi",
      "constellation": "Dra",
      "RA_hour": 18,
      "RA_min": 20,
      "RA_sec": 45.3,
      "dec_deg": "+71",
      "dec_min": 20,
      "dec_sec": 16,
      "magnitude": 4.22
    },
    {
      "ID": 6923,
      "greek_letter": "",
      "constellation": "Dra",
      "RA_hour": 18,
      "RA_min": 23,
      "RA_sec": 54.4,
      "dec_deg": "+58",
      "dec_min": 48,
      "dec_sec": "02",
      "magnitude": 4.99
    },
    {
      "ID": 6927,
      "greek_letter": "chi",
      "constellation": "Dra",
      "RA_hour": 18,
      "RA_min": 21,
      "RA_sec": "03.2",
      "dec_deg": "+72",
      "dec_min": 43,
      "dec_sec": 58,
      "magnitude": 3.58
    },
    {
      "ID": 6930,
      "greek_letter": "gam",
      "constellation": "Sct",
      "RA_hour": 18,
      "RA_min": 29,
      "RA_sec": 11.7,
      "dec_deg": -14,
      "dec_min": 33,
      "dec_sec": 57,
      "magnitude": 4.71
    },
    {
      "ID": 6934,
      "greek_letter": "del1",
      "constellation": "Tel",
      "RA_hour": 18,
      "RA_min": 31,
      "RA_sec": 45.3,
      "dec_deg": -45,
      "dec_min": 54,
      "dec_sec": 54,
      "magnitude": 4.96
    },
    {
      "ID": 6945,
      "greek_letter": "",
      "constellation": "Dra",
      "RA_hour": 18,
      "RA_min": 25,
      "RA_sec": 58.9,
      "dec_deg": "+65",
      "dec_min": 33,
      "dec_sec": 49,
      "magnitude": 4.82
    },
    {
      "ID": 6951,
      "greek_letter": "tet",
      "constellation": "CrA",
      "RA_hour": 18,
      "RA_min": 33,
      "RA_sec": 30.1,
      "dec_deg": -42,
      "dec_min": 18,
      "dec_sec": 45,
      "magnitude": 4.64
    },
    {
      "ID": 6973,
      "greek_letter": "alf",
      "constellation": "Sct",
      "RA_hour": 18,
      "RA_min": 35,
      "RA_sec": 12.3,
      "dec_deg": "-08",
      "dec_min": 14,
      "dec_sec": 39,
      "magnitude": 3.83
    },
    {
      "ID": 6978,
      "greek_letter": "",
      "constellation": "Dra",
      "RA_hour": 18,
      "RA_min": 32,
      "RA_sec": 34.3,
      "dec_deg": "+57",
      "dec_min": "02",
      "dec_sec": 44,
      "magnitude": 4.77
    },
    {
      "ID": 6982,
      "greek_letter": "zet",
      "constellation": "Pav",
      "RA_hour": 18,
      "RA_min": 43,
      "RA_sec": "02.1",
      "dec_deg": -71,
      "dec_min": 25,
      "dec_sec": 42,
      "magnitude": 4.01
    },
    {
      "ID": 7001,
      "greek_letter": "alf",
      "constellation": "Lyr",
      "RA_hour": 18,
      "RA_min": 36,
      "RA_sec": 56.2,
      "dec_deg": "+38",
      "dec_min": 47,
      "dec_sec": "01",
      "magnitude": 0.03
    },
    {
      "ID": 7012,
      "greek_letter": "",
      "constellation": "",
      "RA_hour": 18,
      "RA_min": 45,
      "RA_sec": 26.6,
      "dec_deg": -64,
      "dec_min": 52,
      "dec_sec": 17,
      "magnitude": 4.79
    },
    {
      "ID": 7020,
      "greek_letter": "del",
      "constellation": "Sct",
      "RA_hour": 18,
      "RA_min": 42,
      "RA_sec": 16.3,
      "dec_deg": "-09",
      "dec_min": "03",
      "dec_sec": "09",
      "magnitude": 4.72
    },
    {
      "ID": 7029,
      "greek_letter": "",
      "constellation": "",
      "RA_hour": 18,
      "RA_min": 44,
      "RA_sec": 19.3,
      "dec_deg": -35,
      "dec_min": 38,
      "dec_sec": 32,
      "magnitude": 4.87
    },
    {
      "ID": 7032,
      "greek_letter": "eps",
      "constellation": "Sct",
      "RA_hour": 18,
      "RA_min": 43,
      "RA_sec": 31.2,
      "dec_deg": "-08",
      "dec_min": 16,
      "dec_sec": 31,
      "magnitude": 4.89
    },
    {
      "ID": 7039,
      "greek_letter": "phi",
      "constellation": "Sgr",
      "RA_hour": 18,
      "RA_min": 45,
      "RA_sec": 39.3,
      "dec_deg": -26,
      "dec_min": 59,
      "dec_sec": 27,
      "magnitude": 3.16
    },
    {
      "ID": 7056,
      "greek_letter": "zet1",
      "constellation": "Lyr",
      "RA_hour": 18,
      "RA_min": 44,
      "RA_sec": 46.3,
      "dec_deg": "+37",
      "dec_min": 36,
      "dec_sec": 18,
      "magnitude": 4.36
    },
    {
      "ID": 7061,
      "greek_letter": "",
      "constellation": "Her",
      "RA_hour": 18,
      "RA_min": 45,
      "RA_sec": 39.6,
      "dec_deg": "+20",
      "dec_min": 32,
      "dec_sec": 47,
      "magnitude": 4.19
    },
    {
      "ID": 7063,
      "greek_letter": "bet",
      "constellation": "Sct",
      "RA_hour": 18,
      "RA_min": 47,
      "RA_sec": 10.4,
      "dec_deg": "-04",
      "dec_min": 44,
      "dec_sec": 53,
      "magnitude": 4.22
    },
    {
      "ID": 7064,
      "greek_letter": "",
      "constellation": "",
      "RA_hour": 18,
      "RA_min": 46,
      "RA_sec": "04.4",
      "dec_deg": "+26",
      "dec_min": 39,
      "dec_sec": 43,
      "magnitude": 4.84
    },
    {
      "ID": 7069,
      "greek_letter": "",
      "constellation": "Her",
      "RA_hour": 18,
      "RA_min": 47,
      "RA_sec": "01.2",
      "dec_deg": "+18",
      "dec_min": 10,
      "dec_sec": 53,
      "magnitude": 4.36
    },
    {
      "ID": 7074,
      "greek_letter": "lam",
      "constellation": "Pav",
      "RA_hour": 18,
      "RA_min": 52,
      "RA_sec": 12.9,
      "dec_deg": -62,
      "dec_min": 11,
      "dec_sec": 16,
      "magnitude": 4.22
    },
    {
      "ID": 7106,
      "greek_letter": "bet",
      "constellation": "Lyr",
      "RA_hour": 18,
      "RA_min": 50,
      "RA_sec": "04.7",
      "dec_deg": "+33",
      "dec_min": 21,
      "dec_sec": 46,
      "magnitude": 3.42
    },
    {
      "ID": 7107,
      "greek_letter": "kap",
      "constellation": "Pav",
      "RA_hour": 18,
      "RA_min": 56,
      "RA_sec": 57,
      "dec_deg": -67,
      "dec_min": 14,
      "dec_sec": "01",
      "magnitude": 4.44
    },
    {
      "ID": 7116,
      "greek_letter": "nu1",
      "constellation": "Sgr",
      "RA_hour": 18,
      "RA_min": 54,
      "RA_sec": 10.1,
      "dec_deg": -22,
      "dec_min": 44,
      "dec_sec": 42,
      "magnitude": 4.83
    },
    {
      "ID": 7120,
      "greek_letter": "nu2",
      "constellation": "Sgr",
      "RA_hour": 18,
      "RA_min": 55,
      "RA_sec": "07.0",
      "dec_deg": -22,
      "dec_min": 40,
      "dec_sec": 17,
      "magnitude": 4.98
    },
    {
      "ID": 7121,
      "greek_letter": "sig",
      "constellation": "Sgr",
      "RA_hour": 18,
      "RA_min": 55,
      "RA_sec": 15.8,
      "dec_deg": -26,
      "dec_min": 17,
      "dec_sec": 48,
      "magnitude": 2.03
    },
    {
      "ID": 7125,
      "greek_letter": "omi",
      "constellation": "Dra",
      "RA_hour": 18,
      "RA_min": 51,
      "RA_sec": 11.9,
      "dec_deg": "+59",
      "dec_min": 23,
      "dec_sec": 18,
      "magnitude": 4.67
    },
    {
      "ID": 7133,
      "greek_letter": "",
      "constellation": "Her",
      "RA_hour": 18,
      "RA_min": 54,
      "RA_sec": 44.8,
      "dec_deg": "+22",
      "dec_min": 38,
      "dec_sec": 43,
      "magnitude": 4.6
    },
    {
      "ID": 7134,
      "greek_letter": "lam",
      "constellation": "Tel",
      "RA_hour": 18,
      "RA_min": 58,
      "RA_sec": 27.6,
      "dec_deg": -52,
      "dec_min": 56,
      "dec_sec": 18,
      "magnitude": 4.87
    },
    {
      "ID": 7137,
      "greek_letter": "",
      "constellation": "",
      "RA_hour": 18,
      "RA_min": 53,
      "RA_sec": 13.5,
      "dec_deg": "+50",
      "dec_min": 42,
      "dec_sec": 29,
      "magnitude": 4.93
    },
    {
      "ID": 7139,
      "greek_letter": "del2",
      "constellation": "Lyr",
      "RA_hour": 18,
      "RA_min": 54,
      "RA_sec": 30.1,
      "dec_deg": "+36",
      "dec_min": 53,
      "dec_sec": 56,
      "magnitude": 4.3
    },
    {
      "ID": 7141,
      "greek_letter": "tet1",
      "constellation": "Ser",
      "RA_hour": 18,
      "RA_min": 56,
      "RA_sec": 13.1,
      "dec_deg": "+04",
      "dec_min": 12,
      "dec_sec": 13,
      "magnitude": 4.62
    },
    {
      "ID": 7142,
      "greek_letter": "tet2",
      "constellation": "Ser",
      "RA_hour": 18,
      "RA_min": 56,
      "RA_sec": 14.5,
      "dec_deg": "+04",
      "dec_min": 12,
      "dec_sec": "07",
      "magnitude": 4.98
    },
    {
      "ID": 7149,
      "greek_letter": "eta",
      "constellation": "Sct",
      "RA_hour": 18,
      "RA_min": 57,
      "RA_sec": "03.6",
      "dec_deg": "-05",
      "dec_min": 50,
      "dec_sec": 46,
      "magnitude": 4.83
    },
    {
      "ID": 7150,
      "greek_letter": "xi2",
      "constellation": "Sgr",
      "RA_hour": 18,
      "RA_min": 57,
      "RA_sec": 43.7,
      "dec_deg": -21,
      "dec_min": "06",
      "dec_sec": 24,
      "magnitude": 3.51
    },
    {
      "ID": 7152,
      "greek_letter": "eps",
      "constellation": "CrA",
      "RA_hour": 18,
      "RA_min": 58,
      "RA_sec": 43.3,
      "dec_deg": -37,
      "dec_min": "06",
      "dec_sec": 26,
      "magnitude": 4.87
    },
    {
      "ID": 7157,
      "greek_letter": "",
      "constellation": "Lyr",
      "RA_hour": 18,
      "RA_min": 55,
      "RA_sec": 20,
      "dec_deg": "+43",
      "dec_min": 56,
      "dec_sec": 46,
      "magnitude": 4
    },
    {
      "ID": 7176,
      "greek_letter": "eps",
      "constellation": "Aql",
      "RA_hour": 18,
      "RA_min": 59,
      "RA_sec": 37.3,
      "dec_deg": "+15",
      "dec_min": "04",
      "dec_sec": "06",
      "magnitude": 4.02
    },
    {
      "ID": 7178,
      "greek_letter": "gam",
      "constellation": "Lyr",
      "RA_hour": 18,
      "RA_min": 58,
      "RA_sec": 56.5,
      "dec_deg": "+32",
      "dec_min": 41,
      "dec_sec": 22,
      "magnitude": 3.24
    },
    {
      "ID": 7180,
      "greek_letter": "ups",
      "constellation": "Dra",
      "RA_hour": 18,
      "RA_min": 54,
      "RA_sec": 23.7,
      "dec_deg": "+71",
      "dec_min": 17,
      "dec_sec": 50,
      "magnitude": 4.82
    },
    {
      "ID": 7188,
      "greek_letter": "zet",
      "constellation": "CrA",
      "RA_hour": 19,
      "RA_min": "03",
      "RA_sec": "06.7",
      "dec_deg": -42,
      "dec_min": "05",
      "dec_sec": 43,
      "magnitude": 4.75
    },
    {
      "ID": 7192,
      "greek_letter": "lam",
      "constellation": "Lyr",
      "RA_hour": 19,
      "RA_min": "00",
      "RA_sec": "00.8",
      "dec_deg": "+32",
      "dec_min": "08",
      "dec_sec": 44,
      "magnitude": 4.98
    },
    {
      "ID": 7193,
      "greek_letter": "",
      "constellation": "Aql",
      "RA_hour": 19,
      "RA_min": "01",
      "RA_sec": 40.7,
      "dec_deg": "-05",
      "dec_min": 44,
      "dec_sec": 20,
      "magnitude": 4.02
    },
    {
      "ID": 7194,
      "greek_letter": "zet",
      "constellation": "Sgr",
      "RA_hour": 19,
      "RA_min": "02",
      "RA_sec": 36.6,
      "dec_deg": -29,
      "dec_min": 52,
      "dec_sec": 49,
      "magnitude": 2.59
    },
    {
      "ID": 7217,
      "greek_letter": "omi",
      "constellation": "Sgr",
      "RA_hour": 19,
      "RA_min": "04",
      "RA_sec": 40.9,
      "dec_deg": -21,
      "dec_min": 44,
      "dec_sec": 30,
      "magnitude": 3.77
    },
    {
      "ID": 7234,
      "greek_letter": "tau",
      "constellation": "Sgr",
      "RA_hour": 19,
      "RA_min": "06",
      "RA_sec": 56.3,
      "dec_deg": -27,
      "dec_min": 40,
      "dec_sec": 14,
      "magnitude": 3.31
    },
    {
      "ID": 7235,
      "greek_letter": "zet",
      "constellation": "Aql",
      "RA_hour": 19,
      "RA_min": "05",
      "RA_sec": 24.5,
      "dec_deg": "+13",
      "dec_min": 51,
      "dec_sec": 48,
      "magnitude": 2.99
    },
    {
      "ID": 7236,
      "greek_letter": "lam",
      "constellation": "Aql",
      "RA_hour": 19,
      "RA_min": "06",
      "RA_sec": 14.8,
      "dec_deg": "-04",
      "dec_min": 52,
      "dec_sec": 57,
      "magnitude": 3.43
    },
    {
      "ID": 7242,
      "greek_letter": "del",
      "constellation": "CrA",
      "RA_hour": 19,
      "RA_min": "08",
      "RA_sec": 20.8,
      "dec_deg": -40,
      "dec_min": 29,
      "dec_sec": 48,
      "magnitude": 4.59
    },
    {
      "ID": 7254,
      "greek_letter": "alf",
      "constellation": "CrA",
      "RA_hour": 19,
      "RA_min": "09",
      "RA_sec": 28.2,
      "dec_deg": -37,
      "dec_min": 54,
      "dec_sec": 16,
      "magnitude": 4.11
    },
    {
      "ID": 7259,
      "greek_letter": "bet",
      "constellation": "CrA",
      "RA_hour": 19,
      "RA_min": 10,
      "RA_sec": "01.6",
      "dec_deg": -39,
      "dec_min": 20,
      "dec_sec": 27,
      "magnitude": 4.11
    },
    {
      "ID": 7264,
      "greek_letter": "pi",
      "constellation": "Sgr",
      "RA_hour": 19,
      "RA_min": "09",
      "RA_sec": 45.7,
      "dec_deg": -21,
      "dec_min": "01",
      "dec_sec": 25,
      "magnitude": 2.88
    },
    {
      "ID": 7292,
      "greek_letter": "psi",
      "constellation": "Sgr",
      "RA_hour": 19,
      "RA_min": 15,
      "RA_sec": 32.3,
      "dec_deg": -25,
      "dec_min": 15,
      "dec_sec": 24,
      "magnitude": 4.83
    },
    {
      "ID": 7298,
      "greek_letter": "eta",
      "constellation": "Lyr",
      "RA_hour": 19,
      "RA_min": 13,
      "RA_sec": 45.4,
      "dec_deg": "+39",
      "dec_min": "08",
      "dec_sec": 46,
      "magnitude": 4.38
    },
    {
      "ID": 7304,
      "greek_letter": "",
      "constellation": "Sgr",
      "RA_hour": 19,
      "RA_min": 17,
      "RA_sec": 38,
      "dec_deg": -18,
      "dec_min": 57,
      "dec_sec": 11,
      "magnitude": 4.93
    },
    {
      "ID": 7306,
      "greek_letter": "",
      "constellation": "Vul",
      "RA_hour": 19,
      "RA_min": 16,
      "RA_sec": 12.9,
      "dec_deg": "+21",
      "dec_min": 23,
      "dec_sec": 26,
      "magnitude": 4.77
    },
    {
      "ID": 7309,
      "greek_letter": "",
      "constellation": "Dra",
      "RA_hour": 19,
      "RA_min": 13,
      "RA_sec": 55.1,
      "dec_deg": "+57",
      "dec_min": 42,
      "dec_sec": 18,
      "magnitude": 4.99
    },
    {
      "ID": 7310,
      "greek_letter": "del",
      "constellation": "Dra",
      "RA_hour": 19,
      "RA_min": 12,
      "RA_sec": 33.1,
      "dec_deg": "+67",
      "dec_min": 39,
      "dec_sec": 42,
      "magnitude": 3.07
    },
    {
      "ID": 7314,
      "greek_letter": "tet",
      "constellation": "Lyr",
      "RA_hour": 19,
      "RA_min": 16,
      "RA_sec": 22,
      "dec_deg": "+38",
      "dec_min": "08",
      "dec_sec": "01",
      "magnitude": 4.38
    },
    {
      "ID": 7328,
      "greek_letter": "kap",
      "constellation": "Cyg",
      "RA_hour": 19,
      "RA_min": 17,
      "RA_sec": "06.0",
      "dec_deg": "+53",
      "dec_min": 22,
      "dec_sec": "07",
      "magnitude": 3.76
    },
    {
      "ID": 7337,
      "greek_letter": "bet1",
      "constellation": "Sgr",
      "RA_hour": 19,
      "RA_min": 22,
      "RA_sec": 38.2,
      "dec_deg": -44,
      "dec_min": 27,
      "dec_sec": 32,
      "magnitude": 4.01
    },
    {
      "ID": 7340,
      "greek_letter": "ro1",
      "constellation": "Sgr",
      "RA_hour": 19,
      "RA_min": 21,
      "RA_sec": 40.3,
      "dec_deg": -17,
      "dec_min": 50,
      "dec_sec": 50,
      "magnitude": 3.93
    },
    {
      "ID": 7342,
      "greek_letter": "ups",
      "constellation": "Sgr",
      "RA_hour": 19,
      "RA_min": 21,
      "RA_sec": 43.5,
      "dec_deg": -15,
      "dec_min": 57,
      "dec_sec": 18,
      "magnitude": 4.61
    },
    {
      "ID": 7343,
      "greek_letter": "bet2",
      "constellation": "Sgr",
      "RA_hour": 19,
      "RA_min": 23,
      "RA_sec": 13.1,
      "dec_deg": -44,
      "dec_min": 47,
      "dec_sec": 59,
      "magnitude": 4.29
    },
    {
      "ID": 7348,
      "greek_letter": "alf",
      "constellation": "Sgr",
      "RA_hour": 19,
      "RA_min": 23,
      "RA_sec": 53,
      "dec_deg": -40,
      "dec_min": 36,
      "dec_sec": 58,
      "magnitude": 3.97
    },
    {
      "ID": 7352,
      "greek_letter": "tau",
      "constellation": "Dra",
      "RA_hour": 19,
      "RA_min": 15,
      "RA_sec": 32.8,
      "dec_deg": "+73",
      "dec_min": 21,
      "dec_sec": 20,
      "magnitude": 4.45
    },
    {
      "ID": 7371,
      "greek_letter": "pi",
      "constellation": "Dra",
      "RA_hour": 19,
      "RA_min": 20,
      "RA_sec": 40,
      "dec_deg": "+65",
      "dec_min": 42,
      "dec_sec": 52,
      "magnitude": 4.59
    },
    {
      "ID": 7372,
      "greek_letter": "",
      "constellation": "Cyg",
      "RA_hour": 19,
      "RA_min": 24,
      "RA_sec": "07.5",
      "dec_deg": "+29",
      "dec_min": 37,
      "dec_sec": 17,
      "magnitude": 4.97
    },
    {
      "ID": 7377,
      "greek_letter": "del",
      "constellation": "Aql",
      "RA_hour": 19,
      "RA_min": 25,
      "RA_sec": 29.8,
      "dec_deg": "+03",
      "dec_min": "06",
      "dec_sec": 53,
      "magnitude": 3.36
    },
    {
      "ID": 7387,
      "greek_letter": "nu",
      "constellation": "Aql",
      "RA_hour": 19,
      "RA_min": 26,
      "RA_sec": 31,
      "dec_deg": "+00",
      "dec_min": 20,
      "dec_sec": 19,
      "magnitude": 4.72
    },
    {
      "ID": 7405,
      "greek_letter": "alf",
      "constellation": "Vul",
      "RA_hour": 19,
      "RA_min": 28,
      "RA_sec": 42.2,
      "dec_deg": "+24",
      "dec_min": 39,
      "dec_sec": 54,
      "magnitude": 4.45
    },
    {
      "ID": 7417,
      "greek_letter": "bet1",
      "constellation": "Cyg",
      "RA_hour": 19,
      "RA_min": 30,
      "RA_sec": 43.2,
      "dec_deg": "+27",
      "dec_min": 57,
      "dec_sec": 35,
      "magnitude": 3.14
    },
    {
      "ID": 7420,
      "greek_letter": "iot2",
      "constellation": "Cyg",
      "RA_hour": 19,
      "RA_min": 29,
      "RA_sec": 42.2,
      "dec_deg": "+51",
      "dec_min": 43,
      "dec_sec": 47,
      "magnitude": 3.78
    },
    {
      "ID": 7424,
      "greek_letter": "iot",
      "constellation": "Tel",
      "RA_hour": 19,
      "RA_min": 35,
      "RA_sec": 12.8,
      "dec_deg": -48,
      "dec_min": "05",
      "dec_sec": 57,
      "magnitude": 4.9
    },
    {
      "ID": 7426,
      "greek_letter": "",
      "constellation": "Cyg",
      "RA_hour": 19,
      "RA_min": 31,
      "RA_sec": 46.2,
      "dec_deg": "+34",
      "dec_min": 27,
      "dec_sec": 11,
      "magnitude": 4.74
    },
    {
      "ID": 7429,
      "greek_letter": "mu",
      "constellation": "Aql",
      "RA_hour": 19,
      "RA_min": 34,
      "RA_sec": "05.3",
      "dec_deg": "+07",
      "dec_min": 22,
      "dec_sec": 44,
      "magnitude": 4.45
    },
    {
      "ID": 7437,
      "greek_letter": "",
      "constellation": "Vul",
      "RA_hour": 19,
      "RA_min": 34,
      "RA_sec": 34.8,
      "dec_deg": "+19",
      "dec_min": 46,
      "dec_sec": 24,
      "magnitude": 4.99
    },
    {
      "ID": 7440,
      "greek_letter": "",
      "constellation": "Sgr",
      "RA_hour": 19,
      "RA_min": 36,
      "RA_sec": 42.3,
      "dec_deg": -24,
      "dec_min": 53,
      "dec_sec": "01",
      "magnitude": 4.6
    },
    {
      "ID": 7446,
      "greek_letter": "kap",
      "constellation": "Aql",
      "RA_hour": 19,
      "RA_min": 36,
      "RA_sec": 53.4,
      "dec_deg": "-07",
      "dec_min": "01",
      "dec_sec": 39,
      "magnitude": 4.96
    },
    {
      "ID": 7447,
      "greek_letter": "iot",
      "constellation": "Aql",
      "RA_hour": 19,
      "RA_min": 36,
      "RA_sec": 43.2,
      "dec_deg": "-01",
      "dec_min": 17,
      "dec_sec": 11,
      "magnitude": 4.36
    },
    {
      "ID": 7462,
      "greek_letter": "sig",
      "constellation": "Dra",
      "RA_hour": 19,
      "RA_min": 32,
      "RA_sec": 21.5,
      "dec_deg": "+69",
      "dec_min": 39,
      "dec_sec": 40,
      "magnitude": 4.69
    },
    {
      "ID": 7469,
      "greek_letter": "tet",
      "constellation": "Cyg",
      "RA_hour": 19,
      "RA_min": 36,
      "RA_sec": 26.4,
      "dec_deg": "+50",
      "dec_min": 13,
      "dec_sec": 16,
      "magnitude": 4.47
    },
    {
      "ID": 7478,
      "greek_letter": "phi",
      "constellation": "Cyg",
      "RA_hour": 19,
      "RA_min": 39,
      "RA_sec": 22.5,
      "dec_deg": "+30",
      "dec_min": "09",
      "dec_sec": 12,
      "magnitude": 4.7
    },
    {
      "ID": 7479,
      "greek_letter": "alf",
      "constellation": "Sge",
      "RA_hour": 19,
      "RA_min": 40,
      "RA_sec": "05.7",
      "dec_deg": "+18",
      "dec_min": "00",
      "dec_sec": 50,
      "magnitude": 4.38
    },
    {
      "ID": 7488,
      "greek_letter": "bet",
      "constellation": "Sge",
      "RA_hour": 19,
      "RA_min": 41,
      "RA_sec": "02.9",
      "dec_deg": "+17",
      "dec_min": 28,
      "dec_sec": 33,
      "magnitude": 4.38
    },
    {
      "ID": 7515,
      "greek_letter": "",
      "constellation": "Sgr",
      "RA_hour": 19,
      "RA_min": 46,
      "RA_sec": 21.6,
      "dec_deg": -19,
      "dec_min": 45,
      "dec_sec": 40,
      "magnitude": 4.86
    },
    {
      "ID": 7517,
      "greek_letter": "",
      "constellation": "Cyg",
      "RA_hour": 19,
      "RA_min": 44,
      "RA_sec": 16.5,
      "dec_deg": "+37",
      "dec_min": 21,
      "dec_sec": 16,
      "magnitude": 4.89
    },
    {
      "ID": 7525,
      "greek_letter": "gam",
      "constellation": "Aql",
      "RA_hour": 19,
      "RA_min": 46,
      "RA_sec": 15.5,
      "dec_deg": "+10",
      "dec_min": 36,
      "dec_sec": 48,
      "magnitude": 2.72
    },
    {
      "ID": 7528,
      "greek_letter": "del",
      "constellation": "Cyg",
      "RA_hour": 19,
      "RA_min": 44,
      "RA_sec": 58.4,
      "dec_deg": "+45",
      "dec_min": "07",
      "dec_sec": 51,
      "magnitude": 2.87
    },
    {
      "ID": 7534,
      "greek_letter": "",
      "constellation": "Cyg",
      "RA_hour": 19,
      "RA_min": 46,
      "RA_sec": 25.5,
      "dec_deg": "+33",
      "dec_min": 43,
      "dec_sec": 40,
      "magnitude": 4.99
    },
    {
      "ID": 7536,
      "greek_letter": "del",
      "constellation": "Sge",
      "RA_hour": 19,
      "RA_min": 47,
      "RA_sec": 23.2,
      "dec_deg": "+18",
      "dec_min": 32,
      "dec_sec": "03",
      "magnitude": 3.81
    },
    {
      "ID": 7546,
      "greek_letter": "zet",
      "constellation": "Sge",
      "RA_hour": 19,
      "RA_min": 48,
      "RA_sec": 58.6,
      "dec_deg": "+19",
      "dec_min": "08",
      "dec_sec": 31,
      "magnitude": 5
    },
    {
      "ID": 7557,
      "greek_letter": "alf",
      "constellation": "Aql",
      "RA_hour": 19,
      "RA_min": 50,
      "RA_sec": 46.9,
      "dec_deg": "+08",
      "dec_min": 52,
      "dec_sec": "06",
      "magnitude": 0.76
    },
    {
      "ID": 7564,
      "greek_letter": "chi",
      "constellation": "Cyg",
      "RA_hour": 19,
      "RA_min": 50,
      "RA_sec": 33.8,
      "dec_deg": "+32",
      "dec_min": 54,
      "dec_sec": 51,
      "magnitude": 4.24
    },
    {
      "ID": 7565,
      "greek_letter": "",
      "constellation": "Vul",
      "RA_hour": 19,
      "RA_min": 51,
      "RA_sec": "04.0",
      "dec_deg": "+22",
      "dec_min": 36,
      "dec_sec": 36,
      "magnitude": 4.96
    },
    {
      "ID": 7570,
      "greek_letter": "eta",
      "constellation": "Aql",
      "RA_hour": 19,
      "RA_min": 52,
      "RA_sec": 28.3,
      "dec_deg": "+01",
      "dec_min": "00",
      "dec_sec": 20,
      "magnitude": 3.9
    },
    {
      "ID": 7581,
      "greek_letter": "iot",
      "constellation": "Sgr",
      "RA_hour": 19,
      "RA_min": 55,
      "RA_sec": 15.5,
      "dec_deg": -41,
      "dec_min": 52,
      "dec_sec": "06",
      "magnitude": 4.13
    },
    {
      "ID": 7582,
      "greek_letter": "eps",
      "constellation": "Dra",
      "RA_hour": 19,
      "RA_min": 48,
      "RA_sec": 10.3,
      "dec_deg": "+70",
      "dec_min": 16,
      "dec_sec": "04",
      "magnitude": 3.84
    },
    {
      "ID": 7590,
      "greek_letter": "eps",
      "constellation": "Pav",
      "RA_hour": 20,
      "RA_min": "00",
      "RA_sec": 35.4,
      "dec_deg": -72,
      "dec_min": 54,
      "dec_sec": 38,
      "magnitude": 3.96
    },
    {
      "ID": 7592,
      "greek_letter": "",
      "constellation": "Vul",
      "RA_hour": 19,
      "RA_min": 53,
      "RA_sec": 27.6,
      "dec_deg": "+24",
      "dec_min": "04",
      "dec_sec": 47,
      "magnitude": 4.58
    },
    {
      "ID": 7595,
      "greek_letter": "xi",
      "constellation": "Aql",
      "RA_hour": 19,
      "RA_min": 54,
      "RA_sec": 14.8,
      "dec_deg": "+08",
      "dec_min": 27,
      "dec_sec": 41,
      "magnitude": 4.68
    },
    {
      "ID": 7597,
      "greek_letter": "omg",
      "constellation": "Sgr",
      "RA_hour": 19,
      "RA_min": 55,
      "RA_sec": 50.3,
      "dec_deg": -26,
      "dec_min": 17,
      "dec_sec": 58,
      "magnitude": 4.7
    },
    {
      "ID": 7602,
      "greek_letter": "bet",
      "constellation": "Aql",
      "RA_hour": 19,
      "RA_min": 55,
      "RA_sec": 18.7,
      "dec_deg": "+06",
      "dec_min": 24,
      "dec_sec": 24,
      "magnitude": 3.72
    },
    {
      "ID": 7604,
      "greek_letter": "",
      "constellation": "Sgr",
      "RA_hour": 19,
      "RA_min": 56,
      "RA_sec": 56.7,
      "dec_deg": -27,
      "dec_min": 10,
      "dec_sec": 12,
      "magnitude": 4.5
    },
    {
      "ID": 7613,
      "greek_letter": "",
      "constellation": "Cyg",
      "RA_hour": 19,
      "RA_min": 55,
      "RA_sec": 51.6,
      "dec_deg": "+38",
      "dec_min": 29,
      "dec_sec": 12,
      "magnitude": 4.95
    },
    {
      "ID": 7615,
      "greek_letter": "eta",
      "constellation": "Cyg",
      "RA_hour": 19,
      "RA_min": 56,
      "RA_sec": 18.3,
      "dec_deg": "+35",
      "dec_min": "05",
      "dec_sec": "00",
      "magnitude": 3.93
    },
    {
      "ID": 7618,
      "greek_letter": "",
      "constellation": "Sgr",
      "RA_hour": 19,
      "RA_min": 58,
      "RA_sec": 57.1,
      "dec_deg": -26,
      "dec_min": 11,
      "dec_sec": 44,
      "magnitude": 4.82
    },
    {
      "ID": 7619,
      "greek_letter": "psi",
      "constellation": "Cyg",
      "RA_hour": 19,
      "RA_min": 55,
      "RA_sec": 37.7,
      "dec_deg": "+52",
      "dec_min": 26,
      "dec_sec": 20,
      "magnitude": 4.92
    },
    {
      "ID": 7623,
      "greek_letter": "tet1",
      "constellation": "Sgr",
      "RA_hour": 19,
      "RA_min": 59,
      "RA_sec": 44.1,
      "dec_deg": -35,
      "dec_min": 16,
      "dec_sec": 35,
      "magnitude": 4.37
    },
    {
      "ID": 7633,
      "greek_letter": "",
      "constellation": "",
      "RA_hour": 19,
      "RA_min": 55,
      "RA_sec": 55.2,
      "dec_deg": "+58",
      "dec_min": 50,
      "dec_sec": 46,
      "magnitude": 4.96
    },
    {
      "ID": 7635,
      "greek_letter": "gam",
      "constellation": "Sge",
      "RA_hour": 19,
      "RA_min": 58,
      "RA_sec": 45.3,
      "dec_deg": "+19",
      "dec_min": 29,
      "dec_sec": 32,
      "magnitude": 3.47
    },
    {
      "ID": 7650,
      "greek_letter": "",
      "constellation": "Sgr",
      "RA_hour": 20,
      "RA_min": "02",
      "RA_sec": 39.4,
      "dec_deg": -27,
      "dec_min": 42,
      "dec_sec": 36,
      "magnitude": 4.54
    },
    {
      "ID": 7652,
      "greek_letter": "",
      "constellation": "",
      "RA_hour": 20,
      "RA_min": "03",
      "RA_sec": 33.4,
      "dec_deg": -37,
      "dec_min": 56,
      "dec_sec": 27,
      "magnitude": 4.77
    },
    {
      "ID": 7653,
      "greek_letter": "",
      "constellation": "Vul",
      "RA_hour": 20,
      "RA_min": "01",
      "RA_sec": "06.0",
      "dec_deg": "+27",
      "dec_min": 45,
      "dec_sec": 13,
      "magnitude": 4.65
    },
    {
      "ID": 7659,
      "greek_letter": "",
      "constellation": "",
      "RA_hour": 20,
      "RA_min": "04",
      "RA_sec": 19.5,
      "dec_deg": -32,
      "dec_min": "03",
      "dec_sec": 22,
      "magnitude": 4.99
    },
    {
      "ID": 7665,
      "greek_letter": "del",
      "constellation": "Pav",
      "RA_hour": 20,
      "RA_min": "08",
      "RA_sec": 43.2,
      "dec_deg": -66,
      "dec_min": 10,
      "dec_sec": 56,
      "magnitude": 3.56
    },
    {
      "ID": 7673,
      "greek_letter": "xi",
      "constellation": "Tel",
      "RA_hour": 20,
      "RA_min": "07",
      "RA_sec": 23.1,
      "dec_deg": -52,
      "dec_min": 52,
      "dec_sec": 51,
      "magnitude": 4.97
    },
    {
      "ID": 7685,
      "greek_letter": "ro",
      "constellation": "Dra",
      "RA_hour": 20,
      "RA_min": "02",
      "RA_sec": 48.9,
      "dec_deg": "+67",
      "dec_min": 52,
      "dec_sec": 25,
      "magnitude": 4.5
    },
    {
      "ID": 7708,
      "greek_letter": "",
      "constellation": "Cyg",
      "RA_hour": 20,
      "RA_min": "09",
      "RA_sec": 25.5,
      "dec_deg": "+36",
      "dec_min": 50,
      "dec_sec": 23,
      "magnitude": 4.93
    },
    {
      "ID": 7710,
      "greek_letter": "tet",
      "constellation": "Aql",
      "RA_hour": 20,
      "RA_min": 11,
      "RA_sec": 18.2,
      "dec_deg": "-00",
      "dec_min": 49,
      "dec_sec": 17,
      "magnitude": 3.22
    },
    {
      "ID": 7724,
      "greek_letter": "ro",
      "constellation": "Aql",
      "RA_hour": 20,
      "RA_min": 14,
      "RA_sec": 16.5,
      "dec_deg": "+15",
      "dec_min": 11,
      "dec_sec": 51,
      "magnitude": 4.95
    },
    {
      "ID": 7730,
      "greek_letter": "",
      "constellation": "Cyg",
      "RA_hour": 20,
      "RA_min": 13,
      "RA_sec": 17.9,
      "dec_deg": "+46",
      "dec_min": 48,
      "dec_sec": 57,
      "magnitude": 4.83
    },
    {
      "ID": 7735,
      "greek_letter": "",
      "constellation": "Cyg",
      "RA_hour": 20,
      "RA_min": 13,
      "RA_sec": 37.8,
      "dec_deg": "+46",
      "dec_min": 44,
      "dec_sec": 29,
      "magnitude": 3.8
    },
    {
      "ID": 7736,
      "greek_letter": "",
      "constellation": "Cyg",
      "RA_hour": 20,
      "RA_min": 14,
      "RA_sec": 31.9,
      "dec_deg": "+36",
      "dec_min": 48,
      "dec_sec": 23,
      "magnitude": 4.99
    },
    {
      "ID": 7739,
      "greek_letter": "",
      "constellation": "",
      "RA_hour": 20,
      "RA_min": 15,
      "RA_sec": 15.8,
      "dec_deg": "+25",
      "dec_min": 35,
      "dec_sec": 31,
      "magnitude": 4.77
    },
    {
      "ID": 7740,
      "greek_letter": "",
      "constellation": "Cyg",
      "RA_hour": 20,
      "RA_min": 13,
      "RA_sec": 23.8,
      "dec_deg": "+56",
      "dec_min": 34,
      "dec_sec": "04",
      "magnitude": 4.3
    },
    {
      "ID": 7744,
      "greek_letter": "",
      "constellation": "Vul",
      "RA_hour": 20,
      "RA_min": 15,
      "RA_sec": 46,
      "dec_deg": "+27",
      "dec_min": 48,
      "dec_sec": 51,
      "magnitude": 4.52
    },
    {
      "ID": 7747,
      "greek_letter": "alf1",
      "constellation": "Cap",
      "RA_hour": 20,
      "RA_min": 17,
      "RA_sec": 38.8,
      "dec_deg": -12,
      "dec_min": 30,
      "dec_sec": 30,
      "magnitude": 4.27
    },
    {
      "ID": 7750,
      "greek_letter": "kap",
      "constellation": "Cep",
      "RA_hour": 20,
      "RA_min": "08",
      "RA_sec": 53.2,
      "dec_deg": "+77",
      "dec_min": 42,
      "dec_sec": 41,
      "magnitude": 4.39
    },
    {
      "ID": 7751,
      "greek_letter": "",
      "constellation": "Cyg",
      "RA_hour": 20,
      "RA_min": 15,
      "RA_sec": 28.2,
      "dec_deg": "+47",
      "dec_min": 42,
      "dec_sec": 52,
      "magnitude": 3.98
    },
    {
      "ID": 7754,
      "greek_letter": "alf2",
      "constellation": "Cap",
      "RA_hour": 20,
      "RA_min": 18,
      "RA_sec": "03.2",
      "dec_deg": -12,
      "dec_min": 32,
      "dec_sec": 42,
      "magnitude": 3.58
    },
    {
      "ID": 7763,
      "greek_letter": "",
      "constellation": "Cyg",
      "RA_hour": 20,
      "RA_min": 17,
      "RA_sec": 47.1,
      "dec_deg": "+38",
      "dec_min": "01",
      "dec_sec": 59,
      "magnitude": 4.82
    },
    {
      "ID": 7773,
      "greek_letter": "nu",
      "constellation": "Cap",
      "RA_hour": 20,
      "RA_min": 20,
      "RA_sec": 39.7,
      "dec_deg": -12,
      "dec_min": 45,
      "dec_sec": 33,
      "magnitude": 4.76
    },
    {
      "ID": 7776,
      "greek_letter": "bet",
      "constellation": "Cap",
      "RA_hour": 20,
      "RA_min": 21,
      "RA_sec": "00.6",
      "dec_deg": -14,
      "dec_min": 46,
      "dec_sec": 53,
      "magnitude": 3.08
    },
    {
      "ID": 7790,
      "greek_letter": "alf",
      "constellation": "Pav",
      "RA_hour": 20,
      "RA_min": 25,
      "RA_sec": 38.8,
      "dec_deg": -56,
      "dec_min": 44,
      "dec_sec": "07",
      "magnitude": 1.94
    },
    {
      "ID": 7796,
      "greek_letter": "gam",
      "constellation": "Cyg",
      "RA_hour": 20,
      "RA_min": 22,
      "RA_sec": 13.6,
      "dec_deg": "+40",
      "dec_min": 15,
      "dec_sec": 24,
      "magnitude": 2.23
    },
    {
      "ID": 7806,
      "greek_letter": "",
      "constellation": "Cyg",
      "RA_hour": 20,
      "RA_min": 23,
      "RA_sec": 51.5,
      "dec_deg": "+32",
      "dec_min": 11,
      "dec_sec": 25,
      "magnitude": 4.44
    },
    {
      "ID": 7822,
      "greek_letter": "ro",
      "constellation": "Cap",
      "RA_hour": 20,
      "RA_min": 28,
      "RA_sec": 51.5,
      "dec_deg": -17,
      "dec_min": 48,
      "dec_sec": 49,
      "magnitude": 4.81
    },
    {
      "ID": 7831,
      "greek_letter": "",
      "constellation": "Aql",
      "RA_hour": 20,
      "RA_min": 29,
      "RA_sec": 38.9,
      "dec_deg": "-02",
      "dec_min": 53,
      "dec_sec": "08",
      "magnitude": 4.91
    },
    {
      "ID": 7834,
      "greek_letter": "",
      "constellation": "Cyg",
      "RA_hour": 20,
      "RA_min": 29,
      "RA_sec": 23.6,
      "dec_deg": "+30",
      "dec_min": 22,
      "dec_sec": "07",
      "magnitude": 4.01
    },
    {
      "ID": 7844,
      "greek_letter": "omg1",
      "constellation": "Cyg",
      "RA_hour": 20,
      "RA_min": 30,
      "RA_sec": "03.4",
      "dec_deg": "+48",
      "dec_min": 57,
      "dec_sec": "06",
      "magnitude": 4.95
    },
    {
      "ID": 7848,
      "greek_letter": "phi1",
      "constellation": "Pav",
      "RA_hour": 20,
      "RA_min": 35,
      "RA_sec": 34.7,
      "dec_deg": -60,
      "dec_min": 34,
      "dec_sec": 54,
      "magnitude": 4.76
    },
    {
      "ID": 7850,
      "greek_letter": "tet",
      "constellation": "Cep",
      "RA_hour": 20,
      "RA_min": 29,
      "RA_sec": 34.8,
      "dec_deg": "+62",
      "dec_min": 59,
      "dec_sec": 39,
      "magnitude": 4.22
    },
    {
      "ID": 7852,
      "greek_letter": "eps",
      "constellation": "Del",
      "RA_hour": 20,
      "RA_min": 33,
      "RA_sec": 12.7,
      "dec_deg": "+11",
      "dec_min": 18,
      "dec_sec": 12,
      "magnitude": 4.04
    },
    {
      "ID": 7859,
      "greek_letter": "ro",
      "constellation": "Pav",
      "RA_hour": 20,
      "RA_min": 37,
      "RA_sec": 35.2,
      "dec_deg": -61,
      "dec_min": 31,
      "dec_sec": 48,
      "magnitude": 4.88
    },
    {
      "ID": 7866,
      "greek_letter": "",
      "constellation": "Cyg",
      "RA_hour": 20,
      "RA_min": 33,
      "RA_sec": 54.1,
      "dec_deg": "+35",
      "dec_min": 15,
      "dec_sec": "03",
      "magnitude": 4.63
    },
    {
      "ID": 7869,
      "greek_letter": "alf",
      "constellation": "Ind",
      "RA_hour": 20,
      "RA_min": 37,
      "RA_sec": 34,
      "dec_deg": -47,
      "dec_min": 17,
      "dec_sec": 29,
      "magnitude": 3.11
    },
    {
      "ID": 7871,
      "greek_letter": "zet",
      "constellation": "Del",
      "RA_hour": 20,
      "RA_min": 35,
      "RA_sec": 18.4,
      "dec_deg": "+14",
      "dec_min": 40,
      "dec_sec": 27,
      "magnitude": 4.69
    },
    {
      "ID": 7873,
      "greek_letter": "",
      "constellation": "Aql",
      "RA_hour": 20,
      "RA_min": 36,
      "RA_sec": 43.5,
      "dec_deg": "-02",
      "dec_min": 32,
      "dec_sec": 59,
      "magnitude": 4.89
    },
    {
      "ID": 7882,
      "greek_letter": "bet",
      "constellation": "Del",
      "RA_hour": 20,
      "RA_min": 37,
      "RA_sec": 32.9,
      "dec_deg": "+14",
      "dec_min": 35,
      "dec_sec": 43,
      "magnitude": 3.63
    },
    {
      "ID": 7884,
      "greek_letter": "",
      "constellation": "Aql",
      "RA_hour": 20,
      "RA_min": 38,
      "RA_sec": 20.2,
      "dec_deg": "-01",
      "dec_min": "06",
      "dec_sec": 19,
      "magnitude": 4.33
    },
    {
      "ID": 7891,
      "greek_letter": "",
      "constellation": "Vul",
      "RA_hour": 20,
      "RA_min": 38,
      "RA_sec": 31.2,
      "dec_deg": "+21",
      "dec_min": 12,
      "dec_sec": "04",
      "magnitude": 4.82
    },
    {
      "ID": 7906,
      "greek_letter": "alf",
      "constellation": "Del",
      "RA_hour": 20,
      "RA_min": 39,
      "RA_sec": 38.2,
      "dec_deg": "+15",
      "dec_min": 54,
      "dec_sec": 43,
      "magnitude": 3.77
    },
    {
      "ID": 7913,
      "greek_letter": "bet",
      "constellation": "Pav",
      "RA_hour": 20,
      "RA_min": 44,
      "RA_sec": 57.4,
      "dec_deg": -66,
      "dec_min": 12,
      "dec_sec": 11,
      "magnitude": 3.42
    },
    {
      "ID": 7920,
      "greek_letter": "eta",
      "constellation": "Ind",
      "RA_hour": 20,
      "RA_min": 44,
      "RA_sec": "02.2",
      "dec_deg": -51,
      "dec_min": 55,
      "dec_sec": 16,
      "magnitude": 4.51
    },
    {
      "ID": 7924,
      "greek_letter": "alf",
      "constellation": "Cyg",
      "RA_hour": 20,
      "RA_min": 41,
      "RA_sec": 25.8,
      "dec_deg": "+45",
      "dec_min": 16,
      "dec_sec": 49,
      "magnitude": 1.25
    },
    {
      "ID": 7928,
      "greek_letter": "del",
      "constellation": "Del",
      "RA_hour": 20,
      "RA_min": 43,
      "RA_sec": 27.5,
      "dec_deg": "+15",
      "dec_min": "04",
      "dec_sec": 28,
      "magnitude": 4.44
    },
    {
      "ID": 7936,
      "greek_letter": "psi",
      "constellation": "Cap",
      "RA_hour": 20,
      "RA_min": 46,
      "RA_sec": "05.6",
      "dec_deg": -25,
      "dec_min": 16,
      "dec_sec": 16,
      "magnitude": 4.13
    },
    {
      "ID": 7939,
      "greek_letter": "",
      "constellation": "Vul",
      "RA_hour": 20,
      "RA_min": 44,
      "RA_sec": 52.4,
      "dec_deg": "+25",
      "dec_min": 16,
      "dec_sec": 15,
      "magnitude": 4.91
    },
    {
      "ID": 7942,
      "greek_letter": "",
      "constellation": "Cyg",
      "RA_hour": 20,
      "RA_min": 45,
      "RA_sec": 39.6,
      "dec_deg": "+30",
      "dec_min": 43,
      "dec_sec": 11,
      "magnitude": 4.23
    },
    {
      "ID": 7948,
      "greek_letter": "gam2",
      "constellation": "Del",
      "RA_hour": 20,
      "RA_min": 46,
      "RA_sec": 39.4,
      "dec_deg": "+16",
      "dec_min": "07",
      "dec_sec": 27,
      "magnitude": 4.27
    },
    {
      "ID": 7949,
      "greek_letter": "eps",
      "constellation": "Cyg",
      "RA_hour": 20,
      "RA_min": 46,
      "RA_sec": 12.6,
      "dec_deg": "+33",
      "dec_min": 58,
      "dec_sec": 13,
      "magnitude": 2.46
    },
    {
      "ID": 7950,
      "greek_letter": "eps",
      "constellation": "Aqr",
      "RA_hour": 20,
      "RA_min": 47,
      "RA_sec": 40.5,
      "dec_deg": "-09",
      "dec_min": 29,
      "dec_sec": 45,
      "magnitude": 3.77
    },
    {
      "ID": 7951,
      "greek_letter": "",
      "constellation": "Aqr",
      "RA_hour": 20,
      "RA_min": 47,
      "RA_sec": 44.1,
      "dec_deg": "-05",
      "dec_min": "01",
      "dec_sec": 40,
      "magnitude": 4.44
    },
    {
      "ID": 7952,
      "greek_letter": "zet",
      "constellation": "Ind",
      "RA_hour": 20,
      "RA_min": 49,
      "RA_sec": 28.9,
      "dec_deg": -46,
      "dec_min": 13,
      "dec_sec": 37,
      "magnitude": 4.89
    },
    {
      "ID": 7955,
      "greek_letter": "",
      "constellation": "",
      "RA_hour": 20,
      "RA_min": 45,
      "RA_sec": 21,
      "dec_deg": "+57",
      "dec_min": 34,
      "dec_sec": 47,
      "magnitude": 4.52
    },
    {
      "ID": 7956,
      "greek_letter": "",
      "constellation": "",
      "RA_hour": 20,
      "RA_min": 47,
      "RA_sec": 10.7,
      "dec_deg": "+34",
      "dec_min": 22,
      "dec_sec": 27,
      "magnitude": 4.92
    },
    {
      "ID": 7957,
      "greek_letter": "eta",
      "constellation": "Cep",
      "RA_hour": 20,
      "RA_min": 45,
      "RA_sec": 17.3,
      "dec_deg": "+61",
      "dec_min": 50,
      "dec_sec": 20,
      "magnitude": 3.43
    },
    {
      "ID": 7963,
      "greek_letter": "lam",
      "constellation": "Cyg",
      "RA_hour": 20,
      "RA_min": 47,
      "RA_sec": 24.4,
      "dec_deg": "+36",
      "dec_min": 29,
      "dec_sec": 27,
      "magnitude": 4.54
    },
    {
      "ID": 7965,
      "greek_letter": "alf",
      "constellation": "Mic",
      "RA_hour": 20,
      "RA_min": 49,
      "RA_sec": 58,
      "dec_deg": -33,
      "dec_min": 46,
      "dec_sec": 48,
      "magnitude": 4.9
    },
    {
      "ID": 7977,
      "greek_letter": "",
      "constellation": "Cyg",
      "RA_hour": 20,
      "RA_min": 48,
      "RA_sec": 56.2,
      "dec_deg": "+46",
      "dec_min": "06",
      "dec_sec": 51,
      "magnitude": 4.86
    },
    {
      "ID": 7980,
      "greek_letter": "omg",
      "constellation": "Cap",
      "RA_hour": 20,
      "RA_min": 51,
      "RA_sec": 49.2,
      "dec_deg": -26,
      "dec_min": 55,
      "dec_sec": "09",
      "magnitude": 4.12
    },
    {
      "ID": 7986,
      "greek_letter": "bet",
      "constellation": "Ind",
      "RA_hour": 20,
      "RA_min": 54,
      "RA_sec": 48.5,
      "dec_deg": -58,
      "dec_min": 27,
      "dec_sec": 15,
      "magnitude": 3.65
    },
    {
      "ID": 7990,
      "greek_letter": "mu",
      "constellation": "Aqr",
      "RA_hour": 20,
      "RA_min": 52,
      "RA_sec": 39.1,
      "dec_deg": "-08",
      "dec_min": 59,
      "dec_sec": "00",
      "magnitude": 4.75
    },
    {
      "ID": 7995,
      "greek_letter": "",
      "constellation": "Vul",
      "RA_hour": 20,
      "RA_min": 52,
      "RA_sec": "07.6",
      "dec_deg": "+27",
      "dec_min": "05",
      "dec_sec": 49,
      "magnitude": 4.57
    },
    {
      "ID": 8001,
      "greek_letter": "",
      "constellation": "Cyg",
      "RA_hour": 20,
      "RA_min": 53,
      "RA_sec": 14.7,
      "dec_deg": "+44",
      "dec_min": 23,
      "dec_sec": 14,
      "magnitude": 4.77
    },
    {
      "ID": 8028,
      "greek_letter": "nu",
      "constellation": "Cyg",
      "RA_hour": 20,
      "RA_min": 57,
      "RA_sec": 10.3,
      "dec_deg": "+41",
      "dec_min": 10,
      "dec_sec": "02",
      "magnitude": 3.94
    },
    {
      "ID": 8039,
      "greek_letter": "gam",
      "constellation": "Mic",
      "RA_hour": 21,
      "RA_min": "01",
      "RA_sec": 17.4,
      "dec_deg": -32,
      "dec_min": 15,
      "dec_sec": 28,
      "magnitude": 4.67
    },
    {
      "ID": 8047,
      "greek_letter": "",
      "constellation": "Cyg",
      "RA_hour": 20,
      "RA_min": 59,
      "RA_sec": 49.5,
      "dec_deg": "+47",
      "dec_min": 31,
      "dec_sec": 16,
      "magnitude": 4.75
    },
    {
      "ID": 8060,
      "greek_letter": "eta",
      "constellation": "Cap",
      "RA_hour": 21,
      "RA_min": "04",
      "RA_sec": 24.2,
      "dec_deg": -19,
      "dec_min": 51,
      "dec_sec": 18,
      "magnitude": 4.84
    },
    {
      "ID": 8075,
      "greek_letter": "tet",
      "constellation": "Cap",
      "RA_hour": 21,
      "RA_min": "05",
      "RA_sec": 56.7,
      "dec_deg": -17,
      "dec_min": 13,
      "dec_sec": 58,
      "magnitude": 4.07
    },
    {
      "ID": 8079,
      "greek_letter": "xi",
      "constellation": "Cyg",
      "RA_hour": 21,
      "RA_min": "04",
      "RA_sec": 55.8,
      "dec_deg": "+43",
      "dec_min": 55,
      "dec_sec": 40,
      "magnitude": 3.73
    },
    {
      "ID": 8080,
      "greek_letter": "",
      "constellation": "Cap",
      "RA_hour": 21,
      "RA_min": "07",
      "RA_sec": "07.6",
      "dec_deg": -25,
      "dec_min": "00",
      "dec_sec": 21,
      "magnitude": 4.49
    },
    {
      "ID": 8089,
      "greek_letter": "",
      "constellation": "Cyg",
      "RA_hour": 21,
      "RA_min": "06",
      "RA_sec": 36,
      "dec_deg": "+47",
      "dec_min": 38,
      "dec_sec": 54,
      "magnitude": 4.6
    },
    {
      "ID": 8093,
      "greek_letter": "nu",
      "constellation": "Aqr",
      "RA_hour": 21,
      "RA_min": "09",
      "RA_sec": 35.5,
      "dec_deg": -11,
      "dec_min": 22,
      "dec_sec": 18,
      "magnitude": 4.52
    },
    {
      "ID": 8097,
      "greek_letter": "gam",
      "constellation": "Equ",
      "RA_hour": 21,
      "RA_min": 10,
      "RA_sec": 20.5,
      "dec_deg": "+10",
      "dec_min": "07",
      "dec_sec": 53,
      "magnitude": 4.68
    },
    {
      "ID": 8115,
      "greek_letter": "zet",
      "constellation": "Cyg",
      "RA_hour": 21,
      "RA_min": 12,
      "RA_sec": 56.1,
      "dec_deg": "+30",
      "dec_min": 13,
      "dec_sec": 37,
      "magnitude": 3.21
    },
    {
      "ID": 8123,
      "greek_letter": "del",
      "constellation": "Equ",
      "RA_hour": 21,
      "RA_min": 14,
      "RA_sec": 28.8,
      "dec_deg": "+10",
      "dec_min": "00",
      "dec_sec": 25,
      "magnitude": 4.49
    },
    {
      "ID": 8130,
      "greek_letter": "tau",
      "constellation": "Cyg",
      "RA_hour": 21,
      "RA_min": 14,
      "RA_sec": 47.4,
      "dec_deg": "+38",
      "dec_min": "02",
      "dec_sec": 44,
      "magnitude": 3.73
    },
    {
      "ID": 8131,
      "greek_letter": "alf",
      "constellation": "Equ",
      "RA_hour": 21,
      "RA_min": 15,
      "RA_sec": 49.3,
      "dec_deg": "+05",
      "dec_min": 14,
      "dec_sec": 52,
      "magnitude": 3.9
    },
    {
      "ID": 8135,
      "greek_letter": "eps",
      "constellation": "Mic",
      "RA_hour": 21,
      "RA_min": 17,
      "RA_sec": 56.2,
      "dec_deg": -32,
      "dec_min": 10,
      "dec_sec": 21,
      "magnitude": 4.71
    },
    {
      "ID": 8140,
      "greek_letter": "tet",
      "constellation": "Ind",
      "RA_hour": 21,
      "RA_min": 19,
      "RA_sec": 51.9,
      "dec_deg": -53,
      "dec_min": 26,
      "dec_sec": 59,
      "magnitude": 4.39
    },
    {
      "ID": 8143,
      "greek_letter": "sig",
      "constellation": "Cyg",
      "RA_hour": 21,
      "RA_min": 17,
      "RA_sec": 24.9,
      "dec_deg": "+39",
      "dec_min": 23,
      "dec_sec": 41,
      "magnitude": 4.24
    },
    {
      "ID": 8146,
      "greek_letter": "ups",
      "constellation": "Cyg",
      "RA_hour": 21,
      "RA_min": 17,
      "RA_sec": 55,
      "dec_deg": "+34",
      "dec_min": 53,
      "dec_sec": 49,
      "magnitude": 4.42
    },
    {
      "ID": 8151,
      "greek_letter": "tet1",
      "constellation": "Mic",
      "RA_hour": 21,
      "RA_min": 20,
      "RA_sec": 45.5,
      "dec_deg": -40,
      "dec_min": 48,
      "dec_sec": 35,
      "magnitude": 4.82
    },
    {
      "ID": 8154,
      "greek_letter": "",
      "constellation": "Cyg",
      "RA_hour": 21,
      "RA_min": 18,
      "RA_sec": 27,
      "dec_deg": "+43",
      "dec_min": 56,
      "dec_sec": 46,
      "magnitude": 5
    },
    {
      "ID": 8162,
      "greek_letter": "alf",
      "constellation": "Cep",
      "RA_hour": 21,
      "RA_min": 18,
      "RA_sec": 34.7,
      "dec_deg": "+62",
      "dec_min": 35,
      "dec_sec": "08",
      "magnitude": 2.45
    },
    {
      "ID": 8167,
      "greek_letter": "iot",
      "constellation": "Cap",
      "RA_hour": 21,
      "RA_min": 22,
      "RA_sec": 14.7,
      "dec_deg": -16,
      "dec_min": 50,
      "dec_sec": "05",
      "magnitude": 4.27
    },
    {
      "ID": 8173,
      "greek_letter": "",
      "constellation": "Peg",
      "RA_hour": 21,
      "RA_min": 22,
      "RA_sec": "05.1",
      "dec_deg": "+19",
      "dec_min": 48,
      "dec_sec": 16,
      "magnitude": 4.09
    },
    {
      "ID": 8181,
      "greek_letter": "gam",
      "constellation": "Pav",
      "RA_hour": 21,
      "RA_min": 26,
      "RA_sec": 26.7,
      "dec_deg": -65,
      "dec_min": 21,
      "dec_sec": 59,
      "magnitude": 4.22
    },
    {
      "ID": 8204,
      "greek_letter": "zet",
      "constellation": "Cap",
      "RA_hour": 21,
      "RA_min": 26,
      "RA_sec": 39.9,
      "dec_deg": -22,
      "dec_min": 24,
      "dec_sec": 41,
      "magnitude": 3.74
    },
    {
      "ID": 8213,
      "greek_letter": "",
      "constellation": "Cap",
      "RA_hour": 21,
      "RA_min": 28,
      "RA_sec": 43.3,
      "dec_deg": -21,
      "dec_min": 48,
      "dec_sec": 26,
      "magnitude": 4.5
    },
    {
      "ID": 8225,
      "greek_letter": "",
      "constellation": "Peg",
      "RA_hour": 21,
      "RA_min": 29,
      "RA_sec": 56.8,
      "dec_deg": "+23",
      "dec_min": 38,
      "dec_sec": 20,
      "magnitude": 4.57
    },
    {
      "ID": 8232,
      "greek_letter": "bet",
      "constellation": "Aqr",
      "RA_hour": 21,
      "RA_min": 31,
      "RA_sec": 33.4,
      "dec_deg": "-05",
      "dec_min": 34,
      "dec_sec": 16,
      "magnitude": 2.89
    },
    {
      "ID": 8238,
      "greek_letter": "bet",
      "constellation": "Cep",
      "RA_hour": 21,
      "RA_min": 28,
      "RA_sec": 39.5,
      "dec_deg": "+70",
      "dec_min": 33,
      "dec_sec": 39,
      "magnitude": 3.23
    },
    {
      "ID": 8252,
      "greek_letter": "ro",
      "constellation": "Cyg",
      "RA_hour": 21,
      "RA_min": 33,
      "RA_sec": 58.8,
      "dec_deg": "+45",
      "dec_min": 35,
      "dec_sec": 31,
      "magnitude": 4.02
    },
    {
      "ID": 8254,
      "greek_letter": "nu",
      "constellation": "Oct",
      "RA_hour": 21,
      "RA_min": 41,
      "RA_sec": 28.6,
      "dec_deg": -77,
      "dec_min": 23,
      "dec_sec": 24,
      "magnitude": 3.76
    },
    {
      "ID": 8255,
      "greek_letter": "",
      "constellation": "Cyg",
      "RA_hour": 21,
      "RA_min": 34,
      "RA_sec": 46.5,
      "dec_deg": "+38",
      "dec_min": 32,
      "dec_sec": "03",
      "magnitude": 4.91
    },
    {
      "ID": 8260,
      "greek_letter": "eps",
      "constellation": "Cap",
      "RA_hour": 21,
      "RA_min": 37,
      "RA_sec": "04.7",
      "dec_deg": -19,
      "dec_min": 27,
      "dec_sec": 58,
      "magnitude": 4.68
    },
    {
      "ID": 8264,
      "greek_letter": "xi",
      "constellation": "Aqr",
      "RA_hour": 21,
      "RA_min": 37,
      "RA_sec": 45,
      "dec_deg": "-07",
      "dec_min": 51,
      "dec_sec": 15,
      "magnitude": 4.69
    },
    {
      "ID": 8278,
      "greek_letter": "gam",
      "constellation": "Cap",
      "RA_hour": 21,
      "RA_min": 40,
      "RA_sec": "05.4",
      "dec_deg": -16,
      "dec_min": 39,
      "dec_sec": 45,
      "magnitude": 3.67
    },
    {
      "ID": 8279,
      "greek_letter": "",
      "constellation": "Cep",
      "RA_hour": 21,
      "RA_min": 37,
      "RA_sec": 55.1,
      "dec_deg": "+62",
      "dec_min": "04",
      "dec_sec": 55,
      "magnitude": 4.73
    },
    {
      "ID": 8288,
      "greek_letter": "kap",
      "constellation": "Cap",
      "RA_hour": 21,
      "RA_min": 42,
      "RA_sec": 39.4,
      "dec_deg": -18,
      "dec_min": 51,
      "dec_sec": 59,
      "magnitude": 4.73
    },
    {
      "ID": 8301,
      "greek_letter": "pi1",
      "constellation": "Cyg",
      "RA_hour": 21,
      "RA_min": 42,
      "RA_sec": "05.6",
      "dec_deg": "+51",
      "dec_min": 11,
      "dec_sec": 23,
      "magnitude": 4.67
    },
    {
      "ID": 8305,
      "greek_letter": "iot",
      "constellation": "PsA",
      "RA_hour": 21,
      "RA_min": 44,
      "RA_sec": 56.7,
      "dec_deg": -33,
      "dec_min": "01",
      "dec_sec": 33,
      "magnitude": 4.34
    },
    {
      "ID": 8308,
      "greek_letter": "eps",
      "constellation": "Peg",
      "RA_hour": 21,
      "RA_min": 44,
      "RA_sec": 11.1,
      "dec_deg": "+09",
      "dec_min": 52,
      "dec_sec": 30,
      "magnitude": 2.39
    },
    {
      "ID": 8309,
      "greek_letter": "mu1",
      "constellation": "Cyg",
      "RA_hour": 21,
      "RA_min": 44,
      "RA_sec": "08.5",
      "dec_deg": "+28",
      "dec_min": 44,
      "dec_sec": 34,
      "magnitude": 4.73
    },
    {
      "ID": 8313,
      "greek_letter": "",
      "constellation": "Peg",
      "RA_hour": 21,
      "RA_min": 44,
      "RA_sec": 30.6,
      "dec_deg": "+17",
      "dec_min": 21,
      "dec_sec": "00",
      "magnitude": 4.35
    },
    {
      "ID": 8315,
      "greek_letter": "kap",
      "constellation": "Peg",
      "RA_hour": 21,
      "RA_min": 44,
      "RA_sec": 38.6,
      "dec_deg": "+25",
      "dec_min": 38,
      "dec_sec": 42,
      "magnitude": 4.12
    },
    {
      "ID": 8316,
      "greek_letter": "mu",
      "constellation": "Cep",
      "RA_hour": 21,
      "RA_min": 43,
      "RA_sec": 30.3,
      "dec_deg": "+58",
      "dec_min": 46,
      "dec_sec": 48,
      "magnitude": 4.08
    },
    {
      "ID": 8317,
      "greek_letter": "",
      "constellation": "Cep",
      "RA_hour": 21,
      "RA_min": 41,
      "RA_sec": 55.2,
      "dec_deg": "+71",
      "dec_min": 18,
      "dec_sec": 42,
      "magnitude": 4.57
    },
    {
      "ID": 8322,
      "greek_letter": "del",
      "constellation": "Cap",
      "RA_hour": 21,
      "RA_min": 47,
      "RA_sec": "02.3",
      "dec_deg": -16,
      "dec_min": "07",
      "dec_sec": 38,
      "magnitude": 2.83
    },
    {
      "ID": 8334,
      "greek_letter": "nu",
      "constellation": "Cep",
      "RA_hour": 21,
      "RA_min": 45,
      "RA_sec": 26.8,
      "dec_deg": "+61",
      "dec_min": "07",
      "dec_sec": 15,
      "magnitude": 4.29
    },
    {
      "ID": 8335,
      "greek_letter": "pi2",
      "constellation": "Cyg",
      "RA_hour": 21,
      "RA_min": 46,
      "RA_sec": 47.5,
      "dec_deg": "+49",
      "dec_min": 18,
      "dec_sec": 35,
      "magnitude": 4.24
    },
    {
      "ID": 8353,
      "greek_letter": "gam",
      "constellation": "Gru",
      "RA_hour": 21,
      "RA_min": 53,
      "RA_sec": 55.6,
      "dec_deg": -37,
      "dec_min": 21,
      "dec_sec": 54,
      "magnitude": 3.01
    },
    {
      "ID": 8368,
      "greek_letter": "del",
      "constellation": "Ind",
      "RA_hour": 21,
      "RA_min": 57,
      "RA_sec": 55,
      "dec_deg": -54,
      "dec_min": 59,
      "dec_sec": 34,
      "magnitude": 4.4
    },
    {
      "ID": 8383,
      "greek_letter": "",
      "constellation": "",
      "RA_hour": 21,
      "RA_min": 56,
      "RA_sec": 39.1,
      "dec_deg": "+63",
      "dec_min": 37,
      "dec_sec": 33,
      "magnitude": 4.9
    },
    {
      "ID": 8387,
      "greek_letter": "eps",
      "constellation": "Ind",
      "RA_hour": 22,
      "RA_min": "03",
      "RA_sec": 21.3,
      "dec_deg": -56,
      "dec_min": 47,
      "dec_sec": 10,
      "magnitude": 4.69
    },
    {
      "ID": 8402,
      "greek_letter": "omi",
      "constellation": "Aqr",
      "RA_hour": 22,
      "RA_min": "03",
      "RA_sec": 18.7,
      "dec_deg": "-02",
      "dec_min": "09",
      "dec_sec": 19,
      "magnitude": 4.69
    },
    {
      "ID": 8411,
      "greek_letter": "lam",
      "constellation": "Gru",
      "RA_hour": 22,
      "RA_min": "06",
      "RA_sec": "06.8",
      "dec_deg": -39,
      "dec_min": 32,
      "dec_sec": 36,
      "magnitude": 4.46
    },
    {
      "ID": 8413,
      "greek_letter": "nu",
      "constellation": "Peg",
      "RA_hour": 22,
      "RA_min": "05",
      "RA_sec": 40.7,
      "dec_deg": "+05",
      "dec_min": "03",
      "dec_sec": 31,
      "magnitude": 4.84
    },
    {
      "ID": 8414,
      "greek_letter": "alf",
      "constellation": "Aqr",
      "RA_hour": 22,
      "RA_min": "05",
      "RA_sec": 46.9,
      "dec_deg": "-00",
      "dec_min": 19,
      "dec_sec": 11,
      "magnitude": 2.94
    },
    {
      "ID": 8417,
      "greek_letter": "xi",
      "constellation": "Cep",
      "RA_hour": 22,
      "RA_min": "03",
      "RA_sec": 47.3,
      "dec_deg": "+64",
      "dec_min": 37,
      "dec_sec": 41,
      "magnitude": 4.29
    },
    {
      "ID": 8418,
      "greek_letter": "iot",
      "constellation": "Aqr",
      "RA_hour": 22,
      "RA_min": "06",
      "RA_sec": 26.1,
      "dec_deg": -13,
      "dec_min": 52,
      "dec_sec": 11,
      "magnitude": 4.25
    },
    {
      "ID": 8425,
      "greek_letter": "alf",
      "constellation": "Gru",
      "RA_hour": 22,
      "RA_min": "08",
      "RA_sec": 13.9,
      "dec_deg": -46,
      "dec_min": 57,
      "dec_sec": 40,
      "magnitude": 1.71
    },
    {
      "ID": 8430,
      "greek_letter": "iot",
      "constellation": "Peg",
      "RA_hour": 22,
      "RA_min": "07",
      "RA_sec": "00.6",
      "dec_deg": "+25",
      "dec_min": 20,
      "dec_sec": 42,
      "magnitude": 3.76
    },
    {
      "ID": 8431,
      "greek_letter": "mu",
      "constellation": "PsA",
      "RA_hour": 22,
      "RA_min": "08",
      "RA_sec": 22.9,
      "dec_deg": -32,
      "dec_min": 59,
      "dec_sec": 19,
      "magnitude": 4.5
    },
    {
      "ID": 8433,
      "greek_letter": "ups",
      "constellation": "PsA",
      "RA_hour": 22,
      "RA_min": "08",
      "RA_sec": 25.9,
      "dec_deg": -34,
      "dec_min": "02",
      "dec_sec": 38,
      "magnitude": 4.99
    },
    {
      "ID": 8447,
      "greek_letter": "tau",
      "constellation": "PsA",
      "RA_hour": 22,
      "RA_min": 10,
      "RA_sec": "08.7",
      "dec_deg": -32,
      "dec_min": 32,
      "dec_sec": 55,
      "magnitude": 4.92
    },
    {
      "ID": 8450,
      "greek_letter": "tet",
      "constellation": "Peg",
      "RA_hour": 22,
      "RA_min": 10,
      "RA_sec": 11.9,
      "dec_deg": "+06",
      "dec_min": 11,
      "dec_sec": 52,
      "magnitude": 3.55
    },
    {
      "ID": 8454,
      "greek_letter": "pi2",
      "constellation": "Peg",
      "RA_hour": 22,
      "RA_min": "09",
      "RA_sec": 59.2,
      "dec_deg": "+33",
      "dec_min": 10,
      "dec_sec": 42,
      "magnitude": 4.29
    },
    {
      "ID": 8465,
      "greek_letter": "zet",
      "constellation": "Cep",
      "RA_hour": 22,
      "RA_min": 10,
      "RA_sec": 51.2,
      "dec_deg": "+58",
      "dec_min": 12,
      "dec_sec": "05",
      "magnitude": 3.35
    },
    {
      "ID": 8468,
      "greek_letter": "",
      "constellation": "Cep",
      "RA_hour": 22,
      "RA_min": "09",
      "RA_sec": 48.3,
      "dec_deg": "+72",
      "dec_min": 20,
      "dec_sec": 29,
      "magnitude": 4.79
    },
    {
      "ID": 8485,
      "greek_letter": "",
      "constellation": "",
      "RA_hour": 22,
      "RA_min": 13,
      "RA_sec": 52.6,
      "dec_deg": "+39",
      "dec_min": 42,
      "dec_sec": 54,
      "magnitude": 4.49
    },
    {
      "ID": 8486,
      "greek_letter": "mu1",
      "constellation": "Gru",
      "RA_hour": 22,
      "RA_min": 15,
      "RA_sec": 36.9,
      "dec_deg": -41,
      "dec_min": 20,
      "dec_sec": 48,
      "magnitude": 4.79
    },
    {
      "ID": 8494,
      "greek_letter": "eps",
      "constellation": "Cep",
      "RA_hour": 22,
      "RA_min": 15,
      "RA_sec": "01.9",
      "dec_deg": "+57",
      "dec_min": "02",
      "dec_sec": 37,
      "magnitude": 4.19
    },
    {
      "ID": 8498,
      "greek_letter": "",
      "constellation": "Lac",
      "RA_hour": 22,
      "RA_min": 15,
      "RA_sec": 58.1,
      "dec_deg": "+37",
      "dec_min": 44,
      "dec_sec": 56,
      "magnitude": 4.15
    },
    {
      "ID": 8499,
      "greek_letter": "tet",
      "constellation": "Aqr",
      "RA_hour": 22,
      "RA_min": 16,
      "RA_sec": 49.9,
      "dec_deg": "-07",
      "dec_min": 47,
      "dec_sec": "00",
      "magnitude": 4.16
    },
    {
      "ID": 8502,
      "greek_letter": "alf",
      "constellation": "Tuc",
      "RA_hour": 22,
      "RA_min": 18,
      "RA_sec": 30.1,
      "dec_deg": -60,
      "dec_min": 15,
      "dec_sec": 35,
      "magnitude": 2.86
    },
    {
      "ID": 8518,
      "greek_letter": "gam",
      "constellation": "Aqr",
      "RA_hour": 22,
      "RA_min": 21,
      "RA_sec": 39.3,
      "dec_deg": "-01",
      "dec_min": 23,
      "dec_sec": 14,
      "magnitude": 3.84
    },
    {
      "ID": 8522,
      "greek_letter": "",
      "constellation": "Peg",
      "RA_hour": 22,
      "RA_min": 21,
      "RA_sec": 19.2,
      "dec_deg": "+28",
      "dec_min": 19,
      "dec_sec": 50,
      "magnitude": 4.81
    },
    {
      "ID": 8523,
      "greek_letter": "",
      "constellation": "Lac",
      "RA_hour": 22,
      "RA_min": 21,
      "RA_sec": "01.5",
      "dec_deg": "+46",
      "dec_min": 32,
      "dec_sec": 12,
      "magnitude": 4.56
    },
    {
      "ID": 8538,
      "greek_letter": "bet",
      "constellation": "Lac",
      "RA_hour": 22,
      "RA_min": 23,
      "RA_sec": 33.5,
      "dec_deg": "+52",
      "dec_min": 13,
      "dec_sec": 45,
      "magnitude": 4.44
    },
    {
      "ID": 8539,
      "greek_letter": "pi",
      "constellation": "Aqr",
      "RA_hour": 22,
      "RA_min": 25,
      "RA_sec": 16.5,
      "dec_deg": "+01",
      "dec_min": 22,
      "dec_sec": 39,
      "magnitude": 4.64
    },
    {
      "ID": 8540,
      "greek_letter": "del",
      "constellation": "Tuc",
      "RA_hour": 22,
      "RA_min": 27,
      "RA_sec": 20,
      "dec_deg": -64,
      "dec_min": 58,
      "dec_sec": "00",
      "magnitude": 4.48
    },
    {
      "ID": 8541,
      "greek_letter": "",
      "constellation": "Lac",
      "RA_hour": 22,
      "RA_min": 24,
      "RA_sec": 30.9,
      "dec_deg": "+49",
      "dec_min": 28,
      "dec_sec": 35,
      "magnitude": 4.58
    },
    {
      "ID": 8551,
      "greek_letter": "",
      "constellation": "Peg",
      "RA_hour": 22,
      "RA_min": 27,
      "RA_sec": 51.5,
      "dec_deg": "+04",
      "dec_min": 41,
      "dec_sec": 44,
      "magnitude": 4.8
    },
    {
      "ID": 8556,
      "greek_letter": "del1",
      "constellation": "Gru",
      "RA_hour": 22,
      "RA_min": 29,
      "RA_sec": 16.1,
      "dec_deg": -43,
      "dec_min": 29,
      "dec_sec": 45,
      "magnitude": 3.97
    },
    {
      "ID": 8558,
      "greek_letter": "zet1",
      "constellation": "Aqr",
      "RA_hour": 22,
      "RA_min": 28,
      "RA_sec": 49.6,
      "dec_deg": "-00",
      "dec_min": "01",
      "dec_sec": 13,
      "magnitude": 4.59
    },
    {
      "ID": 8559,
      "greek_letter": "zet2",
      "constellation": "Aqr",
      "RA_hour": 22,
      "RA_min": 28,
      "RA_sec": 50,
      "dec_deg": "-00",
      "dec_min": "01",
      "dec_sec": 12,
      "magnitude": 4.42
    },
    {
      "ID": 8560,
      "greek_letter": "del2",
      "constellation": "Gru",
      "RA_hour": 22,
      "RA_min": 29,
      "RA_sec": 45.4,
      "dec_deg": -43,
      "dec_min": 44,
      "dec_sec": 58,
      "magnitude": 4.11
    },
    {
      "ID": 8571,
      "greek_letter": "del",
      "constellation": "Cep",
      "RA_hour": 22,
      "RA_min": 29,
      "RA_sec": 10.2,
      "dec_deg": "+58",
      "dec_min": 24,
      "dec_sec": 55,
      "magnitude": 3.75
    },
    {
      "ID": 8572,
      "greek_letter": "",
      "constellation": "Lac",
      "RA_hour": 22,
      "RA_min": 29,
      "RA_sec": 31.8,
      "dec_deg": "+47",
      "dec_min": 42,
      "dec_sec": 25,
      "magnitude": 4.37
    },
    {
      "ID": 8573,
      "greek_letter": "sig",
      "constellation": "Aqr",
      "RA_hour": 22,
      "RA_min": 30,
      "RA_sec": 38.7,
      "dec_deg": -10,
      "dec_min": 40,
      "dec_sec": 41,
      "magnitude": 4.81
    },
    {
      "ID": 8576,
      "greek_letter": "bet",
      "constellation": "PsA",
      "RA_hour": 22,
      "RA_min": 31,
      "RA_sec": 30.3,
      "dec_deg": -32,
      "dec_min": 20,
      "dec_sec": 46,
      "magnitude": 4.29
    },
    {
      "ID": 8579,
      "greek_letter": "",
      "constellation": "Lac",
      "RA_hour": 22,
      "RA_min": 30,
      "RA_sec": 29.1,
      "dec_deg": "+43",
      "dec_min": "07",
      "dec_sec": 25,
      "magnitude": 4.51
    },
    {
      "ID": 8582,
      "greek_letter": "nu",
      "constellation": "Tuc",
      "RA_hour": 22,
      "RA_min": 33,
      "RA_sec": "00.0",
      "dec_deg": -61,
      "dec_min": 58,
      "dec_sec": 57,
      "magnitude": 4.81
    },
    {
      "ID": 8585,
      "greek_letter": "alf",
      "constellation": "Lac",
      "RA_hour": 22,
      "RA_min": 31,
      "RA_sec": 17.4,
      "dec_deg": "+50",
      "dec_min": 16,
      "dec_sec": 57,
      "magnitude": 3.77
    },
    {
      "ID": 8597,
      "greek_letter": "eta",
      "constellation": "Aqr",
      "RA_hour": 22,
      "RA_min": 35,
      "RA_sec": 21.3,
      "dec_deg": "-00",
      "dec_min": "07",
      "dec_sec": "03",
      "magnitude": 4
    },
    {
      "ID": 8613,
      "greek_letter": "",
      "constellation": "Lac",
      "RA_hour": 22,
      "RA_min": 37,
      "RA_sec": 22.3,
      "dec_deg": "+51",
      "dec_min": 32,
      "dec_sec": 43,
      "magnitude": 4.63
    },
    {
      "ID": 8622,
      "greek_letter": "",
      "constellation": "Lac",
      "RA_hour": 22,
      "RA_min": 39,
      "RA_sec": 15.6,
      "dec_deg": "+39",
      "dec_min": "03",
      "dec_sec": "01",
      "magnitude": 4.89
    },
    {
      "ID": 8628,
      "greek_letter": "eps",
      "constellation": "PsA",
      "RA_hour": 22,
      "RA_min": 40,
      "RA_sec": 39.3,
      "dec_deg": -27,
      "dec_min": "02",
      "dec_sec": 37,
      "magnitude": 4.18
    },
    {
      "ID": 8630,
      "greek_letter": "bet",
      "constellation": "Oct",
      "RA_hour": 22,
      "RA_min": 46,
      "RA_sec": "03.3",
      "dec_deg": -81,
      "dec_min": 22,
      "dec_sec": 54,
      "magnitude": 4.15
    },
    {
      "ID": 8632,
      "greek_letter": "",
      "constellation": "Lac",
      "RA_hour": 22,
      "RA_min": 40,
      "RA_sec": 30.8,
      "dec_deg": "+44",
      "dec_min": 16,
      "dec_sec": 35,
      "magnitude": 4.46
    },
    {
      "ID": 8634,
      "greek_letter": "zet",
      "constellation": "Peg",
      "RA_hour": 22,
      "RA_min": 41,
      "RA_sec": 27.6,
      "dec_deg": "+10",
      "dec_min": 49,
      "dec_sec": 53,
      "magnitude": 3.41
    },
    {
      "ID": 8636,
      "greek_letter": "bet",
      "constellation": "Gru",
      "RA_hour": 22,
      "RA_min": 42,
      "RA_sec": 40,
      "dec_deg": -46,
      "dec_min": 53,
      "dec_sec": "05",
      "magnitude": 2.11
    },
    {
      "ID": 8641,
      "greek_letter": "omi",
      "constellation": "Peg",
      "RA_hour": 22,
      "RA_min": 41,
      "RA_sec": 45.3,
      "dec_deg": "+29",
      "dec_min": 18,
      "dec_sec": 27,
      "magnitude": 4.79
    },
    {
      "ID": 8644,
      "greek_letter": "ro",
      "constellation": "Gru",
      "RA_hour": 22,
      "RA_min": 43,
      "RA_sec": 30,
      "dec_deg": -41,
      "dec_min": 24,
      "dec_sec": 52,
      "magnitude": 4.85
    },
    {
      "ID": 8649,
      "greek_letter": "",
      "constellation": "Aqr",
      "RA_hour": 22,
      "RA_min": 43,
      "RA_sec": 35.2,
      "dec_deg": -18,
      "dec_min": 49,
      "dec_sec": 50,
      "magnitude": 4.69
    },
    {
      "ID": 8650,
      "greek_letter": "eta",
      "constellation": "Peg",
      "RA_hour": 22,
      "RA_min": 43,
      "RA_sec": "00.1",
      "dec_deg": "+30",
      "dec_min": 13,
      "dec_sec": 17,
      "magnitude": 2.95
    },
    {
      "ID": 8655,
      "greek_letter": "eta",
      "constellation": "Gru",
      "RA_hour": 22,
      "RA_min": 45,
      "RA_sec": 37.8,
      "dec_deg": -53,
      "dec_min": 30,
      "dec_sec": "00",
      "magnitude": 4.85
    },
    {
      "ID": 8665,
      "greek_letter": "xi",
      "constellation": "Peg",
      "RA_hour": 22,
      "RA_min": 46,
      "RA_sec": 41.5,
      "dec_deg": "+12",
      "dec_min": 10,
      "dec_sec": 22,
      "magnitude": 4.19
    },
    {
      "ID": 8667,
      "greek_letter": "lam",
      "constellation": "Peg",
      "RA_hour": 22,
      "RA_min": 46,
      "RA_sec": 31.8,
      "dec_deg": "+23",
      "dec_min": 33,
      "dec_sec": 56,
      "magnitude": 3.93
    },
    {
      "ID": 8675,
      "greek_letter": "eps",
      "constellation": "Gru",
      "RA_hour": 22,
      "RA_min": 48,
      "RA_sec": 33.2,
      "dec_deg": -51,
      "dec_min": 19,
      "dec_sec": "01",
      "magnitude": 3.49
    },
    {
      "ID": 8679,
      "greek_letter": "tau2",
      "constellation": "Aqr",
      "RA_hour": 22,
      "RA_min": 49,
      "RA_sec": 35.4,
      "dec_deg": -13,
      "dec_min": 35,
      "dec_sec": 33,
      "magnitude": 3.98
    },
    {
      "ID": 8684,
      "greek_letter": "mu",
      "constellation": "Peg",
      "RA_hour": 22,
      "RA_min": 50,
      "RA_sec": "00.1",
      "dec_deg": "+24",
      "dec_min": 36,
      "dec_sec": "06",
      "magnitude": 3.48
    },
    {
      "ID": 8694,
      "greek_letter": "iot",
      "constellation": "Cep",
      "RA_hour": 22,
      "RA_min": 49,
      "RA_sec": 40.7,
      "dec_deg": "+66",
      "dec_min": 12,
      "dec_sec": "02",
      "magnitude": 3.54
    },
    {
      "ID": 8695,
      "greek_letter": "gam",
      "constellation": "PsA",
      "RA_hour": 22,
      "RA_min": 52,
      "RA_sec": 31.5,
      "dec_deg": -32,
      "dec_min": 52,
      "dec_sec": 32,
      "magnitude": 4.46
    },
    {
      "ID": 8698,
      "greek_letter": "lam",
      "constellation": "Aqr",
      "RA_hour": 22,
      "RA_min": 52,
      "RA_sec": 36.8,
      "dec_deg": "-07",
      "dec_min": 34,
      "dec_sec": 47,
      "magnitude": 3.74
    },
    {
      "ID": 8699,
      "greek_letter": "",
      "constellation": "Lac",
      "RA_hour": 22,
      "RA_min": 52,
      "RA_sec": "02.0",
      "dec_deg": "+43",
      "dec_min": 18,
      "dec_sec": 45,
      "magnitude": 4.94
    },
    {
      "ID": 8702,
      "greek_letter": "",
      "constellation": "",
      "RA_hour": 22,
      "RA_min": 47,
      "RA_sec": 28.8,
      "dec_deg": "+83",
      "dec_min": "09",
      "dec_sec": 14,
      "magnitude": 4.74
    },
    {
      "ID": 8709,
      "greek_letter": "del",
      "constellation": "Aqr",
      "RA_hour": 22,
      "RA_min": 54,
      "RA_sec": 38.9,
      "dec_deg": -15,
      "dec_min": 49,
      "dec_sec": 15,
      "magnitude": 3.28
    },
    {
      "ID": 8717,
      "greek_letter": "ro",
      "constellation": "Peg",
      "RA_hour": 22,
      "RA_min": 55,
      "RA_sec": 13.6,
      "dec_deg": "+08",
      "dec_min": 48,
      "dec_sec": 58,
      "magnitude": 4.9
    },
    {
      "ID": 8720,
      "greek_letter": "del",
      "constellation": "PsA",
      "RA_hour": 22,
      "RA_min": 55,
      "RA_sec": 56.8,
      "dec_deg": -32,
      "dec_min": 32,
      "dec_sec": 23,
      "magnitude": 4.21
    },
    {
      "ID": 8726,
      "greek_letter": "",
      "constellation": "",
      "RA_hour": 22,
      "RA_min": 56,
      "RA_sec": 25.9,
      "dec_deg": "+49",
      "dec_min": 44,
      "dec_sec": "01",
      "magnitude": 4.94
    },
    {
      "ID": 8728,
      "greek_letter": "alf",
      "constellation": "PsA",
      "RA_hour": 22,
      "RA_min": 57,
      "RA_sec": 39,
      "dec_deg": -29,
      "dec_min": 37,
      "dec_sec": 20,
      "magnitude": 1.16
    },
    {
      "ID": 8747,
      "greek_letter": "zet",
      "constellation": "Gru",
      "RA_hour": 23,
      "RA_min": "00",
      "RA_sec": 52.8,
      "dec_deg": -52,
      "dec_min": 45,
      "dec_sec": 15,
      "magnitude": 4.12
    },
    {
      "ID": 8748,
      "greek_letter": "",
      "constellation": "",
      "RA_hour": 22,
      "RA_min": 54,
      "RA_sec": 24.6,
      "dec_deg": "+84",
      "dec_min": 20,
      "dec_sec": 47,
      "magnitude": 4.72
    },
    {
      "ID": 8752,
      "greek_letter": "",
      "constellation": "",
      "RA_hour": 23,
      "RA_min": "00",
      "RA_sec": "05.0",
      "dec_deg": "+56",
      "dec_min": 56,
      "dec_sec": 44,
      "magnitude": 5
    },
    {
      "ID": 8762,
      "greek_letter": "omi",
      "constellation": "And",
      "RA_hour": 23,
      "RA_min": "01",
      "RA_sec": 55.2,
      "dec_deg": "+42",
      "dec_min": 19,
      "dec_sec": 34,
      "magnitude": 3.62
    },
    {
      "ID": 8773,
      "greek_letter": "bet",
      "constellation": "Psc",
      "RA_hour": 23,
      "RA_min": "03",
      "RA_sec": 52.5,
      "dec_deg": "+03",
      "dec_min": 49,
      "dec_sec": 12,
      "magnitude": 4.52
    },
    {
      "ID": 8775,
      "greek_letter": "bet",
      "constellation": "Peg",
      "RA_hour": 23,
      "RA_min": "03",
      "RA_sec": 46.4,
      "dec_deg": "+28",
      "dec_min": "04",
      "dec_sec": 58,
      "magnitude": 2.42
    },
    {
      "ID": 8780,
      "greek_letter": "",
      "constellation": "And",
      "RA_hour": 23,
      "RA_min": "04",
      "RA_sec": 10.9,
      "dec_deg": "+50",
      "dec_min": "03",
      "dec_sec": "08",
      "magnitude": 4.66
    },
    {
      "ID": 8781,
      "greek_letter": "alf",
      "constellation": "Peg",
      "RA_hour": 23,
      "RA_min": "04",
      "RA_sec": 45.6,
      "dec_deg": "+15",
      "dec_min": 12,
      "dec_sec": 19,
      "magnitude": 2.48
    },
    {
      "ID": 8787,
      "greek_letter": "tet",
      "constellation": "Gru",
      "RA_hour": 23,
      "RA_min": "06",
      "RA_sec": 52.7,
      "dec_deg": -43,
      "dec_min": 31,
      "dec_sec": 14,
      "magnitude": 4.28
    },
    {
      "ID": 8789,
      "greek_letter": "",
      "constellation": "Aqr",
      "RA_hour": 23,
      "RA_min": "06",
      "RA_sec": 40.8,
      "dec_deg": -23,
      "dec_min": 44,
      "dec_sec": 35,
      "magnitude": 4.48
    },
    {
      "ID": 8795,
      "greek_letter": "",
      "constellation": "Peg",
      "RA_hour": 23,
      "RA_min": "07",
      "RA_sec": "00.2",
      "dec_deg": "+09",
      "dec_min": 24,
      "dec_sec": 34,
      "magnitude": 4.51
    },
    {
      "ID": 8796,
      "greek_letter": "",
      "constellation": "Peg",
      "RA_hour": 23,
      "RA_min": "07",
      "RA_sec": "06.6",
      "dec_deg": "+25",
      "dec_min": 28,
      "dec_sec": "06",
      "magnitude": 4.74
    },
    {
      "ID": 8797,
      "greek_letter": "",
      "constellation": "Cas",
      "RA_hour": 23,
      "RA_min": "06",
      "RA_sec": 36.8,
      "dec_deg": "+59",
      "dec_min": 25,
      "dec_sec": 12,
      "magnitude": 4.85
    },
    {
      "ID": 8812,
      "greek_letter": "",
      "constellation": "Aqr",
      "RA_hour": 23,
      "RA_min": "09",
      "RA_sec": 26.7,
      "dec_deg": -21,
      "dec_min": 10,
      "dec_sec": 21,
      "magnitude": 3.64
    },
    {
      "ID": 8817,
      "greek_letter": "",
      "constellation": "Aqr",
      "RA_hour": 23,
      "RA_min": "09",
      "RA_sec": 54.7,
      "dec_deg": -22,
      "dec_min": 27,
      "dec_sec": 27,
      "magnitude": 4.68
    },
    {
      "ID": 8819,
      "greek_letter": "pi",
      "constellation": "Cep",
      "RA_hour": 23,
      "RA_min": "07",
      "RA_sec": 53.8,
      "dec_deg": "+75",
      "dec_min": 23,
      "dec_sec": 16,
      "magnitude": 4.42
    },
    {
      "ID": 8820,
      "greek_letter": "iot",
      "constellation": "Gru",
      "RA_hour": 23,
      "RA_min": 10,
      "RA_sec": 21.5,
      "dec_deg": -45,
      "dec_min": 14,
      "dec_sec": 48,
      "magnitude": 3.89
    },
    {
      "ID": 8830,
      "greek_letter": "",
      "constellation": "And",
      "RA_hour": 23,
      "RA_min": 12,
      "RA_sec": 32.9,
      "dec_deg": "+49",
      "dec_min": 24,
      "dec_sec": 23,
      "magnitude": 4.53
    },
    {
      "ID": 8834,
      "greek_letter": "phi",
      "constellation": "Aqr",
      "RA_hour": 23,
      "RA_min": 14,
      "RA_sec": 19.3,
      "dec_deg": "-06",
      "dec_min": "02",
      "dec_sec": 56,
      "magnitude": 4.22
    },
    {
      "ID": 8841,
      "greek_letter": "psi1",
      "constellation": "Aqr",
      "RA_hour": 23,
      "RA_min": 15,
      "RA_sec": 53.4,
      "dec_deg": "-09",
      "dec_min": "05",
      "dec_sec": 16,
      "magnitude": 4.25
    },
    {
      "ID": 8848,
      "greek_letter": "gam",
      "constellation": "Tuc",
      "RA_hour": 23,
      "RA_min": 17,
      "RA_sec": 25.7,
      "dec_deg": -58,
      "dec_min": 14,
      "dec_sec": "08",
      "magnitude": 3.99
    },
    {
      "ID": 8852,
      "greek_letter": "gam",
      "constellation": "Psc",
      "RA_hour": 23,
      "RA_min": 17,
      "RA_sec": "09.9",
      "dec_deg": "+03",
      "dec_min": 16,
      "dec_sec": 56,
      "magnitude": 3.7
    },
    {
      "ID": 8858,
      "greek_letter": "psi2",
      "constellation": "Aqr",
      "RA_hour": 23,
      "RA_min": 17,
      "RA_sec": 54.1,
      "dec_deg": "-09",
      "dec_min": 10,
      "dec_sec": 57,
      "magnitude": 4.4
    },
    {
      "ID": 8860,
      "greek_letter": "",
      "constellation": "And",
      "RA_hour": 23,
      "RA_min": 17,
      "RA_sec": 44.6,
      "dec_deg": "+49",
      "dec_min": "00",
      "dec_sec": 55,
      "magnitude": 4.86
    },
    {
      "ID": 8863,
      "greek_letter": "gam",
      "constellation": "Scl",
      "RA_hour": 23,
      "RA_min": 18,
      "RA_sec": 49.4,
      "dec_deg": -32,
      "dec_min": 31,
      "dec_sec": 55,
      "magnitude": 4.41
    },
    {
      "ID": 8865,
      "greek_letter": "psi3",
      "constellation": "Aqr",
      "RA_hour": 23,
      "RA_min": 18,
      "RA_sec": 57.6,
      "dec_deg": "-09",
      "dec_min": 36,
      "dec_sec": 38,
      "magnitude": 4.98
    },
    {
      "ID": 8872,
      "greek_letter": "omi",
      "constellation": "Cep",
      "RA_hour": 23,
      "RA_min": 18,
      "RA_sec": 37.4,
      "dec_deg": "+68",
      "dec_min": "06",
      "dec_sec": 42,
      "magnitude": 4.76
    },
    {
      "ID": 8880,
      "greek_letter": "tau",
      "constellation": "Peg",
      "RA_hour": 23,
      "RA_min": 20,
      "RA_sec": 38.2,
      "dec_deg": "+23",
      "dec_min": 44,
      "dec_sec": 25,
      "magnitude": 4.6
    },
    {
      "ID": 8892,
      "greek_letter": "",
      "constellation": "Aqr",
      "RA_hour": 23,
      "RA_min": 22,
      "RA_sec": 58.1,
      "dec_deg": -20,
      "dec_min": "06",
      "dec_sec": "02",
      "magnitude": 3.98
    },
    {
      "ID": 8904,
      "greek_letter": "",
      "constellation": "Cas",
      "RA_hour": 23,
      "RA_min": 24,
      "RA_sec": 50.2,
      "dec_deg": "+62",
      "dec_min": 16,
      "dec_sec": 59,
      "magnitude": 4.98
    },
    {
      "ID": 8905,
      "greek_letter": "ups",
      "constellation": "Peg",
      "RA_hour": 23,
      "RA_min": 25,
      "RA_sec": 22.7,
      "dec_deg": "+23",
      "dec_min": 24,
      "dec_sec": 15,
      "magnitude": 4.4
    },
    {
      "ID": 8906,
      "greek_letter": "",
      "constellation": "Aqr",
      "RA_hour": 23,
      "RA_min": 26,
      "RA_sec": "02.7",
      "dec_deg": -20,
      "dec_min": 38,
      "dec_sec": 31,
      "magnitude": 4.39
    },
    {
      "ID": 8911,
      "greek_letter": "kap",
      "constellation": "Psc",
      "RA_hour": 23,
      "RA_min": 26,
      "RA_sec": 55.9,
      "dec_deg": "+01",
      "dec_min": 15,
      "dec_sec": 20,
      "magnitude": 4.94
    },
    {
      "ID": 8916,
      "greek_letter": "tet",
      "constellation": "Psc",
      "RA_hour": 23,
      "RA_min": 27,
      "RA_sec": 58,
      "dec_deg": "+06",
      "dec_min": 22,
      "dec_sec": 44,
      "magnitude": 4.3
    },
    {
      "ID": 8923,
      "greek_letter": "",
      "constellation": "Peg",
      "RA_hour": 23,
      "RA_min": 29,
      "RA_sec": "09.2",
      "dec_deg": "+12",
      "dec_min": 45,
      "dec_sec": 38,
      "magnitude": 4.56
    },
    {
      "ID": 8926,
      "greek_letter": "",
      "constellation": "",
      "RA_hour": 23,
      "RA_min": 30,
      "RA_sec": "01.9",
      "dec_deg": "+58",
      "dec_min": 32,
      "dec_sec": 57,
      "magnitude": 4.91
    },
    {
      "ID": 8937,
      "greek_letter": "bet",
      "constellation": "Scl",
      "RA_hour": 23,
      "RA_min": 32,
      "RA_sec": 58.2,
      "dec_deg": -37,
      "dec_min": 49,
      "dec_sec": "07",
      "magnitude": 4.37
    },
    {
      "ID": 8939,
      "greek_letter": "",
      "constellation": "Aqr",
      "RA_hour": 23,
      "RA_min": 33,
      "RA_sec": 16.5,
      "dec_deg": -20,
      "dec_min": 54,
      "dec_sec": 52,
      "magnitude": 4.72
    },
    {
      "ID": 8943,
      "greek_letter": "",
      "constellation": "Peg",
      "RA_hour": 23,
      "RA_min": 33,
      "RA_sec": 57.1,
      "dec_deg": "+31",
      "dec_min": 19,
      "dec_sec": 32,
      "magnitude": 4.98
    },
    {
      "ID": 8949,
      "greek_letter": "iot",
      "constellation": "Phe",
      "RA_hour": 23,
      "RA_min": 35,
      "RA_sec": "04.5",
      "dec_deg": -42,
      "dec_min": 36,
      "dec_sec": 55,
      "magnitude": 4.71
    },
    {
      "ID": 8959,
      "greek_letter": "",
      "constellation": "",
      "RA_hour": 23,
      "RA_min": 37,
      "RA_sec": 50.9,
      "dec_deg": -45,
      "dec_min": 29,
      "dec_sec": 33,
      "magnitude": 4.74
    },
    {
      "ID": 8961,
      "greek_letter": "lam",
      "constellation": "And",
      "RA_hour": 23,
      "RA_min": 37,
      "RA_sec": 33.8,
      "dec_deg": "+46",
      "dec_min": 27,
      "dec_sec": 30,
      "magnitude": 3.82
    },
    {
      "ID": 8965,
      "greek_letter": "iot",
      "constellation": "And",
      "RA_hour": 23,
      "RA_min": 38,
      "RA_sec": "08.1",
      "dec_deg": "+43",
      "dec_min": 16,
      "dec_sec": "05",
      "magnitude": 4.29
    },
    {
      "ID": 8968,
      "greek_letter": "omg1",
      "constellation": "Aqr",
      "RA_hour": 23,
      "RA_min": 39,
      "RA_sec": 47,
      "dec_deg": -14,
      "dec_min": 13,
      "dec_sec": 18,
      "magnitude": 5
    },
    {
      "ID": 8969,
      "greek_letter": "iot",
      "constellation": "Psc",
      "RA_hour": 23,
      "RA_min": 39,
      "RA_sec": 57,
      "dec_deg": "+05",
      "dec_min": 37,
      "dec_sec": 35,
      "magnitude": 4.13
    },
    {
      "ID": 8974,
      "greek_letter": "gam",
      "constellation": "Cep",
      "RA_hour": 23,
      "RA_min": 39,
      "RA_sec": 20.8,
      "dec_deg": "+77",
      "dec_min": 37,
      "dec_sec": 57,
      "magnitude": 3.21
    },
    {
      "ID": 8976,
      "greek_letter": "kap",
      "constellation": "And",
      "RA_hour": 23,
      "RA_min": 40,
      "RA_sec": 24.4,
      "dec_deg": "+44",
      "dec_min": 20,
      "dec_sec": "02",
      "magnitude": 4.14
    },
    {
      "ID": 8982,
      "greek_letter": "",
      "constellation": "Aqr",
      "RA_hour": 23,
      "RA_min": 41,
      "RA_sec": 45.7,
      "dec_deg": -17,
      "dec_min": 48,
      "dec_sec": 59,
      "magnitude": 4.83
    },
    {
      "ID": 8984,
      "greek_letter": "lam",
      "constellation": "Psc",
      "RA_hour": 23,
      "RA_min": 42,
      "RA_sec": "02.7",
      "dec_deg": "+01",
      "dec_min": 46,
      "dec_sec": 48,
      "magnitude": 4.51
    },
    {
      "ID": 8988,
      "greek_letter": "omg2",
      "constellation": "Aqr",
      "RA_hour": 23,
      "RA_min": 42,
      "RA_sec": 43.2,
      "dec_deg": -14,
      "dec_min": 32,
      "dec_sec": 42,
      "magnitude": 4.51
    },
    {
      "ID": 8997,
      "greek_letter": "",
      "constellation": "Peg",
      "RA_hour": 23,
      "RA_min": 43,
      "RA_sec": 59.4,
      "dec_deg": "+29",
      "dec_min": 21,
      "dec_sec": 42,
      "magnitude": 4.93
    },
    {
      "ID": 9003,
      "greek_letter": "psi",
      "constellation": "And",
      "RA_hour": 23,
      "RA_min": 46,
      "RA_sec": "02.0",
      "dec_deg": "+46",
      "dec_min": 25,
      "dec_sec": 13,
      "magnitude": 4.95
    },
    {
      "ID": 9008,
      "greek_letter": "tau",
      "constellation": "Cas",
      "RA_hour": 23,
      "RA_min": 47,
      "RA_sec": "03.4",
      "dec_deg": "+58",
      "dec_min": 39,
      "dec_sec": "07",
      "magnitude": 4.87
    },
    {
      "ID": 9016,
      "greek_letter": "del",
      "constellation": "Scl",
      "RA_hour": 23,
      "RA_min": 48,
      "RA_sec": 55.5,
      "dec_deg": -28,
      "dec_min": "07",
      "dec_sec": 49,
      "magnitude": 4.57
    },
    {
      "ID": 9045,
      "greek_letter": "ro",
      "constellation": "Cas",
      "RA_hour": 23,
      "RA_min": 54,
      "RA_sec": 23,
      "dec_deg": "+57",
      "dec_min": 29,
      "dec_sec": 58,
      "magnitude": 4.54
    },
    {
      "ID": 9062,
      "greek_letter": "eta",
      "constellation": "Tuc",
      "RA_hour": 23,
      "RA_min": 57,
      "RA_sec": 35.2,
      "dec_deg": -64,
      "dec_min": 17,
      "dec_sec": 55,
      "magnitude": 5
    },
    {
      "ID": 9064,
      "greek_letter": "psi",
      "constellation": "Peg",
      "RA_hour": 23,
      "RA_min": 57,
      "RA_sec": 45.5,
      "dec_deg": "+25",
      "dec_min": "08",
      "dec_sec": 29,
      "magnitude": 4.66
    },
    {
      "ID": 9066,
      "greek_letter": "",
      "constellation": "",
      "RA_hour": 23,
      "RA_min": 58,
      "RA_sec": 24.7,
      "dec_deg": "+51",
      "dec_min": 23,
      "dec_sec": 19,
      "magnitude": 4.8
    },
    {
      "ID": 9067,
      "greek_letter": "",
      "constellation": "Psc",
      "RA_hour": 23,
      "RA_min": 58,
      "RA_sec": 40.3,
      "dec_deg": "-03",
      "dec_min": 33,
      "dec_sec": 22,
      "magnitude": 4.86
    },
    {
      "ID": 9071,
      "greek_letter": "sig",
      "constellation": "Cas",
      "RA_hour": 23,
      "RA_min": 59,
      "RA_sec": "00.4",
      "dec_deg": "+55",
      "dec_min": 45,
      "dec_sec": 18,
      "magnitude": 4.88
    },
    {
      "ID": 9072,
      "greek_letter": "omg",
      "constellation": "Psc",
      "RA_hour": 23,
      "RA_min": 59,
      "RA_sec": 18.6,
      "dec_deg": "+06",
      "dec_min": 51,
      "dec_sec": 48,
      "magnitude": 4.01
    },
    {
      "ID": 9076,
      "greek_letter": "eps",
      "constellation": "Tuc",
      "RA_hour": 23,
      "RA_min": 59,
      "RA_sec": 55,
      "dec_deg": -65,
      "dec_min": 34,
      "dec_sec": 38,
      "magnitude": 4.5
    },
    {
      "ID": 9084,
      "greek_letter": "tet",
      "constellation": "Oct",
      "RA_hour": "00",
      "RA_min": "01",
      "RA_sec": 35.8,
      "dec_deg": -77,
      "dec_min": "03",
      "dec_sec": 57,
      "magnitude": 4.78
    },
    {
      "ID": 9089,
      "greek_letter": "",
      "constellation": "Psc",
      "RA_hour": "00",
      "RA_min": "01",
      "RA_sec": 57.5,
      "dec_deg": "-06",
      "dec_min": "00",
      "dec_sec": 51,
      "magnitude": 4.41
    },
    {
      "ID": 9098,
      "greek_letter": "",
      "constellation": "Cet",
      "RA_hour": "00",
      "RA_min": "03",
      "RA_sec": 44.3,
      "dec_deg": -17,
      "dec_min": 20,
      "dec_sec": 10,
      "magnitude": 4.56
    },
    {
      "ID": 9103,
      "greek_letter": "",
      "constellation": "Cet",
      "RA_hour": "00",
      "RA_min": "04",
      "RA_sec": 30,
      "dec_deg": -10,
      "dec_min": 30,
      "dec_sec": 35,
      "magnitude": 4.98
    }
  ]